import { getImgUrl } from "../Utility/Utility";

// start live shows
// export const ShowsPostsData = [

// 	{
// 		id:1,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tom Jones \n Tel Aviv ",
//         smltitle: "The one and only Tom Jones returns to Tel Aviv for one live performance",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tomjones.com/">
// 												www.tomjones.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/1/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							At the request of the audience and after the success of his sold-out show in 2013, the legendary performer Tom Jones returns to Israel for one live performance, to be held in Tel Aviv on Wednesday, June 28, 2017.
// 						</p>

// 						<p>
// 							Tom Jones, a world-famous living legend, is known for not allowing the diverse audience that fills his halls to sit quietly for a moment. He is a performer who captures the hearts of men and women of all ages, crosses generations and genres with his infinite inherent talent and his powerful and unique voice.
// 						</p>
// 						<p>
// 							Tom Jones has had an amazing stage career and sold over 100 million records. He has been awarded many titles including the Brit Awards for his immense musical contribution and Lifetime Achievement Award for his many achievements in the world of music and live performances at the Silver Clef (annual British Music Awards). For his contribution to the music industry, he won a star on the Hollywood Walk of Fame. In 1999, Tom Jones was awarded the Order of the British Empire (OBE) and in 2006 His Royal Highness Queen Elizabeth gave him the title of nobility and he became Sir Tom Jones.
// 						</p>

// 						<p>
// 							Jones, recognized across the world as a "hit machine", will be hitting the 24/7 city this June for the second time. As he did in his last sold out show in Tel Aviv to the delight of his audience, will be performing his all-time greatest hits.
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//       id:2,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Britney Spears \n  Live in Concert",
//         smltitle: "Britney Spears- performing all her greatest hits in the fabulous city of Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											03.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.britneyspears.com">
// 												www.britneyspears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/2/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							Pop Icon Britney Spears is coming to Tel Aviv for the first time ever, for one show only, as part of her international tour of Asia. The show will take place in stunning Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>

// 						<p>
// 							Pop Icon Britney Spears will be coming to Israel for the first time ever for one show only as part of her international tour of Asia. The show will take place in Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Multi-platinum, Grammy Award-winning pop icon Britney Spears was born in Mississippi and raised in Louisiana, Spears became a household name as a teenager when she released her first single “…Baby One More Time,” a Billboard Hot 100 No. 1 smash and international hit that broke sales records with more than 20 million copies sold worldwide and is currently 14x Platinum in the U.S.
// 						</p>

// 						<p>
// 							Spears is one of the most successful and celebrated entertainers in pop history with nearly 150 million records worldwide. In the U.S. alone, she has sold more than 70 million albums, singles and songs, according to Nielsen Music.
// 						</p>

// 						<p>
// 							Britney’s live concerts are renowned for their amazing production and nonstop energy. Her first ever show in Tel Aviv is likely to feature some of her most recent songs from her Glory Album, including massive 2016 hit ‘Slumber Party’, and also some of her massive all-time hits such as ‘Baby One More Time’ and ‘Oops I Did It Again’!
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:3,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tears for Fears",
//         smltitle: "Tear for Fears in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											05.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tearsforfears.com">
// 												www.tearsforfears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<p>
// 							This summer, the trendy city of Tel Aviv is embracing it’s 80s vibe for one performance only by the incomparable Tears for Fears. The legendary British pop/rock band that is responsible for many unforgettable hits is coming to the rocking city of Tel Aviv for a single awesome performance!
// 						</p>

// 						<p>
// 							Originally from Bath, Avon, Tears for Fears was founded in 1981 and was associated at first with the new wave synthesizer bands but later on became a part of mainstream rock and pop and hit international success. During the 80's the band released 3 albums that were a combination of pop, new wave and rock. Their first album from 1983, "The Hurting", reached number one in the UK albums chart and was a platinum-selling album. It included major hits such as "Pale Shelter", "Change", and "Mad World". Their second album, "Songs from the Big Chair", followed the same path and reached number one on the US Billboard 200, getting multi-platinum status in the UK and the US. It contained unforgettable hits such as "Shout", "Head Over Heels" and "Everybody Wants to Rule the World" which won the Brit Award for best British single in 1986. Their third successful album "The Seeds of Love" that came out in 1989 included the epic songs "The Seeds of Love", "Sowing Woman in Chains" and many more.
// 						</p>
// 						<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans
// 						</p>
// 						<p>
// 						Tears for Fears’ albums and singles were sold in tens of millions of copies and their songs were covered by other artists countless times. Last year the band announced they are working on a new album to be released during 2017. This July they will be gracing the nonstop city of Tel Aviv for the first time with a single performance, guaranteed to be a night to remember.
// 						</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:4,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: " Guns N' Roses  \"Not in this Lifetime\"",
//         smltitle: "Legendary Guns N' Roses is Coming Back to Rock Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											15.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.gunsnroses.com">
// 											www.gunsnroses.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								After their celebrated reunion tour last summer, which became the most profitable musical rock concert in 2016, Guns N' Roses, one of the world's most important and beloved rock bands, is coming to Tel Aviv as part of its successful tour with has already added more than 30 shows in the US and Europe.
// 							</p>

// 							<p>
// 								The concert in Tel Aviv will take place on Saturday, July 15 and, 17 at the Yarkon Park, and will close the European tour.
// 							</p>
// 							<p>
// 								Twenty-three years after standing together on the stage in Tel Aviv for the first time, the three original members of the ensemble will come back again: vocalist Axel Rose, guitarist Slash and bassist Duff McGinn, along with an impressive ensemble of musicians including drummer Frank Ferrer, keyboardist Dizzy Red (who was an integral part of the band in the 1990s) Guitarist Richard Fortus and keyboardist Melissa Reyes.
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/2.jpg"} class="img-responsive" />
// 							</div>

// 							<h3>
// 							"Not in this Lifetime"
// 							</h3>
// 							<p>
// 							Since their first reunion concert at Cochlea Festival last April, the band's tour has become one of the most sought-after shows in America with more than 2 million tickets sold.
// 							</p>
// 							<p>
// 								The success and numbers of the current tour show more than anything else that the audience's love of the band's music and rock music is more relevant and bigger than ever. The historic tour last summer visited 21 cities (25 performances) in North America.
// 							</p>
// 							<p>
// 								The band has recently completed a successful tour in South America, Brazil, Argentina and Mexico. All of band's new tour dates are completely sold out, generating massive interest among audiences. In January, the band will continue to Japan and from there to Australia, Thailand, Singapore, Dubai and will arrive in the “nonstop city” of Tel Aviv in July.
// 							</p>
// 						`
// 			}
// 		}

// 	},

// 	{
//         id:5,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: " RADIOHEAD  \n Tel Aviv",
//         smltitle: "The trailblazing RADIOHEAD bringing their iconic repertoire to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.radiohead.com">
// 											www.radiohead.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/5/1.jpeg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Preforming in Tel Aviv for the second time ever, Radiohead has managed to remain innovative, relevant and especially moving since first visiting here 17 years ago . It is a band blessed with superhuman ability to meld together distant musical influences to create a new identity for themselves and their listeners; A band whose compulsive tendency to experiment with groundbreaking sound echoed the impact of entire generations of artists and shattered it to the walls of superfluous genres; A band that changed the way we listen to music, make music, see music, think music and even buy music. Now, 17 years after they last visited here, Radiohead is coming to a concert in Tel Aviv.
// 							</p>

// 							<p>
// 								Watching Radiohead's show, it becomes clear that first and foremost, they are the authors and performers of a huge amount of unforgettable songs. Their repertoire manages to be on the one hand familiar, classical - most of us know it by heart - and on the other hand revolutionary, developing and surprising. The tight performance of the ensemble, along with the unique energy of the soloist, Tom York, transforms each performance into a one-time live experience that attracts huge audiences, to participate in the celebration of artistic evolution, to see how they grew, evolved and reinvented themselves time and time again.
// 							</p>

// 							<p>
// 								Today's Radiohead is a band with a more contemporary presence than ever before, with a glorious past and a variety that transcends all cataloging: a band that began with the Immortal Grange anthem of Creep; Slapped critics over the head with the alternative masterpiece The Bends and then committed commercial suicide - and reached heaven - twice! - with two of the best albums of all time, OK Computer and Kid A.
// 							</p>

// 							<p>
// 								The new generations who discover Radiohead through their new works - In Rainbows a favorite in Israel or the new and acclaimed album A Moon Shaped Pool - discover a band whose influences have permeated every musical genre today: rock, electronic, world, hip hop. Today's Radiohead is more than just another band, it is a world - with a unique visual language, exceptional imagery, an unreplaceable atmosphere and inner humor. Especially in Israel - a country that has always enjoyed an intimate and warm relationship with the band - Radiohead's performance is a cultural experience of the rarest kind.
// 							</p>
// 							<p>
// 							This concert will not have assigned seats, Golden Ring, VIP, unfair prices or any other division of class. Anyone who wants to sit is welcome to bring a blanket, and anyone who wants to stand close to the stage is welcome to arrive early, the ticket price is equal to all, and as many people as possible will be able to enjoy this momentous musical event.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:6,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											25-26.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!
// 							</p>

// 							<p>
// 								The famous rock band was founded in 1986 in Boston and released its first EP "Come on Pilgrim" in 1987. A year later, when their first album "Surfer Rose" came out, they became a unique voice in the American Rock. 2 years later, they released their second album "Doolittle" that is considered one of the best rock albums of all times. Their third album "Bossanova" came out in 1990 and included unforgettable songs such as "Hang Wire", "Stormy Weather", and "All Over the World".
// 							</p>
// 							<p>
// 							A year later they released their fourth album "Trompe le Monde" that featured songs such as "Planet of Sound", "Distance Equals Rate Times Time" and many more. They fell apart in 1993 but went back to performing together in 2004. After a decade of touring the world, they released their fifth album "Indie Cindy" which included songs like "Another Toe in The Ocean", "Blue Eyed Hexe", and "Jaime Bravo". To this date they released six albums, the last one, "Head Carrier" came out last year. Their biggest hits include "Hey", "Where Is My Mind", "Monkey Gone to Heaven" and "Here Comes Your Man".
// 							</p>
// 							<p>
// 								The band that is known to influence artists such as PJ Harvey and Kurt Kobain will perform this summer in Tel Aviv, giving only 7000 lucky fans the opportunity to see them live and after the rave reviews of their 2014 performance, it’s shaping up to be an unmissable night!
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:7,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Regina Spektor – Back in Israel",
//         smltitle: "Regina Spektor – Back in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											19.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reginaspektor.com">
// 											www.reginaspektor.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								Beloved pianist, songwriter and singer Regina Spektor is coming back to Tel Aviv for the third time, closing the worldwide tour of her recent 2016 album “Remember Us to Life” that has gotten excellent reviews.
// 							</p>

// 							<p>
// 								Regina Spektor, whose past concerts in Israel were sold out in 2007 and 2013, will perform again for one time only in Ra’anana Amphitheater on Saturday, August 19.
// 							</p>
// 							<p>
// 								Grammy and VMA nominee Regina Spektor was born in Russia, where she started her classical music training at the age of six and immigrated shortly after to the New York, where she began writing her own original songs. Her first Album came out in 2001 and a year later she already released her second album, “songs”, but her real success started after her third album, Soviet Kitsch, was out in 2004 and the fans started pouring in.
// 							</p>
// 							<p>
// 								Her international breakthrough came in 2006 with her album “Begin to Hope” that reached gold status and sold more than 500,000 copies (!!!). The album includes the single “Fidelity” that is very popular in Israel and in the rest of the world to this day and was used as part of the soundtrack of TV shows such as “Grey’s Anatomy”. Her success only became stronger when her fifth album “Far” and her sixth album “What We Saw From The Cheap Seats” got to the third place in Billboard's album chart.
// 							</p>

// 							<p>
// 								In 2013 Spektor created the theme song of the successful Netflix series “Orange Is the New Black”, called “You’ve Got Time” that also became a radio hit and got her her first Grammy Award nomination. The following year, she sang “Love Me or Leave Me” for the HBO historical crime series “Boardwalk Empire”.
// 							</p>
// 							<p>
// 								Regina Spektor is coming to the non-stop city of Tel Aviv after her sold-out tour in the United States and her old and new fans can’t wait for her show, guaranteed to light up the beautiful summer night of Tel Aviv with it’s amazing infectious energy.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:8,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Nick Cave & The Bad Seeds",
//         smltitle: "Rock legend Nick Cave & The Bad Seeds returning to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											19-20.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.nick-cave.com">
// 											www.nick-cave.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								19 years after his last performance in Tel Aviv, the prince of darkness returns once again with his band The Bad Seeds for two shows only to the joy of his fans in what are set to be intimate and unique performances.
// 							</p>

// 							<p>
// 								Australian musician, singer-songwriter, author, screenwriter, composer and film actor Nick Cave is well known as rock musics' "Prince of Darkness" because of his dark, intense tunes. His music is known to be emotionally intense and is characterized by a variety of influences such as death, religion, love and violence. He was called by NME "the grand lord of gothic lushness".
// 							</p>

// 							<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans.
// 							</p>
// 							<p>
// 								Cave started his musical path in the 1970's when he formed "the Boys Next Door" which became a huge success in Melbourne's post-punk scene. Their name was changed to "the Birthday Party" and the band's sound and shows took a rather violent direction and they became known as one of the darkest groups of the 1980's, they fell apart in 1983
// 							</p>
// 							<p>
// 								The end of the Birthday Party was the beginning of Nick Cave and the Bad Seeds in 1983 and they released their debut album the following year. In 1996 the band released its album "Murder Ballads" which featured "Where the Wild Roses Grow", a duet with Kylie Minogue that is also Cave's biggest commercial success to date.
// 							</p>
// 							<p>
// 								Many artists have covered Cave's songs over the years, including Metallica, Johnny Cash, and even the Arctic Monkeys.
// 							</p>

// 							<p>
// 								Nick Cave & The Bad Seeds will perform at the Menora Arena in Tel Aviv on November 19 and an additional date has been added on November 20 due to high demand. For the mere 7,000 fans who will get the chance to look the legendary Nick Cave in the eyes, this is guaranteed to be an unforgettable show!
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:9,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Justin Bieber",
//         smltitle: "Justin Bieber, is landing in Tel Aviv for a single breathtaking concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											03.05.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.justinbiebermusic.com">
// 											www.justinbiebermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/9/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The artist with the most followers on Twitter 90,149,014
// 								The artist with the most watched official music channel online 13,518,849,954
// 								The artist with the most mentions on Youtube music channel
// 							</p>

// 							<p>
// 							Justin Bieber, the biggest international star of our day, arrives in Israel for just one concert as part of the PURPOSE WORLD TOUR, a tour bearing the name of his last album, which has sold 640,000 copies in just a week and became his bestselling album.
// 							</p>
// 							<p>
// 								Bieber, born in Ontario, Canada, learned to play piano, guitar and drums as a child. At the age of 13, with the help of his mother, he began posting videos on YouTube where he sang covers to artists such as Asher, Stevie Wonder, Chris Brown and others.
// 							</p>

// 							<p>
// 								Scooter Browne, a former marketing director at “So So Def”, was the first to spot Bieber’s talent and invited him and his mother to recordings in Atlanta.
// 							</p>

// 							<p>
// 								In 2008, Bieber was signed by Universal Records, and in 2009, "My World", the first mini-album by Bieber, including "One Time Lonely", "Love Me" and "Favorite Girl" topped the Canadian Billboard charts and the top 40 Billboard Hot 100 hits
// 							</p>
// 							<p>
// 								In 2010, he released his second album, "My World 2.0" with the single "Baby", which became a huge hit and was accompanied by the most watched YouTube video by November 24, 2012.
// 							</p>
// 							<p>
// 								In October 2015, Bieber released the second single from the album "Sorry". The dance clip for the song accumulated over 10 million views in the first 24 hours since its release.
// 							</p>

// 							<p>
// 								In November 2015 he released his fourth album "Purpose", which sold 640,000 copies in the first week and became Bieber’s best-selling album with hits such as "Love Yourself." That same month Bieber made history by placing 17 songs on the American charts and breaking the record held by the Beatles since 1964.
// 							</p>

// 							<p>
// 								In December 2015, Bieber and Skrillex won the Grammy Award for "Where are You Now".
// 							</p>

// 							<p>
// 								Justin Bieber will be performing in Israel on May 3 at Hayarkon Park, with his latest hits "love yourself" and "Sorry" and with the hits "Baby" and "As long as you love me".
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:10,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "AEROSMITH \n \"AERO-VEDERCI BABY\" ",
//         smltitle: " Aerosmith launching its tour in the rocking city of Tel Aviv  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.aerosmith.com">
// 											www.aerosmith.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Aerosmith’s farewell concerts began several months ago in South America and will continue in 2017 in the United States and Europe. the European leg of the tour will begin in Tel Aviv and the band will go on to perform in Georgia, Russia, Germany, Poland, Denmark, Ireland, Italy, Portugal and Spain, including appearances in some of the world's leading rock festivals.
// 							</p>
// 							<p>
// 								For over 45 years, Aerosmith has been the quintessential Rock & Roll band, becoming one of the most influential and loved groups in the world. An endless list of amazing songs, many of them becoming massive worldwide hits, and their groundbreaking live shows have gained the band mass appeal for nearly half a century. Rock & Roll Hall of Fame inductees, Aerosmith, have sold over 100 million albums and won countless awards (including four Grammy Awards, eight American Music Awards, six Billboard Awards, and 12 MTV Awards).
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/2.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								<strong>Steven Tyler</strong> – "Aerosmith just got done ripping through South America like true ambassadors of rock...The band is unstoppable right now and in Europe, we're going to keep doing what we do best... Let The Music Do The Talking...Living On The Edge, and living to rock another day."
// 							</p>

// 							<p>
// 								<strong>Joe Perry </strong> – “It’s been 3 years since we have been on tour in Europe and I can speak for my brothers that we can’t wait to get over there and take it up a few notches. Last tour in South America we were running on all cylinders and I can see no reason to let up now." ;
// 							</p>

// 							<p>
// 							This May, the city of Tel Aviv will be hosting Steven Tyler, Joe Perry, Joey Kramer, Tom Hamilton and Brad Whitford in the beautiful Ganei Yehoshua Park for what promises to be an unforgettable experience and the concert of a lifetime.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:11,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Frankie Valli & The Four Seasons  ",
//         smltitle: " An American Legend in the heart of Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											4.007.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.frankievallifourseasons.com/">
// 											www.frankievallifourseasons.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/11/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The American legend comes to the rocking city of Tel Aviv for the first time ever for an unforgettable 4th of July celebration with the best timeless classics!
// 							</p>
// 							<p>
// 								The original Jersey boy, musical legend Frankie Valli, comes Tel Aviv for the first time for one single performance. Back in the 50’s, Valli started singing in harmonies with different bands in New Jersey, but the success only struck him when he grabbed the microphone in the early 60’s as the lead singer for The Four Seasons that rocked the music world in the next decades with major hits such as “Big Girls Don’t Cry”, “Sherry”, “Walk Like a Man” and more. Valli scored 29 Top 40 hits with The Four Seasons and nine Top 40 hits as a solo artist. The band sold more than 175 million albums and Valli, Tommy DeVito, Nick Massi and Bob Gaudio – the original members of The Four Seasons – were inducted into the Rock and Roll Hall of Fame in 1990 and the Vocal Group Hall of Fame in 1999.
// 							</p>

// 							<p>
// 								At the same time, Valli also has a successful solo career with songs such as the theme song for Grease, and “Can’t Take My Eyes Off You” that was covered by hundreds of artists, from The Pet Shop Boys to Muse. Younger generations got to know Valli from the remarkable musical “Jersey Boys” that tell the story of the band that is responsible for songs that became a part of our life’s soundtrack for over four decades and was turned into a movie which was directed by Clint Eastwood.
// 							</p>

// 							<p>
// 								Ever since he began, Frankie has been performing all over the world, and soon the magic will come to Tel Aviv for one unforgettable show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:12,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Unite With Tomorrowland",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											29.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tomorrowland.com/en/unite-israel/en/welcome">
// 											www.tomorrowland.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/12/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous Tomorrowland festival might take place in Belgium, but Tel Aviv is also up for the party! Unite with Tomorrowland brings the party to the hottest city in the Middle East with live connection from the Tomorrowland Mainstage, live local and international DJ’s on the UNITE stage and of course – the magical Tomorrowland atmosphere.
// 							</p>
// 							<p>
// 								The live connection with the Mainstage in Belgium will give the People of Tomorrow the chance to connect with the crowd in Israel and vice versa. 3 mainstage headliners will be broadcasted live on a unique UNITE with Tomorrowland stage and special effects will be synchronized with the show in Belgium, creating a special global connection.
// 							</p>

// 							<p>
// 								The main headliners in Belgium will be Armin Van Buuren who has won best trance DJ at the DJ Awards 9 years in a row, was ranked among the world’s top 4 DJ’s at DJ Magazine 13 years in a row, the known electro-house duo Dimitri Vegas & Like Mike and the house sensation KSHMR. On the UNITE stage in Israel the DJs will be Steve Angello who won the DJ award for best house in 2010, the Israeli trance artist Alien Project, DJ Tomer Maizner, Dor Dekel, Teamworx, and TRIPL.
// 							</p>

// 							<p>
// 								EUnite with Tomorrowland isn’t just a livestream, it’s a one of a kind show that allows you to escape reality and join the magical world of tomorrow.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:13,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Chainsmokers",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											NEAR Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											3.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thechainsmokers.com/">
// 											www.thechainsmokers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/13/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Tel Aviv is known for its great dance scene, so it makes perfect sense that the hottest DJ/production duo that everyone is talking about to come to get the city on its feet! The duo is responsible for many current hits such as “Don’t let me go”, “Roses”, and their recent collaboration with Coldplay “Something Just Like This”, and they will perform in Israel as part of their international tour “Memories Do Not Open”.
// 							</p>
// 							<p>
// 								The Chainsmokers consists of Andrew Taggart and Alex Pall. The duo performed live for the first time as the opening for Timeflies in 2014, and their single "#Selfie" was re-released at the same year, leading to breakthrough success as "#Selfie" became a worldwide hit and peaked on the Dance/Electronic chart. In 2015 they released their first EP “Bouquet”, featuring “New York City”, “Until You Were Gone, “Good Intentions” and “Roses”, all of which climbed the international charts and became major hits.
// 							</p>

// 							<p>
// 								A year later, the duo released their singles “Don’t Let Me Down” featuring Daya, “Inside Out”, featuring Charlee, and “Closer” featuring Halsey. The latter peaked at number one in the United Kingdom and the United States. Their success didn’t stop there and after releasing “All We Know” featuring Phoebe Ryan, they were ranked 18th in DJ Magazine’s annual list of “Top 100 DJ’s” in 2016. The same year the duo won favorite electronic/dance music artist at the American Music Awards and top dance/electronic artist at the Billboard Music Awards. A year later “Closer” also won top hot 100 songs, top collaboration and top electronic/dance song at the same Awards ceremony.  “Don’t Let Me Down” also won best dance recording in 2017 at the Grammy awards.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:14,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Dire Straits Experience",
//         smltitle: "Get a shiver in the dark in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											14.09.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.direstraitsexperience.com/">
// 											www.direstraitsexperience.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/14/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								25 years have passed since Dire Straits disbanded and we last heard that unmistakable sound of Mark Knopfler’s guitar…
// 							</p>
// 							<p>
// 								Close your eyes and get transported back to an original Dire Straits gig. Beautiful inspiring tracks, quality sound, amazing atmosphere, spine tingling riffs, vocals, instrumentals and an outstanding performance.
// 							</p>

// 							<p>
// 								After selling over 25,000 tickets in Israel within the past three years, and in light of the high demand for yet another show, The Dire Straits Experience are coming to Tel Aviv for only one night.  A single performance on the 14th of September at the Menora Mivtachim Arena.
// 							</p>

// 							<p>
// 							   The Dire Straits Experience was founded by saxophonist Chris White after their successful debut playing for a charity event at the Royal Albert Hall where members of the legendary band got back together on stage. News travelled fast, and an increasing global demand to hear the most dramatic songs in rock history played live eventually led to a worldwide tour.
// 							</p>

// 							<p>
// 							    Chris White, who recorded and performed with the rock legends for over a decade, joined Dire Straits for their record breaking “Brothers in Arms” world tour in 1985. This included their famous performance at Live Aid and later the renowned Nelson Mandela 70th birthday concert. White has played with some of the greatest rock stars the world has known, such as Paul Mccartney, Joe Cocker, Mick Jagger, Robbie Williams and many others. Joining Chris White is a stellar band consisting of some of the finest professional musicians the UK has to offer.
// 							</p>

// 							<p>
// 							   “When I was first approached to put together a band to play Dire Straits songs, I didn’t believe it would be possible to find someone who would be able to stand in Mark’s shoes without sounding like an imposter. I was wrong. In Terence Reis, I think we may have found the only person on the planet that is able to play and sing like Mark but maintain his own integrity and identity.”
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:15,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alan Parsons",
//         smltitle: "The man that said no to Pink Floyd, live in TA",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											11.11.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.alanparsonsmusic.com/">
// 											 www.alanparsonsmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/15/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The musical legend Alan Parsons and his band are coming to Israel for two shows, the first at the Congress Centre in Haifa and the second at the Menorah Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 								Parsons has a large following in Israel. In fact, this will be his third visit to the country in order to play on stage. This time they’ll be performing their new “I Robot” tour, commemorating 40 years for the release of the similarly titled mythological album in 1977. You can expect to hear all of their greatest hits of course.
// 							</p>

// 							<p>
// 								Alan Parsons is a renowned musician and one of the most influential musical producers in history. He started out as a sound technician working in the notorious Abbey Road recording studio. Alan became famous after helping to produce Pink Floyd’s masterpiece album “Dark Side of the Moon”. He has worked as a sound technician with others such as The Beatles, Wings, Al Stewart and many more.
// 							</p>

// 							<p>
// 							   In 1975, Pink Floyd invited him to work on their next album “Wish You Were Here”. Alan declined the offer in order to form his progressive rock band “The Alan Parsons Project”. The band succeeded immediately, receiving international acclaim for their huge hits “Eye in the Sky”, “Time” and “Old and Wise” to name a few.
// 							</p>

// 							<p>
// 							   An accomplished vocalist, keyboardist, bassist, guitarist and flautist receiving gold and platinum awards from many nations, Parsons also has ten Grammy Award nominations for engineering and production. Up until today The Alan Parsons Project is one of the most popular events in Europe, with tickets being sold out within hours.
// 							</p>

// 							<p>
// 							   Come indulge your ears and listen firsthand to some of the classics of our time. You can catch the concerts either in Haifa on the 9th of November or in Tel Aviv on the 11th of November.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:16,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Bryan Adams",
//         smltitle: "Bryan Adams to warm our winter with 3 shows",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv & Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											4+5+6.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bryanadams.co.il/">
// 											 www.bryanadams.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/16/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								With the summer days way behind us and the days getting shorter, a little winter comfort is necessary. What better way to warm up from the inside than with some romantic ballads and timeless rock anthems. Treat yourself (and someone you love) to a throwback of nostalgia from our younger days, reminding us those sweet moments of slow dancing, first crushes and innocent youth.
// 							</p>
// 							<p>
// 								The Canadian pop rock icon with hits spanning over four decades is coming to Israel for three consecutive shows! Two will performances in Tel Aviv on the 4th and 5th of December at the Menora Mivtachim Arena and one more concert in Jerusalem on the 6th of December at the Pais Arena.
// 							</p>

// 							<p>
// 								Born in 1959 in Kingston, Ontario, Bryan Adams’ music career took off in the early 80’s with the release of his third album “Cuts Like A Knife” which included the hit “Straight From The Heart”. It was his following album “Reckless” that skyrocketed his career and brought his rise to stardom with the hits “Run To You”, “Heaven” and “Summer of ‘69”. Following these hits Adams later brought us the U.S. Billboard Hot 100 number-one singles "Heaven", "All for Love" and "Have You Ever Really Loved a Woman?".
// 							</p>

// 							<p>
// 							  Besides topping the charts in North America and Europe, his songs were nominated for several Grammy, Golden Globe and Academy Awards. His records have collectively sold over 100 million copies worldwide, making him one of the best-selling music artists of all time.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   Make sure you don’t miss this time-defying legend.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {
//         id:17,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Chris Rock",
//         smltitle: "Coming to Tel Aviv to rock your world ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											8+9.01.18
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.chrisrock.com/">
// 											 www.chrisrock.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/17/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Chris Rock, one of the greatest standup comedians of all time and the funniest people in the world is going on a rare, highly awaited tour for the first time in 9 years. One of his few stops will be in Tel Aviv.
// 							</p>
// 							<p>
// 								The hilarious comedian has put on a new live act, after nearly a decade of focusing on television and film. Chris Rock will make his first ever live on stage appearance in Israel as part of his 2017 “Total Blackout” tour.
// 							</p>

// 							<p>
// 								Born in 1965, he made his breakthrough on SNL (Saturday Night Live) starring next to Adam Sandler, David Spade and Chris Farley. Eddie Murphy helped accelerate his stardom by giving him a role in Beverly Hills Cop 2. Since then it’s been a long line of success, from Lethal Weapon 4, Madagascar, Scary Movie, Nurse Betty and the list goes on. He’s hosted the Academy Awards twice and has also written, directed and produced several movies and TV shows. Despite all this, Chris Rock has and always will shine brightest where he truly belongs, on stage with a microphone.
// 							</p>

// 							<p>
// 							  His previous standup acts: Bigger and Blacker, Born Suspect, Bring the Pain and Kill the Messenger all broke records and are considered to be classics, with bits that are still quoted today.
//                               Rock is often compared to the greatest comedians in the field, alongside Jerry Seinfeld, Louis CK and Dave Chappelle (all of which he’s also collaborated with).

// 							</p>

// 							<p>
// 							   He made it to the top 5 in Rolling Stone magazine’s 50 greatest comedians of all time.
// 							</p>

// 							<p>
// 							   When he gets on stage it’s like seeing a boxer, a preacher and a poet all bundled together into one man. Chris delivers powerful, fast paced, side-splitting punches. His views on relationships, race and politics challenge his listeners and make them rethink everything they know. Rock dares to cross boundaries with his material and is not afraid to shock and surprise.
// 							</p>

// 							<p>
// 							   In an interview he recently gave to Rolling Stone magazine, he talked about his divorce after 18 years of marriage and how he decided to devote himself to standup again. According to him, these events gave rise to the world tour in which he will be performing in Tel Aviv.
// 							</p>

// 							<p>
// 							   Catch Chris live on January 8th at the Menorah Mivtachim Arena.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:18,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Patricia Kaas",
//         smltitle: "The great French singer returns to the white city once again",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.patriciakaas.net/">
// 											  www.patriciakaas.net
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/18/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous French singer and actress Patricia Kaas is coming back to Tel Aviv for the third time after her previous performance three years ago became a huge success and recieved incredible reviews. Kaas is considered one of the all-time most successful French singers and her music is a mix of pop, cabaret, jazz, and chanson. She started her career in the late 80’s and very quickly she climbed the charts in France.
// 							</p>
// 							<p>
// 								Kaas’s first single “Mademoiselle chante le blues” that came out in 1987 became a huge hit and got to the top 10 in the French chart. A year later she released her second single “D’Allemagne”, followed by her first album “Mademoiselle chante…” that was ranked number two at the French chart. The album sold over 100,000 copies within less than two months and became a gold album. It didn’t take long and within less than three months more than 350,000 copies were sold and it became a platinum album. Kaas received a platinum album status in Belgium, Switzerland and Canada as well, and at the same year she won the most important French music award – Victories de la Musique.
// 							</p>

// 							<p>
// 								Since then the French phenomenon sold more than 17 million albums worldwide. Her third album “Je te dis vous” brought her major success in Germany, Belgium, Switzerland, Canada, Russia, Finland, Ukraine and Korea. In 2002 she acted in a movie for the first time, it was “And now… Ladies and Gentlemen” in which she performed with the British actor Jeremy Irons. In 2009 she represented France at the Eurovision contest and got to the 8th place.
// 							</p>

// 							<p>

//                                    Patricia Kaas is responsible for many hits and her songs became a part of our lives. The talented musician is coming back to Tel Aviv to sing her famous repertoire and bring back the nostalgia to the nonstop city.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:19,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blue Man Group",
//         smltitle: "The phenomenal musical group is returning to Tel Aviv once again for a show like no other!  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											 7-23.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.blueman.com/">
// 											  www.blueman.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/19/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Blue Man Group is coming to Tel Aviv as a part of their 25 years of living in full-color tour! This is a show unlike anything you have ever seen before that combines music, theater, art and technology.
// 							</p>
// 							<p>
// 								Originally Formed in New York in 1988 by three close friends, Chris Wink, Matt Goldman and Phil Stanton, Blue Man Group originated as a celebration of the end of the 1980s. The three men wore blue masks and led a procession that included the burning of a Rambo doll and a piece of the Berlin Wall. They caught the eye of an MTV reporter and gained attention. They started with small acts on the streets of New York, growing into shows at downtown clubs, eventually becoming a full performance at the Astor Place Theatre in 1991.
// 							</p>

// 							<p>
// 								In 1999 the band released its first gold album “Audio” and it was nominated for the Grammy Award for Best Pop Instrumental Performance. Their second album, “The Complex” (2003), features collaborations with various musicians like Gavin Rossdale, Dave Matthews and many others. It charted four songs on the Billboard charts. In 2006 they released “Live at The Venetian – Las Vegas” which was an iTunes exclusive, and their most recent album, “THREE”, came out in 2016 and was also nominated for the Grammy Award.
// 							</p>

// 							<p>

//                                  Currently, the Blue Man Group is performing on a regular basis in five theaters around the world- in Vegas, New York, Boston, Orlando and Berlin. They recently launched their new book “Blue Man World” that tells the story of the blue man from their perspective.  Three blue people that will take you on a crazy adventure full of music, laughter and surprises. More than 35 million people worldwide have already seen them, not it’s your turn!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:20,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Sean Paul",
//         smltitle: "The international mega star is coming to make our summer sizzle!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv Outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											22.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.allseanpaul.com/">
// 											  www.allseanpaul.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/20/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Grammy winner dancehall artist, Sean Paul will return to Tel Aviv for a single hot hot hot hot performance.
// 							</p>
// 							<p>
// 								Sean Paul will arrive in Tel Aviv for the third time as part of his new international tour. The artist is currently storming the international charts with a string of hits that including collaborations with some of the most popular names in music including Sia, Anne-Marie and more.
// 							</p>
// 							<p>
// 							    His extraordinary voice, rhythms, catchy songs and super-polished productions all combine the winning recipe of the Grammy winner and international star - Sean Paul. Originally known as Sean Paul Ryan Francis Henriques, Sean Paul was born in Jamaica in 1973. His musical career soared in 2002 with the tremendous success of his second studio album, "Dutty Rock," mainly for the songs "Gimmie The Light" and "Get Busy" Hot 100 chart toppers). Sean Paul has managed to maintain his relevance in the music industry since breaking into fame in the year 2000 until now with a string hits such as Cheap Thrills, Rockabye, No Lie, and Body.
// 							</p>

// 							<p>
// 							   Sean Paul studied at the University of Technology in Jamaica with aspirations for a career in the hotel industry, but his passion for music took over. The single ‘Baby Girl’ was the first to mark his successful career as a recording artist and led to his debut album ‘Stage One’ at VP Records. To date, he has released six studio albums; the last five were all nominated for the Grammy Award.
// 							</p>
// 							<p>
// 							   The album "Dutty Rock," 2002, earned him the Grammy Best Reggae Album. "The Trinity," 2005, reached platinum status in Europe and the Recording Industry Association in the United States. His albums, "Imperial Blaze" in 2009 "Tomahawk Technique" in 2012, and the last one was released in 2014 - "Recent Full Frequency" – were all warmly received and highly acclaimed.
// 							</p>

// 							<p>

//                                   His hard work, perseverance, and dedication over the years have earned him several nominations for the Grammy and Billboard awards. His most notable accomplishments include An American Music Award, Mobo Awards, Soul Train Awards, MTV Music Awards, ASCAP Rhythm and Soul Music Awards, a Source Award and a BET Award.

// 							</p>

// 							<p>
//                                 Sean Paul maintains a multinational presence thanks to his collaborations with artists in a wide variety of genres such as EDM, Soca, Pop, Afro-Beat and Latin music. His icon status allows him to maintain an immense fan base in Latin America, Japan, Europe and the US and his relationship with the Spanish audience received a serious boost, following his collaboration with the singer Farruko in the single Passion Whine and of course the legendary collaboration with Enrico Iglesias ‘Bailando’ which became no.1 in 33 (!) countries and gained millions of views on YouTube.
// 							</p>

// 							<p>
//                                Sean's collaborations throughout his career include numerous international collaborations with hip-hop stars such as Busta Rhymes, Beyoncé, Rihanna, Keyshia Cole, Kelly Rowland, Juicy J, 2Chainz and Nicki Minaj.
// 							</p>

// 							<p>
//                                Sean Paul performs regularly on the biggest most respectable venues in the world and enjoys a huge following from a worldwide audience of all ages.
// 							</p>

// 							<p>
//                                His last performance in Tel Aviv received fantastic revues from critics and fans alike, and he is back on popular demand, promising to make the hot summer scorch even more with a what is guaranteed to be a party like no other!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:21,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "The Pretenders",
//         smltitle: "The legendary rock band and Chrissie Hynde are coming to rock out Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											23.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thepretenders.com/">
// 											  www.thepretenders.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/21/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								For the past three decades Chrissie Hynde and The Pretenders stayed at the top of the British rock and won the hearts of millions of fans. Hynde took a long break from writing and recording new materials but after the raving reviews the band’s most recent album, “Alone” got, she and The Pretenders are back on a world tour and are now coming for one unforgettable show in Tel Aviv!
// 							</p>
// 							<p>
// 								The band started its way in the music world in England in 1978 and experienced numerous subsequent personnel changes, with Chrissie Hynde being the only consistent member. The original band was active until 1982 and released its first album (Pretenders) that was a success in the United Kingdom and the United States both critically and commercially. The band got to No. 1 in the UK with its single "Brass in Pocket", which was also successful in the US, reaching No. 14 on the Billboard Hot 100.
// 							</p>

// 							<p>
// 								Later on the band released nine more albums - Pretenders II (1981), Learning to Crawl (1984), Get Close (1986), Packed! (1990), Last of the Independents (1994) which was rated gold in the US, Viva el Amor (1999), Loose Screw (2002), Break Up the Concrete (2008) which was among the Top 40 album in the US, and The Pretenders’ most recent album - Alone (2016). During March 2005, the Pretenders were inducted into the Rock and Roll Hall of Fame. Among their most famous song one can remember “Brass in pocket”, “Hymn to her”, “Don’t get me wrong”, “I’ll stand by you”, and many others.
// 							</p>

// 							<p>

//                                   The Pretenders worked carefully on their new show and started their new tour at the Royal Albert Hall in London, which was full with fans that showed how much they missed the incredible band. Hynde and The Pretenders performed in music festivals all over the world, and they’ll start the second part of their tour right here in the rocking city of Tel Aviv, make sure not to miss it!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:22,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Cliff Richard",
//         smltitle: "The incomparable Cliff Richard coming back to Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											10.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.cliffrichard.org/">
// 											  www.cliffrichard.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/22/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Cliff Richard, the beloved British artist who previously performed in the fabulous city of Tel Aviv more than 20 years back, is coming back to the delight of his local fans.
// 							</p>
// 							<p>
// 								Over his long and illustrious career, the 72-year-old Cliff Richard has sold more than 260 million records worldwide and is best known for his tunes "Fallen angel Woman," "We Don't Talk Anymore," "The Young Ones," "Summer Holiday," and "Congrats" .
// 							</p>

// 							<p>
// 								Richard has a long list of hits and is responsible for many worldwide beloved songs. He has sold over 21 million singles in the UK and has become an intrinsic part of the nation’s soundtrack.
// 							</p>

// 							<p>

//                                  Richard has had eight US Top 40 singles, including the million-offering "Demon Woman" and "We Don't Talk Anymore". In Canada, Richard made a real splash during the mid-1960s, and again in the late 1970s and mid-1980s with a few singles and collections achieving gold and platinum status. He has remained a prominent music, film, and TV character in Australia, New Zealand, South Africa, Northern Europe and Asia, and has a strong following.

// 							</p>

// 							<p>
// 							   Throughout his career, spanning over 50 years, Richard has amassed numerous gold and platinum records and awards, including three Brit Awards—winning Best British Male Singer twice and the Brit Award for Outstanding Contribution to Music, as well as two Ivor Novello Awards. He has had more than 130 singles, collections and EPs make the UK Top 20, more than any other artist.
// 							</p>

// 							<p>
// 							   Richard has had 67 UK top ten singles, including one written for the great Elvis Presley.  He has had 14 UK No. 1 singles and is the leading vocalist to have had a No. 1 single in the UK in five back to back decades: the 1950s through to the 1990s.
// 							</p>

// 							<p>
// 							   This October, after much anticipation, Cliff Richard is coming to Tel Aviv to sing his mind-blowing songs live, in his unmatchable performing style. Come watch the living legend himself on-stage in the exciting city of Tel Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:23,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "DGTL Festival",
//         smltitle: "An awesome digital celebration in the one of the world’s Digital Capitals",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											05.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/?skip_portal=1">
// 											  www.tlv-digital.nl
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/23/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The first ever of its kind in the country, the DGTL festival is a dream come true for the music and nightlife scene of this buzzing metropolis. The DGTL festival is set to be by far the biggest electronic music event held in Tel Aviv, which is considered one of the nightlife capitals of the world.
// 							</p>
// 							<p>
// 								DGTL Festival, making its Tel Aviv debut this October originates in Holland and takes place each year in the most trendy capitals including Amsterdam, Sau Paulo, and Barcelona.
// 							</p>

// 							<p>
// 								The festival is an innovative technology centered event showcasing some of the world’s greatest biggest names in the digital scene alongside new hot up and comers from the industry. Tickets are often sold out in advance, and dozens of DJs and leading artists show off their talents in this a multi-sensory experience of art, music, lighting and uncompromising production standards throughout the:
// 							</p>

// 							<p>

//                                The festival has a unique and electrifying atmosphere, and audiences will also get to enjoy a variety of food stalls, art, and meticulous sound.

// 							</p>

// 							<p>
// 							   The festival will include three stages featuring excellent music at any given moment.
// 							</p>

// 							<p>
// 							   The fantastic international line up is set to include:
// 							</p>

// 							<p>
// 							  Maslow Flux, Marcel Dettman, John Talabot, Red Access, Jennifer Cardini, Avalon Emerson, Young Marko, Yotam Avni, Otarki, Joba Jobsa and many others.
// 							</p>

// 							<p>
// 							  This huge production will be launched for the first time in October 2017. In addition to being an innovative music festival, DGTL is held under the theme of environmental preservation and sustainability and is considered the greenest festival in Europe. Also, DGTL festival promotes vegetarian food only and develops a unique program for recycling materials. Alongside the local audience, the festival will be marketed in 50 countries, and thousands of music fans from all over the world are expected to arrive in Tel Aviv to take part in the party.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:24,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Richard Clayderman",
//         smltitle: "The famous pianist returns to perform in Israel with all his unforgettable hits!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											17.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.clayderman.co.uk/">
// 											  www.clayderman.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/24/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Romance lovers, prepare yourselves – after his last show in Israel three years ago, the famous French pianist Richard Clayderman returns to the holy land as a part of his new tour that marks 40 years of an outstanding career!
// 							</p>
// 							<p>
// 								Clayderman recently turned 63 and he is one of the world’s most successful pianists with a rich and diverse career that started four decades ago. He recorded over 1200 songs and his biggest hit ever is “Ballade Pour Adeline” that was sold in 22 million copies in 38 different countries. Clayderman is considered one of the world’s most successful instrumental artists along with others like Kenny G and more.
// 							</p>

// 							<p>
// 								During his career, Richard Clayderman sold more than 85 million albums and had more than 340 gold and platinum albums. He created a new romantic style through a repertoire that combines his original melodies with classics and pop standards. The phenomenal artist devoted much of his time to performing, going as far as playing 200 shows in 250 days. The Guinness Book of World Records noted him as “the most successful pianist in the world”.
// 							</p>

// 							<p>

//                                His previous visits in Israel were extremely successful with multiple sold out concerts. In his upcoming shows in Israel, Clayderman will play a selection of his best pieces, including the 12 minutes of the “Titanic Symphony”, “Don’t Cry for Me Argentina”, “Love Story”, “Ballade Pour Adeline”, and song from other famous movies such as “West Side Story”, “Harry Potter Melody” and “The Schindler List”. Come listen to the outstanding pianist who has touched the heart of millions around the world!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:25,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Smokie",
//         smltitle: "Smokie, coming to light up the stage this fall in Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv + Jerusalim
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28+31.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//smokie.co.uk/Band">
// 											  www.smokie.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/25/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Smokie, the iconic British rock band is coming back to Tel Aviv to rock it out in the city this fall.
// 							</p>
// 							<p>
// 								Smokie initially rose to fame in the 1970's and is most know for its chart topping hits 'Living Next Door to Alice', 'Lay Back in the Arms of Someone', and "If You Think You Know How to Love Me.'
// 							</p>

// 							<p>
// 								The band has had 13 top twenty hits during the 1970s and has sold more than 30 million albums.
// 							</p>

// 							<p>

//                               Initially formed in Yorkshire, England, in 1966, Smokie hit the British pop charts a few times amid the late '70s with a fresh pop style.  The quartet recorded many singles amid the late '60s and mid '70s, and in 1975 hit number three in the U.K. with "If You Think You Know How to Love Me."

// 							</p>

// 							<p>
// 							   After another Top Ten hit, "Don't Play Your Rock’n’ Roll to Me,” the band made it big with three Top 20 hits, including "Living Next Door to Alice." Smokie hit number five both in 1977 ("It's Your Life") and 1978 ("Oh Carol(".
// 							</p>

// 							<p>
// 							   The band has performed in Tel Aviv several times and are returning shortly after their last visit to the non stop city with an extremely successful run two years ago. The Tel Aviv concert will be a part of the band’s new tour which includes England and many countries around Europe and which also includes musicians Martin Bullard, Mick McConnell, Mike Craft, Steve Pinnell and Terry Uttley.
// 							</p>

// 							<p>

// 							    Smokie’s songs have gained iconic status over the years and have been covered multiple times due to their catchy style. The band enjoys a strong fan base in the country and regularly fills every seat in the house in each of their performances. The band will be playing its greatest hits to the joy of their fans which will flock to see the rock legends in action in Tel Aviv.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:26,
//         bgImage :"/posts/bank/15/1.jpg",
//         mobBgImage :"/posts/bank/15/M.jpg",
//         title: "Foreigner",
//         smltitle: "The 80's are back to rock Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											  www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/26/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The 80's are coming back! The British-American hard rock group is returning once again to the amazing city of Tel Aviv. The band is returning to Israel again after 3 sold out concerts in the past – one in 2014 and two in 2016, which got incredible reviews.
// 							</p>
// 							<p>
// 								Foreigner was founded in New York in 1976 by veteran English musician Mick Jones, ex-King Crimson member Ian McDonald and American vocalist Lou Gramm. The band focused more on commercial rock and is remembered mostly for its soft ballads that topped the charts worldwide.
// 							</p>

// 							<p>
// 								The rock group released its debut album in 1977 which provided one of its most popular hits "Cold As Ice", but the band's real breakthrough happened in the early 1980's when they released the album "4". Their success continued as they released their next album "Agent Provocateur" in 1984, as well as in their last one- "Can't Slow Down", in 2009.
// 							</p>

// 							<p>

//                               The band has sold over 80 million records worldwide in the past 3 decades, out of them 37.5 were sold in the United States alone, making it one of the bestselling bands in the history. Their most memorable hits include "Waiting for a Girl Like You", "I Want to Know What Love Is", "Urgent", "Juke Box Hero", and "That Was Yesterday".

// 							</p>

// 							<p>
// 							  Come rock with the American-British legend and bring the 80's back to life in a one of a kind concert!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:27,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Carcass",
//         smltitle: "The British metal legends are coming <br>to rock the city that never sleeps!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											09.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/OfficialCarcass/">
// 											  facebook.com/OfficialCarcass
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/27/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The British extreme metal band was formed in 1985. They started as a school band by Bill Steer and Ken Owen, and the latter left the band soon after. Steer then joined the D-beat band Disattack and played with drummer Middie, bassist Paul and the lead singer Andrew Pek. The band later changed its name to Carcass as the members changed their musical direction. The band recorder only one album with Pek, who changed his name to Sanjiv, and shortly after "Flesh Ripping Sonic Torment" was released he left the group.
// 							</p>
// 							<p>
// 								The vocal duties were shared between Walker, Steer and Owen, and together they recorded a debut album in only four days.  The band wasn't pleased with the poor production of their album "Reek of Putrefaction" but it became a favorite of Radio 1 DJ John Peel. His interest in them made them participate in his first "Peel Session", in which they released materials for their second album.
// 							</p>

// 							<p>
// 								Carcass are considered to be the pioneers of the grindcore genre, although their early work is considered to be more splatter death metal, hardgore and goregrind. The band also became one of the pioneers of melodic death metal with their album "Heartwork" which was released in 1993. Their lyrics usually focus on animal rights issues, as both Jeff Walker and Bill Steer are vegetarians.
// 							</p>

// 							<p>

//                               In 2013 the band signed with Nuclear Blast, and in Japan they signed with Trooper Entertainment for the release of their new album. They released "Surgical Steel", which received extremely positive reviews and earned Top 50 position on the US Billboard 200 charts. Soon afterward they headlined Damnation Festival in Leeds and then performed at 70000 Tons of Metal in 2014 and headlined the Agglutination Festival the same year.

// 							</p>
// 							<p>
// 							   The band is coming to give only one show in the nonstop city of Tel Aviv, which is guaranteed to be an extraordinary experience for all the metal fans out there, make sure to get your ticket now!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:28,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Kygo",
//         smltitle: "The Norwegian house phenomena for the first time ever in Tal Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.kygomusic.com/">
// 											  www.kygomusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/28/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Kygo, originally a Norwegian pianist, became a tropical house music producer in no time. "Spotify" announced him as the biggest discovery of 2015 after his songs "Firestone" and "Stole the Show" were played over a billion times. Both of these songs also received gold and platinum status in 16 countries.
// 							</p>
// 							<p>
// 								His first album, "Cloud Nine", reached the top of the dance albums chart on "Itunes" and also on the electronic albums chart of Nielsen Soundscan. The house sensation preformed in the most popular TV shows in the United States such as "The Late Late Show" with James Corden, "The Tonight Show", "Good Morning America" with Jimmy Fallon and on Ellen Degeneres. Moreover, he was on the cover of the biggest magazines – "The Billboard", "Haute Living Magazine", "LA Times", "USA Today", "The Wall Street Journal", "The Rolling Stones", "Forbes" and more.
// 							</p>

// 							<p>
// 								Kygo started his musical journey at the age of 6 when he started learning how to play the piano. It took almost a decade for the classical music to step aside and for the new love in his life to take over – Electronic music. He only decided that he wants a career in the music industry a moment before he was about to graduate from his economics and business degree.
// 							</p>

// 							<p>

//                               His first significant breakthrough was with the hit "Firestone" that shortly grabbed the attention of tens of millions of listeners. Aviici played it in his sets and in festivals. Afterwards Coldplay's lead singer, Chris Martin, gave him permission to create a remix of their song "Midnight". Kygo's unique sound led him to incredible achievements, such as the hit "ID" that was featured in Ultra Festival's official trailer and in the playlist of FIFA 2016.

// 							</p>
// 							<p>
// 							  The extraordinary house sensation is coming to rock Tel Aviv for the first time ever, for one show only. His shows in New York and Hollywood were sold out, and the reviews were incredible. This is guaranteed to be a night to remember, you definitely want to be there!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:29,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Led Zeppelin 2",
//         smltitle: "Don’t Miss the Zeps in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv, Haifa and Be'er Sheva
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											07-10.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//zep2.com/">
// 											  www.zep2.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/29/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The tribute band from Chicago Led Zeppelin 2, which was named after the mythological band's second album, is coming to Israel for 4 shows only. Come feel the old Led Zeppelin vibes and kick it with the ultimate Led Zeppelin experience here in rocking Tel Aviv
// 							</p>
// 							<p>
// 								Led Zeppelin 2 have been performing  for over a decade and are considered to be the ultimate Led Zeppelin experience. The band consists of 4 musicians from the indie-rock, jazz and metal scene in Chicago. The lead singer, Bruce Lamont, who took the place of the legendary Robert Plant, is also a part of the avant-garde metal group "Yakuza", and he has collaborated with bands like "Dyslexic Apaches", and "Circle of Animals". His solo album "Feral Songs for The Epic Decline" was recently rated among SPIN magazine's top 20 metal albums.
// 							</p>

// 							<p>
// 								Greg Fundis, the group's drummer, is playing with leading musicians among which one can find the singer and jazz guitarist George Benson, the musician Joey De Francesco, the saxophonist Joe Lovano and more. The bassist Matthew Longbons participates in more than 200 shows a year next to leading international artists such as Alice Cooper and Matt Walker from the "Smashing Pumpkins". Paul Kamp, the group's guitarist, is known mostly from his collaboration with "Busker Soundcheck", a well-known alternative rock band.
// 							</p>

// 							<p>

//                              Led Zeppelin is considered until today to be one of the most revolutionary, influencing and successful bands in the history. They sold more than 300 million albums worldwide, with 'Led Zeppelin IV' alone selling over 37 million copies and being ranked as the third all-time best-selling album in the U.S. All 9 of the band's albums were rated in the top 10 in the U.S. chart, and 6 of them even top over the top 5. Their second album that was recorded during their first tour was a huge success both in the U.S. and in the UK, and it featured the hit 'Whole Lotta Love' that sold over a million copies.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:30,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Oh Wonder",
//         smltitle: "Live in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											16.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ohwondermusic.com/">
// 											  www.ohwondermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/30/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Oh Wonder consist of Josephine Vander Gucht and Anthony West. In 2014 they started releasing singles every month and then they combined all of them and released a debut album that's named after them and sold over 500 million copies. This year they released their second album, "Ultralife", which had even a bigger success and reached the Top 10 in the UK charts.
// 							</p>
// 							<p>
// 								In 2015 the duo was announced by Billboard as one of the 5 biggest breakthroughs. They come to Israel this year after a long tour and performing in the biggest festivals around the world as part of the promotion of their new album, which includes hits such as "Without You" and "Drive".
// 							</p>

// 							<p>
// 								Gutcht and West played sold out shows in New York, Los Angeles, Paris and London, and now they're coming for one show only to give the people of Tel Aviv a taste of their alt-pop hits. The successful duo is guaranteed to get you dancing and give the ultimate pop experience, this will be one night in Tel Aviv you are sure to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:31,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Ott & The All Seeing I",
//         smltitle: "Electro explosion in the city that never sleeps",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											15.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ottsonic.com/">
// 											  www.ottsonic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/31/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Ott and the All Seeing I are coming to take Tel Aviv by a storm this December.
// 							</p>
// 							<p>
// 								Ott is considered to be one of the pioneers of calm, groovy electronic music and likes to record the sounds of nature in his mobile studio, with which he tours England. The British record producer and musician has worked with Sinead O'Connor, The Orb, Brian Eno and Embrace, and has achieved recognition since 2002. He's known for psychedelic dub tracks and his collaborations with other artists. He has released two albums on Twisted Records – "Blumenkraft" in 2003 and "Skylon" in 2008, and two other albums on Ottsonic – "Mir" in 2011 and "Fairchildren" in 2015.
// 							</p>

// 							<p>
// 								The electro genius performed at the Glastonbury Festival in 2007, and then in 2011 he performed at Glade Festival, a show that was described as "the perfect opening act" in an article at Virtual Festivals. The same publication also called Ott a "Psy-dub maestro" and ranked his performance 10/10. The Israeli crowd was first exposed to Ott in the early 2000's with the album "Hallucinogen in Dub", the remix album he produced for Simon Posford. All the albums he released later only enhanced the effect he has with his powerful and addictive music.
// 							</p>

// 							<p>
// 							   The All Seeing I are an English electronic music group from Sheffield, consisting of Dean Honer, Jason Buckle and DJ Parrot. Their first single "I Walk" came out in 1997, but it was only in the following year that they gained mainstream commercial success with the song "Beat Goes On". The trio worked with artists such as Tony Christie, Jarvis Cocker, Babybird, Phillip Oakey and many others.
// 							</p>

// 							 <p>
// 							    Ott has performed Tel Aviv twice in the past and his shows received incredible reviews. This is guaranteed to be a one of a kind night that you definitely don't want to miss!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:32,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Take That",
//         smltitle: "Take That – Taking Tel Aviv By Storm!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											27.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//takethat.com/">
// 											  www.takethat.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/32/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The legendary British pop band is this coming November to rock Tel Aviv for one show only!
// 							</p>
// 							<p>
// 								Take That started in Manchester in 1990 and currently includes Mark Owen, Gary Barlow, and Howard Donald. The original band also featured Robbie Williams and Jason Orange. Barlow is the band's lead singer and songwriter, while Owen and Donald act as backing vocals.
// 							</p>

// 							<p>
// 								Their most memorable songs include "Pray" which won The Guardian Music Award for Best Number 1 Single, "Back For Good" which won BRIT Award for Best British Single, "Everything Changes" and "Could It Be Magic." The band released 28 top 40 singles and 17 top 5 singles in the United Kingdom, out of which 12 reached number one, and they have 7 number one albums. Internationally, the band released 56 number one singles and 37 number one albums. They won 8 Brit Awards, including awards for Best British Live Act and Best British Group.
// 							</p>

// 							<p>
// 							   The British pop sensation set the record in 2011 for the fastest-selling tour of all time in the United Kingdom with "Progress Live", beating their own personal record from 2009 with their "Circus Live Tour". They were named as Amazon's top-selling music artist of all time, and in 2012 Forbes announced them as the fifth highest-earning music stars in the world. During the same year, the Official Charts Company announced the biggest-selling singles artists in the British music chart history with Take That being placed at 15th overall and having four of the best-selling albums of the millennium, which makes them the most successful boy band in the UK chart history.
// 							</p>

// 							 <p>
// 							   The band will come to Israel as a part of its international tour in order to promote its last album "Wonderland". Their previous tours have gotten raving reviews, with "Progress" winning Audio Pro International Awards for Best Live Sound Event and Audio Pro International Awards Grand Prix Award. Their performance in Tel Aviv will for sure be a one to remember, don't miss out!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:33,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Kooks",
//         smltitle: "Getting it on with the Kooks in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											27-28.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thekooks.com/">
// 											  www.thekooks.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/33/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Kooks – one of the ultimate British rock/pop bands of the century are coming this January to rock Tel Aviv as a part of "The Best of The Kooks" tour that marks a decade to their existence.
// 							</p>
// 							<p>
// 								The band was formed in Brighton, UK, in 2004 by lead singer Luke Pritchard and consists of Hugh Harris the lead guitarist, drummer Alexis Nunez and bassist Peter Denton. The band released its debut album, "Inside In/Inside Out" in 2006, which included hits such as "Ooh La" and "She Moves in Her Own Way" and achieved quadruple platinum status in the UK within a year and also abroad in the form of a platinum certification in Australia and two times platinum in Ireland.
// 							</p>

// 							<p>
// 								The group released its second album "Konk" in 2008 which debuted at number one on the UK Albums Chart and recorded first week sales of 65000, achieving gold status in both the UK and Ireland, which continued to establish their reputation as one of the world's most beloved brit-pop and post-punk bands. In 2011 their third album "Junk of the Heart" came out, followed by "Listen" in 2014 which debuted at No. 16 on the UK Albums Chart. Besides the fact that they quickly signed with "Virgin Records" only 3 months after forming, they also won several awards, such as MTV's best band of 2006 award, Best UK & Ireland Act at the MTV Europe Music Awards 2006 and even a nomination for the famous Brits award.
// 							</p>

// 							<p>
// 							  The band's music is primarily influenced by the 1960s British Invasion movement and post-punk revival of the new millennium. The Kooks have experimented in genres such as pop, reggae, ska, Britpop, rock, funk and hip-hop, and released songs that were describes as "catchy as hell".
// 							</p>

// 							 <p>
// 							  The Kooks are known for their amazing sold out shows and this one is due to be no different, so make sure to get your ticket now!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:34,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Willy William and Farruko",
//         smltitle: "The reggaetón superstars coming to get you movin’ in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											  Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reggaetontelaviv.co.il/indexEN.php">
// 											  www.reggaetontelaviv.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/34/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The reggaetón superstars coming to get you movin’ in Tel Aviv!
// 							</p>
// 							<p>
// 								Willy William and Farruko, the reggaeton megastars are coming this fall to perform as a part of the "Reggaeton Tel Aviv" festival and get the people of Tel Aviv on their feet in one extraordinary show only!
// 							</p>

// 							<p>
// 								Farruko , the 26-year-old world famous reggaton singer comes from Puerto Rico. He started his professional career in 2009 through Myspace. Since then, he released six albums and collaborated with Sean Paul, Daddy Yankee, Maluma, Don Omar, Shaggy, Nicky Jam, Ky-Many Marley, Chino&Nacho, J Balvin, Ozuna and many other successful reggaeton legends, and he was nominated for the Latin Grammy awards in 2012. His hits got millions of views on Youtube, and among them, one can find the famous "6 AM", "Passion Wine", "Me Voy Enamorando", "Krippy Kush", "Sunset" and "Chillax".
// 							</p>

// 							<p>
// 							  The 36-year-old singer, producer and DJ, Willy William is coming to Tel Aviv all the way from France. He's known for his remixes and collaborations with dance artists. His big breakthrough was in 2003 when he collaborated with DJ Flex and released his hit "B Boyz Shake da Body" and right afterwards his next song "Tragedie" and the name "Lord William". His most famous hits are "EGO" and "Mi Gente" which topped the charts in many radio stations worldwide, including Israel.
// 							</p>

// 							 <p>
// 							  Come get the addictive reggaetón vibes in you and dance the night away in the city that just won't quit!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:35,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Buena Vista",
//         smltitle: "The ultimate Cuban experience in Tel Aviv & Jerusalem!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											21-26.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pasion-de-buena-vista.com/">
// 											  www.pasion-de-buena-vista.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/35/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   The ultimate Cuban experience in Tel Aviv & Jerusalem!
// 							</p>
// 							<p>
// 								After 600 shows worldwide -  the extraordinary Buena Vista Cuban sensation is coming for first time to give Tel Aviv and Jerusalem a taste of Cuba!
// 							</p>
// 							<p>
// 								The show is a one-of-a-kind experience that expresses love to the Cuban culture with all the known Cuban hits such as La Vida es un Carnaval. The Buena Vista Band includes 11 talented musicians, working together with a group of unbelievable dancers to provide an experience you never had before.
// 							</p>

// 							<p>
// 								The show will be held in two separate dates in Tel Aviv and Jerusalem, both awesome choices offering a huge host of activities and experiences in a unique unrivaled atmosphere. Jerusalem is known for its rich history, interesting architecture and incredible cultural diversity, while Tel Aviv is known for its fast tempo, warm exotic weather, amazing beaches and non-stop nightlife! Whatever city you'll choose- you visit is bound to be exciting and packed with unforgettable experiences!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:36,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Jerry Seinfeld",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											30.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jerryseinfeld.com/">
// 											  www.jerryseinfeld.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/36/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Comedy King Closing 2017 in Tel Aviv!
// 							</p>
// 							<p>
// 								Jerry Seinfeld, the undisputed king of American comedy is returning to Tel Aviv for two performances which will be held on the same night in Tel Aviv.
// 							</p>
// 							<p>
// 								Home to incredible comedy venues a sought-after location for many international comedians such as Eddie Izzard, Jim Jeffries, Chris Rock and many others, Tel Aviv has a hedonistic vibe, incredible vibrancy and energy and a liberal loose spirit making in a comedy heaven.
// 							</p>

// 							<p>
// 								Seinfeld, hailed as one of the top comedians of his generation has without a doubt shaped the way we watch television and sitcoms, with his iconic show “Seinfeld” which ran from 1990-1998 and reigned over primetime TV for nearly a decade.
// 							</p>

// 							<p>
// 							   However, Seinfeld is a man loyal to his roots and has often declared that performing live is one of his favorites and he’s coming to Tel Aviv to do Just that.
// 							</p>

// 							<p>
// 							  This December, Seinfeld will strut his stuff onstage live in his hilarious laugh- a – second style, performing two consecutive shows in the nonstop city of Tel Aviv, and what better city is there to close the 2017 with a smile?
// 							</p>

// 							<p>
// 							   For visitors coming to check out Seinfeld’s show, the city of Tel Aviv, with its winter sunshine and world-famous nightlife is without a doubt THE place to spend a fantastic and absolutely unforgettable Tel Aviv Style New Year’s Eve.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:37,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alt-J",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											29.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.altjband.com/">
// 											  www.altjband.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/37/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  The British indie band is returning to Tel Aviv once again after their last successful sold-out show in Israel two years ago. The band was formed in 2007 in England, and their debut album “An Awesome Wave” was released in 2012 and won the Mercury award the same year. The band is a combination of electro-pop, psychedelic folk, African beats, post-dubstep and rock n’ roll. The band members met through their mutual love for Radiohead while they were in college, and their sound was affected by the fact that they weren’t allowed to use a bass guitar and drums when they were students.
// 							</p>
// 							<p>
// 								The band comes to rock Tel Aviv this spring and invites fans from all over the world to come and enjoy the wonderful alternative music scene that the city that never sleeps can offer. From extraordinary art galleries to unique theatre shows to live music concerts – the cultural scene in Tel Aviv is one of a kind. It’s a home for many musicians and artists, and now it welcomes every culture lover.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:38,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ozzy Osbourne",
//         smltitle: "Ozzy O -  coming to say goodbye to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											08.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ozzy.com/">
// 											  www.ozzy.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/38/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Ozzy O -  coming to say goodbye to Tel Aviv!
// 							</p>
// 							<p>
// 								Ozzy Osbourne, the world-famous metal legend returns to Tel Aviv for the last time as part of his farewell tour. While known to younger audiences mainly from the reality show “The Osbournes”, Ozzy was already a musical icon and a huge star since way before – from his role as the lead singer for Black Sabbath, to being the headliner in the international metal festival that was named after him, the “Ozzfest”.
// 							</p>

// 							<p>
// 							   After 2500 shows all around the world, the star comes to say goodbye to his fans in Tel Aviv, a city known around the world for its rich rock and metal scene. Being the most liberal city in Israel, Tel Aviv is always full of action and attracts both younger and older visitors who craving a taste of the underground culture. The rocking city is full of bars with rock themes, alternative clubs, live music venues and is known to attract music lovers from every country.
// 							</p>

// 							<p>
// 							   Don’t miss your chance to see the metal star for the very last time, make sure to get your ticket now and come rock it with ozzy in rockin’ Tel Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:39,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jim Jefferies",
//         smltitle: "Jim Jefferies Kicks Off 2018 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											16.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//jimjefferies.com/">
// 											  www.jimjefferies.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/39/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Jim Jefferies Kicks Off 2018 in Tel Aviv!
// 							</p>
// 							<p>
// 								One of the most popular comedians worldwide, Jim Jefferies, is returning to Tel Aviv after only a year. He will be kicking off 2018 and unleashing his famous humor with new material in a new show, “The Unusual Punishment Tour”.
// 							</p>

// 							<p>
// 							  The show will take place on a special 360-degree platform at the Menorah Mivtachim Hall in Tel Aviv, the perfect location for a comedian of his stature. Catching the show with the hilarious Australian performer is just the right excuse to come visit Tel Aviv, renowned for its exciting atmosphere and diverse nightlife scene.
// 							</p>

// 							<p>
// 							  Take the opportunity to visit one of the exciting bars or clubs which attract top International DJs, or visit one of the smaller neighborhood bars or cafes with its atmospheres to suit all tastes. Whether it’s food, drink or dancing you are after, Tel Aviv has it all.
// 							</p>

// 							<p>
// 							    After creating, writing, producing and starring in the critically acclaimed FX series, Legit, Jefferies and his material have gained a cult following. His voice has become well-known in late-night entertainment, making his show a must-see in Tel Aviv. Those coming to the Tel Aviv for Jefferies’ show will enjoy some good laughs, set on a background of stunning warm winters and an exciting night vibe.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:40,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Gerard Depardieu & Isabelle Adjani",
//         smltitle: "“Love Letters” Coming to Tel Aviv from France!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											05.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/40/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 “Love Letters” Coming to Tel Aviv from France!
// 							</p>
// 							<p>
// 								From France with love! French actors, Gerard Depardieu and Isabelle Adjani, will be performing “Love Letters” in March in Tel Aviv. Written by the late A.R. Gurney, the show has been performed on and off-Broadway by actors and actresses around the world.
// 							</p>

// 							<p>
// 							 The Pulitzer Prize-nominated show is now coming to Israel and will be performed by Gerard Depardieu and Isabelle Adjani in French, with Hebrew and Russian subtitles. With the performance taking place in Tel Aviv, visitors to the city will have the chance to enjoy some of the exotic and exciting nightlife that makes Tel Aviv so popular.
// 							</p>

// 							<p>
// 							  With restaurants to suit all palettes, dinner is just the thing for before the show, and with a nightlife that just starts to come alive around midnight, those who are looking for some adventure after the show will have plenty of options open to them. Anyone visiting the city especially for the show is sure to come away dazzled, both by the liveliness of the atmosphere and from the two well-known French stars.
// 							</p>

// 							<p>
// 							   While this is Adjani’s first trip to Israel, Depardieu has been here a number of times, and this occasion is sure to be memorable.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:41,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "A-HA",
//         smltitle: "An Electric Summer with A-HA!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											21.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://a-ha.com/">
// 											  www.a-ha.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/41/1.gif"} class="img-responsive" />
// 							</div>

// 							<p>
// 							 An Electric Summer with A-HA!
// 							</p>
// 							<p>
// 								Israel will be treated to an exciting performance from Norwegian band, A-HA, in June, 2018. Coming to Israel as part of their Electric Summer Tour 2018, the band will perform in Tel Aviv at the Exhibition Grounds in a show that promises to be a hit.
// 							</p>

// 							<p>
// 							 Formed in Oslo in 1982, A-HA has been talked about for more than three decades, and since their hit “Take On Me” in 1985, they have grown to be one of the most popular Scandinavian bands in the world. While they originally split up in 2010, they have come back together again for a number of tours and Tel Aviv is honored to be among their stops this time around.
// 							</p>

// 							<p>
// 							 Fans of the band will be treated to an exciting performance by the well-known group, while having the chance to enjoy some of the best entertainment venues in the country. From museums to theatres, restaurants to clubs, there is something to suit everyone in the bustling city of Tel Aviv.
// 							</p>

// 							<p>
// 							  Take the opportunity to enjoy a walk along the brilliant beachfront as the city’s locals get ready for the summer sun, and enjoy the vibe as diverse cultures come together for the band’s latest show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:42,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ringo Starr",
//         smltitle: "Ringo’s All Starr Band Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											23-24.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ringostarr.com/">
// 											 www.ringostarr.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/42/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Ringo’s All Starr Band Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								It’s been a year of stars in Tel Aviv and the latest concert to come to the dynamic city, has everyone talking! Ringo Starr will be coming to Israel as part of his European Tour and will be performing two concerts with his All Starrs Band at the Menorah Mivtachim Arena in June 2018.
// 							</p>

// 							<p>
// 							Starr, an English songwriter, singer and actor, first became famous as the drummer for the Beatles; however, since 1989, he has toured with his All Starr Band. The 77-year old released his 19th studio album in September, known as “Give More Love.”
// 							</p>

// 							<p>
// 							Tel Aviv is the ideal location for a concert with such a big name. Known as the New York City of Israel, Tel Aviv is the center of excitement, fun and initiatives in the country. As the city that attracts over a million tourists each year, whether for business or pleasure, Tel Aviv offers a beautiful beach, unique restaurants, theatres, museums and pulsing bars.
// 							</p>

// 							<p>
// 							  If you are joining the many fans who are coming to Tel Aviv to hear Ringo and his All Starrs Band perform, make sure not to miss out on the rest of what Tel Aviv has to offer and come away with an experience to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:43,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Scorpions",
//         smltitle: "Tel Aviv to Go Crazy in July with The Scorpions!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.the-scorpions.com/">
// 											 www.the-scorpions.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/43/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Go Crazy in July with The Scorpions!
// 							</p>
// 							<p>
// 								One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							Those looking to make a day of it in Tel Aviv, will have their pick of food and entertainment venues. The spirited city has become a melting pot of cultures and this is reflected in the museums, restaurants and street stalls that can be found all around the city. Enjoy cuisine to suit every palate, stroll around the interesting streets or pop into one of the many unique exhibitions that can be found around the city.
// 							</p>

// 							<p>
// 							  With the show scheduled for the beginning of the summer, it will be daylight until late and the locals will be out enjoying the sunshine. Soak up the vibe before you go on to rock the night away with The Scorpions!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:44,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Natalia Oreiro",
//         smltitle: "Natalia to Wow Tel Aviv in March",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											20.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.nataliaoreiro.com/">
// 											 www.nataliaoreiro.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/44/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							Natalia to Wow Tel Aviv in March
// 							</p>
// 							<p>
// 								South American singer and actress, Natalia Oreiro, is headed to Israel in March, where she will be performing a live concert at Menora Mivtachim Arena in Tel Aviv. Coming back to Tel Aviv, straight from Argentina, fans are looking forward to seeing the Latin star once again.
// 							</p>

// 							<p>
// 							Having performed in numerous daily series, including telenovelas and movies, and after producing 3 CDs, she will bring some of her biggest hits to the show, such as Cambio dolor, Corazon Valiente, Me Muero de Amor and Rio de la Plata y más, as she opens her new World Tour.
// 							</p>

// 							<p>
// 							Tel Aviv, which attracts celebrity singers, actors and performers from around the world, is the perfect location for the Grammy-nominated singer from Uruguay. The pumping city offers entertainment beyond the walls of the Menora Mivtachim Arena, with its trendy restaurants, upscale bars, and clubs.
// 							</p>

// 							<p>
// 							 Natalia, who has performed in Israel many times in the last 20 years, already has a following here. The show is sure to attract a large audience. Join the excitement before the performance by satisfying your taste buds in one of the many highly-acclaimed restaurants in the area or continue the celebration after the curtains have closed with a drink at a pub. Whatever your tastes, Tel Aviv is a great complement to Natalia Oreiro.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:45,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "André Rieu",
//         smltitle: "Tel Aviv to Be Treated to Rieu in 2018",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											04-05.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.andrerieu.com/">
// 											 www.andrerieu.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/45/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Be Treated to Rieu in 2018
// 							</p>
// 							<p>
// 								World-class Dutch composer and violinist, André Rieu, is coming to Tel Aviv with his Johann Strauss Orchestra for a performance that promises to be unforgettable. The two events, which are Rieu’s first in Israel, will be held at the Menora Mivtachim Arena in Tel Aviv.
// 							</p>

// 							<p>
// 							Rieu will be conducting his 60-piece orchestra while playing his famous Stradivarius violin, treating the audience to their repertoire of renowned ballads and waltzes. The event will be particularly captivating as Rieu will be presenting his new album, “Amore,” which includes a unique interpretation of Naomi Shemer’s “Jerusalem of Gold.”
// 							</p>

// 							<p>
// 							Tel Aviv, with its many facets, is just the right location for the range of musical pieces that Rieu and the Johann Strauss Orchestra will be performing. From the beach to the theater, classy restaurants to lively pubs, Tel Aviv has it all. Sit down to a posh dinner, visit a charming cafe, or enjoy a drink at a chic bar, before you end off your evening with a concert that promises no shortage of exquisite music.
// 							</p>

// 							<p>
// 							  André Rieu has become one of the most popular live acts around the world and Tel Aviv is about to find out why! Make sure you don’t miss out on the experience!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:46,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Foreigner",
//         smltitle: "Foreigner Returning to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											05.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											 www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/46/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Foreigner Returning to Israel in May!
// 							</p>
// 							<p>
// 								Popular British hard rock band, Foreigner, is returning to Tel Aviv in May 2018. After recently playing 2 concerts in Caesarea, the band will now be performing in the entertainment capital of the country, Tel Aviv.
// 							</p>

// 							<p>
// 							Since being founded in 1976 by Mick Jones, Foreigner has sold nearly 80 million albums across the globe. It reached the height of its popularity in the 1980s, with some of its most well-known hits including “I Want to Know What Love Is,” “I Don’t Want to Live Without You,” “That Was Yesterday” and “Waiting for a Girl Like You.”
// 							</p>

// 							<p>
// 							With the band performing at the Menora Mivtachim Arena in Tel Aviv, fans and visitors will be able to make the most of the concert and enjoy the vibe and energy of the city. Soak up the rays on the beach as the summer sun starts to make an appearance or spend the day in one of the many museums or exhibitions of the city.
// 							</p>

// 							<p>
// 							 You will be transported back to the 80’s with this popular band, while enjoying the best that Tel Aviv has to offer. Don’t miss out on the great nightlife of the clubs and pubs after the show, as you complete your evening with style!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:47,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Don Mclean",
//         smltitle: "Enjoy a Piece of “American Pie” in June!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											16.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://don-mclean.com/">
// 											 www.don-mclean.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/47/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Enjoy a Piece of “American Pie” in June!
// 							</p>
// 							<p>
// 								Famous American songwriter, Don McLean, will perform in the outskirts of Tel Aviv in June, 2018. After almost 60 years of career, McLean remains most famous for his hit song, American Pie, which came out in 1972 and is still covered by big names in the industry, such as Madonna.
// 							</p>

// 							<p>
// 							   McLean has released 40 gold and platinum records, but it is his attachment to Israel that makes him so popular here. This is particularly clear with his song, Jerusalem, which he wrote in support of the country. This time, he will be performing closer to the entertainment capital of Israel, Tel Aviv.
// 							</p>

// 							<p>
// 							    With the show taking place only 10 minutes from the hustle and bustle of the lively city, there are plenty of options for fans to make a full day of the concert. Visit one of a number of world-class museums or take in one of the many temporary exhibitions that come to the city. If you’re looking for food, there is certainly no shortage in Tel Aviv with a range of styles and tastes to suit all visitors. Soak up the sun as summer begins to arrive or enjoy the sounds and scenes of the nightlife that Tel Aviv is famous for.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:48,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Enrique Iglesias",
//         smltitle: "Tel Aviv to Host Spanish Pop Legend!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://enriqueiglesias.com/">
// 											 www.enriqueiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/48/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Tel Aviv to Host Spanish Pop Legend!
// 							</p>
// 							<p>
// 								Spanish pop legend, Enrique Iglesias, will be returning to Israel for his fourth visit, this time to perform at the Yarkon Park in Tel Aviv. While this won’t be his first time in the entertainment capital of the country, it is expected to be his largest performance to date.
// 							</p>

// 							<p>
// 							  This visit comes close on the heels of the Hebrew remix of his popular piece, “Subleme La Radio,” together with Israeli singer, Rotem Cohen. Concert-goers can look forward to hearing some of Iglesias’ hit songs which may include “Bailamos,” “Hero,” “Be With You” and “I Like It.” He is expected to perform together with his long-time guitarist, Israeli Sean Hurwitz.
// 							</p>

// 							<p>
// 							   Iglesias is predicted to be one of the most popular concerts of the year judging by the fact that it will be held in the Yarkon Park venue which can accommodate up to 100,000 people. Those looking to make a whole evening of the event will find plenty to keep them entertained in Tel Aviv before the concert starts.
// 							</p>

// 							<p>
// 							    With a wide range of eateries and pubs, there is something to suit all tastes. Enjoy the limitless choices when it comes to restaurants and pick up the vibe of the city before heading off to the main event.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:49,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blood Sweat and Tears",
//         smltitle: "Blood, Sweat & Tears Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											22.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//bloodsweatandtears.com/">
// 											 www.bloodsweatandtears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/49/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Blood, Sweat & Tears Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								Legendary rock band, Blood, Sweat & Tears, is heading to Israel for one concert to be held in Hangar 11 in Tel Aviv. The band was last in Israel 10 years ago when they played in Tel Aviv and Caesarea.
// 							</p>

// 							<p>
// 							  Established in 1967 in New York City, their best-known hits include “I Love You More than You’ll Ever Know,” “I Cannot Quit Her,” “When I Die” and “You’ve Made Me So Very Happy.” There are no original members of the band left, but seven current members will take to the stage when they perform in March. These include lead vocalist and popular runner-up to American Idol in 2005, Bo Bice.
// 							</p>

// 							<p>
// 							   Tel Aviv promises a full day of excitement for concert-goers with the opportunity to enjoy the beautiful beaches, parklands and entertainment options that the city offers before the concert even begins. Make sure to eat in one of the many restaurants scattered around the city and immerse yourself in the character of Tel Aviv by visiting one of the popular pubs or clubs that make up its charming nightlife.
// 							</p>
//                             <p>
//                                 Create the perfect night out as you combine the atmosphere of Tel Aviv with jazz and rock in a unique concert from Blood, Sweat & Tears.
//                             </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:50,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jamiroquai",
//         smltitle: "Jamiroquai Heads to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											02.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jamiroquai.com/">
// 											 www.jamiroquai.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/50/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jamiroquai Heads to Israel in May!
// 							</p>
// 							<p>
// 								British band, Jamiroquai, is heading to Israel in May 2018, where they will perform in the outskirts of the bustling city of Tel Aviv. With only one performance in Israel, the popular band from the 90s is expected to attract a large crowd.
// 							</p>

// 							<p>
// 							  The band has published 8 studio albums, with “Automaton” being their latest from 2017. The hip city of Tel Aviv is the ideal location for a concert that promises an exciting performance by the group that introduced “future funk” and took the world by storm. Founded in 1992 by Jay Kay, Jamiroquai holds the Guinness Book of World Records listing for “Best Selling Funk Album” of all time.
// 							</p>

// 							<p>
// 							   Anyone looking for a lively night out will do well to head to this concert. Being held a short drive from the center of Tel Aviv, concert-goers will be able to begin the party early at one of the city’s top-notch restaurants, clubs or pubs. Start your evening with a quality dinner at any one of dozens of stylish restaurants and then move onto one of Tel Aviv’s famous clubs before making your way to the concert for an unforgettable night out.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:51,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Backstreet Boys",
//         smltitle: "The Backstreet Boys are Back and Larger Than Life",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											22.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.backstreetboys.com/">
// 												www.backstreetboys.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/51/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    The Backstreet Boys are Back and Larger Than Life
// 							</p>
// 							<p>
// 									The Backstreet Boys will be back in Israel this year for a concert. To be held in the outskirts of Tel Aviv in April, concert-goers will be able to enjoy the incredible vibe of the city together with some of the greatest hits in history.
// 							</p>

// 							<p>
// 									Tel Aviv is one of the most sought-after locations for big names in the entertainment industry, with its energy, vitality and spirit. There is no shortage of eateries, pubs and coffee shops for those looking for a culinary experience. Or, if you prefer to make a full day of it, you can visit some of the world-class museums, theaters or galleries around the city.
// 							</p>

// 							<p>
// 									Formed almost 20 years ago, the Backstreet Boys have produced 7 multi-platinum albums and sold more than 130 million records worldwide, with some of their most popular hits such as “I Want It That Way,” “As Long as You Love Me” and “Larger Than Life”.
// 							</p>
// 							<p>
// 									Visitors heading to the concert will be able to enjoy Tel Aviv at its best with beautiful Spring weather enticing locals and guests to the beach, before making their way to hear the best-selling boy band of all times!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:52,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alice in Chains",
//         smltitle: "Alice in Chains Announces Debut Show in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											17.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.aliceinchains.com/">
// 												www.aliceinchains.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/52/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Alice in Chains Announces Debut Show in Tel Aviv
// 							</p>
// 							<p>
// 									Making their debut appearance in Israel, rock band and grunge pioneer, Alice in Chains, will perform in July, north of Tel Aviv, in what promises to be an electrifying concert.
// 							</p>

// 							<p>
// 									Having come together in the late 80’s, Alice in Chains is one of four major groups that led the grunge revolution, and they became one of the most influential bands of all time. With music that combines rock, alternative rock and metal, the band was nominated for 9 Grammy awards and sold more than 20 million albums.
// 							</p>

// 							<p>
// 									Taking place in the middle of summer, Tel Aviv is the perfect location to start the day’s activities. If you’re looking for some indoor entertainment, visit one of the city’s world-class museums or galleries, or head over to one of the many restaurants around the city. For something a bit different, soak up the rays walking along the promenade of a beautiful beach or pop into a club or pub in the area before heading north for the concert.
// 							</p>
// 							<p>
// 									This show is part of the first European tour the band has been on in four years, and being its first appearance ever in Israel, it promises to be a night full of excitement.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:53,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Hardwell",
//         smltitle: "Hardwell Headed to Israel in April",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											06.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.djhardwell.com/">
// 												www.djhardwell.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/53/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Hardwell Headed to Israel in April
// 							</p>
// 							<p>
// 									Number 1 ranking DJ, Hardwell, is coming to Israel in April where he will thrill crowds just outside Tel Aviv. This will be his third concert in the country, after performing to sell-out audiences in 2013 and 2017.
// 							</p>

// 							<p>
// 									Robbert van de Corput, better known as DJ Hardwell, first made a name for himself at the young age of 14, but it was at age 25 when he truly became famous, named World’s #1 DJ by the 2013 DJ Mag. Hardwell has become an International name, hosting his own radio show which is broadcast around the world, and producing a consistently top 10 iTunes podcast. He is also well known for his remix of The Wanted’s “Chasing the Sun”.
// 							</p>

// 							<p>
// 									Tel Aviv is the ideal location for a concert of this type with the natural vibe and energy of the city adding to the excitement that will be in the air. Tel Aviv in Spring is full of blue skies and warm weather, attracting crowds to the beach and the outdoor cafes and restaurants that can be found throughout the city. Enjoy a full day out or join the gathering of people at one of the city’s world-class restaurants before heading to the concert.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:54,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jethro Tull",
//         smltitle: "Jethro Tull’s 50th Anniversary Tour Heads to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											27-28.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jethrotull.com/">
// 												jethrotull.com/
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/54/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jethro Tull’s 50th Anniversary Tour Heads to Israel
// 							</p>
// 							<p>
// 									Ian Anderson, vocalist, flutist, and guitarist of the popular British rock band, Jethro Tull, is coming to Israel for the band’s 50th anniversary tour. Performances will take place at Heichal Hatarbut in Tel Aviv on October 27, followed by the International Convention Center in Jerusalem on October 28.
// 							</p>

// 							<p>
// 									Formed in 1967, the band initially played blues rock, but later evolved and developed elements of hard rock. Their greatest success came in the 1970s with hit songs such as “Bungle In The Jungle,” “Living In The Past,” and “The Witch’s Promise.” The band has performed in Israel numerous times in the past, and Anderson who is the only remaining member of the band who is coming on tour, is expected to receive a warm welcome.
// 							</p>

// 							<p>
// 									Performing in both Tel Aviv and Jerusalem will appeal to a wide audience. Join the energy and vibe of the lively city of Tel Aviv with its nightlife, culinary experiences and beautiful beaches, or enjoy the concert in the cultural and historic center of the country, which is Jerusalem. No matter which flavor of the region you prefer, there are plenty of restaurants, cafes, museums or galleries to visit in each of the cities before the venues open their doors.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:55,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Israel Calling",
//         smltitle: "Good Evening Europe, This is Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											08-10.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<!--	<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h2>
// 							   Good Evening Europe,<br class="show-on-mobile"> This is Tel Aviv!
// 							</h2>
// 							<p>
// 								Eurovision fever is sweeping over Tel Aviv as it confirms hosting the star and glitter studded event - “Israel Calling”, for the 3rd consecutive year!
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/55/1.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								About 30 delegates from Eurovision participating countries worldwide will be gathering at the beginning of April in the nonstop city of Tel Aviv, for the largest Eurovision promo-event to ever take place in front of a crowd of thousands from Israel and around Europe.
// 							</p>

// 							<p>
// 								This unique and exciting event, held only in Tel Aviv, will give Eurovision fans from far and wide an amazing and completely free of charge opportunity to take part in the glamour of the Eurovision right here in the beautiful city of Tel Aviv.

// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/2.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 						The event will be held for three days starting on the 8th of April. The main stage will be set in Rabin Square, Tel Aviv’s main square and one of the city’s favorite outdoor venues, located at the heart of the buzzing city.
// 						</p>

// 						<p>
// 						The main event will take place on Tuesday and will include a mini Eurovision show in front of a live audience, featuring performances by the various Eurovision contenders performing the songs they will be competing with on the main event in May.

// 						</p>

// 						<p>
// 						This much anticipated pre-Eurovision event is set to take place just a few minutes’ walk from the stunning Tel Aviv beach. Fans and music lovers coming to see the show will get to take in all the city has to offer, including the excellent bars, restaurants and the awesome nightlife in this world-famous ultimate vacation destination called Tel Aviv.
// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/3.jpg"} class="img-responsive" />
// 						</div>

// 						`
// 			}
// 		}

//     },

//     {

//       id:56,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Clean Bandit",
//         smltitle: "Clean Bandit Announces First Visit to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											26.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//cleanbandit.co.uk/">
// 												cleanbandit.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/56/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Clean Bandit Announces First Visit to Israel
// 							</p>
// 							<p>
// 									British electro-pop group, Clean Bandit, which has become one of the leading dance acts around the world, has announced their debut performance in Israel. Visiting as part of their European tour, the band will play on the outskirts of Tel Aviv on June 26.
// 							</p>

// 							<p>
// 									Formed in 2008, they became well-known for merging classical instruments and pop with a unique and masterful outcome and they became a sensation with their smash hits “Rather Be,” “Real Love,” “Rockabye,” and “Symphony.” Since its release in 2016, “Rockabye” has been viewed almost 2 billion times on YouTube, while they won a Grammy for “Rather Be” in 2015.
// 							</p>

// 							<p>
// 									The band has been together for ten years and has seen incredible success in the that time. Join the throngs of people heading to Tel Aviv for the group’s first visit.
// 						    </p>

// 						    <p>
// 									Tel Aviv is just the venue for the unforgettable night that this concert offers. With cafes, bars, clubs, and pubs throughout the city, there is no shortage of activities in Tel Aviv. Known as “the city that doesn’t stop”, you can take advantage of the buzz of the nightlife and enjoy the vibe of the bustling beachfront at any hour before or after the concert.
// 						    </p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:57,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alanis Morissette",
//         smltitle: "Alanis Morissette to Turn Up The Heat with Summer Performance in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											30.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//alanis.com/">
// 												alanis.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/57/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Alanis Morissette to Turn Up The Heat with Summer Performance in Israel
// 							</p>
// 							<p>
// 									Canadian singer and songwriter, Alanis Morissette, will return to Israel in the summer for one show which will take place on the outskirts of the lively city of Tel Aviv. Morissette has performed in Israel a number of times, including in 2000 and 2012, since she released her first album, “Jagged Little Pill” in 1995.
// 							</p>

// 							<p>
// 									The popular alternative rock singer is expected to rock Tel Aviv with some of her top hits, including “All I Really Want,” “Hand in My Pocket,” “Head Over Feet,” “Ironic,” “You Learn,” and “You Ought to Know.” Having taken home seven Grammy Awards and with eight albums having sold more than 60 million copies across the globe, her upcoming visit is already causing much excitement.
// 							</p>

// 							<p>
// 									The Tel Aviv area is the perfect location for a concert of this calibre, with visitors to the city given an exceptional choice of wining, dining and entertainment options. Begin your night at one of the many world-class restaurants or head out to one of the quaint coffee shops or bustling bars to end off your evening. The music scene will be hotter than ever with Alanis Morissette this July!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:58,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Marc Almond",
//         smltitle: "Marc Almond’s Amazing Summer Concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											14.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.marcalmond.co.uk/news/index.html">
// 												marcalmond.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/58/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Marc Almond’s Amazing Summer Concert
// 							</p>
// 							<p>
// 									English musician, Marc Almond, will be heading to Israel in the summer for a much-awaited concert. The singer, who is most famous for his part in the new wave duo Soft Cell, will be playing north of Just north of the nonstop city of Tel Aviv in August.
// 							</p>

// 							<p>
// 									Soft Cell became famous for its 80’s hits “Tainted Love,” “Torch,” “Say Hello, Wave Goodbye,” and others, while Almond’s solo career took off when the duo split in the mid-80’s with hits including “Jacky” and “Something’s Gotten Hold of My Heart.” In another tribute to the decade, the Israeli rock group, Tattoo, which broke up in 1989, will open the concert in a historic reunion.
// 							</p>

// 							<p>
// 									Fans have been waiting for this performance since 2011, when his planned concert was canceled due to technical reasons. The 2018 concert promises to be an experience to remember.
// 							</p>

// 						    <p>
// 									From music to art, culture to fun, Tel Aviv has something for everyone. Spend the day wandering the vibrant streets of the city or pop into one of the many museums, theatres or galleries downtown. Make sure to stop off for a bite to eat at any of the city’s many world-class restaurants so you’ll be energized for what is sure to be an awesome concert.
// 							</p>

// 						`
// 			}
// 		}

//     },
//     {

//         id:59,
//         bgImage:"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title : "Shakira",
//         smlTitle : "Shakira to heat up the summer in sizzling Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											09.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.shakira.com/">
// 												shakira.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/59/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Shakira to heat up the summer in sizzling Tel Aviv
// 							</p>
// 							<p>
// 									The worldwide sensation Shakira is set to perform for the first time on the big stage in Tel Aviv this coming July and the city’s a buzz. The 41-year-old Colombian superstar who has sold close to 200 million albums and has won over 250 awards including three Grammys is just the perfect fit for a summertime concert in Tel Aviv.
// 							</p>

// 							<p>
// 									With a long and illustrious list of hit songs, including “Waka-Waka”, “Chantage” and “Whenever, whenever” Shakira is one of the most celebrated artists in the world today and nearly every song she records tops the international charts and receives hundreds of millions of Youtube views.
// 							</p>

// 							<p>
// 									Shakira’s concert is due to be held on July 9th in Yarkon Park, Tel Aviv’s massive park also dubbed the city’s “Green Lung”, which boasts, in addition to beautiful greenery, a stunning lake and excellent bike trails, a huge outdoor live music venue.
// 							</p>
// 							<p>
// 							        The party atmosphere of the nonstop city in July, the beautiful beaches and amazing nightlife and cool street vibe, all set the scene for perfectly Shakira’s show-stopping style and what is guaranteed to be an explosive musical celebration in the heart of cool city of Tel Aviv.
// 							</p>

// 	                    `
// 			}
// 		}
//       },
//   //     {

//   //     id: 60,
//   //     bgImage:"/posts/bank/16/1.jpg",
//   //     mobBgImage:"/posts/bank/16/M.jpg",
//   //     title: "White Night TLV",
//   //     smlTitle: "A “White Night” Rager In the Non-Stop City!",
//   //     html: function(){
// 		// 	return {
// 		// 		__html: `

// 		// 					<h2 class="align-center">
// 		// 					   16.05.2019
// 		// 					</h2>
// 		// 					<h1 class="align-center">
// 		// 					   A “White Night” Rager In the<br class="show-on-mobile"/> Non-Stop City!
// 		// 					</h1>
// 		// 					<div class="responisve-iframe">
// 		// 						<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 		// 					</div>
// 		// 					<p>
// 		// 						When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…
// 		// 					</p>

// 		// 					<p>
// 		// 						From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Adam Primer
// 		// 					</small>
// 		// 					<p>
// 		// 						The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.
// 		// 					</p>
// 		// 					<p>
// 		// 						This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Kfir Sivan
// 		// 					</small>
// 		// 					<p>
// 		// 						The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by Moshik Lindenbaum
// 		// 					</small>
// 		// 					<p>
// 		// 						So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by: Guy Yechiely‎.
// 		// 					</small>

// 		// 			               `
// 		// 	}
// 		// }
//   //   },
//       {
//       id: 60,
//       bgImage:"/posts/bank/16/1.jpg",
//       mobBgImage:"/posts/bank/16/M.jpg",
//       title: "White Night TLV",
//       smlTitle: "All Night Citywide party in Tel Aviv on Eurovision Semifinal!",
//       html: function(){
// 			return {
// 				__html: `

// 							<h2 class="align-center">
// 							   16.05.2019
// 							</h2>
// 							<h1 class="align-center">
// 							   All Night Citywide party in Tel Aviv on Eurovision Semifinal!
// 							</h1>
// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>
// 								When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat, and this year the treat is going to be especially epic!
// 							</p>

// 							<p>
// 								As part of the warm and exciting welcome awaiting visitors during Eurovision week, the powers that be have decided to combine Tel Aviv’s annual “White Night” extravaganza with the Eurovision Semifinal set to be held on 16.05.2019.
// 							</p>
// 							<p>
// 								“White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open, and everything is happening throughout the city simultaneously.
// 							</p>
// 							<p>
// 								The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City as a world cultural heritage site, setting off annual citywide celebration in a series of white night events in the city that (truly) doesn’t sleeps.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>
// 								From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>
// 								So you better get some rest - you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>

// 					               `
// 			}
// 		}
//     },
//     {

//         id:61,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Brian Wilson",
// 	    smlTitle: "The legendary Brian Wilson returning to rock Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											07.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.brianwilson.com/">
// 												brianwilson.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/61/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 The legendary Brian Wilson returning to rock Tel Aviv!
// 							</p>
// 							<p>
// 									He returns to the white city with Al Jardine and Blondie Chaplin as a part of his world tour that celebrates his biggest hits from the last 54 years. The Beach Boys is one of the world’s most successful bands, the band has won many Grammy awards, got their own star in Hollywood and entered the Rock N’ Roll hall of fame.
// 							</p>

// 							<p>
// 									The band sold over 100 million records over the years and produced more hits than any other American band. They’re known especially for their hits “God Only Knows”, “Get Around”, “California Girls” and “Good Vibrations”. Wilson’s solo career is also successful, he recorded 11 albums and won 2 Grammy awards.
// 							</p>

// 							<p>
// 									Wilson’s concert will take place in Tel Aviv on August’s 7th. The summertime provides long daylight hours that give visitors the perfect opportunity to see what Tel Aviv has to offer; from an incredible art scene to fantastic theatres, to phenomenal live music shows and world-class restaurants – there are so many options in the spectacular city of Tel Aviv for  everyone will to find their brand of fun and excitement in the nonstop city.

//                             </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 62,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Jason Derulo and Rita Ora",
// 	    smlTitle: "Jason Derulo and Rita Ora to raise it up in Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											The outskirts of Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jasonderulo.com/">
// 												jasonderulo.com
// 											</a><br>
// 											<a target="_blank" href="//ritaora.com/">
// 												ritaora.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/62/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						         	Jason Derulo and Rita Ora to raise it up in Tel Aviv!
// 							</p>
// 							<p>
// 									The two mega pop stars will perform at the “Lollipop” festival that will take place at the outskirts of Tel Aviv on the first of August. Derulo, that made his big breakthrough in 2009 with the hit “Whatcha Say”, became over the last decade one of the biggest stars in the international music industry with his huge hits such as “Wiggle”, “Want to Want Me”, “Swalla”, “Tip Toe” and “Talk Dirty”. The popular British Pop star, Rita Ora, is known especially for her famous hits “I Will Never Let You Down”, “Anywhere”, “R.I.P” and “Hot Right Now”.
// 							</p>

// 							<p>
// 									The festival provides a great opportunity to explore the city that never sleeps and enjoy its famous nightlife scene – from world-class bars, to secret underground clubs, to live music shows and various culinary options and even alternative art galleries, Tel Aviv for sure has something for everyone to enjoy. Whether you’re following a map or letting yourself get lost in the streets, you’re sure to fall in love with Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 63,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Julio Iglesias",
// 	    smlTitle: "The Latin legend returning to wow Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											06.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.julioiglesias.com/">
// 												julioiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/63/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						             The Latin legend returning to wow Tel Aviv!
// 							</p>
// 							<p>
// 									Tel Aviv can’t wait for the return of the beloved Spanish star! With a great cultural scene, incredible culinary options, amazing beaches, phenomenal museums and galleries and plenty of unique spots to explore – those who come to enjoy Iglesias’s concert have plenty of different ways to spend their time in the cultural capital.
// 							</p>

// 							<p>
// 									The hot climate and long daylight hours just reminiscent of the phenomenal singer’s origin country, Tel Aviv offers a variety of options that suit all ages and therefore attracts a big amount of visitors all around the year.
// 							</p>
// 							<p>
// 							        Iglesias has an ongoing love affair with the nonstop city and his past shows were sold out. He’s one of the most successful singers in the history and during his career became a phenomenal success story all around the world. He has 77 different albums that sold over 300 million copies!
// 							</p>

// 							<p>
// 							         Many of the Spanish phenomenon’s hits have reached the top of the charts and he won numerous awards, such as the Grammy. His fans are incredibly excited about his return and tickets are selling like hot falafels. This is guaranteed to be a show to remember!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 64,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Maluma",
// 	    smlTitle: "The Reggaeton sensation returns to the white city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fame.malumaofficial.com/">
// 												fame.malumaofficial.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/64/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The Reggaeton sensation returns to the white city!
// 							</p>
// 							<p>
// 									After winning over the crowd’s hearts during his last visit, the Colombian reggaetón singer and songwriter Juan Luis Londoño Arias, better known by his stage name Maluma returns to the city that never stops for one show only!
// 							</p>

// 							<p>
// 									Maluma has several singles that have charted within the top 10 on Billboard Hot Latin Songs, including "Felices los 4", "Borro Cassette", "El Perdedor" and "Corazón". During his career he won several awards, among which there is MTV Europe’s award for best world tour. The phenomenal performer is known among his fans as “the Latin lover” despite being only 24 years old.
// 							</p>
// 							<p>
// 							       His show will be held on June’s 28th in HaYarkon Park, located in the heart of Tel Aviv. Fans from all over the world who come to the show can enjoy the lovely beaches the city has to offer, the variety of restaurants and cafes, the remarkable art scene, the world-class bars and clubs, the various shopping venues spread all across the city – Tel Aviv has something for everyone.
// 						    </p>

// 							<p>
// 							         The Latin superstar is known to be quite a charmer and win everyone over in his shows – don’t miss this fantastic mix of Maluma and Tel Aviv -  come see the legend live in the hot hot city!
// 						    </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 65,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Martin Garrix",
// 	    smlTitle: "The 1# DJ comes to the nonstop city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											10.09.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.martingarrix.com/">
// 												martingarrix.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/65/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The 1# DJ comes to the nonstop city!
// 							</p>
// 							<p>
// 									Martin Garrix , hailed as “the world’s best DJ” by DJMag is coming to get the party going in the nightlife capital of the middle east! With tons of world known clubs, bars, pubs and a one of a kind atmosphere, Tel Aviv is known for its vibrant vibe and incredible night scene.
// 							</p>

// 							<p>
// 									At 20 years old, the Dutch wonderkid is coming at the height of his career for one unforgettable show in Tel Aviv! The international hits machine became famous when he was only 17 and since then has released many loved tracks and climbed the charts all over the world.
// 							</p>
// 							<p>
// 							       Garrix is considered by many is the undeniable king of the industry. With remarkable hits such as “Animals”, “Tremor”, “In the Name of Love” and “Scared to Be Lonely”, the phenomenal DJ is one of the most popular performers in the world and is a must-have headliner for every well-known festival.
// 							</p>

// 							<p>
// 							        The show will be held in HaYarkon Park, in the heart of the awesome city, on September 10th. The international vibe, gorgeous location and great nightlife scene attract an extraordinary crowd that comes from different corners of the world and is guaranteed to make this show a once in a lifetime experience!
// 						    </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 66,
// 	    bgImage:"/posts/bank/59/1.jpg",
// 	    mobBgImage:"/posts/bank/59/M.jpg",
// 	    title: "Eurovision Tel Aviv",
// 	    smlTitle: "Epic song contest in the Non-Stop City",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											14-18.05.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<!--<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h3>A once in a lifetime opportunity to visit Tel Aviv as it hosts the Eurovision song contest.</h3>
// 							<p>
// 						     Epic song contest in the Non-Stop City
// 							</p>
// 							<p>Semi-final 1: 14 May 2019</p>
//                             <p>Semi-final 2: 16 May 2019</p>
//                             <p>Grand Final: 18 May 2019</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/67/1.svg"} class="img-responsive" />

// 							</div>
//                             <p>It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city. </p>
//                             <p>Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak.  Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest. </p>
//                             <div class="img-wrapper">

// 							    <img src=${getImgUrl() + "/Concerts/67/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv. </p>

//                             <p>The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all! </p>

// 					               `
// 			}
// 		}
//     },

//    {

//         id: 68,
// 	    bgImage:"/posts/bank/68/1.jpg",
// 	    mobBgImage:"/posts/bank/68/M.jpg",
// 	    title: "",
// 	    smlTitle: "36 Years of Cinema Magic!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											25.07-04.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jff.org.il/en">

// 												www.jff.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h2>Jerusalem Film Festival (JFF)</h2>
// 							<p>Time to start preparing your Summer 2019 checklist: Buy suntan lotion, pick wildflowers, host a barbeque, make plans to attend the 36th Annual Jerusalem Film Festival! It’s 11 days, over 200 films, prizes awarded to the very best, and you’ll be a part of it all! From star-studded international features to independent productions and the best of Israeli cinema, this unique film fest showcases excellence from various genres. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/68/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>Take advantage of the opportunity to meet festival guests, including world-renown stars, writers, directors, cinematographers and other movie-making professionals. Film enthusiasts will enjoy Jerusalem’s many cinema spaces and be delighted by JFF on the Go, which presents films under the stars throughout the festival, and Cinema Park, which includes a 300 square meter pool with rubber boats, a giant LED screen, and a concert stage featuring live musical performances nightly. </p>
//                             <p>As you travel across the city to attend screenings, workshops, master classes, parties, musical shows and other festival events, you’ll experience how ancient cultures give modern spice to the contemporary vibe and personality of this global city. Fill your spare time strolling through neighborhood streets, exploring local shops, and taking your pick of Jerusalem’s wide variety of restaurants and cafes. You may have attended other film fests, but you won’t find one quite like this and, certainly, none other can boast the grandeur of the eternal City of Peace! </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 69,
// 	    bgImage:"/posts/bank/69/1.jpg",
// 	    mobBgImage:"/posts/bank/69/M.jpg",
// 	    title: "",
// 	    smlTitle: "Jerusalem Wine Festival (JWF)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											01-31.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Wine Festival (JWF)</h2>
// 							<p>
// 								Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premiere social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.
// 							</p>
//                            <p>
// 								Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: 70,
// 	    bgImage:"/posts/bank/70/1.jpg",
// 	    mobBgImage:"/posts/bank/70/M.jpg",
// 	    title: "OPEN RESTAURANTS TLV",
// 	    smlTitle: "Feed Your Curiosity!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											2019 y.
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Feed Your Curiosity!</h2>
// 							<p>
// 								Ever wanted to get more than a taste of what gets created in a truly fine restaurant? Have you ever fantasized about what it would be like to be a top chef? Well, now’s your chance!
// 							</p>
// 							<p>
// 								OpenRestaurants is more than a culinary event, it’s a cultural happening that showcases Tel Aviv’s wide array of restaurants, chefs, and local culinary personalities. Guests get to meet with chefs from around the city, wander through open markets, and try their hands at cooking up flagship dishes under the supervision of first-class professionals. It’s your opportunity to experience a day in the life of the sophisticated chefs, line cooks, restaurateurs, food vendors, and others who make gastronomy in Tel Aviv as palate pleasing as it is.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/70/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Beyond peeking behind many kitchen curtains, OpenRestaurants hosts a range of events that include curated dinners, history presentations, and exhibitions of culinary-themed art, design, music, and technology!
// 							</p>
//                            <p>
// 								Many events are available at no charge, including the Culinary Innovation Summit, the Food & Hospitality Hackathon, and various food talks. There are also family-oriented events that focus on cooking activities for children and several market tours.
// 							</p>
//                            <p>
// 								Everyone’s gotta eat and there’s no one who doesn’t enjoy good food that’s well prepared. So, whether you like to understand the process behind the preparation, you like to do the preparing, or you just have a hearty appetite, there’ll be plenty to delight your senses at OpenRestaurants: Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 71,
// 	    bgImage:"/posts/bank/71/1.jpg",
// 	    mobBgImage:"/posts/bank/71/M.jpg",
// 	    title: "CULINARY FESTIVAL",
// 	    smlTitle: "Round Tables Culinary Festival",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											09-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Round Tables Culinary Festival</h2>
// 							<p>
// 								The 4th edition of this celebrated culinary experience that brings renowned chefs from around the globe and invites them to take over the kitchens of several of Tel Aviv’s most notable restaurants.
// 							</p>
// 							<p>
// 								This year offers a new twist: The eight visiting chefs are all women – hailing from Mexico, South Korea, Italy, Switzerland, Colombia, Slovenia, Spain, and the United States. They’ll work with their local counterparts in the creation of culture crossover chowdowns featuring signature dishes from the guest chefs alongside flavors offered by the local chefs from the host restaurants.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/71/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Everyone involved agrees that creative cooking is always intensely steeped cultural context and a deeply felt sense of place. All of them are passionate about using local ingredients. Of course, each of these chefs has received accolades and awards from international critics and guides.
// 							</p>
//                            <p>
// 								There’s no better way to showcase Tel Aviv’s growing prominence on the global stage of gastronomy than the annual Round Table event. Seats get reserved quickly and must be made in advance. So, don’t miss your chance for a place at these prestigious tables – your taste buds will never forgive you!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 72,
// 	    bgImage:"/posts/bank/72/1.jpg",
// 	    mobBgImage:"/posts/bank/72/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "Tel Aviv Fashion Week (TAFW)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Tel Aviv Fashion Week (TAFW)</h2>
// 							<p>
// 								Fashion events are always occasions for the celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!
// 							</p>
//                            <p>
// 								In 2019, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 73,
// 	    bgImage:"/posts/bank/73/1.jpg",
// 	    mobBgImage:"/posts/bank/73/M.jpg",
// 	    title: "DGTL FESTIVAL",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 												tlv.dgtl.nl/en
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
//                             <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                             <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology and art, as well as the latest discoveries in production and sound. </p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/73/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include three stages which will operate simultaneously at any given moment.</p>
//                             <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                             <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the host for DGTL. </p>
//                             <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 74,
// 	    bgImage:"/posts/bank/74/1.jpg",
// 	    mobBgImage:"/posts/bank/74/M.jpg",
// 	    title: "Tel Aviv Marathon",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											22.02.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>

// 											<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=5418">
// 												www.tlvmarathon.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Run and fun in the city that doesn’t stop</h2><br/>
//                             <p>Tel Aviv Marathon is the country’s biggest international sports event and a unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its awesome sites and views and feel their heart beat become one with the pulse of this adrenaline charged metropolis. </p>
//                             <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/74/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                             <p>Much more than just a run, the marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                             <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 75,
// 	    bgImage:"/posts/bank/75/1.jpg",
// 	    mobBgImage:"/posts/bank/75/M.jpg",
// 	    title: "Jerusalem Marathon",
// 	    smlTitle: "The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											15.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://jerusalem-marathon.com/Register.aspx">

// 												jerusalem-marathon.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem</h2>
//                             <p>The International Jerusalem Winner Marathon is one of Israel's largest marathons, with 30,000 participants including hundreds of elite runners from Israel and around the world.</p>
//                             <p>The marathon offers a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, Israel's capital guaranteeing a challenging, thrilling and unforgettable experience for all runners. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/75/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>With a series of cultural happenings planned around the central event, the Jerusalem International Marathon provides international runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event. </p>
//                             <p>The Jerusalem marathon allows runners the chance to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners.</p>
//                             <p>The course takes the runner on a unique path through Jerusalem’s 3,000-year historical narrative, on the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of Israel’s capital. The course includes the city’s best known sites including, among others, the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 76,
// 	    bgImage:"/posts/bank/76/1.jpg",
// 	    mobBgImage:"/posts/bank/76/M.jpg",
// 	    title: "Bon Jovi",
// 	    smlTitle: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, TLV
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											25.07.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">

// 												bonjovi.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!</h2>

//                             <p>Bon Jovi, all-time favorites in Tel Aviv, are making their way back to the city, famed for its lively music scene once more to appear in the famous Yarkon Park, the beautiful green lung of the city.
//                             <p>Currently touring America to sold out venues, Bon Jovi will arrive here as part of a new European tour in the summer of 2019, entitled "This House is not for Sale". The tour is set will begin on May 31, 2019 in Moscow and will probably end on July 25, 2019 with their show in Tel Aviv.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/76/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The band, considered e one of the most successful American bands of all times has sold more than 100 million copies, performed in over 2700 concerts in 50 different countries to more than 34 million viewers worldwide.
//                             <p>This is not Bon Jovi's first stint in the city. The band gave a truly memorable performance about three years ago at the Hayarkon Park in Tel Aviv to 50,000 adoring fans, singing along to every lyric .
//                             <p>Those coming to see the band play in Tel Aviv are in for a special treat as they will get to experience Tel Aviv in July, the city’s summer finest,  sunbathe on the fabulous beaches, enjoy the awesome culinary options, take in  the epic hot night life and best of all see Bon Jovi raise it live on stage in the city that doesn’t stop!

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 77,
// 	    bgImage:"/posts/bank/77/1.jpg",
// 	    mobBgImage:"/posts/bank/77/M.jpg",
// 	    title: "TAG 2019",
// 	    smlTitle: "Tel Aviv Games are Back!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											TAG 2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											27-30.3.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">
// 												www.telavivgames.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <h2>
//                             	Tel Aviv Games are Back!
//                           	 </h2>

//                             <p>
// 								Tel Aviv, declared one of the best gay travel destinations in the world, is joining a list of renowned capitals such as Paris, New York, Berlin and Rome, organizing its own LGBT multinational sports event – Tel Aviv Games – TAG2019. TAG 2019 offering the LGBT+ traveler a unique and exciting sports experience.
//                             </p>
//                             <p>
// 								With over 250 athletes from all over the world already signed up, and an estimated 500 more expected, Tel Aviv Games 2019 is anticipated to become the biggest LGBT+ Sports event in the middle east and one of the biggest in Europe.
//                             </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/77/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>
// 								LGBT+ athletes from more than 17 countries (including France, Germany, UK, US, Australia, Canada, Belgium, Czech Rep., Greece, Netherlands, Norway, Spain, Russia, Surnami and more) will come together for a 3-day multi-national celebration of participation, inclusion and personal best.
//                             </p>
//                             <p>
// 								The tournament will include individual and team events in 7 sporting categories: Swimming, Tennis, Basketball, Soccer, Volleyball, Same Sex Dance, and 5K and 10K Competitive Running.
//                             </p>
//                             <p>
// 								This year Tel Aviv Games will also introduce the city’s first ever “Pride Run - Running for the youth”, supporting Healthy LGBT+ Youth lifestyle in a 5K race along Tel Aviv’s beautiful shore.
// 							 </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 78,
// 	    bgImage:"/posts/bank/100/1.jpg",
// 	    mobBgImage:"/posts/bank/100/M.jpg",
// 	    title: "Purim 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											20-22.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tel-aviv.gov.il/en/Pages/MainItemPage.aspx?WebID=9336473c-1537-4ab6-8a69-d299b5db8bcc&ListID=0ac6b290-896c-4fcb-bb36-0c5252101eff&ItemId=123">
// 												Tel Aviv Purim 2019
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <p>Every year in March, the people of Tel Aviv & Jerusalem dress up in costumes, the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/1.jpg"} class="img-responsive" />
// 							</div>

//                             <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – the annual street party is Tel Aviv’s biggest event. Thousands of dressed up people will gather together in “Kikar Hamedina” (State’s Square)  to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/2.jpg"} class="img-responsive" />
// 							</div>
//                             <p>If your prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events is at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/3.jpg"} class="img-responsive" />
// 							</div>
//                             <p>So choose your costume and come celebrate with us!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/4.jpg"} class="img-responsive" />
// 							</div>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: "J_Lo",
// 	    bgImage:"/posts/bank/J_Lo/1.jpg",
// 	    mobBgImage:"/posts/bank/J_Lo/M.jpg",
// 	    title: "J.LO",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Hayarkon Park
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h3>
// 								J.LO HEADING TO TEL AVIV TO SET THE SUMMER ON FIRE!
// 							</h3>
// 							<p>
// 								Yes, it's true! after weeks of rumors flying around it is officially confirmed the J.Lo, AKA Jeniffer Lopes, AKA Jenny from the block, the hottest name worldwide as queen of pop for the past 2 decades, is coming to light up your summer in Tel Aviv!
// 							</p>
//                          <p>
// 								Performing for the first time in this country, J.Lo will be getting loud on the floor on August 1st at the Yarkon Park. The show, part of the maga star’s “It’s My Party” worldwide tour is expected to be one of the summer’s biggest concerts, along with Bon Jovi’s highly anticipated performance on the very same Tel Aviv stage on the 25th July.
// 							</p>
// 							<p>
// 								Hayarkon park is Tel Aviv’s green lung. This is the perfect place to get some respite after spending a wild night in Tel Aviv. Here you can spend the day cycling, walking or relaxing in the beautiful outdoor scenery and even enjoy flying high on a hot air balloon before heading to take your place in the stunning amphitheater. Whatever you choose, make sure to come packed with energy for J.Lo’s once in a lifetime performance in sunny awesome Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: "Pride_Parade_2019",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Parade 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											14.6.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h3>
// 								The  most fabulous event of the Year
// 							</h3>
// 							<p>
// 								<strong>
// 									Tel Aviv 2019 Pride Celebrations – guaranteed to blow your mind!
// 								</strong>
// 							</p>
// 							<p>
// 								Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties. One of the biggest and hottest events, by far in the city is the ‘Gay Pride Week’ parties ending with the awesome Friday Pride Parade.
// 							</p>
//                          <p>
// 								The parade, a tradition which began as early as 1998, draws a huge crowd of the coolest people and thousands of participants from around the world. All them come together to celebrate and support freedom and embrace all lifestyles and genres in an open minded, off the charts, celebration.
// 							</p>
// 							<p>
// 								The parade is the highlight of a week of gay pride events which take place around the city of Tel Aviv and include pride-themed parties, exhibitions, movie festivals, music concerts and so much more.
// 							</p>
// 							<p>
// 								The parade itself takes place along the buzzing main streets of marvelous Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic extravagant floats, live music, dance performances and revelers dressed in a colorful festival dress.
// 							</p>
// 							<p>
// 								The parade stops and rests at the stunning Tel Aviv promenade by the shores of the beautiful coastline, where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.
// 							</p>
// 							<p>
// 								The 2019 parade will take place on June 14th 2019 and participation, as always, will be completely free of charge.
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: "Open_Restaurants_Jerusalem",
// 	    bgImage:"/posts/bank/Open_Restaurants_Jerusalem/1.jpg",
// 	    mobBgImage:"/posts/bank/Open_Restaurants_Jerusalem/M.jpg",
// 	    title: "Open Restaurants Jerusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											19-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												www.open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h3>
// 								Open Restaurants Jerusalem
// 							</h3>
// 							<p>
// 								Taking place in the iconic city of Jerusalem at varying hours, \‘Open Restaurants\’ is a unique culinary festival giving visitors a glimpse into the fascinating cultural and culinary diversity of Jerusalem.
// 							</p>
// 							<p>
// 								The festival includes about 100 different events held all over the city of Jerusalem, even in places which are less culinary oriented, as well as in culinary adequate venues and combine food with art, culture, innovation and technology.
// 							</p>
//                          <p>
// 								Festival-goers will also have a chance to participate in a series of meetings, workshops and lectures by prominent local personalities, and visits to the city\'s famous restaurant kitchens.
// 							</p>
// 							<p>
// 								As part of the festival program, day and night tours will be held at various culinary centers throughout Jerusalem including flavors tours in the Old City,Ein Kerem and more. You are encouraged to take at least one of them!
// 							</p>
// 							<p>
// 								In addition, FoodTalks meetings will be held with leading culinary experts (we can’t reveal who they are, so keep guessing…), photographers and chefs. The top hotels in Jerusalem will also collaborate with their private chefs at special prices.
// 							</p>
// 							<p>
// 								Whether you’re a foodie or just a curious visitor, you are sure to enjoy this unique taste of magical Jerusalem’s culinary side happening between the 19th -23rd , November,2019.
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//                   id: "Jerusalem_Beer_Festival",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													28 - 29.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 	                                <p>The city of Jerusalem is proud to host, for the 15th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’.</p>
// 	                                <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>

// 	                                <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an incomparable atmosphere, guaranteeing an unforgettable experience. </p>

// 	                                <p>The iconic festival has become over the years, a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe, to enjoy a delicious variety of cold beers, food and people in open air of Jerusalem.</p>

// 	                                <p>During the festival you will have the opportunity to taste any (or all) of the variety special flavors of beers from around the country and the world (and we have over 120 of them), served in pop up bars, built specifically for the festival. </p>
// 	                                <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local breweries. </p>

// 	                                <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>
//                                     <a href="https://www.jerusalembeer.com/en" target="_blank" class="jerusalem-link">www.jerusalembeer.com</a>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "DGTL_Festival",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													14.10.19
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to the Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                                    <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now, Tel Aviv. DGTL brings together the worlds of music, technology and art, as well as the latest discoveries in production and sound.</p>
//                                    <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which, will operate simultaneously at any given moment.</p>
//                                    <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for reducing electricity consumption, vegetarian food only, a recycling plan and more. </p>
//                                    <p>The Festival will be held in the fabulous Yarkon Park,  situated in the heart of the buzzing city of Tel Aviv. As a hub of innovation, trendiness and exciting nightlife scene, it is the perfect host for DGTL festival. </p>
//                                    <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

// 	                            `
// 			}
// 		}
//     },

//     {
// 	              id: "The_International_Arts",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "The International Arts",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													12 - 24.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>

//                                     <h2>The International Arts and Crafts Festival 2019<br>
//                                     <small>Hutzot Hayotzer Jerusalem<small></h2>
//                                     <p>Jerusalem is packed with fantastic events throughout the summer. One of the most celebrated events is the colorful “Hutzot Hayotzer -International Art and Crafts Festival”. </p>
//                                     <p>This large-scale annual festival takes place in the Hutzot Hayotzer lane and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
//                                     <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years. It has long since became a hugely popular tourist and artistic attraction for visitors from around the world. Visitors will enjoy more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more, as well as an international exhibition, showcasing the work of overseas artists.  They will be able to engage in fascinating art conversations and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music, all wrapped up in an authentic European carnival atmosphere. </p>
//                                     <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
//                                     <p>Last but definitely not least, don’t miss the “Food around the world” - an Israeli and international food fair, which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>
//                                     <a href="https://artfair-jer.com/english/" target="_blank" class="artfair-link">www.artfair-jer.com</a>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Jerusalem_Marathon",
// 	              bgImage:"/posts/bank/jer-marathon2019/1.jpg",
// 	              mobBgImage:"/posts/bank/jer-marathon2019/M.jpg",
// 	              title: "Jerusalem Marathon",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													20.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://jerusalem-marathon.com/default.aspx">

// 														jerusalem-marathon.com
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
//                                     <h2>A Spectacular run through the 3,000-Year-old city</h2>
//                                     <p>With 30,000 participants including hundreds of elite runners from around the world, The International Jerusalem marathon, is a fantastic celebration of body and mind in the heart of one of the most enchanted cities in the world. </p>
//                                     <p>The Jerusalem International Marathon provides the runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event, with a series of cultural happenings planned around the central event.</p>
//                                     <p>The marathon offers a variety of tracks, from professional to family friendly.</p>
//                                     <p>The course takes you by the fascinating historical sites that reveal the 3,000 years of Jerusalem’s history, the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of the capital. </p>
//                                     <p>The course includes the city’s best-known sites, among others the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>

//                                     <p>Runners are provided with the opportunity to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners. Ultimately guaranteeing an illuminating, challenging, thrilling and unforgettable experience for all runners. </p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Open_Houses_Festival",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, City -Wide
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													19 - 21.09.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">

// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2>An amazing experience for design lovers everywhere</h2>
//                                     <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>

//                                     <p>The ‘Open Houses’ opens a one-time door to allow a glimpse into the forms of design, style of living, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
//                                     <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical as well as urban buildings. The Festival will also include special guided tours and attractions in unusual places -  from tours of residential apartments to tours of  new buildings. </p>
//                                     <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
//                                      <p>"Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
//                                     <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "TelAviv_Marathon",
// 	              bgImage:"/posts/bank/tlv-marathon2020/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-marathon2020/M.jpg",
// 	              title: "La Maratón de Jerusalén",
// 	              smlTitle: "",
// 	              html: function(){
// 			              return {
// 				              __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													28.02.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=6607">

// 														www.tlvmarathon.co.il
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Run and fun in the city that doesn’t stop</h2>
//                                     <p>Tel Aviv Marathon is the country’s biggest international sports event. A unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its remarkable sites and views while their heart beat becomes one with the pulse of this adrenaline charged metropolis. </p>
//                                      <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                                      <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                                      <p>The marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                                      <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Night_Run_TelAviv",
// 	              bgImage:"/posts/bank/tlv-nightrun2019/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-nightrun2019/M.jpg",
// 	              title: "Night Run Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											30.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tlvnightrun.co.il/MenuDefault.aspx?id=6571">

// 												www.tlvnightrun.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2>The most exhilarating 10km you will ever experience</h2>
//                                     <p>A lot has been said about the world-renowned city of Tel Aviv. Named among Lonely Planet’s 'Top 10 Action-Packed Cities’, this city is a truly trendy buzzing metropolis that doesn’t rest. While its official slogan is the Non Stop City, it truly gives NYC a run for its money for the title the City that doesn’t sleep. </p>
//                                     <p>This is especially the case when it comes to the amazing Night Run Tel Aviv annual race. </p>
//                                     <p>With around 25,000 runners and tens of thousands of cheering spectators, this upbeat adrenaline-charged race is more of a full-blown night time party for the scores of participants and spectators who come from all around the world to take part.</p>
//                                     <p>Taking place during the autumn, the 10KM night run begins well after sundown and follows a fantastic urban route along the streets of Tel Aviv, starting at  Rabin Square in the center of town, and south along Rothschild Boulevard, before continuing along Dizengoff Street, Nordau Boulevard, and into Park Hayarkon, reaching the finish line alongside the river. </p>
//                                     <p>You will be passing all the trendy,, fascinating attractions and renowned Bauhaus architecture the "White City" of Tel Aviv has been declared a UNESCO World Heritage Site for. </p>
//                                     <p>Best of all, The TLV Night Run ends with a celebratory finish line festival at Hayarkon park in the heart of the city where thousands more come to join the runners and spectators in an all-night rager of music, dancing and nonstop fun.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Celine_Dion",
// 	              bgImage:"/posts/bank/Celine_Dion/1.jpg",
// 	              mobBgImage:"/posts/bank/Celine_Dion/M.jpg",
// 	              title: "Celine Dion",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											04.08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.celinedion.com">

// 												www.celinedion.com

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Our Heart Goes On – for Celine Dion in Tel Aviv!</h2>
// 										<p>The Diva is coming! Now it’s official: Celine Dion will perform in Tel Aviv on August 4th of next summer and it’s going to be a hot one! This will be Dion’s first ever concert here, and boy are we excited.</p>

//                                         <p>The 6 Grammy award-winner will visit Tel Aviv, the city that never sleeps, to keep the party going all Night. Dion’s countless hits, “Because you Loved Me”, “Just Walk Away” and of course her all-time greatest hit – “My Heart Will Go On” – will hopefully make their debut live in Tel Aviv.</p>

//                                         <p>Tel Aviv has also hosted some of the largest art exhibitions, live shows and festivals, making it one of the liveliest cities in the world. With a combination of sun, rich nightlife scene, spectacular sights in every corner and the Dion’s first appearance – Tel Aviv is the place to be next summer.</p>

//                                         <p>Ticket sales have yet to open, but it’s never too early to start planning your next visit to Tel Aviv!

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Nickcave_Badseeds",
// 	              bgImage:"/Concerts/bank/nickcave_badseeds/1.jpg",
// 	              mobBgImage:"/Concerts/bank/nickcave_badseeds/M.jpg",
// 	              title: "NICK CAVE & BAD SEEDS",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Bloomfield Stadium, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											17.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 												Update Soon

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">NICK CAVE AND THE BAD SEEDS LIVE IN TEL AVIV!</h2>
//                                     <p>Nick Cave is coming to Tel Aviv to blow the roof off! Returning to the city that never sleeps in June 2020, the Australian pop-punk musician is coming to rock you.</p>

//                                     <p>Having recorded no less than 17 studio albums with his band, the talented musician is excited about his visit – which will be hotter than ever.</p>

//                                     <p>Coming back just a little more than two years after his previous performance here, this time, lighting up the newly renovated Bloomfield Stadium (which has hosted a long line of international artists). Judging by the last performance, this one should be truly sensational.</p>

//                                     <p>Tel Aviv has been known to attract and feature some of the biggest names in the world, making it one of the hottest cities when it comes to live concerts and the nightlife scene. This performance shouldn’t be any different and is a great opportunity to catch Nick Cave live, as part of his summer tour.</p>

//                                     <p>Warm summer nights, soft sand beaches and the mesmerizing music of a world-renowned artist – what more could you ask for? Tel Aviv has it all!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Louis_CK",
// 	              bgImage:"/posts/bank/Louis_CK/1.jpg",
// 	              mobBgImage:"/posts/bank/Louis_CK/M.jpg",
// 	              title: "He’s coming back! Louis CK in Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Hangar 11, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/events/%D7%A4%D7%99%D7%A1-%D7%90%D7%A8%D7%A0%D7%94-%D7%9E%D7%9C%D7%97%D7%94-%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%9C%D7%95%D7%90%D7%99%D7%A1-%D7%A1%D7%99-%D7%A7%D7%99%D7%99-%D7%91%D7%94%D7%95%D7%A4%D7%A2%D7%94-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C-louis-ck-live-in-israel/554683431359536/">

// 												Louis CK

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>Back for the second time, Louis CK will preform at the Hangar 11 in Tel Aviv, this upcoming November.</p>

//                                     <p>After his tremendous success in Jerusalem in 2016, Louis CK is about to return for another exclusive show; this time, right here in Tel Aviv, one of the hottest cities for live shows.</p>

//                                     <p>The talented, hilarious comedian is back in action after a two-year break making this show, bigger, better and funnier than ever. Having a wide following audience in Tel Aviv alone, the sharp comedian is sure to light up the stage.</p>

//                                     <p>Tel Aviv has hosted dozens of comedians from all over the world, including Jerry Seinfeld and Chris Rock, Jim Jefferies and many others, is the ultimate city for having a good time. The city is known for its art and culture as well as its exciting club scene and trendy bars and restaurants.</p>

//                                     <p>So book your trip now and get ready for an unforgettable time in the city that doesn’t stop!</p>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Cycle_Tel_Aviv",
// 	              bgImage:"/Concerts/bank/cycle-tlv-2019/1.jpg",
// 	              mobBgImage:"/Concerts/bank/cycle-tlv-2019/M.jpg",
// 	              title: "Cycle Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											All Around Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											18.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>The mild to warm October weather, combined with the energetic vibe of Tel Aviv, provide the perfect setting for the biggest cycling event in the country.</p>

//                                     <p>Thousands of cycling enthusiasts flock to Tel Aviv to ride through the vibrant city, on a scenic course showing you everything Tel Aviv has to offer:</p>

//                                     <p>From the beautiful Yarkon Park, along the coast, past the city’s many dazzling beaches and back up to the park through the city center, you’ll get a glimpse of every characteristic place, the “Mediterranean capital” has to offer.</p>

//                                     <p>Everyone can experience the thrill and excitement of the event, from the 60 km course for professional riders to the 8 km course for families and beginners, there is even a rollerblades course for those who prefer to make their way through the city on foot.</p>

//                                     <p>With the locals coming out in droves to cheer on the event, you’ll see a colorful and diverse crowd, adding to the fun and excitement in the air.</p>

//                                     <p>Whether you’re looking for a personal challenge to compete against some of the top riders in the country, or you’re hoping to enjoy a family day out with the crowds, you’re sure to experience the beauty and energy that makes up the unique atmosphere of Tel Aviv.</p>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "DGTL_Festival_2020",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							         <p>DGTL Festival is back!  B</p>
//                                     <p>ringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                                     <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology, and art, as well as the latest discoveries in production and sound. </p>
//                                     <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which will operate simultaneously at any given moment.</p>
//                                     <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                                     <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the perfect host for DGTL festival.</p>
//                                     <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world!

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Pride_Week_2020",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Week 2020",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											12.6.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<div class="responisve-iframe">
// 					             <iframe width="560" height="315" src="https://www.youtube.com/embed/U8KwXVP3Xng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				             </div>
// 				             <div class="ac-cradit" style="margin-top: -15px;margin-bottom: 40px;">
// 							<span class="ac-cradit-text">Credits:</span>

// 								<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
// 							</div>
// 							<p></p>
// 							</div>
// 							 <h2 class="ac-align-center">The  most fabulous event of the Year</h2>

//                             <p class="ac-align-center ac-margin-bottom-20"><strong>Tel Aviv 2020 Pride Celebrations – guaranteed to blow your mind!</strong></p>
//                             <p>Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties, but by far one of the biggest and hottest events in the city are the Gay Pride Week festivities culminating in the awesome Friday Pride Parade.</p>
//                             <p>The parade, a tradition which began as early as 1998 draws a huge crowd of the coolest people from around the world who come together to celebrate and support freedom and the embracing of all lifestyles and genres in an open-minded off the charts celebration.</p>
//                             <p>The parade is the highlight of a week of gay pride events that take place around the city and include nonstop pride-themed parties, exhibitions, movie festivals, music concerts and so much more. </p>
//                             <p>The parade itself takes place along the buzzing main streets of amazing Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic floats, live music, dance performances and revelers dressed in a colorful festival dress.</p>
//                             <p>The parade culminates at the stunning Tel Aviv promenade by the shores of the beautiful Tel Aviv coastline where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.  </p>
//                             <p>The 2020 parade will take place on June 12th 2020 and participation, as always, will be completely free of charge. </p>

// 					               `
// 			}
// 		}
//     },

//     {
// 	              id: "Hutzot_Hayotzer_Jerusalem_2020",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "Hutzot Hayotzer Jerusalem",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													The Sultan’s Pool, Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <div class="clear"></div>
//                                     <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">The International Arts and Crafts Festival</h2>
//                                     <p>Jerusalem is packed with fantastic events throughout the summer, one of the most celebrated events is the colorful “Hutzot Hayotzer International Art and Crafts Festival”. </p>
//                                     <p>This large-scale annual festival takes place in the Hutzot Hayotzer area and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
//                                     <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years and has become a hugely popular tourist and artistic attraction for visitors from around the world.</p>
//                                     <p>The festival includes more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more. The festival also includes an international exhibition, showcasing the work of overseas artist.</p>
//                                     <p>Visitors will get to engage in a fascinating dialogue of art and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music and all in an authentic European carnival atmosphere. </p>
//                                     <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
//                                     <p>Last but definitely not lease, don’t miss the “Food around the world” - an Israeli and international food fair which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//                   id: "Jerusalem_Beer_Festival_2020",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							        <p>The city of Jerusalem is proud to host, for the 16th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’. </p>
//                                     <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>

//                                     <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an unparalleled atmosphere, guaranteeing an unforgettable experience.</p>

//                                     <p>The iconic festival has become over the years a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe to enjoy a delicious variety of excellent cold beers, food and people in open Jerusalem air.</p>

//                                     <p>During the festival, you will have the opportunity to taste any (or all) of the over 120 special flavors of beers from around the country and the world, served in pop up bars, build specifically for the festival. </p>
//                                     <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local artisanal breweries.</p>

//                                     <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Jerusalem_Wine_Festival_2020",
// 	    bgImage:"/Concerts/bank/jer-wine-festival-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jer-wine-festival-2020/M.jpg",
// 	    title: "Jerusalem Wine Festival",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							 <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Wine and dine in the holy city!</h2>
// 							<p>Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world-class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premier social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.</p>
//                             <p>Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!</p>

// 					     `
// 			}
// 		}
//     },

//     {

// 	              id: "Open_Houses_Festival_2020",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, City -Wide
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													09.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">

// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">An amazing experience for design lovers everywhere</h2>
//                                     <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year in a row, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>
//                                     <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical buildings, and urban buildings. I from tours of residential apartments and new buildings. The Festival will also include special guided tours and attractions in unusual places.</p>
//                                     <p>The ‘Open Houses’ opens a one-time door and allow a glimpse into the forms of design, life forms, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
//                                     <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
//                                     <p> "Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
//                                     <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Purim_2020",
// 	              bgImage:"/Concerts/bank/purim2020/1.jpg",
// 	              mobBgImage:"/Concerts/bank/purim2020/M.jpg",
// 	              title: "Purim 2020",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv and Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													09-10.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									</div><div class="clear"></div>

//                                     <p>Every year in March, Tel Aviv and Jerusalem people dress up in costumes and the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!</p>
// 		                            <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/1.jpg"} class="img-responsive" />
// 									</div>
// 		                            <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – with the annual street party being Tel Aviv’s biggest event. Thousands of dressed up people will gather together in Kikar Hamedina to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.</p>
// 		                            <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/2.jpg"} class="img-responsive" />
// 									</div>
// 		                            <p>If you prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events are held at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!</p>
// 		                            <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/4.jpg"} class="img-responsive" />
// 									</div>
// 		                            <p>So choose your costume and come celebrate with us!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "TelAviv_Fashion_Week_2020",
// 	    bgImage:"/Concerts/bank/fashion-week-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/fashion-week-2020/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											03.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">C'est chic, magnifique!</h2>
//                             <p>Fashion events are always a celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene. </p>

//                            <!--<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>-->
// 							<p>TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!</p>
//                             <p>In 2020, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: "The_Jerusalem_March_2020",
// 	    bgImage:"/Concerts/bank/jerusalem-march/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jerusalem-march/M.jpg",
// 	    title: "The Jerusalem March",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											30.09.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<p>Taking place in October, the Jerusalem Walk is one of the most colorful and exciting events in the country, bringing together tens of thousands of marchers from around the world.</p>
//                              <p>The Jerusalem march includes three events - a morning walk on nature trails, a happening in Sacher Park and a festive parade that takes place in the streets of central Jerusalem.</p>
//                              <p>To ensure the inclusion of all those who want to join, the march offers a variety of routes with different lengths and difficulty levels. </p>
//                              <p><strong>Morning Tracks</strong><br/>
//                              	<u>Track A</u> - for those who can walk, about 12 km (07:00 to 09:00)</p>
//                              <p><strong>Ammunition Hill to Sacher Park.</strong><br/>
//                              	<u>Track B</u> - Medium difficulty level, about 9 km (07:30 to 09:30)</p>
//                              <p><strong>Mount Scopus to Sacher Park.</strong><br/>
//                                 <u>Track C </u>- easy / family difficulty level, about 4 km (08:00 to 10:00)</p>
//                              <p>Safra Square to Sacher Park.<br/>
//                              Sacher Park Festival </p>
//                              <p>Between 10:00 and 16:00 a festive happening will take place in Sacher Park that will include performances, live music and children’s shows, and a designated area dedicated for kids. </p>
//                              <p>The festive parade will begin at 15:00 and will follow the route of Bezalel, Hillel and King David streets and will end next to the bell park and will include collector vehicles, representative groups from Israel and around the world, orchestras, dance groups, IDF soldiers, street artists, sports teams and more.</p>
//                              <p>Don’t miss your chance to take part in this beautiful and lively Jerusalem celebration! </p>

// 				`
// 			}
// 		}
//     },

//     {

//         id:"The_Pixies_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											14.07.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">The Pixies - coming back to rock it live Tel Aviv!</h2>

// 										<p>The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!</p>
// 			                            <p>The famous American band, well known for its signature style of aggressive punk rock and pop, is responsible for some of the most iconic tunes in music history, including their all-time audience favorite ‘where is my mind’. The pixies are returning to Tel Aviv for the third time as part of their promotional tour for their new album, ‘Beneath the Eyrie’. </p>
// 			                            <p>The pixies will be giving a single performance in the nonstop city of Tel Aviv, the perfect way to rock your beach, sun and fun Tel Aviv holiday.  The concert is set to be held in July, a fabulous time to enjoy the famous Tel Aviv summer, the parties, the amazing cuisine, and the stunning beaches. </p>
// 			                            <p>Tickets are selling fast so hurry up and book your trip today!  </p>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"White_Night_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "White Night",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">A “White Night” Rager In the Non-Stop City!</h2>

// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…</p>
//                             <p>From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.</p>
//                             <p>This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<p>The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time. </p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv! </p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"Piano_Competition_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "La Competición Internacional de Piano Rubinstein 2020",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>Fecha</h2>
// 									<div class="text">
// 										<p>
// 											05-21.05.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas Informacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://arims.org.il/">
// 											www.arims.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p>No faltan eventos fantásticos de arte y cultura en Tel Aviv, pero la Competición Internacional Rubinstein es el orgullo de la ciudad.</p>
// 							<p>39 pianistas de extremado talento han sido nominados para participar en la Competicion Internacional de Maestros del Piano Arthur Rubinstein. 15 competidores vienen de Asia, 10 de Europa del Este, 7 de Europa Occidental, 3 talentos locales, 2 de Georgia y 2 de los EE.UU. Tel Aviv, el núcleo cultural de Israel, se enorgullece de darles la bienvenida.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/piano-competition-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>Las primeras dos fases de esta prestigiosa competición tendrán lugar en el Museo del Arte de Tel Aviv, una de las instituciones culturales y artísticas líderes del país. El vibrante Mercado de Sarona está solo a 10 minutos andando.</p>
// 							<p>Las ultimas fases se celebrarán en el Auditorio de Charles Bronfman, también conocido como el Palacio de la Cultura (Heichal Ha Tarbut), en la plaza de Habima, al lado del teatro nacional. Algunas de las mejores cafeterías y restaurantes de Tel Aviv se encuentran muy cerca, además del precioso Rothschild Boulevard.</p>
// 							<p>La venta anticipada para socios ya ha empezado. La venta para todo el público empezó el 16 de febrero. del 2020.</p>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"Red_Hot_Chili_Peppers_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Red Hot Chili Peppers",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Parque Hayarkon Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>Fecha</h2>
// 									<div class="text">
// 										<p>
// 											10.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas Informacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://redhotchilipeppers.com/">
// 											www.redhotchilipeppers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<p>¡Son candentes, son sexis, son los Red Hot Chili Peppers, y vuelven a Tel Aviv por primera vez desde el 2012!</p>
// 							<p>Con 11 álbumes, 16 nominaciones a los Grammy y seis premios, esta banda mega-exitosa hará que tu cuerpo y alma bailen en el nuevo Festival Funkyard que se celebrará en el corazón verde de Tel Aviv – el parque Hayarkon.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/red-hot-chili-peppers-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>En diciembre pasado, la banda anunció la reincorporación por segunda vez de su legendario guitarrista John Frusciante, y es de esperar que los iconos del funk-rock de LA volverán a arrasar en el parque.</p>
// 							<p>Los Red Hot Chili Peppers darán un único concierto en la ciudad que nunca para, donde puedes empezar el día bronceándote en la playa con unas cervezas fresquitas y acabar en uno de los animados bares abiertos hasta el amanecer. Los Peppers actuarán al principio del verano cuando las temperaturas aún no son muy altas, aunque las fiestas por la ciudad están al rojo vivo.</p>
// 							<p>Las entradas ya están a la venta y se van a agotar, así que, ¡reserva tu viaje antes de que ya no queden más!</p>

// 						`
// 			}
// 		}
// 	},

// ];

// End live shows

export const ShowsPostsData = [];
export const newPostdata = [
  {
    id: "eurovision",
    bgImage: "/posts/bank/eurovision/1.jpg",
    mobBgImage: "/posts/bank/eurovision/M/1.jpg",
    title: "EUROVISION TEL AVIV",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/logo.png"} class="img-responsive" />
					</div>
					<h3>
						A ONCE IN A LIFETIME OPPORTUNITY TO VISIT TEL AVIV AS IT HOSTS THE EUROVISION SONG CONTEST
					</h3>
					<p>					
						Epic song contest in the Non-Stop City
					</p>
					<p>
						Semi-final 1: 14 May 2019
					</p>
					<p>
						Semi-final 2: 16 May 2019
					</p>
					<p>
						Grand Final: 18 May 2019
					</p>
					<p>
						It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city.
					</p>					
					<p>
						Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak. Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest.
					</p>            
                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv.
					</p>
					<p>
						The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all!
					</p>

            	`,
      };
    },
  },

  {
    id: "Get_ready_to_party",
    bgImage: "/posts/bank/Get_ready_to_party/1.jpg",
    mobBgImage: "/posts/bank/Get_ready_to_party/M/1.jpg",
    title: "The best Eurovision parties to be at",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

               <h3>
               	Your Total Guide to Tel Aviv Eurovision parties
               </h3>
               <p>
					From the Eurovision Village to the EXPO Centre, these are all the key places you need to know about for Eurovision 2019 in Tel Aviv…
				</p>
				<h3>
					CHARLES CLORE PARTY VENUE
				</h3>
				<h3>
					Charles Clore Park: home to the largest Eurovision Village to have ever been made.
				</h3>
				<p>
					Charles Clore Park is located on the sea-front in the south-west of Tel Aviv. It’s a beautiful green space overlooking Old Jaffa, one of the most ancient places in Tel Aviv. 
					During Eurovision week it will be home to the Eurovision Village, where free concerts from the biggest Eurovision stars will take place. Highlights include Dana International and Conchita Wurst, plus parties and screenings of the live Eurovision TV shows will take place outside, right in-front of the beautiful Mediterranean sea! 
				</p>
				<p>
					Also, some of Israel’s best chefs will be opening food stalls for the public to get first-hand experience of-mouth-watering Israeli and Middle-Eastern cuisine.
				</p>
				<p>
					Charles Clore is easy to get to: It’s a five minute walk from the Carmelit bus terminal, so any bus terminating there is a good choice. Then you can just walk towards the sea and you’ll see the village. If coming by foot, walk along the beach promenade. Or you can cycle or scoot along the sea front to get there. 
					It’s a big park and will be having a Eurovision makeover, so you won’t be able to miss it! In fact, this is the largest village to ever have been made for the Eurovision!
				</p>
				<h3>
					TEL AVIV PORT VENUE (“The Namal”)
				</h3>
				<h3>
					Home to 2019’s official Eurovision Euro Club
				</h3>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					The club will feature theme parties, live performances, screenings of the Eurovision live shows and many more surprises to be revealed. Former Eurovision acts and winners, both Israeli and international, are set to perform there during the Eurovision week, so the venue will offer much more than just a traditional night-club. Entry to the Euroclub is free for accredited fans, journalists, delegations and artists. Members of the general public can get in to the Euroclub by purchasing a special weekly bracelet, here:
					<a href="https://www.eventer.co.il/euroclub?fbclid=IwAR37-d_19OE7bsq0rQ_gPHAW-sRfn1QAMi-cxp_ID2pFtDODBYzbf5NB6S0" target="_blank">https://www.eventer.co.il</a>
				</p>
				<h3>
					EUROVISION VENUE
				</h3>
				<h3>
					Expo Tel Aviv: home to the Eurovision Song Contest itself
				</h3>
				<p>
					The 2019 Eurovision Song Contest will be held at the Tel Aviv Expo center on the14th, 16th and 18th May. If you’ve got tickets, this is the place you’ll need to get to.
					It’s located on Rokach Boulevard in the north of the city, past HaYarkon Park and near to Tel Aviv University. To get there, use a journey planning app to find a bus route that will drop you right outside. Or, if travelling by train, get off at Tel Aviv University Train Station which is just a few minutes’ away from the convention centre.
				</p>
				<p>
					Don’t forget about the White Night, all the details are in the next article.
				</p>

         	`,
      };
    },
  },

  {
    id: "Tourist_info",
    bgImage: "/posts/bank/Tourist_info/1.jpg",
    mobBgImage: "/posts/bank/Tourist_info/M/1.jpg",
    title: "Tourist info",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

					<h3>
					How to get to Tel Aviv from the airport:
					</h3>
					<p>
					The cheapest way to get into central Tel Aviv from Ben Gurion airport is by train. Follow the signs to the train station that’s attached to the airport (it’s clearly sign-posted) and look for a train that’s going to Tel Aviv-HaHagana (for south Tel Aviv), Tel Aviv-HaShalom (for Central Tel Aviv), Tel Aviv-Savidor Center (for the Old North area of Tel Aviv), or Tel Aviv-University (for the Eurovision Song Contest venue itself). Please note that Tel Aviv HaShalom is closed on Fridays until September 2019. 
					A one-way single ride ticket will cost 13 shekels 50, and the journey takes around 25 minutes. When you get off the train, you might want to take a taxi to your accommodation. Whenever you get in a taxi, ask the driver to use the meter (“monet”) and have cash ready to pay. Or see below for details of taxi apps. For more information and to plan your journey, visit <a href="https://www.rail.co.il/en" target="_blank">https://www.rail.co.il/en</a>: - it’s in English!
					</p>
					<p>
					If you’d prefer to take a taxi all the way to Tel Aviv from the airport, then join the registered taxi queue outside the arrivals hall. A member of staff will ask you where you’re going and how many passengers and cases you have, then will give you a ticket to hand to your driver. You can either use a meter or accept a fixed price. Journeys usually cost around 150-170 shekels for one person. 
					</p>
					<h3>
					How to get from Tel Aviv to Jerusalem:
					</h3>
					<h3>
					By Bus
					</h3>
					<p>
					Head to the Tel Aviv Savidor train central station take bus no.480. The journey time is around 45 minutes. The bus route finishes at the Jerusalem Central Bus Station on Jaffa Road. From there you can take the tram or any other means of transportation available to you, to get to your final destination. 
					</p>
					<h3>
					By Train
					</h3>            
					<p>
					You can also take the brand new train! If you want to go to Jerusalem directly from Ben Gurion Airport, take the train to Navon Station in Jerusalem. The journey from the airport takes around 25 minutes. If you’re connecting from other Tel Aviv stations, just take a train to Ben Gurion Airport station and change there for a connection to Navon.  
					</p>            
					<h3>
					How to get around Tel Aviv
					</h3>
					<p>
					The municipality of Tel Aviv will offer free public transport throughout the city over the weekend of the Eurovision Song Contest. 
					Free buses will run on Friday and Saturday May 17-18.
					However Usually on Saturday there is no public transport in Tel Aviv (aside from taxies).
					</p>
					<p>
					For the other days of Eurovision week, you’ll need a Rav Kav card: Similar to the “Oyster Card” in London, a Rav Kav is a smart card that can be loaded with credit to allow you to ride on buses without needing to worry about cash. In fact, bus drivers no longer let you pay in cash, so it’s super important to get a Rav Kav as soon as you arrive in Tel Aviv.
					To get a card, just jump on a bus at any bus stop, and ask the driver for a Rav-Kav card - it costs 5 shekels (You will need exact change). Then, when you get off the bus, take the card anywhere with you. Some local 7/11s (Kiosk) provide top up serives, ask to add some credit. 50 shekels is probably enough for a one-week visit, as it will cover the cost of around 10 local journeys (each journey is 5 shekels 90). 
					You can also buy a Rav Kav at the official Rav Kav office at 35 Iban Gabirol Street, which is open Sunday to Thursday 8:00 - 20:00 and Friday and holiday eves 8:00 - 13:00 ,or in the Tel Aviv Savidor train station and Carmelit central. You can also add credit at any train station. 
					</p>
					<h3>
					Cycling
					</h3>
					<p>
					Tel Aviv is a cycling hot-spot and there are bike lanes all around the city, including one that runs all the way along the beach promenade from Jaffa in the south  the north of Tel Aviv and beyond, which are gorgeous locations to take a bike ride while soaking up the atmosphere and architecture of Tel Aviv. If you have a bicycle helmet, bring it with you. 
					</p>
					<h3>
					Electric Scooters
					</h3>
					<p>
					Scooters have become super popular in Tel Aviv! They offer a convenient and fun way to get round the city. There are a few brands around – all you have to do is download the relevant app, follow instructions and off you go. Swap your handbag for a rucksack as this will help with balance and remember to keep an eye on the traffic and not to listen to music while scooting. If you have a helmet, it’s a good idea to wear it while you scoot
					</p>
					<h3>
					Walking
					</h3>
					<p>
					Walking is also a great option too - your step-count will soar after a few days in the non-stop city! Equip yourself with a map, a sun-hat and a bottle fo water, and hit the pavements!
					</p>
					<h3>
					Transportation Apps 
					</h3>
					<p>
					There are various transportation apps you can download before arrival to help you plan your way around. Search for one from each category: there are taxi apps, bicycle rental apps, scooter rental apps and journey planning apps. You can also ask your hotel concierge or apartment host for advice on how to get around Tel Aviv - they will be happy to help! 
					</p>
					<h3>
					WIFI
					</h3>
					<p>
					Tel Aviv has a free Wifi network throughout the city. Look for the ‘Free TLV’ network in your smartphone - it works in 80 locations around the city. Most cafes and bars have free public Wifi networks you can use too; just ask for the password when you make your order. Hotels also have free Wifi so just ask for the password information when you check-in.
					</p>

         	`,
      };
    },
  },

  {
    id: "White_night",
    bgImage: "/posts/bank/White_night/1.jpg",
    mobBgImage: "/posts/bank/White_night/M/1.jpg",
    title: "White night",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<h3 class="align-center">
							  White Night Lights Up Tel Aviv on 16th May 
							</h3>
        					<div class="responisve-iframe">
								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
							</div>

							<p>What do you get when you cross a Eurovision Semi-Final with an all-night party in a city that is famous for its 24/7 party energy? The answer is White Night, which will hit Tel Aviv this year on Thursday 16th May, just two days before the 2019 Eurovision Song Contest grand final.</p>
                            <p>Featuring pop-up art installations, live music, dance parties, cultural events, food and drink, all fused together with Tel Aviv’s eclectic atmosphere, White Night is one of the biggest cultural events of the year. </p>
                            <p>And for 2019, it’s taking place a month earlier than usual, so that visitors coming for the Eurovision Song Contest can also experience this magical experience in the White City of Tel Aviv.</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/1.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Adam Primer
							</small>

							<p>From sunset until sunrise, the city will be wide-awake with cultural activities. Locals and visitors alike are invited to explore the city and soak up all the activities on offer. Many bars, restaurants and shops will be offering experiences free of charge or at reduced rates, so it’s definitely worth stocking up on sleep so you’re ready to party all night long!</p>
                            <p>And at the Eurovision Village in Charles Clore Park, there’ll be an extra sparkle of Eurovision magic, as several icons of the competition take to the stage to entertain visitors during the night. </p>
                            <p>Last year’s runner-up, Eleni Foureira, who narrowly missed out to Tel Aviv’s own Neta Barzilai with her smash-hit song “Fuego”, will be performing, as will 2014 winner, Conchita Wurst from Austria, who will most likely perform his iconic winning song, “Rise Like a Phoenix” while showcasing his new-look for 2019!</p>
                            <p>They’ll be joined by three more Queens of Eurovision, in the form of 1970s pop icon Anne-Marie David, who won for Luxembourg in 1973, Swedish pop star Carola Häggkvist, who won the contest in 1991, and Loreen, who also won for Sweden in 2012 with her song Euphoria. The performances will take place on the coast, overlooking the Mediterranean; the live semi-final will also be shown on big-screens in the Eurovision Village, off-set by jaw-dropping light compositions, created by the competition’s official lighting partner OSRAM.</p>
                            <p>All in all, White Night is a night not to be missed. So make the 15th May your duvet day and get-set to party all night long on Thursday 16th May 2019. Tel Aviv is ready and waiting to celebrate with you!</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/2.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Kfir Sivan
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/3.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by Moshik Lindenbaum
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/4.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by: Guy Yechiely‎.
							</small>

         	`,
      };
    },
  },

  {
    id: "Tel_Aviv_Street_Food",
    bgImage: "/posts/bank/street-food/1.jpg",
    mobBgImage: "/posts/bank/street-food/M/1.jpg",
    title: "TEL AVIV STREET FOOD",
    ctg: "telaviv",
    isVid: true,
    vidId: "JQD9JpMaw9g",
    smlTitle: "",
    html: function() {
      return {
        __html: `

                     <h3>It is no wonder that Tel Aviv was named one of Saveur Magazine’s “Outstanding Culinary Destinations</h3>

                        <p>Tel Aviv, home to sandy beaches, non-stop action and a raging nightlife, is also chock-full of unique restaurants and bars, making the seaside city a trendy foodie destination. The Tel Aviv food industry is truly the city’s heart and soul and while plenty of high-end eateries can be found throughout Tel Aviv, it is fresh local street food that has taken the city by storm.</p>

                        <h3>Taking traditional street food to a whole new level</h3>

                        <p>Say goodbye to the days where Tel Aviv street food was mostly limited to the scrumptious, yet singular concept of crisply fried falafel stuffed into a freshly baked pita. Today, the Tel Aviv street food scene is just that - a scene, with gourmet and specialty treats being served to the masses on local street corners. Take a walk down Ibn Gvirol, Ben Yehuda or Carmel streets and choose from a myriad of high-end meats, fish, prepared vegetables and sauces, all artfully inserted inside pita bread, between slices of toast or other casings. Nibble on the succulent delicacies inspired by the four corners of the world - sabich and tahini in laffa bread, unique herring sandwiches and more, as you continue to wander throughout the city, a taste of Israeli culture on your tongue and a pleasant sense of satisfaction in your belly.</p>


                        <h3>Restaurant quality meals for the foodie on the go</h3>

                        <p>What more could a bustling city full of hurried business professionals and excited tourists want than easy access to flavorful and trendy dishes that can be eaten on the go? With more and more unique streetside quick-stop eateries popping up throughout the city and serving dishes like entrecote-stuffed ciabatta bread and cornflour arepas, it is no wonder that Tel Aviv was named one of Saveur Magazine’s “Outstanding Culinary Destinations.” </p>

                        <p>Foodies delight: Tel Aviv and its hip street food scene, with countless delectable choices on every corner, is the ultimate culinary travel destination and a must-visit stop on your next Israel trip.</p>

         	`,
      };
    },
  },

  {
    id: "Jerusalem_Old_City",
    bgImage: "/posts/bank/jerusalem-old-city/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-old-city/M/1.jpg",
    title: "LA CIUDAD VIEJA!",
    ctg: "jerusalem",
    isVid: true,
    // vidId:"FvAWuLQEOJw",
    vidId: "rkjLPq-Zsp8",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                     <br/>
                     <h3>
                         Sienta cómo la historia cobra vida. Inspírese con los tesoros de fama mundial de la Ciudad Vieja de Jerusalén
                     </h3>
                     <h3>Sienta el resplandor espiritual que irradia de sus murallas </h3>
					<p>Visitar la Ciudad Vieja de Jerusalén es como viajar a un nuevo mundo, místico y mágico. Considerada durante mucho tiempo como uno de los lugares más sagrados y visitados del mundo, que alberga estructuras y restos significativos para las tres religiones monoteístas: judaísmo, cristianismo e islam. Un paseo por sus pasajes sagrados es una emocionante fuente de cambio de perspectiva histórica, cultural y espiritual que no se puede perder.</p>
                    
					<h3>Un entorno iluminado espiritualmente</h3>
					<p>Únase a los numerosos turistas que visitan diariamente la Ciudad Vieja de Jerusalén y será transportado en el tiempo. Sea testigo cómo judíos, musulmanes, cristianos y armenios viven e interactúan mientras visita los numerosos sitios inspiradores y espiritualmente edificantes, escondidos entre los callejones sinuosos de la Ciudad Vieja y camuflados por la uniformidad de la piedra de Jerusalén. Recorra la Vía Dolorosa y visite las numerosas iglesias ornamentales, destacando la Iglesia del Santo Sepulcro, rinda respeto en la Tumba del Jardín, susurre una oración en el Muro Occidental (Kotel), visite los túneles del Kotel o adéntrese en el muy ajetreado mercado árabe. Las estructuras son sensacionales y le conectan a una época pasada.</p>
					<div class="img-wrapper">
								<img src=${getImgUrl() +
                  "/posts/jerusalem-old-city2/1.jpg"} class="img-responsive" />
							 </div>
					<h3>Un paseo moderno a través de la historia antigua</h3>
					<p>Entre a la Ciudad Vieja por cualquiera de sus grandes y magníficas puertas y será transportado instantáneamente a una época antigua, con olores auténticos y lugareños vestidos de forma tradicional. Aquí, podrá encontrar estrechos carros tirados por burros, bicicletas y vehículos de tamaño especial que dominan las estrechas calles y callejones y que dan una sensación rústica del viejo mundo. Comerciantes apasionados, gestionan bulliciosas tiendas, puestos y restaurantes, cada uno vende sus mercancías con gran energía.</p>
					<p>En la Ciudad Vieja asegúrese de caminar a lo largo de las paredes de piedra antiguas y encontrará impresionantes vistas,hermosas e históricamente ricas, de los sitios circundantes, lugares de interés y acontecimientos cotidianos apasionantes. Dé un paseo a lo largo de las murallas de la Ciudad Vieja o visite el adyacente Museo de la Torre de David, donde la historia cobra vida a través del sonido y la luz, magnificando la belleza pura y el significado de los adoquines que pisa.</p>



                     <!--<p>No other place offers as many attractions and emotionally inspiring sites in a single square kilometer. A tour of the Old City of Jerusalem is an opportunity to get lost among the magical walkways and connect with the city’s resplendent past, history, culture and spirituality. </p>

                             <h3>The Western Wall</h3>
                             <p>Thousands of years old, the Western Wall is the last remaining relic of the Second Jewish Temple and the most important Jewish prayer site in the world, where millions of visitors from around the world place notes with requests and prayers into its cracks.</p>
                             
                             <h3>Western Wall Tunnels</h3>
                             <p>Located beneath the Western Wall, the tunnels provide a glimpse of the various periods in the history of Jerusalem and are as close as you'll probably get to travelling back in time.</p>

                             <h3>City of David</h3>
                             <p>Discover the story of Jerusalem during the reigns of Kings David, Solomon and Hezekiah in this captivating archeological site, where many treasures have been unearthed. A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was carved during the reign of King Hezekiah.</p>

                             <h3>The Old City Market</h3>
                             <p>A must-see attraction made up of a series of alleyways, with numerous stalls offering a staggering variety of products of every imaginable kind. This lively bustling market (or shuk) is a perfect place to pick up a unique souvenir (haggling is a
                             must) or try one of the many local delicacies.</p>-->
         	`,
      };
    },
  },

  {
    id: "Jerusalem_Calling",
    bgImage: "/posts/bank/25/1.jpg",
    mobBgImage: "/posts/bank/25/M.jpg",
    vidId: "1Yx2Uht4rms",
    ctg: "jerusalem",
    isVid: true,
    title: "Jerusalén te está Llamando",
    smltitle: "",
    html: function() {
      return {
        __html: `

				    <p>
						¿Qué más se puede decir sobre la ciudad más singular del mundo? En pocas palabras: Bienvenido a Jerusalén, donde una historia gloriosa se entrelaza con una vida moderna y dinámica.
					</p>

					<p>
						Jerusalén alberga innumerables lugares históricos fascinantes, senderos mágicos, vistas impresionantes al atardecer, una gran variedad de opciones de entretenimiento, restaurantes que ofrecen emociones culinarias, una animada vida nocturna y una enorme oferta de centros para las artes y la cultura.
					</p>

					<h3>
					   La Ciudad Vieja
					</h3>
					<p>
						Ningún otro lugar ofrece tantas atracciones y lugares de inspiradora emoción en un solo kilómetro cuadrado. La Ciudad Vieja de Jerusalén rebosa de oportunidades para conectarse con el resplandeciente pasado, la historia, la cultura y la espiritualidad de la ciudad. En el casco antiguo, encontrará tesoros arqueológicos que tienen miles de años de antigüedad, arte contemporáneo y mercados bulliciosos donde puede comprar delicias exquisitas.
					</p>

					<h3>
					  El Muro de las Lamentaciones:
					</h3>
					<p>
						Considerado el único tramo restante del Segundo Templo, el Muro de las Lamentaciones se ha convertido en un verdadero sinónimo de Jerusalén. De antigüedad milenaria, es el lugar de oración judío más importante del mundo, donde los chicos de trece años acuden a celebrar sus Bar Mitzvahs, y donde millones de visitantes y turistas de todo el mundo colocan notas con peticiones y oraciones en sus grietas
					</p>
					<h3>
					  Túneles del Muro de las Lamentaciones:
					</h3>
					<p>
						Visitar los túneles es como entrar en una máquina del tiempo. Situados bajo el Muro de las Lamentaciones y el barrio musulmán, proporciona al visitante una visión de los diferentes períodos de la historia de Jerusalén.
					</p>
					<h3>
					   Ciudad de David:
					</h3>
					<p>
						Situada junto a la Puerta del Estiércol, este lugar presenta la historia de Jerusalén durante los reinados del Rey David, el Rey Salomón y el Rey Ezequías. Muchos tesoros arqueológicos fueron desenterrados en la excavación, incluido un pendiente de oro de dos mil años de antigüedad.
					</p>
					<p>
					   Una visita al lugar le permitirá tomar una linterna y atravesar el agua que fluye del túnel Siloam, que fue construido durante el reinado del rey Ezequías.
					</p>

					<h3>
					 Vía Dolorosa
					</h3>
					<p>
						Los cristianos siguen los pasos de Jesús por la Vía Dolorosa y las 14 Estaciones de la Cruz, recreando el fatídico camino que tuvo un impacto sin precedentes en el curso de la historia.
					</p>

					<h3>
					  Iglesia del Santo Sepulcro:
					</h3>
					<p>
						Según la tradición cristiana, la Iglesia es el lugar donde Jesús fue crucificado, sepultado y donde resucitó de entre los muertos. Ha sido durante mucho tiempo y sigue siendo un importante centro de peregrinación para cristianos de todo el mundo.
					</p>

					<h3>
					 El mercado de la Ciudad Vieja
					</h3>
					<p>
						Esta atracción obligada se compone de una serie de callejones, con numerosos puestos que ofrecen una asombrosa variedad de recuerdos, ropa, comidas (productos horneados, especias, dulces, o tehini entre otros); quioscos que venden zumos de todo tipo, cerámicas armenias, tambores y otros instrumentos musicales, artesanía en barro y mucho más. El colorido mercado ofrece una experiencia auténtica para disfrutar al máximo que simplemente no se puede dejar pasar.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/2.jpg"} class="img-responsive" />
					</div>

					<h3>
						Atracciones
					</h3>

					<h3>
						Tours en Segway:
					</h3>
					<p>
						Esta forma de ver la ciudad cargada de adrenalina le permitirá apreciar la belleza de Jerusalén desde una perspectiva completamente diferente. Los recorridos en Segway parten de varios puntos céntricos, como el paseo Armon HaNatziv (Talpiot Este), Yemin Moshe o la Ciudad Vieja, así como también desde cerca del Knesset y el área de museos.

					</p>

					<h3>
                        
                        El Ascensor del Tiempo (Time Elevator):
					</h3>

					<p>
					   Si le gustan las atracciones de feria, le encantará iluminar sus sentidos con el Ascensor del Tiempo (Time Elevator). Es una experiencia interactiva que traslada a los visitantes a lugares fascinantes a través de fabulosos viajes, con asientos en movimiento en una sala única llena de efectos especiales.
					</p>

					<h3>
                        La Primera Estación (Hatachana):
					</h3>

					<p>
					  La Primera Estación está justo en el corazón de Jerusalén, entre la Ciudad Vieja y el centro de la ciudad, y entre los barrios históricos de la Colonia Alemana y Yemin Moshe. Es donde estaba la primera estación de tren en Jerusalén, que fue construida en 1892. Después de experimentar una renovación y conservación la Primera Estación volvió a abrir sus puertas como un animado lugar de entretenimiento.
					</p>

					<h3>
					   Mercado de Mahane Yehuda:
					</h3>

					<p>
					   Para experimentar la ciudad lo más auténticamente posible, su itinerario debe incluir una parada en el Mercado de Mahane Yehuda. Este representa al Jerusalén del presente y del futuro. Mahane Yehuda aúna de forma única lo viejo y lo nuevo, con su mercado tradicional de frutas y verduras, junto con una excelente comida y una animada zona de entretenimiento.
					</p>

					<h3>
					   Museos
					</h3>

					<p>
					   En una ciudad llena de una gran cantidad de museos, tiene un sinfín de oportunidades para experimentar y aprender sobre los eventos del pasado y para visitar exhibiciones modernas y contemporáneas.
					</p>

					<h3>
					  Museo de Israel
					</h3>

					<p>
					   El Museo de Israel es la institución cultural más grande del país. Cuenta con numerosas alas y grandes colecciones de arte, arqueología y judaica. Uno de los aspectos más destacados de cualquier visita al museo es el Santuario del Libro, con su diseño único que se ha asociado estrechamente con la ciudad en sí.
					</p>

					<h3>
					   Museo de la Torre de David:
					</h3>

					<p>

Hace miles de años, Jerusalén era una ciudad pequeña, donde reyes y profetas recorrían a pie o a caballo sus callejones. Desde ese tiempo, uno de los símbolos más conocidos de la ciudad es la Torre de David, con su torreta manteniéndose en pie orgullosamente sobre la antigua fortaleza que también se ha convertido en uno de los museos más importantes de la ciudad.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/3.jpg"} class="img-responsive" />
					</div>

					<h3>
					   Restaurantes
					</h3>

					<p>
					  Jerusalén cuenta con muchos restaurantes, donde se puede degustar una amplia variedad de delicias locales e internacionales. Y si busca la experiencia gourmet, puede reservar una mesa en restaurantes de chefs exclusivos. Los siguientes son cinco de los lugares más elegantes y populares de Jerusalén, que atraen a multitud de personas a lo largo del día:
					</p>

					<h3>
					   Café Kadosh
					</h3>

					<p>
					 Muy popular, el café sirve productos Kosher. ¡Todo hecho en casa y delicioso!
					</p>

					<h3>
					   Tmol Shilshom
					</h3>

					<p>
					  Un café-librería en el centro de la ciudad, favorecido por su calidez, deliciosa comida y servicio amigable. ¡No te pierdas el shakshuka o el filete de salmón en salsa de higos!
					</p>

					<h3>
					   The Eucalyptus
					</h3>

					<p>
					  El restaurante Kosher, ubicado en el Barrio de los Artistas, sirve la interpretación del chef Moshe Basson de la cocina bíblica. Cada plato tiene su origen en escenas bíblicas y todas las especias y hierbas usadas crecen, como en la antigüedad, en las colinas circundantes de Jerusalén y Judea. Una experiencia inolvidable.
			</p>

					<h3>
					   Darna
					</h3>

					<p>
					  Un auténtico restaurante marroquí Glatt Kosher, ubicado en el corazón de la ciudad. Experimente la cálida bienvenida y el verdadero significado de la hospitalidad marroquí, mientras disfruta de la excelencia culinaria del Magreb.
					</p>

					<h3>
					   Ima Restaurant
					</h3>

					<p>
					  Justo al final de la calle del mercado de Mahane Yehuda, Ima ofrece excelente comida Kosher de Oriente Medio, servida en un ambiente familiar y relajado.
					</p>

					<p>
					   Y ninguna visita a Jerusalén está completa sin un poco de hummus con un pan de pita recién salido del horno. Los siguientes son algunos lugares de hummus ubicados en el centro:
					</p>

					<div class="cradit">
							<p>
							<strong>Azura,</strong><small> en la sección iraquí del Mercado de Mahane Yehuda</small><br>
							<strong>Lina,</strong><small> en el Barrio Cristiano de la Ciudad Vieja</small><br>
							<strong>Hummus Acramawi,</strong><small>  en el Barrio Musulmán de la Ciudad Vieja </small><br>
							<strong>Hummus</strong><small> Ben Sira, en el centro de la ciudad junto al Hotel Mamilla </small><br>
							<strong>Abu Shukri,</strong><small> en el Barrio Musulmán en la Ciudad Vieja of Jerusalén </small><br>
							</p>
				    </div>

				    <h3>
				        Vida Nocturna
				    </h3>

				    <p>
				         Jerusalén está de montones de restaurantes y lugares de entretenimiento que también están abiertos los viernes por la noche (el Sabbat judío). Todas las áreas de entretenimiento de Jerusalén ofrecen excelentes opciones para la diversión del fin de semana los viernes por la noche, así como los sábados, y desde luego puede disfrutar de una deliciosa velada con una cerveza fría o bailando la mejor música.
                         A continuación, tiene una pequeña selección de bares y discotecas que están muy animados los viernes por la noche y le dejarán con ganas de más ...
				    </p>

				    <h3>
				       Mantra
				    </h3>

				    <p>
				       Un íntimo restaurante y vinoteca, donde el ambiente acogedor se combina con una excelente cocina.
				    </p>

				    <h3>
				       Gatsby Cocktail Room
				    </h3>

				    <p>
				       El bar y salón de cócteles evoca la magia de los Locos años 20 y los días de los cabarets.
				    </p>

				    <h3>
				        HaTaklit
				    </h3>

				    <p>
				       Con un nombre que significa “el disco” en hebreo, el moderno bar está decorado con fundas de disco. Disfrute al máximo del bar, la música en vivo, los DJ e incluso de intérpretes independientes.
				    </p>

				    <h3>
				       Toy Bar (HaTza’atzua)
				    </h3>

				    <p>
				Con una ubicación céntrica, el Toy Bar ofrece excelentes bebidas, buena música de algunos de los mejores DJ locales y una gran experiencia de baile.				    </p>

				    <h3>
                        Sira
				    </h3>

				    <p>
                       Uno de los clubes underground más eclécticos de la ciudad, con sala de juegos y pista de baile. El pub también alberga eventos y actuaciones.
				    </p>

				    <h3>
                        Even / Juke
				    </h3>

				    <p>
				       Un club de música que presenta las bandas más creativas de Israel, con énfasis en el jazz, el blues y el funk.
				    </p>

				    <h3>
                       Video Pub
				    </h3>

				    <p>
				       El único bar gay "oficial" de Jerusalén alberga algunas de las fiestas más locas de la ciudad.
				    </p>

				    <p>
				       ¡Jerusalén es el mejor destino de vacaciones! Con tanto que ver y hacer, tanto para estimular sus sentidos y despertar su curiosidad, su viaje a Jerusalén promete ser una experiencia inolvidable. ¡Reserve sus vacaciones ahora!
				    </p>

				    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/4.jpg"} class="img-responsive" />
					</div>

					<h3>Taquilla:</h3>
					<h3>
					   Eventos anuales
					</h3>

					<p>
					   Jerusalén es la sede de una serie de eventos anuales únicos. Consulte en Internet las fechas y más información.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/5.jpg"} class="img-responsive" />
					</div>


         `,
      };
    },
  },

  {
    id: "Outdoor_Adventures",
    bgImage: "/posts/bank/40/1.jpg",
    mobBgImage: "/posts/bank/40/M.jpg",
    title: "Outdoor Adventures",
    ctg: "telaviv",
    // vidId : '88OV6xU0vPI',
    vidId: "Iyziun92P5A",
    isVid: true,
    smltitle: "",
    html: function() {
      return {
        __html: `
                <h3>An action-packed city that’s perfect for active people</h3>
			<p>
				People in Tel Aviv live life to the fullest – and they do it outside. This city is chock-full with outdoor activities, and you can pick and choose your favorites. It’s an action packed city – perfect for active people.
			</p>
			<h3>
				Hayarkon Park
			</h3>
			<p>
				Known as the “Central Park” of Tel Aviv, Hayarkon Park is visited by approximately sixteen million people annually. Attractions range from picnics on the huge lawns, pedal boating on its beautiful manmade lake to cycle tracks and tours of the many amazing gardens, portraying nature at the heart of the city.
			</p>
			<h3>
				The Cycling Scene
			</h3>
			<p>
				One of the ultimate ways to discover Tel Aviv is via its 100km of dedicated bike lanes, where you can enjoy the Tel-O-Fun public bike hire system that lets residents and visitors pick up and drop off sleek green bicycles in 150 stations citywide. If you enjoy spending your time on wheels, you should also check out the many dedicated skating parks, where you can watch the local daredevils do their thing, or get your own skateboard or rollerblades and join the action.
			</p>

         `,
      };
    },
  },

  {
    id: "TelAviv_On_Wheels",
    ctg: "telaviv",
    bgImage: "/posts/bank/40/1.jpg",
    mobBgImage: "/posts/bank/40/M.jpg",
    isVid: true,
    // vidId: "88OV6xU0vPI",
    vidId: "Iyziun92P5A",
    title: "Tel Aviv sobre ruedas",
    smltitle: "",
    html: function() {
      return {
        __html: `

            <br/>
            <p>Dese una vuelta por la ciudad que no se detiene Vaya sobre ruedas allá dónde éstas le lleven en esta fabulosa ciudad</p>

            <div class="img-wrapper">
              <img src=${getImgUrl() +
                "/posts/55/1.jpg"} class="img-responsive" />
            </div>
           
          

        `,
      };
    },
  },

  {
    id: "Port_Pleasures",
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    ctg: "telaviv",
    isVid: true,
    // vidId : "uC5KX4MVpC0",
    vidId: "tgF0zMUYY2g",
    title: "Placeres Portuarios",
    smltitle: "",
    html: function() {
      return {
        __html: `

        			<br/>
                    <h3>Puertos de Tel Aviv y Jaffa – diferentes y fabulosos</h3>
					<p>
						El puerto de Jaffa ofrece una historia antigua, edificios de piedra y callejuelas empedradas, mientras que el puerto de Tel Aviv es un foco de cultura contemporánea y esparcimiento.
					</p>

					<h3>
					   Puerto de Jaffa
					</h3>
					<p>
						La moderna ciudad de Tel Aviv tuvo su humilde principio en el puerto de Jaffa, donde inmigrantes, ejércitos y mercaderes atracaban sus barcos. El puerto es famoso como uno de los más antiguos del mundo y hoy en día aún es utilizado por los pescadores locales, mientras que el área histórica circundante se convirtió en un destino turístico popular.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>


					<p>
					    Los depósitos portuarios junto a la orilla del mar se convirtieron en galerías y en espacios culturales. Como el centro Nalagahat, dirigido por la comunidad de sordos y ciegos en la galería Dvir. Desde las dársenas, las callejuelas empedradas siguen su curso hacia arriba a través de edificios recubiertos de piedra que recuerdan la ciudad vieja de Jerusalén. Entre los edificios históricos hay galerías, negocios especializados y excelentes restaurantes. Al llegar al nivel superior del antiguo puerto se puede ver la iglesia de San Pedro, el Puente de los Deseos, el Museo de la Antigua Jaffa y el Museo Ilana Goor.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
					</div>

					<h3>
						 Puerto de Tel Aviv
					</h3>
					<p>
						En contraste con el puerto de Jaffa, el ambiente en el puerto de Tel Aviv es más comercial y contemporáneo. El puerto actuó como tal entre los años 1938 y 1965 sufriendo renovaciones y restauraciones a fin de convertirlo en un distrito de compras y ocio. El puerto consiste en hangares reconvertidos y un largo y amplio paseo que corre al lado de las dársenas. Las familias suelen visitar el Centro Dyada, muy popular por sus actividades para niños, o  visitan el Centro de Yoga, el Centro de la Mujer, la Sede de Congresos o el Instituto Cavim de Diseño y Arquitectura. El paseo está siempre animado con artistas callejeros, eventos musicales y mercados al aire libre. Es un área moderna y dinámica para la expresión cultural y la creatividad. Cuando cae el sol, el puerto de Tel Aviv se convierte en una popular zona nocturna con bares y clubes.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>

         `,
      };
    },
  },

  {
    id: "Dead_Sea_Video",
    bgImage: "/posts/bank/natures-glory/1.jpg",
    mobBgImage: "/posts/bank/natures-glory/M.jpg",
    title: "El Mar Muerto",
    ctg: "deadsea2",
    isVid: true,
    vidId: "3hxeenS25M0",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                      <p>Siéntase en lo más alto en el lugar más bajo de la tierra.</p>
                   
         	`,
      };
    },
  },

  {
    id: "Dead_Sea2",
    bgImage: "/posts/videos/deadsea/1/1.jpg",
    mobBgImage: "/posts/videos/deadsea/1/M.jpg",
    title: "El Mar Muerto",
    // vidId: "ixFocykfYHo",
    vidId: "3hxeenS25M0",
    ctg: "deadsea",
    isVid: true,
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Siéntase en lo más alto en el lugar más bajo de la tierra</h3>
			<p>
					 Una maravilla geológica en un entorno único y sereno, el Mar Muerto es una atracción turística sumamente popular. Experimente la calma tranquilidad del agua con sus distintas propiedades curativas mientras disfruta de la incomparable belleza del paisaje circundante. <strong>El Mar Muerto, también conocido como el spa natural más antiguo del mundo, ha sido bendecido con una concentración extremadamente alta de sal del 31.5%, permitiendo a los turistas de todas partes la increíble experiencia de flotar sin esfuerzo en las aguas del lugar más bajo de la Tierra. Mientras esté aquí, puede embadurnarse</strong> en el saludable barro negro de la zona o explorar los fascinantes e históricamente ricos paisajes cercanos.
             </p>
           <p>
					 Hoteles de lujo, cocina variada, desde restaurantes gourmet hasta restaurantes de comida rápida, grandes tiendas de souvenirs, la extraordinaria historia de la cercana Masada y muchas actividades culturales durante todo el año, hacen del Mar Muerto un destino popular para turistas locales y visitantes internacionales.
            </p>
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    vidId: "LLOUxE-K_9Y",
    player_id_post: "3",
    title: "Port Pleasures",
    isVid: true,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>The different charms of Tel Aviv and Jaffa Ports</h3>
					<p>
						Jaffa Port offers an ancient history, stone buildings and cobbled lanes while Tel Aviv Port is a contemporary cultural, recreational and commercial hub.
					</p>

					<h3>
					    Jaffa Port
					</h3>
					<p>
						The modern city of Tel Aviv had its humble beginnings in the port of Jaffa where immigrants, armies and traders docked their ships. The port is famed as one of the oldest in the world and today it is still used by local fishermen while the historic surrounding area has become a popular tourist destination.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>

					<p>
						The waterside hangers have been converted into galleries and cultural spaces like the Nalaga’at Center operated by the deaf and blind community and the Dvir Gallery. From the waterfront the ancient cobbled alleyways wend their way up through stone buildings reminiscent of old Jerusalem. In among the historic buildings are galleries, specialty stores and excellent restaurants. As you reach the upper levels of the Old Port area you can see St. Peter’s Church, the Wishing Bridge, the Old Jaffa Museum and the Ilana Goor Museum.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
					</div>

					<h3>
						Tel Aviv Port
					</h3>
					<p>
						In contrast to Jaffa Port Tel Aviv has a more commercial and contemporary feel. The port operated from 1938 to 1965 and has undergone renewal and restoration to convert it into a shopping and entertainment district. The port area consists of converted hangers and a long wide waterfront promenade. It is popular with families visiting the Dyada Center for children’s activities and others visiting the yoga center, center for women, conference venue and the Cavim Institute of Design and Architecture. The promenade is always alive with street performers, musical events and outdoor markets. The port is a contemporary and dynamic area for creative and cultural expression. When the sun goes down the Tel Aviv Port becomes a popular nightlife destination with bars and clubs.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>


         `,
      };
    },
  },

  {
    id: "TelAviv_By_The_Sea",
    bgImage: "posts/bank/17/1.jpg",
    mobBgImage: "posts/bank/17/M.jpg",
    title: "TEL AVIV JUNTO AL MAR",
    vidId: "EJAqEcK4Te0",
    isVid: true,
    ctg: "telaviv",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			

			<br/>
			<p>Porque una playa en Tel Aviv es vida, prepárese para la diversión bajo el sol</p>
			<p>Aclamada como "la capital más cool del Mediterráneo " por el New York Times y entre las "10 mejores ciudades llenas de acción" por Lonely Planet, Tel Aviv es sin lugar a dudas el lugar para visitar en el Mediterráneo.</h3>
			<p>Nombrada por el <em>New York Times</em> "La capital más cool del Mediterráneo, <strong>Tel Aviv</strong> es &nbsp;cosmopolita, moderna y vibrante. Animada escena de arte, la UNESCO reconoció la arquitectura Bauhaus, galardonada cocina, vida nocturna a nivel mundial, ambiente relajado y hermosas playas, todo convierte a la ciudad en uno de los destinos turísticos más importantes del mundo.</p>
			<p>Pero incluso en la ciudad que lo tiene todo, sólo hay un lugar para empezar&nbsp;<strong>la playa</strong>.</p>
			<h3>Descubra el corazón de una ciudad chispeante</h3>
			<p><strong>Qué</strong>. El corazón de la reconocida ciudad por <em>National Geographic</em> &nbsp;como la "Miami Beach del Mediterráneo" e incluida en su lista de las 10 mejores ciudades de playa del mundo, es su costa.</p>
			<p><strong>Por qué</strong>. Playas de arena, aguas cálidas, un montón de deportes acuáticos y buen clima, ¿necesitamos decir más? La costa de Tel Aviv está compuesta por 13 playas que ofrecen experiencias distintas. De la ajetreada y moderna a la relajada y tranquila, juntas forman un tapiz rico y colorido de esta ciudad emocionante y diversa.</p>
			<p><strong>Dónde</strong>. Situada en el extremo oeste de la ciudad, en Tel Aviv siempre está a un paso de la playa. No hay necesidad de resistir la tentación. Sólo cruce la calle, quítese los zapatos y empiece a divertirse.</p>
			<h3>Elija su propia aventura en la playa</h3>
			<p><strong>Siéntase activo</strong>. Playa y deportes acuáticos son muy populares en Tel Aviv. Surf, vela, remo, natación, paddle surf, buceo, voleibol... la lista de posibilidades sigue y sigue.</p>
			<p><strong>Elija su actividad favorita y disfrute</strong>. Entonces, cuando escuche el “toc-toc” de las matkot (palas) en la playa, únase a este juego enormemente popular. No hay ganadores o perdedores aquí, pero sigue siendo divertido ... y muy adictivo.</p>
			<p>Inscríbase al torneo de vela SAIL TLV que tiene lugar en la primavera e incluye yates de vela, yates de motor y barcos de motor de todo el mundo. Disfrute de las actividades deportivas y su maravillosa comunidad.</p>
			<p>¿Quiere más? Únase a los lugareños y monte en bicicleta, camine o corra por paseo marítimo.</p>
			<p><strong>Socialíce.</strong> Construya castillos de arena con su familia, lleve a su perro a caminar y mézclese con la diversa multitud amigable.</p>
			<p><strong>Relájese.</strong> ¿Quiere frenar y relajarse? ¡No hay problema! Encuentre un lugar tranquilo en una de las playas menos concurridas, vea (o únase) a los círculos de tambor y siéntese en uno de los restaurantes a lo largo de la costa. Por la tarde, acérquese al agua, tome una silla, siéntese y vea uno de los hermosos atardeceres de Tel Aviv. No hay nada mejor que eso.</p>

			`,
      };
    },
  },

  {
    id: "Sarona_TelAviv",
    bgImage: "posts/bank/36/1.jpg",
    mobBgImage: "posts/bank/36/M.jpg",
    title: "Sarona Tel Aviv",
    isVid: true,
    ctg: "telaviv",
    // vidId: "AcjsyamDZL8",
    // vidId: "VubRqT0Z9CM",
    vidId: "MJ-gsGs1tqA",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			             <!--<h3>At Tel Aviv’s Sarona Market, the culinary options are endless</h3>

						<p>Built in and around 150-year-old Templer structures in the heart of Tel Aviv is Israel’s culinary melting pot: Sarona Market. Reflecting Tel Aviv’s exemplary culinary atmosphere and placing a modern urban twist on the city’s more traditional marketplaces, Sarona is the place to visit to satisfy your every craving - and get a taste for the diverse ethnic inspirations that drive the bustling sea-side city. </p>



						<h3>Visit Israel’s largest covered culinary marketplace</h3>

						<p>From gourmet creations to spins on traditional local dishes, Sarona Market has it all and will satisfy every quaking belly. With over 90 restaurants, food stands, pubs and culinary boutiques operating seven days of the week, all you need to do is decide whether you’d rather tuck into a bowl of succulent ramen, a plate of spicy empanadas, a tangy sub sandwich or a sweet baked confection. Can’t decide? The eateries are all adjacent to one another, making a seafood entree followed by spicy pad thai or a juicy burger an easy feat. </p>

						<p>Need to take a break between courses? Sarona Market is also home to accessory shops, museums, a visitor’s center and other fun, must-see attractions.  </p>

						<h3>Go Green</h3>

						<p>TGIF! Fridays at Sarona are exceptionally enthralling, with farm-fresh produce available for purchase, making the culinary experience that much more interactive and engaging. Once you’ve selected your produce, continue on your urban market adventure, adding savory imported cheeses, top-quality Italian balsamic vinegar, boutique beers and sweet confections to your shopping bag, all tasty additions to a weekend home-cooked meal. </p>

						<p>Experience modern Israeli cuisine in full force at Sarona Market. With no end to the available culinary options reflecting the popular and unique foodie atmosphere of Tel Aviv, Sarona Market is a must-visit hotspot that will certainly satisfy every imaginable gustatory craving.</p>
                        -->

                        <br/>
                        <p>Una gran selección de atracciones en una impresionante colonia Templaria renovada</p>
                        <h3>En el mercado de Sarona de Tel Aviv, las opciones culinarias son infinitas</h3>
						<p>Construido sobre y alrededor de estructuras templarias &nbsp;de 150 años, en el corazón de Tel Aviv, es el crisol culinario de Israel. El mercado de Sarona refleja la atmósfera culinaria ejemplar de Tel Aviv, dando un giro urbano moderno a los mercados más tradicionales de la ciudad. Sarona es el lugar para visitar, satisfacer antojos y saborear las diversas propuestas étnicas.</p>
						<h3>Visite el mercado culinario cubierto más grande de Israel</h3>
						<p>Desde creaciones gourmet a platos tradicionales locales, el mercado de Sarona tiene todo y satisfará cualquier estomago. Con más de 90 restaurantes, puestos de comida, pubs y boutiques culinarias que operan los siete días de la semana, todo lo que necesita hacer es decidir si prefiere un plato de suculento ramen, un plato de empanadas picantes, un sándwich o dulces horneados. ¿No puede decidir? Los restaurantes están uno al lado del otro, así que puede empezar con un plato de marisco<s>s</s> de entrada, seguido de un plato picante tailandés o una jugosa hamburguesa.</p>
						<p>¿Necesita tomar un descanso entre los platos? El mercado de Sarona es también hogar de tiendas de accesorios, museos, centro de visitantes y otras atracciones divertidas de visita obligada.</p>
						<h3>Vuélvase ecológico</h3>
						<p>&nbsp;Los viernes en Sarona son excepcionalmente apasionantes, con productos frescos de granja disponibles para su compra, convirtiendo la experiencia culinaria mucho más interactiva y atractiva. Una vez que haya seleccionado su producto, continúe con su aventura en el mercado urbano, añadiendo sabrosos quesos importados, vinagre balsámico italiano de alta calidad, cervezas boutique y dulces a su bolsa de la compra, y estará listo para preparar una suculenta comida casera el fin de semana.</p>
						<p>Experimente la cocina israelí moderna en pleno apogeo en el mercado de Sarona. Sin limitar las opciones culinarias disponibles que reflejan la atmósfera gastronómica popular y única de Tel Aviv, el mercado de Sarona es un lugar de visita obligada que sin duda satisface todos los antojos imaginables.</p>

			`,
      };
    },
  },

  {
    id: "Neve_Tzedek",
    bgImage: "posts/bank/4/1.jpg",
    mobBgImage: "posts/bank/4/M.jpg",
    title: "Neve Tzedek",
    // vidId: "bHQwLO6cefs",
    // vidId: "eRNnLm6R0LI",
    vidId: "5jl13Z-38eE",
    smlTitle: "",
    isVid: true,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
                        <br/>

                      	<h3>Un oasis artístico en el corazón de Tel Aviv</h3>
                      	<h3>Disfrute del ambiente mágico en las terrazas de los restaurantes y cafés de Neve Tzedek</h3>
						<p>Ubicado dentro de uno de los distritos más antiguos de Tel Aviv, se encuentra una joya arquitectónica con un corazón joven que no deja de latir. Establecido en 1887, Neve Tzedek, el primer barrio judío fuera de la antigua ciudad portuaria de Jaffa, se ha convertido recientemente en un centro de moda para artistas de todas las disciplinas, que encajan perfectamente con la restaurada y pintoresca arquitectura oriental del distrito.</p>
						<h3>Un verdadero oasis en el animado Tel Aviv</h3>
						<p>Ya sea si está buscando un plato de cerámica artesanal, un artículo único de ropa, o joyas hechas con técnicas tradicionales de soldadura, las innumerables boutiques, galerías, talleres de diseño y tiendas de moda en los edificios de estilo oriental alineadas en la calle Shabazi proporcionan una experiencia de compra única y personal. Y con la fresca brisa marina refrescándole mientras se pasea por el vecindario, empezará a sentirse vivo y alegre, al igual que el espíritu caprichoso del barrio.</p>
						<p>Disfrute del ambiente acogedor en las terrazas de los restaurantes y cafés de Neve Tzedek con una comida ligera y deliciosa. Los numerosos restaurantes, ubicados en pintorescas e históricas estructuras construidas alrededor de las estrechas callejuelas del barrio, son vedaderas experiencias culinarias. Las suculentas comidas, en combinación con el aire sereno al caminar por por las calles, le transportarán a una realidad bohemia.</p>
						<h3>Donde la creatividad no conoce límites</h3>
						<p>La visita a Neve Tzedek no estaría completa sin rendir homenaje al mejor creador de Tel Aviv en el Museo de Arte de Nachum Gutman, donde exposiciones permanentes y actividades interactivas realzan el ambiente artístico ejemplificado en el vecindario sereno, transportándolo a otras galerías locales y estudios de cerámica.</p>
						<p>Visite el Centro Suzanne Dellal de Danza y Teatro de Tel Aviv, donde podrá presenciar una de las muchas actuaciones y festivales que el centro cultural celebra incluyendo las actuaciones de danza de música étnica, que fomentan una verdadera conexión entre las artes escénicas israelíes y las exposiciones internacionales.</p>
						<p>Siga por la calle Shabazi hasta llegar a su cima y vea cómo la creatividad del barrio sigue fluyendo, desembocando en HaTachana, la antigua estación de trenes de Jaffa, recientemente transformada en otro lugar boutique, donde las tiendas y cafés emergen de un entorno sorprendentemente histórico.</p>
						 	 
              
			`,
      };
    },
  },

  {
    id: 9,
    bgImage: "posts/bank/5/1.jpg",
    mobBgImage: "posts/bank/5/M.jpg",
    title: "Jerusalem Old and new ",
    isVid: true,
    ctg: "jerusalem",
    vidId: "MXtcTm_JXus",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Ancient treasures and modern luxuries.</h3>

			<p>
				Downtown Jerusalem is the heart of the modern metropolis, bursting with nightlife, dining and cultural options to rival any major city in the world.
			</p>
			<p>
				The area is made up of several neighborhoods and appealing locations such as charming Nachlat Shiva, the bustling Yafo Street and Ben Yehuda Street, with its own unique personality and atmosphere not to be missed.
			</p>
			<p>
				The center of Jerusalem includes some of the city’s most charming neighborhoods and fascinating attractions. For an unbeatable cultural experience, check out Jerusalem’s variety of fascinating museums, including the world class Israel Museum, the Bible Lands Museum and Jerusalem’s Science Museum.
			</p>
			<h3>
				Machane Yehuda Market
			</h3>
			<p>
				Discover this market's unrivaled atmosphere and variety which draw thousands of tourists every day. Once the shopping is done and the food vendors close up, join the young trendy crowds, foreign and locals alike, who descend on the market to drink and party until the small hours, in the bars, restaurants and alleyways.
			</p>
			<h3>
				Nahalat Shiv’a
			</h3>
			<p>
				This charming cobblestone neighborhood at the heart of the city offers an excellent selection of shops, restaurants, bars and outdoor cafés. Nahalat Shiva is home to Kikar Hamusica (Music Square) – a lively and trendy outdoor space that offers live music every day throughout the week.
			</p>
			<h3>
				Yemin Moshe
			</h3>
			<p>
				This lovely neighborhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. Home to artists, writers and academics, Yemin Moshe is known for its beautiful windmill and oriental style houses, green parks, lively music center and stunning views.
			</p>
			<h3>
				Ein Kerem
			</h3>
			<p>
				Nestled in a peaceful valley between the mountains and the terraced hills southwest of Jerusalem, Ein Kerem is one of Jerusalem’s most picturesque neighborhoods. With its winding paved lanes, their charming stone houses adorned with arches, churches whose bells chime in the clear air, Ein Kerem radiates charm and beauty like an island in a sea of green forest
			</p>  

			`,
      };
    },
  },

  {
    id: "Market_Madness",
    bgImage: "posts/bank/10/1.jpg",
    mobBgImage: "posts/bank/10/M.jpg",
    title: "MERCADO DE MAHANE YEHUDA",
    // vidId: "1Yx2Uht4rms",
    vidId: "oy9ozIvV7Co",
    isVid: true,
    ctg: "culinary",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                     <h3>No querrá perderse las vistas, los sonidos, los olores y, por supuesto, los sabores de este mercado</h3>
					<p>
						Miles de habitantes locales y turistas llegan durante el día para presenciar el ambiente auténtico y los entresijos del mercado, y por supuesto hacer algunas compras, y una vez que los vendedores de comida cierran, los fiesteros, tanto extranjeros como locales, bajan al mercado para beber en los bares, restaurantes y callejones.
                       En realidad, el zoco jamás se toma un día libre durante la semana, pero si estás buscando una noche verdaderamente electrizante, el jueves debe estar en tu punto de mira. Para los habitantes locales, es la única noche que se puede salir sin tener que preocuparse por levantarse para el trabajo al día siguiente, y se nota, ya que los bares y restaurantes permanecen abiertos hasta tarde, organizan fiestas que se esparcen por las calles y ofrecen eventos especiales.
					    <br>Mi "cita" y yo llegamos a las 19:20, cuando muchos de los vendedores todavía estaban abiertos, y los pasillos estaban llenos de compradores que buscaban gangas de fin de semana. Sin embargo, tan pronto los vendedores cerraron, los compradores se disiparon rápidamente, dejando espacio para la gente de fiesta.
					    <br>Aunque parece que fue ayer cuando el zoco era solo un lugar donde comprar y tal vez tomarse algo en un modesto restaurante local, en los últimos 5 años más o menos, el número de bares y restaurantes de moda se ha disparado hasta el punto de que no se puede hacer un seguimiento de todo, entre los nuevos que aparecen todos los días y los lugares secretos escondidos en las esquinas que solo conocen los habitantes locales.
                        "Cuando ves las multitudes de gente de fiesta en el zoco un jueves por la noche, es fácil olvidar que hace tan solo unos pocos años no habrías encontrado ni un alma aquí a esas horas", dice el guía turístico local Joel Haber. "Pero la verdad es que este no es solo el siguiente paso lógico en el constante desarrollo histórico de Mahane Yehuda, sino también la nueva contribución más vibrante a la escena nocturna de la ciudad. El zoco siempre ha sido la encrucijada donde se mezclan todos los habitantes de Jerusalén. Ahora los jóvenes y los que lo son menos, seculares y religiosos, se sientan todos juntos bebiendo cervezas y empapándose del carácter especial del zoco ".
					    <br> Eche un vistazo a algunos de los establecimientos que han alcanzado más o menos el estatus de estelares y que siempre prometen un buen momento.
					 </p>

					<h3>
					   VINO, CENA y BAILE
					</h3>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/1.jpg"} class="img-responsive" />
					</div>

					<h3>
					   CASINO DE PARIS
					</h3>

                    <p>

                          Escondido en las profundidades del zoco georgiano entre las calles cubiertas y descubiertas del mercado,&nbsp;<a href = "http://www.itraveljerusalem.com/city/jerusalem/casino-de-paris/" target = "_ blank" > <strong>el Casino de Paris</strong> </a> &nbsp; tiene una colorida historia. El edificio en el que está alojado ha sido utilizado como casino, hotel, club de oficiales británicos y burdel a lo largo de los años, pero ahora es uno de los lugares con más clase en el zoco. El público es algo más mayor, atrayendo principalmente a profesionales de entre 30 y 40 años, pero los jueves por la noche todavía tienen un aire de diversión y juventud, mientras el bar permanece abierto hasta las 2 o 3 de la mañana y sirve originales cócteles bien elaborados inspirados en el zoco, cervezas artesanales, buenos vinos y un ecléctico menú también inspirado en los ingredientes y la cultura del zoco.

                    </p>

                    <h3>
					   CINCO DE MAYO
					</h3>

					<p>
					   Si está buscando un ambiente de fiesta auténtico, Cinco De Mayo no es un mal lugar para comenzar. El bar con frecuencia presenta DJ pinchando una variedad de estilos diferentes y encontrarás personas bebiendo, comiendo y tal vez incluso bailando hasta alrededor de las 02:00 los jueves por la noche. Los fiesteros realmente comienzan a abarrotar el lugar alrededor de las 22:30 así que no se sorprendan si tienen problemas para encontrar un asiento más tarde de esa hora, pero siempre pueden hacer como los habitantes locales: coger una bebida de dentro y pasar el rato en el callejón.
                         A pesar del nombre, el Cinco de Mayo en realidad no tiene nada que ver con México o el 5 de mayo. El grupo de amigos que fundaron el bar tomaron el nombre de cuando estuvieron viviendo en una comuna en las afueras de Jerusalén, en la que nadie trabajaba el 5 de mayo.
					</p>

                    <h3>
					  BAR SHUKA
					</h3>

					<p>
                       A pesar de su ubicación fuera de la avenida principal y de un tamaño relativamente pequeño, el bar Shuka en la calle Egoz es uno de los lugares más populares del zoco. Es un sitio de tipo carne con patatas que solo sirve cervezas israelíes, licores selectos y pequeños tentempiés, pero los jueves por la noche tiende a pasar de barecillo escondido a gran fiesta.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/2.jpg"} class="img-responsive" />
					</div>



					<h3>
					    QUE PASA
					</h3>

					<p>
					    Mientras tanto justo al lado, el Que Pasa es el valiente esfuerzo del propietario Yaniv Kovenshtein de recrear la cultura de las tapas que tanto amaba en España.
                        El copropietario y chef Avi Betito Golansky le da vida a la visión con un menú lleno de platos tamaño tapa, incluyendo la sabrosa Bruschetta Cuca (sardinas, cebolla, aceite de oliva picante sobre delicioso pan crujiente) y Porcini Bruschetta (porcini salteados en mantequilla con ajo, aceite de almendras y perejil), alcachofas con trufas, sardinas fileteadas rellenas con queso Saint Moor y fritas con mantequilla de salvia encima de una exuberante ensalada de tomate, anillos de mújol fritos con pimientos asados, y más. Si tienes apetito, también tienen porciones más grandes, como gnocchi, filete de lubina o salmonete.
					</p>

					<p>
					    Si bien el lema del bar es "una cerveza por la tarde resuelve todos los problemas", también vale la pena ir un jueves por la noche al Que Pasa, sede de músicos locales con regularidad.					</p>

					<h3>
					    SHEM TOV
					</h3>

					<p>
					   Situado en la Calle Eshkol, una calle cerca del zoco abierto, Shem Tov realmente captura la atmósfera del zoco con un rico menú de Oriente Medio, una selección bastante amplia de cerveza israelí, vino y licor y el golpe de gracia, música de todo el mundo que mantiene el alegre ambiente hasta las 2 o 3 de la mañana. <br> También es un lugar excelente para tomar un vaso de sahleb frío y un alimento básico del zoco que por lo general se sirve caliente, hecho con harina de los tubérculos molidos de las orquídeas con agua de rosas, leche y canela. Mmmmmm. ¡Delicioso!
					</p>

					<h3>
					    BOCADOS DE ÚLTIMA HORA
					</h3>

					<p>
					   Si ha salido y ha estado bebiendo, probablemente tenga ganas de comer algo alrededor de la medianoche y, por suerte, todavía hay muchos restaurantes que satisfarán sus, probablemente, no tan específicas necesidades.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/3.jpg"} class="img-responsive" />
					</div>

					<h3>
					    SORAMELO
					</h3>

					<p>
					   Si todo lo que ha bebido le ha provocado ganas de dulce, diríjase a Soramelo, en la entrada de Aggripas del zoco cubierto, para tomar unos gofres inspirados en el zoco.
                         Llamado así por una leyenda del vecindario conocida por tener una historia sobre todas las cosas, Soramelo sin duda ha dado lugar a algunas historias propias.<br>Soramelo se mantiene constantemente ocupado a lo largo de la noche con gente que se detiene para tomar una cerveza artesanal, un café o un bocado dulce, pero realmente se llena más tarde, cuando las personas pasan de beber a los tentempiés nocturnos. Si usted es uno de ellos, tiene hasta las 3 de la mañana del jueves para conseguir un gofre que absorba toda la cerveza y el arak. Pruebe el que tiene chocolate y tahina, ¡no le decepcionará!
					</p>

					<h3>
					    MICHI’S
					</h3>

					<p>
					    Michi's es un concepto simple pero delicioso que lo convierte en el restaurante perfecto para la noche: hamburguesas de alta calidad y sándwiches de carne a un precio sorprendentemente bueno. Puede obtener una simple hamburguesa de 100 gramos en un panecillo fresco con bastante guarnición por solo 17 NIS. Si realmente tiene hambre, también puede obtener porciones más grandes de carne, rosbif, sándwiches de pollo y mucho más. Michi's está abierto hasta las 12 de la noche.
					</p>

					<h3>
					    MEORAV YERUSHALMI
					</h3>

					<p>
					   Este puede ser el mejor lugar para hacerse con la famosa parrillada mixta Jerusalén, que consiste en una pita rellena de carne y casquería con patatas fritas y ensalada como guarnición. Además de la receta tradicional, también sirven una parrillada mixta con pescado. Las porciones se pueden calificar de gigantes y son perfectas para aquellos a los que realmente se les ha abierto el apetito. Solo asegúrate de llegar aquí antes de la medianoche.
					</p>

					<h3>
					    PASTA BASTA
					</h3>

					<p>
					    Con mucho, uno de los lugares más populares en el zoco. Pasta Basta es el lugar ideal para disfrutar de platos frescos y caseros de pasta que no le llevarán a la ruina. Todo lo que tiene que hacer es elegir un tipo de pasta y una salsa, y su comida estará lista. Los precios varían según el tipo de salsa y van de los 19 a los 26 NIS. Los gnocchi, raviolis y aderezos adicionales cuestan un poco más.
					    <br> Pasta Basta está abierto hasta la medianoche, y no se sorprenda cuando vea que hay cola en la entrada.
					</p>

					<h3>Alégrese la vista y su estómago en el mercado abierto de Jerusalén</h3>
					<p>Considerado el mercado abierto más moderno y vibrante de Israel, el Mahane Yehuda de Jerusalén es un vivero de productos frescos, encantadores comerciantes, restaurantes pintorescos y entretenimiento único.<br>Es un mercado que continúa&nbsp;reinventándose,&nbsp;donde&nbsp;la tradición milenaria choca y se entrelaza con nuevas modas. Los colores y los olores que emanan de las delicias alineadas en los numerosos puestos son absolutamente fascinantes.</p>
					<!--<div>
					<iframe allowfullscreen="" frameborder="0" height="315" src="https://www.youtube.com/embed/fJ7bLOOstgA?enablejsapi=1&amp;origin=https%3A%2F%2Fes.citiesbreak.com" width="560" data-gtm-yt-inspected-11422925_7="true" id="471374627"></iframe>
					</div>-->
					<h3>Admire la cultura y la cocina en grado máximo</h3>
					<p>Pasee por los callejones largos y estrechos del mercado y encontrará una gran variedad de restaurantes, cafeterías, pubs, restaurantes vegetarianos y tiendas al por menor escondidos en todos los rincones posibles. Al cruzar sus umbrales experimentará una calma en relación con el ajetreo y el bullicio de los comerciantes locales que venden sus panes recién horneados, frutas y hortalizas frescas, ensaladas preparadas, postres, aromáticas especias molidas y proteínas crudas a consumidores hambrientos. Sólo los olores son suficientes para hacer que su estómago ruja, transportándolo a culturas y comunidades de todo el mundo. Cada tazón de fruta de temporada, falafel caliente en una pita o halva aderezada es un regalo de bienvenida para sus sentidos.</p>
					<h3>Donde los paseos a pie satisfacen su curiosidad y su apetito</h3>
					<p>Únase a uno de los muchos talleres del mercado o excursiones de degustación, que proporcionan a los turistas una experiencia interactiva de Mahane Yehuda a través de delicias preparadas en algunos de los puestos del mercado. Escuche historias sobre el mercado y conozca las tiendas y puestos únicos y especiales que ayudaron a moldear Mahane Yehuda como el mercado abierto más famoso de Israel. Y, cuando la noche cae, experimente cómo el mercado cambia de marcha, convirtiéndose en un lugar de moda y animado para jóvenes locales y turistas.</p>

              
			`,
      };
    },
  },

  {
    id: 13,
    bgImage: "posts/bank/24/1.jpg",
    mobBgImage: "posts/bank/24/M.jpg",
    title: "The old city ",
    vidId: "rkjLPq-Zsp8",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Feel the story come alive</h3>
			<p>
			   Become inspired by the world renowned treasures of the ancient city of Jerusalem.
			</p>
              
			`,
      };
    },
  },

  {
    id: 14,
    bgImage: "posts/bank/32/1.jpg",
    mobBgImage: "posts/bank/32/M.jpg",
    title: "The Dead Sea ",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Time to bask in nature’s glory</h3>
			<p>
			   Get high on life in the lowest place on earth.
			</p>
              
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "posts/bank/58/1.jpg",
    mobBgImage: "posts/bank/58/M.jpg",
    title: "The Dead Sea ",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Time to bask in nature’s glory</h3>
              <p>
						The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
              </p>
              <p>
              		This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
              </p>
              <p>
              		The Dead Sea is lined with spas, bathing beaches and spa hotels.
              </p>
			`,
      };
    },
  },

  {
    id: "Go_To_Guide",
    bgImage: "/posts/bank/gotoguide/1.jpg",
    mobBgImage: "/posts/bank/gotoguide/M/1.jpg",
    title: "GUÍA",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h3>
                   ¡A menos de una hora!
                    </h3>
					 <p>Una de las mejores cosas de visitar Jerusalén y Tel Aviv es lo increíblemente diferentes y a la vez lo asombrosamente cerca que están estos dos fabulosos destinos. De hecho, las dos ciudades están a menos de una hora en coche la una de la otra, de manera que, si lo desea, podría pasar el día explorando los impresionantes lugares mundialmente famosos de Jerusalén y regresar a tiempo para ver la puesta de sol desde una de las impresionantes playas de Tel Aviv, antes de pasar toda la noche de fiesta en uno de los mejores clubes de la ciudad. ¡Eso sí que es diversión 24 horas!
                     
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/gotoguide/1.jpg"} class="img-responsive" />
					</div>
					 <p>Moverse entre Jerusalén y Tel Aviv es sencillo y existen varias formas de hacerlo según sus preferencias y su presupuesto:</p>
                     <p><strong>Coche:</strong> si opta por alquilar un coche, verá que la carretera 1 conecta las dos ciudades directamente, y se dará cuenta de que las señales de tráfico son bastante claras y están escritas en tres idiomas. Sin embargo, es posible que desee utilizar una de las aplicaciones de navegación locales para mostrarle el camino y ayudarle a evitar los atascos. </p>
                    
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/gotoguide/2.jpg"} class="img-responsive" />
					</div>
					 <p><strong>Bus:</strong> existen bastantes autobuses públicos que viajan entre Tel Aviv y Jerusalén. Este es sin duda uno de los medios de transporte más convenientes y económicos. </p>
                     <p><strong>Tren:</strong> un práctico servicio ferroviario opera en varias estaciones principales entre Tel Aviv y Jerusalén. Actualmente se están llevando a cabo obras de construcción y pronto comenzará a operar una nueva ruta de alta velocidad directa entre las dos ciudades. </p> 
                     <p><strong>Taxi:</strong> los taxis para realizar viajes interurbanos se pueden parar en la calle o reservar por teléfono o por las aplicaciones designadas, como Gett (GetTaxi).</p>
                     <p>Taxis Sherut:</strong> los taxis del servicio “Sherut” son furgonetas de 10 o 12 sitios que generalmente siguen las principales rutas de autobús, dentro de las principales ciudades, y entre ellas. En cuanto al precio, las tarifas de los taxis Sherut son fijas, como las de los autobuses públicos. Los taxis Sherut también ofrecen un servicio de reemplazo para los autobuses los viernes.</p>
                     <p>Para más información sobre los horarios, rutas y estaciones de tren, visite <a href="https://www.rail.co.il/" target="_blank">www.rail.co.il</a></p>
                     <p>Para más información sobre los horarios y rutas de autobús, visite <a href="https://www.bus.co.il/otobusimmvc?" target="_blank">www.bus.co.il</a> </p>
                     <p>Línea telefónica de asistencia de Transporte Público <a href="tel:*8787">*8787</a></p>
                     <p>Aplicación local de transporte - ‘Moovit’</p>
                     <p>¡Venga a visitar la épica Tel Aviv y la inolvidable Jerusalén, a menos de una hora de distancia entre ellas!  </p>


            	`,
      };
    },
  },

  {
    id: "Day_IsTrippin",
    bgImage: "/posts/bank/48/1.jpg",
    mobBgImage: "/posts/bank/48/M/1.jpg",
    title: "EXCURSIONES DE DÍA",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>De puerto a puerto.</h3>

				<p>Comience su día en el parque Jaffa Slope Park, con una magnífica panorámica sobre la mayor parte de la costa israelí, y punto de partida histórico de la metrópoli, hace unos 4000 años. Pida una taza de café en el antiguo puerto restaurado y diríjase hacia el norte para un agradable recorrido a lo largo del paseo marítimo y disfrutar de la diversión junto al mar.</p>
                    <div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/37/2.jpg"} class="img-responsive" />
				</div>
				<p>Cruce la calle hacia la "Tajana Compound", un centro comercial al aire libre fabulosamente renovado ubicado en una estación de tren histórica en desuso construida alrededor de 1890 como estación central de tren de Jaffa y Tel Aviv.</p>
                    <p>Diríjase al pintoresco barrio de Neve Tzedek y cruce las hermosas callejuelas. Dese un capricho en sus boutiques hasta llegar al colorido bullicio del mercado de Carmel. Deténgase para probar la excelente comida callejera y si es martes o viernes, considérese afortunado y haga algunas compras en el mercadillo tradicional Najlat Binyamin, donde los artesanos locales muestran su trabajo.</p>
                    
				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/37/1.jpg"} class="img-responsive" />
				</div>
				<p>Siga su camino hasta el espléndido Rothschild Blvd, el corazón de la arquitectura Bauhaus y patrimonio internacional de la UNESCO. Aquí podrá alquilar una bicicleta y unirse al flujo local hasta la Plaza Habima, sede del teatro nacional y de la orquesta filarmónica israelí. Diríjase a la animada y moderna calle Dizengoff o coma algo en alguna de las cafeterías de la plaza y siga caminando o pedaleando por Hen Blvd hasta la plaza Rabin.</p>
                    <p>Eche un vistazo a la calle Eben Gabiroll, un centro de moda de la fabulosa ciudad, hogar de una gran variedad de restaurantes premiados, y excelentes bares y pubs donde puede comer o beber algo y mezclarse con los habitantes locales.</p>
                    <p>Súbase a un autobús de la línea 5, un icono urbano en sí mismo, y bájese en el puerto de Tel Aviv. Disfrute del atardecer y observe el horizonte de Jaffa hacia el sur, donde comenzó el día. Pase la noche en la zona y mire cómo se transforma en la escena nocturna más animada de la ciudad, repleta de fabulosos bares y discotecas hechos a medida de una noche épica.</p>


            	`,
      };
    },
  },

  {
    id: "Non_Stop_Culture",
    bgImage: "/posts/bank/non-stop-culture/1.jpg",
    mobBgImage: "/posts/bank/non-stop-culture/M/1.jpg",
    title: "Tiempo de cultura",
    isVid: false,
    // vidId:"JxSjC2kZfvI",
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<br/>
                    <h3>Una variedad de fascinantes museos y galerías únicas</h3>
				    <h3>
				        El Museo de Arte de Tel Aviv
				    </h3>

					<p>
						 El Museo de Arte de Tel Aviv presenta una variedad de exhibiciones permanentes y temporales en el Pabellón Helena Rubenstein, ubicado en la avenida Shaul Hamelej cerca del Auditorio Mann. Las exhibiciones permanentes incluyen algunos de los mejores trabajos del arte israelí, así como esculturas del siglo XX y de la actualidad. Cuenta con pinturas europeas – impresionismo y post-impresionismo – desde el siglo XVI hasta el siglo XIX, así como pintura europea y americana del siglo XX. La colección gráfica del museo incluye más de 20.000 grabados y bocetos. Entre los impresionantes trabajos que se exhiben en el museo destaca una selección única de relieves tempranos de Alexander Archipenko y trabajos de Chagall, que fueron donados al museo por el pintor antes de su creación. La conocida colección de arte decorativo de Helena Rubinstein se exhibe permanentemente en el pabellón que lleva su nombre.
					</p>
					<div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/posts/non-stop-culture/1.jpg"} class="img-responsive" />
				    </div>

					<h3>
				         HORARIO DE APERTURA:
				    </h3>

				    <p>

                          Lunes, miércoles, sábados: 10:00 – 18:00 hrs <br>
                          Martes, jueves: 10:00 – 22:00 hrs<br>
                          Viernes: 10:00 – 14:00 hrs <br>

                          Sábados: 10:00 – 16:00 (julio- agosto cerrado los sábados)<br>
                    </p>

                    <p>
                       PARA MÁS INFORMACIÓN, pinche en&nbsp;<a href="//www.tamuseum.org.il/en/default.aspx" target="_blank">Tel Aviv Museum of Art</a>
                    </p>

                    <h3>
                       Beit Hatfutsot: El Museo de la Diáspora
                    </h3>

                    <p>
                        Beit Hatfutsot – El Museo de la Diáspora Judía, se encuentra en el campus de la Universidad de Tel Aviv, y ha ganado una distinción honoraria en el mundo judío por ser el primer museo de la historia del pueblo judío que muestra su contribución a la cultura y creatividad de la humanidad, durante más de dos milenios. La exhibición permanente del museo describe la historia del pueblo judío y vuelve la diáspora a la vida a través de dibujos, videoclips, filmes, maquetas y otro medios. La exhibición enfoca varios temas – incluyendo “el círculo de vida de la familia judía”, “la comunidad”, “la fe” y “el retorno a Sión”.
                    </p>
                        

                    <p>

                          PARA MÁS INFORMACIÓN, pinche en&nbsp;<a href="//www.bh.org.il/" target="_blank">Beit Hatfutsot: El Museo de la Diáspora Judía</a>

                    </p>


                    <h3>
                        Museo de Eretz Israel
                    </h3>

                    <p>

                           El Museo de Eretz Israel de Tel Aviv, es una institución interdisciplinaria que representa la historia del país y su cultura a través de una extensa exhibición permanente, además de una variedad de exhibiciones temporales en temas como arqueología, etnografía, folklore, judaica, historia cultural, identidad local, artesanías tradicionales y artes funcionales. Los pabellones del museo están distribuidos dentro de un patio amplio con el antiguo montículo arqueológico de Tel Kassile, cuyas excavaciones revelaron hallazgos valiosos, posicionado en el centro. El museo alberga una variedad de maquinaria antigua reconstruida, como prensas de vino, prensas de aceite de oliva y un molino de harina, junto con un “mercado de artesanos” que expone herramientas de trabajo tradicionales que fueron usadas en la Tierra de Israel y en toda la región. En el lugar también se ubica un sofisticado planetario con el programa “Viaje al Universo” además de la tienda del museo que ofrece una selección única de regalos de producción local y artesanía.<br>

                            HORARIO DE APERTURA:<br>

                          Domingos a miércoles: 10:00 – 16:00 hrs<br>



                          Jueves: 10:00 – 20:00 hrs<br>



                         Viernes y sábados: 10:00 – 14:00 hrs<br>

                        </p>

                    <p>
                       PARA MÁS INFORMACIÓN, pinche en <strong>&nbsp;</strong><a href="//www.eretzmuseum.org.il/e/" target="_blank">Eretz Israel Museum&nbsp;</a>
                    </p>

					<h3>
					   Beit Ha’ir
					</h3>


					<p>

                         El Beit Ha´ir, renovado por el municipio, es la antigua sede de la municipalidad de Tel Aviv en la calle Bialick, y ahora es una muestra viva de la historia de la historia de la ciudad. El Beit Ha´ir tiene una nueva exhibición que resume la extensa colección de fotos y presentaciones de eventos e historias, lugares y experiencias de residentes de la ciudad a lo largo de los años. Un proyecto que formó parte de las celebraciones del centenario de la ciudad. La sala principal cuenta con una presentación virtual, incluyendo cientos de películas documentales y miles de fotografías inéditas y documentos que exponen los grandes hitos de los primeros años de vida de la ciudad. En el Beit Ha´ir también se puede visitar la casa de Dizengoff, la residencia restaurada del primer alcalde de Tel Aviv, que incluye una exhibición permanente.

                          <br>
                         HORARIO DE APERTURA:
                           Domingos cerrado
                         Lunes a jueves: 9:00-17:00 <br>
                         Viernes y sábados: 10:00-14:00
                    </p>

                    <p>
                      PARA MÁS INFORMACIÓN, pinche en <a href="//www.eretzmuseum.org.il/e/" target="_blank">Beit Ha’ir</a>
                    </p>

                    <h3>
                        Museo de la Experiencia Olímpica
                    <h3>

                    <p>

                         El Museo de la Experiencia Olímpica es un nuevo museo en Tel Aviv, que ofrece un viaje por los cinco anillos de una hora de duración por las grandes marcas olímpicas, con un enfoque especial en los mejores momentos olímpicos de Israel. La Experiencia Olímpica cuenta con modernas imágenes e ilustraciones en alta tecnología, presentaciones audiovisuales, hologramas, pantallas interactivas, obras experimentales y mucho más.<br>

                          Tours guiados para grupos organizados salen cada 30 minutos. Se recomienda hacer reservas por adelantado.
                          Horario de apertura: domingos a jueves: 10:00 – 18:00 hrs, viernes: 10:00 – 14:00 hrs.
                          La Experiencia Olímpica, calles Shitrit 6, Hadar Yosef, teléfono: +972-3-6498385

                    </p>

                    <p>
                       PARA MÁS INFORMACIÓN, pinche en&nbsp;<a href="//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2" target="_blank">Museo de la Experiencia Olímpica</a>
                    </p>

                    

                        <h3> Museo Ilana Goor, Jaffa</h3>

                        <p>   La residencia privada de esta artista mundialmente conocida, se transformó en museo. Es posible ver sus esculturas, muebles, joyas y echar un vistazo a esta casa única en Jaffa.<br>
                          HORARIO DE APERTURA:<br>
                          Domingos a viernes: 10:00 – 16:00 hrs<br>
                           Sábados: 10:00 – 18:00 hrs <br>

                          <a href="//www.ilanagoormuseum.org/eng/">www.ilanagoormuseum.org</a>
                    </p>

                    <h3>
                        Museo del Palmaj
                    </h3>

                    <p>
                       Evaluado como el museo nº 1 de Tel Aviv por Trip Advisor, este museo se centra en el Palmaj, el brazo armado del Movimiento Sionista, que funcionó hasta el establecimiento del Estado de Israel.
                    </p>

                    <p>
                        PARA MÁS INFORMACIÓN, pinche en&nbsp;<a href="//info.palmach.org.il/show_item.asp?itemId=8096&amp;levelId=42798&amp;itemType=0" target="_blank">Palmach Museum</a>
                    </p>

                    <h3>
                        Otros museos interesantes
                    </h3>

                    <p>
                        Tel Aviv-Yafo alberga una variedad de museos pequeños y especializados, como la Casa de Ben Gurión (residencia personal de David Ben Gurión, el primer Primer Ministro de Israel), Beit Hatanaj (La Casa de la Biblia), el Museo de la Haganá (organización de defensa), el Museo del Ezel (Irgún Zvaí Leumí – Organización Militar Nacional), Beit Hasofer (Casa del Escritor), Beit Reuven, Museo Jabotinsky y muchos más. Cada uno de estos pequeños museos es una mina inagotable de tesoros en materia de objetos y artesanías. Beit Bialik por ejemplo – la casa del poeta nacional de Israel, muestra los libros, los muebles y enseres personales del renombrado poeta. La biblioteca personal de Bialik que incluye más de 3.000 libros, se ha conservado, y los archivos del museo contienen miles de manuscritos, incluyendo la colección más extensa de sus escritos.
                    </p>

                    <h3>
                        HORARIOS DE APERTURA DE LOS MUSEOS DE TEL AVIV
                    </h3>
                    <h3>
                       Museo del Ezel:
                    </h3>

                    <p>

                         King George 38: Domingo a jueves 8:30 – 16:00 hrs <br>

                          PARA MÁS INFORMACIÓN, pinche en&nbsp;<a href="//www.goisrael.com/Tourism_Eng/Tourist%20Information/attractions/Pages/Etzel%20Museum.aspx" target="_blank">Etzel Museum</a>
                    </p>

                    <h3>
                        Casa de Ben Gurion:
                    </h3>

                    <p>
                           Domingos, martes-jueves 8:00 – 15:00 hrs <br>
                            Lunes 8:00 – 17:00 hrs<br>
                            Viernes 8:00 – 13:00 hrs <br>
                           Sábados 11:00 – 14:00 hrs
                    </p>

                    <p>
                       PARA MÁS INFORMACIÓN, pinche en&nbsp;<a href="//www.bg-house.org/?categoryId=6575" target="_blank">Casa de Ben Gurion:</a>
                    </p>

                    <h3>
                        Instituto Jabotinsky en Israel:
                    </h3>

                    <p>

                        Domingo-jueves 8:00 – 16:00 hrs <br>
                        Para más Información, pinche en &nbsp;<a href="//en.jabotinsky.org/" target="_blank">Instituto Jabotinsky en Israel:</a>

                    </p>

                    <h3>
                           Museo Israel:
                    </h3>

                    <p>
                             Domingos, lunes, miércoles 9:00 – 17:00 hrs<br>
                            Lunes, jueves 9:00 – 19:00 hrs<br>
                            Viernes 9:00 – 14:00 hrs<br>
                              Para más Información, pinche en
                            <a href="//www.imj.org.il/en/">www.imj.org.il</a>
                    </p>

                    <h3>
                        Centro de visitantes de Jaffa:
                    </h3>

                    <p>

                            Verano: Domingos-jueves, sábados 9:00 – 20:00 hrs<br>



                            PARA MÁS INFORMACIÓN, pinche en  <br>

                            <a href="//www.touristisrael.com/old-jaffa-visitors-center/3604/" target="_blank">Centro de visitantes de Jaffa: </a>

                    </p>

                    <h3>
                         Casa de Joseph Bau:
                    </h3>

                   <p>

                           Con cita previa únicamente (También fines de semana)<br>



                            PARA MÁS INFORMACIÓN, pinche en&nbsp;<a href="//www.josephbau.com/" target="_blank">Casa de Joseph Bau</a>

                    </p>

                    <h3>
                        Museo Rubin:
                    </h3>

                    <p>

                            Domingos cerrado <br>
                             Lunes, miércoles, jueves 10:00 – 15:00 hrs<br>
                             Lunes 10:00 – 20:00 hrs<br>
                             Sábados 11:00 – 14:00 hrs<br>

                            PARA MÁS INFORMACIÓN, pinche en&nbsp;<a href="//www.rubinmuseum.org.il/" target="_blank">Museo Rubin</a>

                    </p>

                    


                    <h3>
                        Galerías de arte
                    </h3>

                    <p>
                       No se pierda las docenas de elegantes galerías de arte, concentradas en su mayoría a los largo de la calle Gordon y en la ciudad vieja de Jaffa. Las galerías exhiben lo último en materia de arte israelí contemporáneo. No diremos ni una palabra más – dejamos que el arte hable por si mismo.
                          </p>
                    </p>
            	`,
      };
    },
  },

  {
    id: "A_Taste_Of_Jerusalem",
    bgImage: "/posts/bank/taste-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/taste-of-jerusalem/M/1.jpg",
    title: "Qué debe probar en Jerusalén",
    ctg: "culinaryjerusalem",
    isVid: true,
    // vidId: "2CSCe2WC7Ns",
    vidId: "oy9ozIvV7Co",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                
				 <p>Jerusalén es una ciudad fascinante y mágica. Muchas personas que visitan Jerusalén alaban su sorprendente atmósfera, sus lugares inolvidables, sus impactantes vistas y mucho más. Sin embargo, para entender realmente de qué trata Jerusalén, hay algunas cosas que sencillamente tendrá que experimentar a través de su estómago. Aquí tiene algunas de las cosas que debería probar durante su visita:</p>
                   
	                    	<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/39/1.jpg"} class="img-responsive" />
				</div>
				    <p><strong>Malabi:</strong> una combinación única de bebida y postre, una mezcla a base de agua de rosas, leche, harina de maíz y azúcar. El Malabi es un plato muy popular de Jerusalén, que se vende en muchos restaurantes y kioscos de Oriente Medio por toda la ciudad. Le garantizamos que no ha probado nunca nada parecido.</p>
                    <p><strong>Knafe:</strong> un plato muy interesante y con un sabor sensacional cuando se sirve y come fresco. El Knafe es esencialmente un postre árabe hecho de queso de cabra fundido y cubierto con hilos de pasta de naranja, bañado en sirope de agua de rosas. Encontrar el Knafe perfecto es una misión, y una vez que lo encuentre, comerlo se convertirá en una adicción.</p>
                    <p><strong>Pretzel de Jerusalén:</strong> cuando recorra los fascinantes lugares del casco antiguo no olvide parar en uno de los carritos verdes y comprar un auténtico pretzel de Jerusalén. Junto con este, obtendrá una hierba verde local aromática llamada Zaatar que combina muy bien con la deliciosa masa.</p>
                    <p><strong>Meorav Yerushalmi:</strong> se traduce literalmente como "Jerusalén mixto". Esta deliciosa mezcla de varias carnes con una combinación local de especias única es una delicia total para los carnívoros.</p>
                    <p><strong>Ashtanur:</strong> abreviatura en hebreo de "fuego en el horno", el Ashtanur es un auténtico pan de pita local que podrá encontrar en el centro de la ciudad o en los mercados durante el almuerzo. Si está especialmente hambriento, pruébelo con shawarma o falafel.</p>
                    <p><strong>Sabij:</strong> absolutamente original, el Sabij es un plato local verdaderamente único compuesto por un pan de pita relleno de berenjena frita, huevos duros y pepinillos, generalmente cubierto por Amba, un sabroso condimento local. Una vez que lo pruebe, se enganchará de por vida.</p>


            	`,
      };
    },
  },

  {
    id: "Sectrets_Of_Jewish_Jerusalem",
    bgImage: "/posts/bank/sectrets-of-jewish-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/sectrets-of-jewish-jerusalem/M/1.jpg",
    title: "LOS SECRETOS DE JERUSALÉN",
    ctg: "jerusalem",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                               
								<h3>Anímese a hacer un viaje espiritual inolvidable en una Jerusalén espectacular</h3>
								<p>Jerusalén es una invitación abierta a un viaje que no olvidará. Suba las montañas, entre en la ciudad y sienta la mezcla única entre pasado y presente, lo ordinario y extraordinario. Una de las ciudades más antiguas del mundo, sagrada para judíos, cristianos y musulmanes, Jerusalén ofrece una experiencia sensorial y espiritual inigualable.</p>
								<p><strong>Entre</strong>. El corazón de la ciudad más sagrada en el judaísmo es la Ciudad Vieja. Entre a través de la histórica<em> puerta de Jaffa</em>, o por <em>la puerta de Zion</em> que conduce directa <strong>al barrio judío</strong>, uno de los cuatro barrios de la ciudad amurallada y hogar de los judíos casi ininterrumpidamente desde el siglo VIII a.C. Maravíllese a través de los callejones, vea la gente, visite el <strong>Cardo</strong>, antigua calle principal de Jerusalén, y absorba el ambiente único. Está caminando tras los pasos de reyes y profetas - No es cosa ordinaria.</p>
								<h3>Sea testigo cómo la historia cobra vida y sienta la energía espiritual profunda dentro de los muros</h3>
								<p><strong>Lo que está por venir</strong>. El último segmento restante de las antiguas murallas que rodearon el Segundo Templo, <strong>el Muro Occidental</strong>, es un símbolo de los anhelos judíos por su patria ancestral y espiritual. Cada judío que no está en Jerusalén reza en dirección al lugar donde está ahora, el lugar donde, según el judaísmo, Dios reside. No importa cuáles sean sus creencias, es una experiencia de humildad. Honrar el espíritu del sitio y colocar una nota en la pared con una oración o un deseo.</p>
								<p><strong>Lo que hay debajo</strong>. Jerusalén está literalmente cubierta de capas de historia y la historia conmovedora obtiene un nuevo significado aquí.</p>
								 <div class="img-wrapper">
													                <img src=${getImgUrl() +
                                            "/posts/sectrets-of-jewish-jerusalem/1.jpg"} class="img-responsive" />
												                </div>
															    <small style="color:#000; display:block;">
								                      		        Credit: Noam Chen
								                      	        </small>
								<p>Haga el tour fascinante a <strong>los Túneles del Muro Occidental</strong> y descubra sus secciones ocultas. La historia cobrará vida a medida que avance por los pasajes subterráneos, averigüe cómo era la vida en Jerusalén durante la era del Segundo Templo y aprenda sobre el arte, la arquitectura y las prácticas de construcción.</p>
								<p>Visite el sitio arqueológico cercano, la <strong>Ciudad de David</strong> y aprenda más sobre la historia de la ciudad. El Rey David la declaró como la capital unificada de las 12 tribus de Israel hace 3000 años. Viaje entre los muros y fortalezas antiguas, fuentes ocultadas donde reyes fueron coronados y sigua el camino de los que huyeron de Jerusalén después de que la ciudad fuera conquistada por los romanos.</p>
								<h3>Maravíllese de la extraordinaria vista impresionante y siéntase en la cima del mundo</h3>
								<p><strong>Lo que está por encima</strong>. Originalmente construido para proteger la ciudad contra los intrusos, Jerusalén está rodeada de murallas. Hoy <strong>los Muros de Jerusalén</strong> ofrecen una oportunidad para explorar la ciudad desde un ángulo diferente. Escuche las historias, vea la ciudad subterránea y disfrute de toda esta belleza.</p>
								<p>Está empezando a alcanzar la superficie.</p>

            	`,
      };
    },
  },

  {
    id: "Jamie_Oliver",
    bgImage: "/posts/bank/jamie_oliver/1.jpg",
    mobBgImage: "/posts/bank/jamie_oliver/M/1.jpg",
    title: "Jamie Oliver degusta el desayuno de Tel Aviv",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "gGe4W8WaIiQ",
    smlTitle: "",
    html: function() {
      return {
        __html: `

						<small style="color:#000; display:block;position: relative;top: 5px;">
						Credit:  Israeli food channel
						</small>

            	`,
      };
    },
  },

  {
    id: "Enjoy_And_Indulge",
    bgImage: "/posts/bank/enjoy-and-indulge/1.jpg",
    mobBgImage: "/posts/bank/enjoy-and-indulge/M/1.jpg",
    title: "El destino de lujo definitivo",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <p>Olvídese del Caribe, Cannes o Las Maldivas. Si lo que quiere son unas vacaciones lujosas ¡Tel Aviv es el sitio!</p>
                    <p>En primer lugar, la ciudad, nombrada "la ciudad más cool" por el NY Times, está a solo unas pocas horas de distancia, lo que significa que no tiene que preocuparse por perder ni siquiera un minuto de sus vacaciones soñadas en librarse del Jet Lag.</p>
                    <p>Una vez aquí, la primera sorpresa es el maravilloso clima soleado durante todo el año, un placer a medida.</p>
                    <p>A continuación, túmbese a descansar y relájese en la gran variedad de alojamientos de lujo ofertados: desde hoteles 5 estrellas en primera línea de playa a los numerosos y asombrosos hoteles boutique en lugares impresionantes por toda la ciudad.</p>
                    
                   	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/38/1.jpg"} class="img-responsive" />
					</div>
					 <p>Para completar la experiencia, coja una toalla y diríjase a cualquiera de las preciosas playas, equipadas con todas las comodidades necesarias para pasar un día fabuloso, por no hablar de la belleza de sus refrescantes aguas.</p>
                    <p>¿Tiene hambre? Disfrute de una gran selección de restaurantes gourmet, desde comida local hasta fusión. Tel Aviv es conocida en todo el mundo por la calidad de su cocina, que se ofrece en restaurantes de chefs galardonados y que están diseñados de forma exquisita.</p>
                    <p>¡Es hora de irse de compras!. Coja su cartera y venga a echarle un vistazo a las boutiques de los diseñadores locales, las exclusivas tiendas chic y los centros comerciales de lujo, donde podrá encontrar de todo, desde alta costura hasta las últimas tendencias internacionales.</p>
                    <p>Para cerrar el día, tómese una cerveza artesanal o un glamuroso coctel en cualquiera de los sensacionales clubes nocturnos o de los elegantes bares que hay por toda la ciudad, y baile hasta que salga el sol antes de dirigirse de vuelta a su hotel para un merecido descanso de 5 estrellas.   </p>
                    <p>¿Lujo? ¿Estilo? ¿Glamour? ¡Lo tenemos todo! ¡Así que dese prisa y reserve hoy su viaje a Tel Aviv!</p>


            	`,
      };
    },
  },

  {
    id: "Cool_Jerusalem",
    bgImage: "/posts/bank/cool-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/cool-jerusalem/M/1.jpg",
    title: "",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    smltitle: "Las sorpresas de Jerusalén",
    html: function() {
      return {
        __html: `
                    <br/>
                    <h3>Una ciudad más allá de las expectativas</h3>
                     <p>Jerusalén es una ciudad mundialmente famosa y uno de los destinos vacacionales más populares del mundo. Mucha gente visita Jerusalén cada año por su significado histórico, sus lugares sagrados, su hermosa arquitectura única y su extraordinaria atmósfera. Sin embargo, Jerusalén está llena de sorpresas y esta increible ciudad ofrece muchas cosas que la mayoría de la gente no asociará con ella de inmediato. Estas son solo algunas de las cosas que no esperaría encontrar en Jerusalén:</p>
                    
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/40/1.jpg"} class="img-responsive" />
					</div>

					 <h3>Fiestas de verano</h3>	
                    <p>Cada año, durante el verano, el centro de Jerusalén se inunda de fiestas los viernes a mediodía, llenas de música, baile, gente guapa de todo el mundo y un embriagador ambiente festivo, para calentar motores y comenzar con fuerza el fin de semana.</p>

                    <h3>Un mercado de locura</h3>
                    <p>Una experiencia increíble que tiene lugar las noches de los jueves, en las que el ajetreado mercado de Majane Yehuda se convierte en un animado escenario nocturno repleto de fantásticos bares y pubs y con música en vivo durante toda la noche.</p>

                    <h3>Festivales</h3>
                    <p>Jerusalén es una ciudad repleta de festivales, desde el famoso festival de cine hasta el festival del vino, un festival internacional de títeres e incluso un festival de la cerveza. Sean cuales sean sus gustos, seguro que encontrará un festival acorde a su estilo en algún punto de la ciudad.</p>

                    <h3>El maratón de Jerusalén</h3>
                    <p>Un maratón fantástico y extremadamente popular que ofrece varios recorridos, desde profesionales hasta familias, que pasan por fascinantes lugares históricos que ilustran 3000 años de la historia de Jerusalén, garantizando una experiencia desafiante, emocionante e inolvidable para corredores y espectadores.</p>
                    <h3>Museos y exhibiciones</h3>
                    <p>La diversidad de la ciudad de Jerusalén se extiende a sus museos y eventos culturales, que se presentan por toda la ciudad. Desde el mundialmente famoso museo de Israel hasta Yad Vashem; del memorable espectáculo de luz y sonido en la Ciudadela al paseo por las murallas (de día o de noche), y mucho más. La ciudad está sencillamente repleta de increíbles experiencias culturales.</p>

                    <h3>El mercado agropecuario</h3>
                    <p>Cada viernes en la colonia alemana, en el corazón de la ciudad, tiene lugar el mercado agropecuario local, en el que puede encontrar multitud de excelentes productos agrícolas, una gran variedad de delicias locales y extraordinarias ofertas.</p>

                    <h3>Un acuario de nivel mundial</h3>
                    <p>Uno de los acuarios más grandes del Medio Oriente. Esta fabulosa atracción para niños y mayores abrió sus puertas al público este año. El acuario mide 7000 metros cuadrados y alberga 40 especies marinas en 33 tanques de agua, el mayor de los cuales contiene 1,6 millones de litros de agua.</p>



            	`,
      };
    },
  },

  {
    id: "Cycle_TelAviv",
    bgImage: "/posts/bank/cycle-in-telaviv/1.jpg",
    mobBgImage: "/posts/bank/cycle-in-telaviv/M/1.jpg",
    //   vidId: "Iyziun92P5A",
    vidId: "5nqL-oIC0GA",
    isVid: true,
    ctg: "telaviv",
    title: "Tel Aviv en bici",
    smltitle: "",
    html: function() {
      return {
        __html: `

					<p>Siendo una de las ciudades más modernas del mundo, no sorprende que Tel Aviv, en los últimos años, se haya unido a la tendencia que se está extendiendo por las ciudades más famosas: la bicicleta.<p>
                     <p>Explorar la ciudad en bici aporta varios beneficios: es respetuoso con el medio ambiente, al reducir sustancialmente el impacto ambiental; le ahorra un valioso tiempo de vacaciones que, de otro modo, pasaría metido en un atasco y, por supuesto, es muy saludable. El ciclismo es un ejercicio fantástico, y como turista, la bici como medio para explorar la ciudad es una forma fabulosa de disfrutar de sus vistas, sonidos y olores de cerca sin interferencias.<p>
                     <p>Estas son solo algunas de las cosas que hacen de Tel Aviv una ciudad fantástica para el ciclismo:<p>
                    
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/41/1.jpg"} class="img-responsive" />
					</div>
					<p>Los carriles exclusivos para bicicletas: la ciudad de Tel Aviv es una gran defensora de las bicicletas como medio de transporte y, para apoyar la causa, hay más de 100 km de carriles exclusivos para bicicletas pavimentados por toda la ciudad, para la seguridad y comodidad de sus usuarios. <p>
                     <p>El tiempo: Tel Aviv goza de un clima fantástico durante todo el año con muy poca lluvia, lo que la convierte en la ciudad perfecta para practicar ciclismo, disfrutando de la brisa fresca que llega desde la playa en el impresionante paseo marítimo o descendiendo por sus asombrosas calles interiores con la fabulosa arquitectura Bauhaus.<p>
                     <p>Tel-O-Fun:  Tel-O-Fun es un sistema público municipal de alquiler de bicicletas fácil, simple y económico. Con Tel-O-Fun, tanto residentes como visitantes pueden coger y dejar bicicletas de excelente calidad usando una tarjeta de crédito en 150 estaciones por toda la ciudad.<p>
                     <p>Lo mejor es que todo está tan cerca en Tel Aviv que puede llevar su bici a la playa, pedalear a lo largo del precioso paseo marítimo, disfrutar de un fantástico picnic en el parque Ha'Yarkon y llevársela en una noche por la ciudad a los fabulosos clubes y bares de Dizengoff o el puerto.<p>
                     <p>Ir en bici nunca fue tan fácil, saludable y divertido en la bella ciudad de Tel Aviv.<p>
                       

            	`,
      };
    },
  },

  {
    id: "TelAviv_Adventures",
    bgImage: "/posts/bank/telaviv-adventures/1.jpg",
    mobBgImage: "/posts/bank/telaviv-adventures/M/1.jpg",
    title: "Cosas geniales que hacer en Tel Aviv",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
                   <p>Tel Aviv es mundialmente reconocida por ser la ciudad que nunca duerme, famosa por su increíble vida nocturna, las fabulosas playas, la fantástica cultura, el arte y mucho más. Pero aquí tiene algunas cosas menos conocidas que puede hacer durante sus vacaciones en la ciudad.</p>
                    
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/42/1.jpg"} class="img-responsive" />
					</div>

					  <h3>Conozca los bares de pulsera</h3>
                    <p>Los bares de pulsera son una excelente manera de pasar la noche bebiendo sin salirse del presupuesto. Simplemente diríjase a uno de los muchos bares en Tel Aviv que le permiten pagar por adelantado un precio fijo.  ¡Diversión asegurada!  </p>
                    <h3>Tambores los viernes tarde</h3>
                    <p>Diríjase a la famosa playa Banana el viernes por la tarde y dese un doble capricho: disfrute de la increíble sesión de tambores en la playa y admire la hermosa puesta de sol, ¡ambas completamente gratis!</p>
                    <h3>Diversión en la azotea</h3>
                    <p>Tal vez sea el clima o tal vez sean las vistas, pero una cosa es segura: los habitantes de Tel Aviv adoran estar al aire libre, especialmente con una bebida en la mano. Durante el verano, la mayoría de los bares y pubs alzan el techo (¡literalmente!), y se convierten en establecimientos al aire libre, mientras que en las azoteas de edificios comerciales y de oficinas surgen numerosos bares. Para dar con estos impresionantes lugares, todo lo que necesita hacer es simplemente seguir los sonidos de la música y la diversión.</p>
                    <h3>Deporte al aire libre</h3>
                    <p>Nada es más importante que su salud, y una de las mejores cosas que puede hacer por su cuerpo es ejercitarlo. Tel Aviv ofrece algunas maneras excelentes de hacerlo, desde nadar en el mar o correr por el paseo marítimo, hasta ir en bicicleta por las calles de la ciudad e incluso practicar gimnasia en cualquiera de las estaciones de ejercicio al aire libre ubicadas alrededor de la ciudad.</p>
                    <h3>Grandes eventos estivales </h3>
                    <p>Desde famosos artistas internacionales hasta increíbles festivales de tecnología, arte y cerveza, inauguraciones de galerías, exposiciones o música callejera en vivo, hasta cines al aire libre y fiestas en la playa que duran toda la noche, ¡Tel Aviv en verano es una fuente inagotable de diversión y entretenimiento que no debe dejar escapar!</p>


            	`,
      };
    },
  },

  {
    id: "2_AWESOME_CITIES",
    bgImage: "/posts/bank/27/1.jpg",
    mobBgImage: "/posts/bank/27/M.jpg",
    title: "2 Ciudades Increibles",
    smltitle: "",
    isVid: true,

    vidId: "NlOJ-i5hJdI",
    ctg: "telavivAndJerusalem",
    html: function() {
      return {
        __html: `

					<br/>
					<h3>Una escapada mágica e inolvidable hacia el sol</h3>
					<p>
						Tel Aviv, una metrópolis bulliciosa y muy moderna, con relucientes playas doradas, un ambiente a la última y amplias oportunidades de diversión con el auténtico sabor de Oriente Medio, sin mencionar la excelente comida y café. A tan solo cuarenta minutos, experimente un ritmo y una vida completamente distintos: Jerusalén, una ciudad con un esplendor incomparable. Será fácil comprender por qué durante milenios ha sido tan inspirador para muchos.
					</p>

					<p>
						Si bien tanto Tel Aviv como Jerusalén son dos ciudades ajetreadas, vitales e intrigantes que ofrecen una multitud de atracciones de visita obligada, no podrían ser más diferentes. A pesar de su proximidad geográfica, tienen paisajes, olores y sabores completamente diferentes. ¿En qué otro lugar podría combinar tan fácilmente el mejor destino de playa con una de las ciudades más antiguas y sagradas de la historia?
						Así que aquí tiene una muestra de lo que puede hacer durante unas vacaciones en ambas ciudades.
					</p>

					<h3>Tel Aviv – la ciudad que nunca duerme</h3>
					<p>
						Ha aterrizado en Tel Aviv…Experimente toda la emoción que la primera ciudad hebrea tiene preparada. Descubra los deslumbrantes tonos azules del Mediterráneo, los pintorescos rincones de la Ciudad Blanca, sus mercados, restaurantes, sabores especiales y una animada vida nocturna. Tome algunas olas y entienda exactamente por qué Tel Aviv es conocida como la ciudad sin pausa, que respira vitalidad las 24 horas del día.
						¡Vamos!
					</p>
					<h3>
						Neve Tzedek:
					</h3>
					<p>
						Descubra la magia de este espectacular y bellamente renovado barrio, ubicado en el extremo sur del paseo marítimo de Tel Aviv, junto a Jaffa. Comience su mañana con una experiencia culinaria que incluye un desayuno típico israelí: deliciosos productos horneados, huevos, quesos y salsas, ensalada verde o ensalada picada, zumo de naranja y, por supuesto, un excelente café. La visita recomendada a Neve Zedek le traslada a monumentos históricos y museos pequeños y maravillosos.
					</p>

					<h3>
						Hatachana:
					</h3>
					<p>
						Tras recargar energías, vaya a visitar Hatachana, que está en las inmediaciones. Allí podrá visitar edificios templarios renovados, así como la antigua estación de tren de Jaffa, completamente restaurada. El lugar cuenta la historia de la estación de tren, con su línea Jaffa-Jerusalén, que operó aquí desde 1892 hasta 1948.
					</p>
					<h3>
						Jaffa
					</h3>
					<p>
						Después, dé un paseo por el impresionante paseo marítimo de Tel Aviv hasta Jaffa. Recomendamos visitar el puerto de Jaffa, considerado uno de los puertos más antiguos del mundo. Relájese en uno de los muchos cafés que salpican el muelle y observe a los pescadores en acción. Luego, continúe hacia el colorido mercadillo, donde podrá disfrutar de un artículo vintage, cerámica armenia, una hamsa o cualquiera de la multitud de recuerdos. Por la noche, el área se transforma en una bulliciosa escena de bares y restaurantes.
					</p>
					<h3>
						Pedalee hasta la playa:
					</h3>
					<p>
						Tel Aviv es conocida como la capital de la bicicleta de Israel. En un día agradable, aquellos de ustedes con espíritu deportivo pueden alquilar una bicicleta en una de las estaciones de Tel-O-Fun o en cualquier otro lugar de alquiler de la ciudad. Ir en bicicleta desde Neve Zedek a la playa de Tel Baruch en la parte norte de la ciudad es una experiencia extraordinariamente divertida.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/7.jpg"} class="img-responsive" />
					</div>
					<h3>
						Museo Tierra de Israel (Eretz Israel)
					</h3>
					<p>
						Si se encuentra en la parte norte de la ciudad, le sugerimos que visite el Museo Tierra de Israel. Es un museo multidisciplinar que se enfoca en la historia y la cultura de Israel a través de exhibiciones permanentes y temporales dedicadas a la arqueología, etnografía, correos y filatelia, folclore, Judaica, artesanías tradicionales, arte popular, historia cultural e identidad local.
					</p>
					<h3>
						Bulevar Rothschild
					</h3>
					<p>
						¿Busca un lugar acogedor donde poder disfrutar de una excelente comida? Pruebe a comer en uno de los restaurantes en o alrededor del Bulevar Rothschild, en el mismo corazón de la ciudad y una de las tres zonas que conforman la Ciudad Blanca, reconocida por la UNESCO como Patrimonio de la Humanidad. Esta calle, que define perfectamente la esencia de Tel Aviv, le ofrece una excelente oportunidad para observar a sus gentes. También puede dar un paseo y disfrutar de la impresionante arquitectura Bauhaus, el antiguo quiosco y los pequeños museos que relatan la fascinante historia de Tel Aviv y su primer vecindario, Ahuzat Bayit.
					</p>
					<h3>
						Vida nocturna
					</h3>
					<p>
						Si planea quedarse en la ciudad, puede optar por reservar una habitación en uno de los grandes hoteles ubicados en la playa, cerca del paseo marítimo o en uno de los encantadores hoteles boutique. Si todavía tiene energía y está deseando ir, ahora es el momento de disfrutar en uno de los populares bares, discotecas, la Ópera, un espectáculo de danza o cualquiera de los muchos eventos y festivales en Tel Aviv.
						¿Ha terminado de probar la buena vida en Tel Aviv? Ahora disfrute de lo mejor de ambos mundos yendo a Jerusalén. ¡Está a solo 40 minutos! ¡La Ciudad Santa le espera!
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/2.jpg"} class="img-responsive" />
					</div>
					<h3>
						Jerusalén – la ciudad más hermosa del mundo
					</h3>
					<p>
						Descubra la ciudad más sagrada para tres religiones: judaísmo, islamismo y cristianismo. Visite los lugares históricos, inhale los olores vertiginosos, pruebe los platos especiales, respire el aire puro de la montaña y diviértase en los muchos lugares de entretenimiento de la ciudad.
					</p>
					<h3>
						Ein Kerem
					</h3>
					<p>
						Antes incluso de llegar a la ciudad, puede visitar el pintoresco barrio de Ein Kerem. A solo 20 minutos en coche del centro de la ciudad, es conocido por su carácter idílico. Ein Kerem, rodeado de zonas verdes, ofrece impresionantes vistas, encantadoras casas de piedra, iglesias y mezquitas, fascinantes lugares históricos, encantadores callejones, galerías y boutiques especiales, cafeterías y restaurantes de calidad, así como exquisitos hoteles, tanto antiguos como nuevos.
					</p>
					<h3>
						Museo de Ciencias de Bloomfield
					</h3>
					<p>
						El museo de ciencias de Jerusalén es un reino mágico para adultos y niños por igual, lleno de objetos en movimiento, ilusiones ópticas, experimentos eléctricos y de todo aquello que ha hecho de nuestro mundo un lugar más fácil.
					</p>
					<h3>
						La Ciudad Vieja
					</h3>
					<p>
						¡En el Top de cualquier itinerario por Jerusalén! El casco antiguo de Jerusalén es, simplemente, un ancestral tesoro escondido para descubrir y deleitarse. La verdadera esencia de Jerusalén se oculta en los angostos y sinuosos callejones de la Ciudad Vieja: la atmósfera especial, la fascinante historia y los secretos se revelan entre sus antiguas piedras. Visite el Muro de las Lamentaciones para conmoverse con la santidad de las ruinas del Templo y para colocar una nota con una petición al Santísimo entre las piedras.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/3.jpg"} class="img-responsive" />
					</div>
					
					<h3>
						Ein Kerem
					</h3>
					<p>
						Even before reaching the city, you can visit the picturesque neighbourhood  of Ein Kerem. Just a 20-minute drive from the city centre, it is known for its idyllic character. Nestled in greenery, Ein Kerem brings you breathtaking views, charming stone houses, churches and mosques, fascinating historical sites, enchanting alleys, galleries and special boutique shops, cafes and fine restaurants, as well as exquisite hotels, both old and new.
					</p>
					<h3>
						Bloomfield Science Museum
					</h3>
					<p>
						Jerusalem’s science museum is a magical kingdom for adults and children alike, filled with moving objects, optical illusions, electrical experiments and everything that has made our world a user-friendly place.
					</p>
					<h3>
						The Old City
					</h3>
					<p>
						At the top of any Jerusalem itinerary! The Old City of Jerusalem is, simply put, an ancient treasure trove of discovery and delight. The true essence of Jerusalem is hidden in the narrow, winding alleyways of the Old City: the special atmosphere, fascinating history and secrets are revealed among its ancient stones. Visit the Western Wall to be moved by the sanctity of the remains of the Temple and to place a note with a request to the Holy One between the stones.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/4.jpg"} class="img-responsive" />
					</div>
					<p>
						Siga los pasos de Jesús, por la Vía Dolorosa, hasta la Iglesia del Santo Sepulcro, hogar de los dos lugares más sagrados del cristianismo: el lugar donde crucificaron a Jesús de Nazaret y la tumba vacía, de la cual se cree que resucitó. Continúe hacia el Monte Sión, donde podrá visitar el Cenáculo, que tradicionalmente se considera el sitio donde tuvo lugar la Última Cena. Luego, como Jesús hacía frecuentemente, visite el Monte de los Olivos para un momento de meditación en Getsemaní, donde Jesús oró y sus discípulos durmieron la noche anterior a la crucifixión. Y suba a la azotea del Hospicio Austriaco de la Sagrada Familia para disfrutar de una vista verdaderamente magnífica de Jerusalén y de la Ciudad Vieja.
						Para sumergirse aún más profundamente en las raíces de la antigua Jerusalén, recorra los túneles del Muro de las Lamentaciones, visite la Cúpula de la Roca, el lugar sagrado donde se cree que Mahoma ascendió al cielo, y la Iglesia Luterana del Redentor, hogar de uno de los órganos más bellos de Israel.
					</p>
					<h3>
						Mercado de Mahane Yehuda
					</h3>
					<p>
						Ha sido un día largo. ¿Empieza a tener hambre? Ahora puede visitar el mercado de Mahane Yehuda, el bullicioso y vibrante mercado al aire libre de Jerusalén. Junto a los tradicionales puestos del mercado, muchos cafés y tiendas gourmet han surgido en los últimos años.
					</p>
					<h3>
						De compras por Jerusalén:
					</h3>
					<p>
						¿Listo para algunas compras y souvenirs? Compre cerámicas armenias o judaica en las hermosas y muy especiales tiendas de la Ciudad Viej. También encontrará comercios que venden una gran cantidad de recuerdos de Israel en el centro de la ciudad. Encontrará numerosas tiendas de ropa ubicadas en el paseo Ben-Yehuda. Y no se olvide de visitar las de segunda mano si quiere comprar algo un poco más auténtico. Además, no se pierda una visita al exclusivo centro comercial Mamila, considerado uno de los más activos de la ciudad.
					</p>
					<p>
						Tan diversas, tan distintas y sin embargo a tan solo un corto viaje la una de la otra, Jerusalén y Tel Aviv forman el paquete vacacional perfecto. Juntos, le ofrecen historia y modernidad, artefactos antiguos y artes modernas, diversión al sol y el viaje más espiritual de su vida. ¡No hay nada mejor que eso! Entonces, ¿a qué espera? ¡Reserve sus vacaciones ahora!
					</p>


           `,
      };
    },
  },

  {
    id: "Jerusalem",
    bgImage: "/posts/bank/jerusalem-p/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-p/M.jpg",
    title: "Jerusalem",
    smltitle: "",
    isVid: true,
    vidId: "FvAWuLQEOJw",
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `

					<h3>A CITY OF MAGIC AND RADIANCE BEYOND YOUR WILDEST DREAMS</h3>
					<h3>Jerusalem is The Capital of Israel and By Far One of The Most Famous and Fascinating Cities in the World, Where Thousands of Years of Glorious History Seamlessly Intertwine with Modern Day Life.</h3>
                              
                                <p>Discover the overwhelming power of this 3,000 year old city - its innumerable historic sites and archeological wonders, its magical walkways and magnificent views which are guaranteed to leave a lasting impression. At the same time, the city’s strikingly modern attractions promise around the clock excitement and pleasure for all lovers of culture, arts, music, and culinary delights.</p>

                                <h3>Walk through 3000 years of history</h3>

                                <p>The Old City of Jerusalem is a favourite for all visitors from first timers, seasoned visitors as well as the locals. Surrounded by an ancient wall that has been rebuilt throughout history, there are 7 gates allowing access to historical and holy sites here. Make your way down the stone cobbled streets and find yourself walking through four thousand years of history, leaving you humbled and yet excited as you connect the modern day present with the simple beginnings of the past.</p>
                              
                                <h3>Meet the modern vibrant Jerusalem</h3>

                                <p>Step outside of the Old City and find everything that a typical modern city offers including hotels, promenades, restaurants and shopping malls. Visit museums, like the Israel Museum which is the largest cultural institution in Israel and ranked among the world’s leading art and archaeology museums housing the infamous Dead Sea Scrolls (oldest biblical manuscripts) among other treasures. Local farms, wineries and breweries are set up around Jerusalem offering a variety of options to foodies ranging from the traditional Israeli cuisine to the contemporary and fusion fare paired with delicious award-winning wines and beers attracting enthusiast from all over the world.</p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Jerusalem-p/1.jpg"} class="img-responsive" />
							    </div>
                                <p>Visit Mahane Yehuda, a colourful and vibrant outdoor market with an attractive vibe filled with culture and delicious aromas of the delicacies sold here. Wait till sundown and see this ‘shuk’ transform into a trendy hangout with live music to suit every mood accompanied with energetic people, a growing ‘street-art’ gallery exceptional food and delightful drinks. Mahane Yehuda offers a special experience so walk down the streets, stop by a food joint, dance a little while enjoying a drink and make your way to the next spot.</p>

                                <p>Drenched in art, history, culture and diversity the capital city of Israel loves to have a good time while allowing one to experience the contrast between old world historical charm and modern city living. As you drive in to Jerusalem you can’t help but connect with the culture, archaeology and history of the many nations who have walked through here, where old meets new beyond the walls of the Old City in this unique world capital.</p>
                                
				


           `,
      };
    },
  },

  {
    id: "Magical_Deadsea",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "EL MAR MUERTO",
    smltitle: "",
    isVid: true,
    vidId: "Y2hAOLNcPKU",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
								<br/>
								<h3>La mente y el cuerpo se elevan en el lugar más bajo de la tierra</h3>
								
								<p>Relájese en la "bondad salada" del mar Muerto</p>
								<p>Con una belleza natural impresionante, balnearios ricos en minerales calmantes, cualidades curativas demostradas y muchas experiencias únicas, no es de extrañar que el mar Muerto</p>
								<p><strong>Relájese</strong>. Sal, barro, sol ... y hay más. Sumérjase en manantiales sulfurosos naturales (calientes) y disfrute de tratamientos de spa. ¿Está familiarizado con la frase "placer culpable”? No se aplica aquí. Saque "culpable" de la oración y simplemente disfrute de unas saludables y revitalizantes vacaciones relajantes.</p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Magical-Deadsea/2.jpg"} class="img-responsive" />
							    </div>
								<p><strong>Flote</strong>. Gracias al excepcional alto nivel de solución salina en el agua, será capaz de realizar un pequeño "milagro" y flotará sin esfuerzo en el agua. Entre en el agua, recuéstese y deje que la naturaleza siga su curso. Puede tomarle un minuto hasta que se&nbsp; acostumbre, pero entonces, lo prometemos, es mágico.</p>
								<p><strong>Sane</strong>. Entrar en la zona del mar Muerto es como entrar en un mundo diferente. Diferentes vistas, diferente ritmo, aire diferente e incluso un sol diferente.</p>
								<p>Los dos últimos son los resultados de las condiciones geológicas especiales del área y las principales razones de sus poderes curativos.</p>
								<p>La atmósfera es diferente porque en la solución salina se disuelven minerales ricos y saludables que usted inhala a través del aire. El sol es diferente porque la ubicación, tan por debajo del nivel del mar, debilita y filtra los dañinos rayos UV. Salga y disfrute de los maravillosos regalos de la naturaleza.</p>
								<h3>Descubra al niño en su interior y deje que la naturaleza le cure</h3>
								<p><strong>Embárrese</strong> - El lodo del mar Muerto ha demostrado ser beneficioso para la salud. Mejora, revitaliza y proporciona alivio para su piel. Puede comprarlo y usarlo en casa, pero ¿por qué perderse la oportunidad de sacar al niño que lleva dentro? Cúbrase con ese barro negro de pies a cabeza y simplemente diviértase. Seguro que se hará un selfie.</p>
								                               


           `,
      };
    },
  },
  {
    id: "Next_Level_DS",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "TAKE RELAXATION TO THE NEXT LEVEL",
    smltitle: "",
    isVid: true,
    vidId: "Y2hAOLNcPKU",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
                     <p>
					The Dead Sea, officially The Lowest Place On Earth (428m Below Sea Level) And A Shortlist Candidate For The World’s 7 Natural Wonders, Is An Enthralling And Evocative Combination Of Natural Splendor, Compelling Ancient History And Modern Luxuries.
				</p>
				<p>
					From the healing powers of the Dead Sea’s cobalt blue waters, through the awesome beauty of the surrounding landscape to the myriad of fascinating sights this area has to offer, the Dead Sea is a place of tranquility, health and inspiration for body and soul alike.
				</p>
				<p>
					Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions. Along the main part of the 75 kilometer stretch dotted with beautiful beaches, you will also find world class hotels and spa facilities to guarantee a truly indulgent experience.
				</p>
				
				<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/next-level/1.jpg"} class="img-responsive" />
				</div>
				<p>
					The Magical Beaches of the Dead Sea
				</p>
				<p>
					The beaches of the Dead Sea are like nothing else the world has to offer. There are many kilometers of beautifully developed and well-maintained spots where you can soak up the sun while on your dream vacation. Choose your spot on the rocky sand and take in the breathtaking scenery with the incredible mountain ranges surrounding the sea. The warm waters of the Dead Sea are always calm and offer superior relaxation from the minute you get in.
				</p>
				<p>
					On the southern shores at the lowest point on earth, you will find an array of hotels where you can enjoy a magical sunrise over the lake, leaving an array of colors on the small ponds with the salt formations scattered throughout. To complete the experience of being at the Dead Sea, take some of the silky dark mud and lather it on allowing your skin to absorb the helpful minerals. Dead Sea mud has been proven beneficial to the skin and body. You will feel refreshed with skin that looks and feels younger. Give yourself the pampering that you deserve and get dirty with the Dead Sea mud – it’s healthy!
				</p>
				<p>
					Discover the desert area around the Dead Sea
				</p>
				<p>
					There is more to do than just relaxing in the spas and floating in the Dead Sea. If you are travelling south from Jerusalem, complement your desert experience by stopping at kibbutz Ein Gedi, a natural oasis on the slopes of the Judean desert, and take a hike through a nature reserve where you will see wildlife like the ibex (a kind of mountain goat) and enjoy the waterfalls and pools cascading on the rock formation. Ein Gedi also offers hotel accommodations and spas which houses hot sulphur pools and have different types of healing and therapeutic massages too. Continue south from here to Masada, a national landmark with a strong historical connection, located at the top of a massive mountain that the adventure seeker can hike, or it can be reached comfortably by cable car.
				</p>
				<h3>
					MOUNT KARKOM
				</h3>
				<p>
					In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.
				</p>
				<p>
					Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai – mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.
				</p>
				<p>
					Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.
				</p>
				<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/next-level/2.jpg"} class="img-responsive" />
				</div>
				<p>
					Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.
				</p>
				<p>
					To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.
				</p>          


           `,
      };
    },
  },

  {
    id: "Dead_Sea1",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "ALEGRÍAS DEL MAR MUERTO",
    smltitle: "",
    isVid: false,
    ctg: "deadsea",
    html: function() {
      return {
        __html: `
                         <h3>Para un buen momento flotante</h3>
                         <p>
			Una maravilla geológica en un entorno único y sereno, el Mar Muerto es una atracción turística sumamente popular. Experimente la calma tranquilidad del agua con sus distintas propiedades curativas mientras disfruta de la incomparable belleza del paisaje circundante. <strong>El Mar Muerto, también conocido como el spa natural más antiguo del mundo, ha sido bendecido con una concentración extremadamente alta de sal del 31.5%, permitiendo a los turistas de todas partes la increíble experiencia de flotar sin esfuerzo en las aguas del lugar más bajo de la Tierra. Mientras esté aquí, puede embadurnarse</strong> en el saludable barro negro de la zona o explorar los fascinantes e históricamente ricos paisajes cercanos.
              		</p>

              		<p>
			Hoteles de lujo, cocina variada, desde restaurantes gourmet hasta restaurantes de comida rápida, grandes tiendas de souvenirs, la extraordinaria historia de la cercana Masada y muchas actividades culturales durante todo el año, hacen del Mar Muerto un destino popular para turistas locales y visitantes internacionales.
              		</p>
					
					
                        


           `,
      };
    },
  },

  // {
  // 	    id:"Eurovision",
  //         bgImage : "/posts/bank/1.jpg",
  //         mobBgImage : "/posts/bank/M.jpg",
  //         title : "Eurovision Tel Aviv",
  //         smltitle : "",
  //         isVid:false,
  //         ctg: "telaviv",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                          <h3>Todo un clásico en la ciudad que nunca duerme</h3>
  //                          <p>Una oportunidad irrepetible para visitar Tel Aviv durante la celebración del Festival de la Canción de Eurovisión.<br/>
  //                             Semifinal 1: 14 de mayo de 2019<br/>
  //                             Semifinal 2: 16 de mayo de 2019<br/>
  //                             Gran final: 18 de mayo de 2019</p>

  //                             <p>¡La cosa se está poniendo interesante en la fabulosa Tel Aviv! La ciudad que nunca duerme se alía con la emoción mientras se prepara para albergar el Festival de la Canción de Eurovisión 2019 en lo que promete ser uno de los eventos más gloriosos que jamás hayan tenido lugar en la famosa ciudad de la fiesta.
  //                             <p>Tel Aviv, conocida por su increíble energía, playas impresionantes, un tiempo genial durante todo el año y su gente guapa, es el destino perfecto para una escapada inolvidable. Tel Aviv es también famosa en todo el mundo por su mentalidad abierta y su espíritu liberal, convirtiéndola en la anfitriona ideal para el concurso de canción de Eurovisión, que ofrece a viajeros de todas partes la oportunidad perfecta para disfrutar de esta vibrante y energética ciudad en su mejor momento.
  //                             <div class="img-wrapper">

  // 								 <img src=${getImgUrl() +  "/posts/eurovision/4.jpg"} class="img-responsive" />
  // 							</div>
  //                             <p>Importantes producciones que realizar en el mes de mayo, cuando se celebre el concurso de Eurovisión, están ya en camino. Algunos de los eventos planeados incluyen una increíble ceremonia de inauguración, el momento “alfombra roja” e incluso una mega "Euro Villa", que se ubicará a solo unos minutos a pie del impresionante paseo marítimo de Tel Aviv y la playa. La Euro Villa estará abierta durante 10 días e incluirá actuaciones en vivo de súper estrellas del presente y el pasado, así como proyecciones de las semifinales del concurso y de la gran final de Eurovisión. El concurso en sí tendrá lugar en la Expo Tel Aviv.
  //                             <p>El Festival de la Canción de Eurovisión en Tel Aviv será sin duda un evento único, así que ¡asegúrese de reservar su viaje ahora al concurso de Eurovisión más increíble hasta el momento, en la ciudad más increíble de todas!

  //            `
  //     }
  //   }
  // },

  {
    id: "Tourist_Information",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "Información de transporte para turistas",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
                                <h3>
									Cómo llegar a Tel Aviv desde el aeropuerto:
								</h3>
								<p>
									La forma más económica de llegar al centro de Tel Aviv desde el aeropuerto de Ben Gurión es el tren. Sigue las señales (la estación está junto al aeropuerto) y busca un tren que vaya a Tel Aviv HaHagana (al sur de Tel Aviv), Tel Aviv-HaShalom (en el centro de Tel Aviv), Tel Aviv-Savidor Center (para la zona norte-vieja de Tel Aviv) o Tel Aviv-University (para llegar a Expo Tel Aviv). Hay que tener en cuenta que Tel Aviv HaShalom está cerrado los viernes hasta septiembre del 2019.
								</p>
								<p>
									Un trayecto de ida cuesta 13,50 NIS (shekalim), y dura unos 25 minutos aproximadamente. Al bajar del tren, se puede coger un taxi al alojamiento. En el taxi, hay que pedirle al conductor que use el taxímetro (“monet”) y tener dinero en efectivo para pagar. Hay otras opciones en las apps de taxis. Para más información y para planificar tu trayecto, visita <a href="https://www.rail.co.il/en" target="_blank">https://www.rail.co.il/en</a> – (disponible en inglés)
								</p>
								<p>
									Si prefieres coger un taxi directamente del aeropuerto a Tel Aviv, hay una parada de taxis a la salida de la terminal. Un trabajador del aeropuerto te preguntará el destino, el número de pasajeros, maletas y te dará un ticket para dar al conductor. Puedes usar el taxímetro o aceptar un precio fijo. Los trayectos suelen costar entre 150-170 NIS por persona.
								</p>
								<h3>
									Cómo llegar de Tel Aviv a Jerusalén:
								</h3>
								<h3>
									En autobús
								</h3>
								<p>
									Dirígete a la estación central de tren Tel Aviv Savidor y coge el bus nº 480. El trayecto dura unos 45 minutos. La ruta del autobús finaliza en la estación central de autobuses de Jerusalén en Jaffa Road. Desde allí puedes coger el tranvía o cualquier otro medio de transporte disponible para llegar a tu destino. 
								</p>
                				<h3>
									En tren
								</h3>            
            					<p>
									¡También puedes coger el nuevo tren! Si quieres ir a Jerusalén directamente desde el aeropuerto de Ben Gurión, coge el tren a la estación de Navon de Jerusalén. El trayecto desde el aeropuerto dura unos 25 minutos. Si viajas desde otras estaciones en Tel Aviv, dirígete a la estación del aeropuerto de Ben Gurión y desde allí cambia para ir a Navon.
								</p>            
								<h3>
									Cómo moverte por Tel Aviv
								</h3>
								<p>
									<!--El municipio de Tel Aviv ofrecerá transporte público gratuito por toda la ciudad durante el fin de semana de Eurovisión.
									Habrá autobuses gratuitos el viernes 17 y sábado 18 de mayo.-->
									Normalmente los sábados no hay transporte público en Tel Aviv (aparte de taxis)
								</p>
								<!--<p>
									Para los demás días de la semana de Eurovisión, necesitarás una tarjeta Rav Kav: es parecida a la “tarjeta Oyster” de Londres.  La tarjeta Rav Kav es una tarjeta inteligente que puede recargarse para poder usar los autobuses sin preocuparte por el efectivo. De hecho, ya no se puede pagar en efectivo, así que es muy importante que adquieras una Rav Kav en cuanto llegues a Tel Aviv.
								</p>-->
								<p>
									Se puede adquirir la tarjeta Rav Kav en cualquier autobús, en cualquier parada, pidiéndosela.  Cuesta 5 NIS (debes llevar el dinero exacto). Luego, cuando bajes del autobús, esta tarjeta te sirve para todos los demás. Algunos quioscos locales 7/11 ofrecen servicios de recarga para añadir crédito. Con unos 50 NIS es suficiente para una semana, ya que cubre unos 10 trayectos locales (cada trayecto son 5,90 shekels).
								</p>
								<p>
									También puedes comprar la Rav Kav en las oficinas de Rav Kav en la calle Ibn Gabirol 35, abierta de domingo a jueves de 8:00 a 20:00 y los viernes y vísperas de festivos de 8:00 a 13:00, o en la estación de tren de Tel Aviv Savidor y Carmelit Central.
									Se puede recargar en cualquier estación de tren.
								</p>
								<h3>
									En bici
								</h3>
								<p>
									Tel Aviv está adaptada para bicicletas con muchos carriles-bici por toda la ciudad, incluso hay uno que va a lo largo de toda la playa, desde Yafo, al sur, hasta el norte de Tel Aviv y más allá. Son unos lugares preciosos para ir en bici mientras disfrutas del ambiente y arquitectura de Tel Aviv. Si tienes un casco de bici, tráetelo.
								</p>
								<h3>
									Scooters eléctricos
								</h3>
								<p>
									¡Los scooters son muy populares en Tel Aviv! Ofrecen una manera cómoda y divertida de moverte por la ciudad. Hay bastantes empresas. Lo único que tienes que hacer es descargarte la app correspondiente, seguir las instrucciones y listo. Cambia tu bolso por una mochila, ya que te ayudará con el equilibrio, presta atención al tráfico y no escuches música cuando montes. Si tienes un casco, es mejor que lo lleves puesto.
								</p>
								<h3>
									Caminando
								</h3>
								<p>
									Caminar es una muy buena opción también ¡el contador de pasos subirá muchísimo después de unos días en la ciudad que nunca para! ¡Equípate con un mapa, una gorra para el sol, una botella de agua y a dominar las aceras!
								</p>
								<h3>
									Apps de transporte 
								</h3>
								<p>
									Hay varias apps de transporte que puedes descargarte antes de llegar para ayudarte a planificar tus trayectos. Busca una de cada categoría: hay apps para taxis, alquiler de bicis o scooters y apps para planificar los trayectos. También puedes pedirle consejo al conserje del hotel o dueño del apartamento para organizar tus rutas.
								</p>
								<h3>
									Wifi
								</h3>
								<p>
									Tel Aviv tiene una red de WIFI gratuita por toda la cuidad. Busca la red “Free TLV” en tu smartphone. Está operativa en 80 ubicaciones de la ciudad. La mayoría de los bares también tienen WIFI gratuita a tu disposición; pide la contraseña cuando hagas tu pedido. Los hoteles también ofrecen WIFI gratuita y puedes pedir la contraseña cuando hagas el registro.
								</p>
								<a href="//visit.tel-aviv.gov.il/move/airport" target="_blank" class="transportation">Transportation.</a>
           `,
      };
    },
  },
  {
    id: "Natures_Glory",
    bgImage: "/posts/bank/natures-glory/1.jpg",
    mobBgImage: "/posts/bank/natures-glory/M.jpg",
    title: "NATURE'S GLORY",
    smltitle: "",
    isVid: true,
    vidId: "M627s8TdaB8",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
			    <p>
					Get high on life in the lowest place on earth
				</p>
				<p>
					The Dead Sea, officially the lowest place on earth (428m below sea level) and one the world’s natural wonders, is an enthralling and evocative combination of natural splendor, compelling ancient history, and modern luxuries.
				</p>
				<p>
					Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions.
				</p>
				<h3>
					NEW BOARDWALK AT THE DEAD SEA
				</h3>
				<p>
					Just in time for the Passover and Easter holidays, a new, stone 4k boardwalk and free, accessible public beaches with full facilities have opened in the hotels area of the Dead Sea. The promenade will eventually extend another ten kilometers, to include a total of 16 public beaches, connecting Ein Bokek and Hamei Zohar, along the southern part of the Dead Sea. This is part of a major new leisure and hotel complex that is planned for the region.
				</p>
				<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/natures-glory/1.jpg"} class="img-responsive" />
				</div>
				<p>
					Visitors to the Dead Sea - the lowest place on earth and the world’s largest natural spa known for its unique wellness properties since Biblical times – can now enjoy full access to wide, sandy beaches, walking, jogging, cycling or even taking a Segway along the entire length of the new boardwalk. The new beaches are all free to the public, with facilities that include beach chairs, showers, canopies, sports equipment, children’s playgrounds and more.
				</p>
				<p>
					The beaches are accessible for the disabled, with special wheelchairs and trails that can take visitors right into the waters of the Dead Sea. Special illumination allows tourists and visitors to walk the boardwalk at night, while at the same time enjoying the very special atmosphere at the Dead Sea.
				</p>
                               


           `,
      };
    },
  },
  {
    id: "Natural_Spa",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "MAR MUERTO",
    smltitle: "",
    isVid: true,
    // vidId: "8p4qfkneH1c",
    vidId: "Y2hAOLNcPKU",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					<br/>
					<h3>Siéntase en la cima del mundo - En el lugar más bajo de la Tierra</h3>
				    <h3><span>Relájese a otro nivel</span></h3>
					<p>El mar Muerto, oficialmente el lugar más bajo de la Tierra (428m por debajo del nivel del mar) y un candidato preseleccionado para las 7 maravillas naturales del mundo, es una fascinante y evocadora combinación de esplendor natural, fascinante historia antigua y lujos modernos.</p>
					<p>Desde los poderes curativos de las aguas azules cobalto del mar Muerto, a través de la impresionante belleza del paisaje circundante, a un sinfín de lugares fascinantes que esta zona ofrece, el mar Muerto es un lugar de tranquilidad, salud e inspiración tanto para el cuerpo como para el alma.</p>
					<p>Flotar en las aguas, tomar un baño de barro o ir a explorar. Con 330 días soleados al año, la zona del mar Muerto está llena de atracciones magníficas, incluyendo balnearios, senderos magníficos, restaurantes gourmet y de comida rápida y atracciones cargadas de adrenalina. A lo largo del tramo principal de 75 kilómetros, salpicado de hermosas playas, encontrará hoteles de renombre mundial e instalaciones de spa que le garantizarán una experiencia verdaderamente gratificante.</p>
                    <div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/posts/natural-spa/2.jpg"} class="img-responsive" />
					</div>
					<h3>Las playas mágicas del mar Muerto</h3>
					<p>Las playas del mar Muerto son únicas en el mundo. Muchos kilómetros de lugares bellamente desarrollados y bien mantenidos, donde puede tomar el sol en sus vacaciones de ensueño. Elija un lugar y disfrute del impresionante paisaje con las increíbles montañas que rodean el mar. Las cálidas aguas del mar Muerto son siempre tranquilas y ofrecen máxima relajación desde el momento en que entra.</span></p>
					<p>En las costas del sur, en el punto más bajo de la tierra, encontrará una gran variedad de hoteles donde puede disfrutar de un amanecer inolvidable sobre el lago. Para completar la experiencia, tome un poco del sedoso barro oscuro y&nbsp; permita que su piel absorba los minerales beneficiosos. El lodo del mar Muerto ha sido demostrado científicamente como beneficioso para la piel y el cuerpo. Se sentirá renovado con una piel que se ve y se siente más joven. Dese el mimo que se merece y ensúciese con el barro del mar Muerto - ¡Es saludable!</span></p>

					<h3>Descubra la zona desértica alrededor del mar Muerto</h3>
					<p>Además de &nbsp;relajarse en los balnearios y flotar en el mar Muerto hay mucho más que hacer. Si viaja al sur desde Jerusalén, complemente su experiencia desértica parando en el kibutz Ein Gedi, un oasis natural en las laderas del desierto de Judea, y camine a través de una reserva natural donde podrá ver vida silvestre como el ibex (una especie de cabra de montaña) y disfrutar de los saltos de agua y piscinas en cascada en la formación rocosa. Ein Gedi también ofrece alojamiento en hoteles y spas con piscinas calientes de azufre y con diferentes tipos de masajes terapéuticos. Continúe hacia el sur, hasta Masada, un punto de referencia nacional con una fuerte conexión histórica, situado en la cima de una gran montaña que puede subir caminando o cómodamente en teleférico.</span></p>		

					

					
                               


           `,
      };
    },
  },
  {
    id: "Natural_Phenomena",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "NATURAL PHENOMENA",
    smltitle: "",
    isVid: true,
    vidId: "Y2hAOLNcPKU",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
                        <p>
							The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
						</p>
						<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/natural-phenomena/1.jpg"} class="img-responsive" />
					    </div>
						<p>
							This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
						</p>
						<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/natural-phenomena/2.jpg"} class="img-responsive" />
					    </div>
						<p>
							The Dead Sea is lined with spas, bathing beaches and spa hotels.
						</p>          


           `,
      };
    },
  },
  {
    id: "Masada",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "MASADA",
    smltitle: "",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
                    <p>        	
				Next to the Dead Sea is a site that, unlike the rest of the landscape, appears to be part of the Rift Valley cliff but is in fact an oval-shaped flat-topped mesa – a mountain completely surrounded by a virtually sheer drop. In the days before helicopters and drones, this was about as secure a site as could be found for King Herod to build himself a palace fortress to which he could retire in the case of emergency. (And, as it was adjacent to the Dead Sea it was convenient for a monarch who historians tell us had a “chronic skin ailment” - possibly psoriasis.) The splendor of Masada was epic. It was also a marvel of engineering that used artificial water courses to channel the desert’s rare rainfall into giant cisterns where, despite the 120°-Fahrenheit heat, they could make and store ice.
			</p>			
			<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/masada/1.jpg"} class="img-responsive" />
							    </div>
			<p>
				After Herod’s death the site was all-but abandoned…until the year 73. After the Romans destroyed Jerusalem in 70 and expelled Jews from their holy city, a group of Jewish refugees made their way to the summit of Masada and converted the once grand palace into their home. Having no interest in the palace’s grandeur and considering themselves zealots, the refugees built a synagogue, created a mikveh, planted crops and tended goats. The Romans, however, could not tolerate their defiance and went on to besiege the mountain for three years, condemning thousands of legionnaires to camp in the extreme heat in a quest to starve the mountaintop inhabitants into surrender. (The outlines of the Roman encampments are clearly visible to this day.) Thousands of Jewish slaves were forced to build a giant ramp to the summit and after the months it took to complete the  construction, the mountaintop zealots -- realizing that the next day would bring Roman soldiers into their hideout -- determined to commit mass suicide rather than have their their wives, children and themselves murdered or enslaved. When the Romans finally battered their way onto the mountaintop they met no resistance and discovered 960 corpses. Two women who had hidden themselves from the mass suicide shared details of the events with the “conquerors” and Jewish Roman historian, Josephus, told the story of Masada in his book “The Jewish Wars.” The pledge by the zealots’ leader, Elazar Ben Yair on the last night of freedom has entered immortality: “Since we long ago resolved never to be servants to the Romans, nor to any other than to God Himself, Who alone is the true and just Lord of mankind, the time is now come that obliges us to make that resolution true in practice...We were the very first that revolted, and we are the last to fight against them; and I cannot but esteem it as a favor that God has granted us, that it is still in our power to die bravely, and in a state of freedom.” The Byzantines built a church atop Masada in the 4th-century, but it and the mountain went on to be abandoned for centuries.
			</p>
			<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/masada/2.jpg"} class="img-responsive" />
							    </div>
			<p>
				In 1964. Israel’s Professor Yigal Yadin lead a two-year international excavation to discover Masada’s secrets. Their hundreds of discoveries support Josephus’ history, with the archeologists even finding the clay tokens on which the zealots had carved names and used as lots to decide who would “euthanize” their families and themselves first…and last.
			</p>
			<p>
				The story of what occurred two millennia ago atop Masada has become a symbol of Israelis’ commitment never to allow “Masada to fall again” and, fifty years after the excavation, Masada is, after Jerusalem, the most visited site in Israel. Access to the summit on foot is possible up the traditional snake path used by Herod, and up the Roman ramp.  But the majority of the millions of tourists who visit Masada are whisked from the Masada Museum and Visitors Center to the summit in giant cable cars that operate daily with the exception of Yom Kippur. Every June, the base of Masada becomes the site of giant Opera Festival and spectacle that uses the floodlit mountain as a backdrop.
			</p>          


           `,
      };
    },
  },

  {
    id: "Tel_Aviv",
    bgImage: "/posts/bank/telaviv-p/1.jpg",
    mobBgImage: "/posts/bank/telaviv-p/M.jpg",
    title: "TEL AVIV",
    smltitle: "",
    isVid: true,
    vidId: "I9a4BFWO_6w",
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
			                    <p>Hailed as ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’, Tel Aviv is without a doubt THE place to visit in the Mediterranean.</p>
								<p>Named by The New York Times "The Mediterranean Capital of Cool", Tel Aviv is a modern, vibrant cosmopolitan. Buzzing art scene, UNESCO recognized Bauhaus architecture, award-winning cuisine, world-class nightlife, friendly laid-back atmosphere and gorgeous beaches all earned the city its rightful place as one of the world's top travel destinations.</p>

                                <p>But even in the city that has it all, there is only one place to start - the beach.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/telaviv-p/1.jpg"} class="img-responsive" />
							    </div>
								<h3>Discover the Heart of a Sizzling City</h3>

                                <h3>What.</strong> The heart of the city National Geographic called "Miami beach of the Mediterranean" and included in its top 10 world's best Beach Cities list, is its coastline.</p>

                                <h3>Why.</strong> Sandy beaches, warm waters, plenty of watersports opportunities and great weather, need we say more? Tel Aviv coastline is comprised of 13 unique beaches that each gives different view and offers a different experience. From the busy and trendy to the chill and laid-back, together they form a rich, colorful tapestry of this exciting and diverse city.</p>

                                <h3>Where.</strong> Located at the western edge of the city, in Tel Aviv you're always one step away from the beach. No need to resist the temptation. Just cross the street, take off your shoes and start having fun.</p>

                                <h3>Choose your own Beach Adventure</h3>

                                <h3>Get Active.</strong> Beach and watersports are very popular in Tel Aviv. Surfing, sailing, rowing, swimming, Supping, diving, volleyball – the list of possibilities goes on and on.</p>

                                <p>Choose your favorite activity and enjoy. Then, when you the click-clock sound of the Matkot on the beach, join the masses in this hugely popular Israeli paddle ball game. There are no winners or losers here, but it's still fun…and very addictive.</p>

                                <h3>Sign up</strong> for the SAIL TLV sailing tournament that takes place in the spring and includes sailing yachts, motor yachts and motor boats from all around the world. Enjoy the sports activities and the wonderful embracive community.</p>

                                <p>Want more? Join the locals and bike, walk or jog on the promenade.</p>

                                <h3>Get Social.</strong> Build castles in sand with your family, take your dog for a walk and mix with the friendly diverse crowd.</p>

                                <h3>Get Chilled.</strong>  Want to slow down and relax? No problem! Find a quiet spot in one of the less crowded beaches, watch (or join) the drum circles and sit at one of the restaurants along the coast. In the afternoon, get close to the water, grab a chair, sit back and watch one of those beautiful Tel Aviv sunsets. It doesn't get better than this.</p>
            	      


           `,
      };
    },
  },

  {
    id: "Simply_Delicious",
    bgImage: "/posts/bank/simply-delicious/1.jpg",
    mobBgImage: "/posts/bank/simply-delicious/M.jpg",
    ctg: "culinarytelaviv",
    isVid: true,
    // vidId: "3wmvk3SknxA",
    // vidId: "yFfkbHHWIc4",
    vidId: "JQD9JpMaw9g",
    title: "Tel Aviv – Simplemente delicioso",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <br/>
                    <h3>Cientos de espectaculares restaurantes, increíbles delicias de mercado y estupenda comida callejera</h3>
                    <p> 
                       Un paraiso para los amantes de la comida <br/> Echa un vistazo a la impresionante escena culinaria de Tel Aviv
                    </p>
					<p>
					Si eres un entusiasta de la comida (y seamos sinceros, la mayoría de nosotros lo somos) simplemente
            tienes que probar un poco de Tel Aviv.

					</p>
					<p>
				  	Los chefs israelíes se han hecho famosos en todo el mundo por sus platos innovadores, y la escena
            culinaria de Tel Aviv está en pleno auge.</p>
            <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/simply-delicious/1.jpg"} class="img-responsive" />
							    </div>
					<p>
				    	Con alrededor de 4500 Restaurantes, Tel Aviv es la verdadera meca de los amantes de la comida. Muchos de los restaurantes son propiedad de brillantes chefs aclamados a nivel mundial, que se formaron y trabajaron en algunos de los mejores establecimientos del mundo antes de regresar a Israel para poner su marca única en la escena culinaria local.
					</p>
					<p>
					   La cocina de Tel Aviv tiene para todos los gustos. Nombrado como un "destino vegano superior" por el sitio web foodie de los EE. UU., The Daily Meal, Tel Aviv tiene alrededor de 400 restaurantes veganos. Querrá probar los excelentes platos tradicionales de comida callejera como Falafel y Hummus y también la variedad de delicias en los mercados locales. Para una experiencia culinaria fantástica, no se pierda los restaurantes de moda en el puerto de Tel Aviv, en la avenida    Rothschild, en Neve Tzedek o en el complejo Tachana, recientemente renovado.
					</p>
					<p>
					    Algunas de las cocinas más vanguardistas de la ciudad se pueden encontrar en Sarona Market, originalmente una Colonia Templaria alemana. Este mercado de 8.700 m2 ha sido meticulosamente restaurado y ahora alberga 91 tiendas de todas las categorías, puestos y restaurantes, donde puede experimentar platos nuevos que no solo son deliciosos, sino también excepcionalmente originales.
					</p>
					
					

         `,
      };
    },
  },

  {
    id: "TLV_Culinary_Offer",
    bgImage: "/posts/bank/culinary-offer/1.jpg",
    mobBgImage: "/posts/bank/culinary-offer/M.jpg",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "yFfkbHHWIc4",
    title: "LA OFERTA CULINARIA DE TEL AVIV",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <br/>
                    <h3>La oferta culinaria de tel aviv: un regalo para los sentidos. Saboree la ciudad de Tel Aviv</h3>
                   
            
							    <p><strong>Tel Aviv</strong>, la ciudad que nunca duerme en la costa del mar Mediterráneo, es uno de los principales destinos de viaje del mundo. Vibrante, llena de acción y divertida, la segunda ciudad más grande de Israel lo tiene todo, incluida una escena culinaria creativa, moderna y galardonada que se ajusta a todas las preferencias y presupuestos. Desde sofisticados y modernos restaurantes gourmet hasta simples restaurantes tradicionales locales. Incluso fue votada como uno de los principales destinos para los viajeros veganos. Sí, amantes de la buena comida, Tel Aviv es el lugar ideal para usted.</p>
								<p><strong>Al aire libre</strong>. Los habitantes de Tel Aviv adoran estar fuera. Siempre hay algo nuevo y emocionante sucediendo en la ciudad y eso incluye comida. ¿Quiere explorar la escena culinaria de Tel Aviv? Comience simplemente saliendo. Vaya a una de las bulliciosas calles principales de Tel Aviv como <strong>Dizengoff</strong> e <strong>Ibn Gabirol</strong> y déjese maravillar. Los mejores cafés, restaurantes, bares, delicatesen y comida callejera están justo debajo de sus pies.</p>
								<p><strong>Saboreando los mercados</strong>. Visite el <strong>mercado Carmel</strong>, el mercado más grande y más céntrico y popular de la ciudad. Vaya al paraíso de comida gourmet y de especias, <strong>el mercado Levinsky,</strong> al sur de la ciudad. Consejo: tómese su tiempo. Algunas de las joyas culinarias de la ciudad están escondidas en el interior de estas calles.</p>
								<div class="img-wrapper">
																   <img src=${getImgUrl() +
                                     "/posts/culinary-offer/1.jpg"} class="img-responsive" />
															    </div>
								<p><strong>Local e internacional</strong>. Con inmigrantes de más de 120 países, no es de extrañar que Tel Aviv sea un gran crisol (literalmente). Si la comida étnica para usted significa comida japonesa, tailandesa o india, aquí hay un término mucho más amplio. Turca, marroquí, persa, yemenita, etíope, georgiana y la lista continúa.</p>
								<p>Aún así, Tel Aviv también se enorgullece de la cocina local que se inspira en esta abundancia de cocinas internacionales y da un giro a los platos tradicionales. El resultado es delicioso y verdaderamente original. Visite el <strong>mercado de agricultores del puerto de Tel Aviv</strong> y el <strong>Mercado Sarona</strong> para probar algunos de los mejores alimentos que Tel Aviv tiene para ofrecer.</p>
								<p><strong>Sofisticado, refinado e innovador</strong>. No es un secreto que muchos de los mejores restaurantes de fama mundial de Israel se pueden encontrar en Tel Aviv. Los cocineros creativos y aventureros que experimentan con comida clásica de Oriente Medio, el este de Asia y Europa convirtieron a Tel Aviv no solo en un centro de cocina gourmet en Israel, sino también en un centro internacional. Inteligente y estéticamente impresionante, hacen uso de los ingredientes locales más frescos: esta experiencia culinaria es algo que no olvidará.</p>
								<p><strong>Vegetariano y vegano</strong>. A diferencia de muchos lugares del mundo, pasar una semana (o más) libre de carne y lácteos es muy simple. Encontrará fácilmente comida rápida, étnica y gourmet. Encontrará panaderías, delicatesen, restaurantes con menú vegetariano completo, así como restaurantes "amigables" que ofrecen muchas opciones vegetarianas y veganas. Es fresco, sabroso e innovador.</p>
								<p>Lo que comenzó hace unos años como otra tendencia, se convirtió en una de las principales características de la escena culinaria de Tel Aviv. Dio paso a diversas influencias gastronómicas y la impresionante variedad de verduras de los mercados, así como refleja la conciencia altamente ambiental de la población de Tel Aviv.</p>
													
					
					

         `,
      };
    },
  },

  {
    id: "Nonstop_Excitement",
    bgImage: "/posts/bank/35/1.jpg",
    mobBgImage: "/posts/bank/35/M.jpg",
    title: "Emoción Sin Fin",
    // vidId_post : "88OV6xU0vPI",
    vidId: "Iyziun92P5A",
    isVid: true,
    smltitle: "",
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
				<br/>
                    <h3>Hermoso, colorido y emocionante - Increíble Tel Aviv</h3>
					<p>
						Bienvenido a la ciudad que irradia vitalidad las 24 horas del día, una ciudad feliz y vibrante que te acoge con los brazos abiertos. ¿Qué tiene Tel Aviv que hace que los visitantes se enamoren de ella y vuelvan a por más? Tel Aviv es conocida como la "ciudad sin pausa" de Israel, y realmente lo es. Los cafés están a rebosar día y noche. Su incomparable vida nocturna comienza al atardecer y se alarga hasta el amanecer.
					</p>
					<p>
					Y, lo que es más, con un clima excelente casi todo el año no importa cuando se visite, lo más probable es que pueda disfrutar de la playa, dar un paseo o montar en bicicleta por el Parque Yarkon, visitar los dos antiguos puertos de la ciudad o simplemente disfrutar del placer de recorrer las calles de la primera ciudad israelí, donde puede disfrutar de una fascinante combinación de edificios históricos junto a proyectos nuevos y modernos. Y, por si fuera poco, la vibrante ciudad también ofrece una gran variedad de eventos culturales y de entretenimiento para todas las edades.
					</p>
					<p>
					    Descubra por qué Tel Aviv fue nombrada por National Geographic una de las 10 mejores ciudades de playa del mundo. Descubra por qué fue calificada como un Destino Culinario Excepcional por la revista gourmet Sauver y reconocido como "sobresaliente" en la categoría Mejores Mercados y Tiendas. Es más, Pastel Brasserie fue votado como el restaurante más hermoso del mundo en 2014 por los premios International Space Design Awards. ¿Es usted un aficionado al café? Huffington Post coronó a esta moderna ciudad costera como una de las mejores ciudades del mundo para los amantes del café. Impresionante, ¿verdad? Pero aún no hemos terminado ...
					</p>

					<p>
					   Tel Aviv venció a otras 250 ciudades para llevarse a casa el <a href="//www.smartcityexpo.com/awards-2014" target="_blank"> Premio World Smart Cities Award 2014 </a>, gracias a su uso de la tecnología innovadora para beneficiar a sus residentes. Según Lonely Planet, <a href="//www.israel21c.org/tel-aviv-named-worlds-third-top-city/" target="_blank"> la urbe ocupa un lugar destacado en la lista de las ciudades con mejor vida nocturna del mundo </a>. Y <a href="//www.jpost.com/LifeStyle/Tel-Aviv-named-worlds-best-gay-city-for-2011" target="_blank"> Tel Aviv está orgullosa de ser nombrada la mejor ciudad gay del mundo por GayCities </a> y American Airlines.
	                  <br>
	                 	 ¿Estás planeando disfrutar en Tel Aviv? Aquí tiene algunas recomendaciones que ayudarán a hacer de sus vacaciones un éxito rotundo.
	                </p>

	                <h3>
	                	Las playas
	                </h3>

					<p>
						¡La vida es una playa! A lo largo de toda la longitud de Tel Aviv-Jaffa, a orillas del Mediterráneo, se encuentran 13 playas que se extienden más 14 kilómetros. Estas playas, perfectas para nadar, divertirse y descansar, atraen a miles de visitantes locales y extranjeros. La temporada de playa va de mayo a octubre, pero incluso en invierno podrá disfrutar de muchos días cálidos y encantadores en Tel Aviv. Los restaurantes, clubes y numerosos lugares de entretenimiento en el extenso paseo son un gran atractivo para todos los visitantes. También puede disfrutar de una amplia gama de deportes acuáticos.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/3.jpg"} class="img-responsive" />
					</div>

					<h3>
						Puertos
					</h3>
					<p>
						Tel Aviv alberga dos puertos ancestrales. Al visitarlos, quedará impactado por la forma única en que estos lugares fusionan pasado y presente, mientras usted celebra el día (y la noche) en los numerosos clubes, restaurantes o cafeterías con vistas a los deslumbrantes tonos azules del mar Mediterráneo.
					</p>
					<h3>
						Puerto de Tel Aviv
					</h3>
					<p>
						Construido en 1938, el puerto se ha convertido en un punto de entretenimiento abierto al público en general. El espacio de 14 000 m2, con su cubierta de madera característica, está salpicado de bares, discotecas, cafeterías, restaurantes y tiendas. Es una atracción obligada para cualquiera que busque una experiencia culinaria variada y deliciosa, compras y entretenimiento. Y por si eso no fuera suficiente, no encontrará puestas de sol más impresionantes en ningún otro lugar. Así que venga a disfrutar de la fresca brisa del mar. Al anochecer, el puerto se transforma en uno de los distritos de entretenimiento más demandados de la ciudad y está lleno de gente.
					</p>

					<h3>
						Puerto de Jaffa
					</h3>

					<p>
						Considerado uno de los puertos más antiguos del mundo, pescadores, marineros, mercaderes, cruzados, conquistadores e inmigrantes dieron uso al Puerto de Jaffa durante miles de años. Hoy en día, el mismo continúa siendo utilizado como un puerto pesquero, y también se está renovando como atracción urbana que ofrece actividades culturales y de ocio, compras y turismo, a la vez que se conserva su carácter histórico y fascinante único.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/2.jpg"} class="img-responsive" />
					</div>
					<h3>
						Vida nocturna
					</h3>
					<p>
						Los noctámbulos pueden disfrutar de los modernos bares y discotecas de la ciudad, y experimentar la variada vida nocturna que ofrece la ciudad sin pausa. Una noche típica en Tel Aviv comienza a las 11 de la noche y, en algunos lugares, puede extenderse hasta el amanecer. La ciudad también ofrece numerosos clubes para la comunidad gay.
						Algunos de los lugares de moda en los que  puede bailar toda la noche son:					</p>

					<h3>
						Haoman 17
					</h3>

					<p>
						Este es el mayor y más consolidado mega-club de Tel Aviv. Alberga a algunos de los mejores DJ de todo el mundo.
					</p>

					<h3>
					    Dizengoff Club
					</h3>

					<p>
					   Con tres barras bien surtidas, pista de baile, áreas de descanso, salas VIP y más, Dizengoff Club atrae una multitud a la moda. Baile música rock, comercial, disco, funk o cualquier otra cosa que pueda estar sonando.
					</p>


					<h3>
					    Kuli Alma
					</h3>

					<p>
					    Uno de los clubes alternativos más populares de la ciudad. Las paredes están cubiertas con arte callejero y videoarte. Cuenta con exposiciones de artistas locales en el espacio de la galería y tiene un agradable patio al aire libre, donde se puede tomar una copa, comer algo y relacionarse.
					</p>
					<h3>
					    The Cat and Dog

					</h3>

					<p>
					    Un club underground situado en la zona de Carlebach que cuenta con música ecléctica, bebidas que fluyen libremente y una pista de baile muy concurrida. Es sin duda uno de los lugares álgidos en la escena nocturna de Tel Aviv.
					</p>
					<h3>
					    The Block
					</h3>

					<p>
					   Ganador de numerosos premios, incluyendo Mejor Club del Año y Mejores Fiestas del Año, y calificado por la BBC Radio 1 como poseedor de "uno de los cinco mejores sistemas de sonido del mundo", merece la pena visitarlo.
					</p>


					<p>
					    Y si andas buscando la experiencia del bar homosexual...
					</p>
					<h3>
					    Apolo Sexy Bar
					</h3>

					<p>
					    Único bar gay en Tel Aviv exclusivo para hombres, el Apolo se inspira en los mejores clubes de Europa.
					</p>
					<h3>
					   Amazona
					</h3>

					<p>
					    Es el mejor bar lésbico de Tel Aviv, con una gran atmósfera.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/4.jpg"} class="img-responsive" />
					</div>


					<h3>
					   Mercados
					</h3>
					<h3>
					    Mercado del Carmel
					</h3>

					<p>
					   El mercado mejor consolidado y más famoso de la ciudad que, aparte del color de su mosaico humano sin igual, también ofrece una variedad infinita de delicias, especias, comidas y otras tentadoras y encantadoras opciones. El mercado posee una actividad frenética durante todo el año. Y además de por los clientes habituales, es visitado por turistas extranjeros que aprovechan al máximo esta experiencia de compra única de Oriente Medio.
					</p>
					<h3>
					   Mercado de Levinsky
					</h3>

					<p>
					    Un torbellino de panaderías, comercios especializados, restaurantes y tiendas que venden especias, frutos secos, fruta deshidratada y alimentos exóticos. Puede inscribirse en recorridos culinarios del mercado aderezados con historias, leyendas y secretos del mercado histórico y del nuevo. El carácter único del Levinsky lo convierte en una atracción tanto para locales como para turistas.
					<h3>
					   Mercadillo de Jaffa
					</h3>

					<p>
					    Situado en Jaffa, el famoso mercadillo ofrece artículos para el hogar, ropa de segunda mano y zapatos. Junto con las antigüedades, la decoración del hogar y los muebles vintage, el mercado también alberga cafeterías de moda, restaurantes que sirven solo el hummus y las habas más auténticos, y una bonanza de artículos del pasado.
					</p>
					<h3>
					   Mercados gastronómicos
					</h3>

					<p>
					   En los últimos años, se han abierto tres mercados gastronómicos en Tel Aviv: Shuk HaNamal en el puerto de Tel Aviv, el Mercado de Sarona en Sarona y Shuk Tzafon en Ramat Hahayal, que ofrecen a los visitantes una experiencia que tentará sus sentidos. Los mercados ofrecen productos frescos y excelentes materias primas que sirven para aquellas personas que aprecian la comida más exquisita, fresca y deliciosa.
					</p>
					<h3>
					    Mercado de Arte y Artesanía en el centro comercial peatonal Binyamin de Nahalat
					</h3>

					<p>
					    Un mercado que está abierto los martes y viernes, decorando la calle con un abanico de colores. Paseando entre los puestos, puede encontrar una gran cantidad de ideas y regalos creativos y originales que no se encuentran en las tiendas, por ejemplo joyas de colores, papel maché, pinturas al óleo, juguetes de madera, relojes de pared decorativos, figuritas de cristal en miniatura, Hamsas, muñecas o artículos para el hogar.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/5.jpg"} class="img-responsive" />
					</div>

					<h3>
					    Restaurantes
					</h3>

					<p>
					    ¡Tel Aviv es un paraíso gastronómico! Más allá del falafel y el shawarma, la ciudad está llena de bares gourmet con los mejores chefs del país al frente y encantadoras cafeterías que sirven comidas ligeras y excelente café. Junto con los establecimientos que tienen prácticamente cualquier cosa y de todo en sus menús, Tel Aviv también tiene muchos restaurantes y cafés Kosher, así como excelentes lugares vegetarianos y veganos.
                        Aquí tiene algunas opciones excelentes para una comida deliciosa.
					</p>
					<h3>
					   MIZLALA
					</h3>

					<p>
					    Este restaurante ofrece a los comensales platos inspirados por la creatividad y la pasión del chef Meir Adoni. Situado en el elegante Binyamin de Nachalat en un edificio Bauhaus bellamente restaurado, Mizlala está repleto de energía vibrante y ofrece una experiencia culinaria inolvidable.
					</p>
					<h3>
					   Topolopompo
					</h3>

					<p>
					   El restaurante dragón de fuego del chef Avi Conforti y su particular arquitectura ofrece sabores, aromas y sensaciones que provienen del trabajo con fuego y especias. Una velada en el establecimiento es, como lo describe el chef, caliente, sexy y emocional. Una visita obligada.
					</p>
					<h3>
					   Abraxas Norte (Tzfon Abraxas)
					</h3>

					<p>
					    El famoso chef local Eyal Shani, sirve platos innovadores, inteligentes, deliciosos e inspiradores. Un lugar de moda que cuenta con una cocina abierta, Abraxas le permite saborear el ambiente junto con la comida, mientras observa al equipo de cocineros y su energía contagiosa.
                        <br> Y si la cocina vegetariana o vegana es más lo suyo …
					</p>
					<h3>
					   Hashwarma Hativonit
					</h3>

					<p>
					    Ampliamente considerado como uno de los mejores restaurantes veganos en Tel Aviv de comida callejera, disfrute de hamburguesas veganas, perritos calientes veganos, sin olvidar el shawarma vegano.
					</p>
					<h3>
					   Nanuchka
					</h3>

					<p>
					    Sirve un delicioso menú vegetariano georgiano en un entorno con suelos antiguos y obras de arte de algunos de los mejores artistas de Israel. El menú es tan original y tan delicioso que incluso los carnívoros más acérrimos no echarán de menos la carne.
					</p>
					<h3>
					  Buddha Burgers
					</h3>

					<p>
					   Un popular restaurante de comida rápida vegana que cuenta con un ambiente acogedor, precios asequibles y una amplia selección de platos, incluyendo hamburguesas, perritos calientes, shawarma y burritos.
					</p>
					<h3>
					  Zakaim
					</h3>

					<p>
					   Se califican a si mismos como una boutique vegana, con una tarifa de mercado de agricultores, y donde todos los platos están hechos con ingredientes locales y de temporada.
					</p>

					<h3>
					  Tenat
					</h3>

					<p>
					   Denominado uno de los mejores restaurantes veganos en Tel Aviv por la Guía Secreta de Tel Aviv, Tenat sirve un menú etíope totalmente vegetariano y sin gluten.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/6.jpg"} class="img-responsive" />
					</div>

					<h3>
					  Cultura
					</h3>

					<p>
					  Si usted es un aficionado al arte y la cultura, eche un vistazo a algunos de los muchos museos y galerías de arte repartidos por la ciudad.
					</p>

					<h3>
					  Museo de Artes de Tel Aviv
					</h3>

					<p>
					  El principal museo de la ciudad para el arte israelí e internacional contiene colecciones permanentes junto con exposiciones rotativas, y exhibe las mejores pinturas, esculturas, diseño y arquitectura, videografía, dibujos y mucho más.
					</p>

					<h3>
					  Beit Hatfusot, el Museo del Pueblo Judío
					</h3>

					<p>
					  Beit Hatfutsot es una de las principales instituciones del mundo involucradas en la investigación del judaísmo y también se considera el primer museo en explorar la historia y los logros del pueblo judío. Una visita al museo es una experiencia judía conmovedora, y permite echar un vistazo a fascinantes exhibiciones que presentan las importantes historias y eventos de la diáspora judía a lo largo de la historia.
					</p>

					<p>
					  Tel Aviv le ofrece todo lo que una gran ciudad de vacaciones debe tener: mar y sol, amplias posibilidades de descanso y relajación junto a una vibrante escena cultural y excelente gastronomía, compras y una vitalidad insuperable. Con vuelos directos desde Madrid y Barcelona descubra exactamente qué hace que las personas se entusiasmen con Tel Aviv.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/7.jpg"} class="img-responsive" />
					</div>

					<h3>
					  Eventos anuales
					</h3>

					<p>
					  ¡Tel Aviv no se detiene aquí! Ofrece eventos deportivos, culturales y de entretenimiento anuales. Le recomendamos que consulte las fechas por Internet. Aquí tiene algunos eventos que recomendamos encarecidamente:
					</p>

					<h3>
					  La Noche en Blanco de Tel Aviv
					</h3>

					<p>
					    Una noche especial que se celebra una vez al año. En esta noche, hay conciertos, fiestas, actuaciones en la calle, obras de teatro y más, todo hasta altas horas de la noche. Los lugares del arte y la cultura de la ciudad permanecen abiertos, junto con los comercios y varios clubes. La mayoría de los eventos de la Noche en Blanco están abiertos al público, ya sea de forma gratuita o por un precio de entrada mínimo.
					</p>

					<h3>
					  Festival Open House:
					</h3>

					<p>
					    El festival incluye una selección de extraordinarias visitas y tours a las casas y edificios más fascinantes de la ciudad, la mayoría de los cuales nunca han sido abiertos al público.
					</p>

					<h3>
					  Night Run Tel Aviv
					</h3>

					<p>
					  Esta carrera de 10K atrae a miles de corredores y decenas de miles de espectadores entusiastas que vienen a ver esta increíble y alegre celebración. El final de la carrera está marcado por una gran fiesta de ritmo y música en Ganei Yehoshua.
					</p>

					<h3>
					  Desfile del Orgullo Gay en Tel Aviv
					</h3>

					<p>
					  Un evento anual que se celebra cada mes de junio en Tel Aviv, una ciudad que se ha convertido en uno de los destinos gay más populares del mundo. El desfile comienza con un emocionante evento en Meir Park, con discursos, desmesuradas actuaciones drags y mucho más. Al terminar, el desfile comienza a abrirse paso a través de las principales calles, acompañado de música excepcional, bandas desfilando, muchos participantes y decenas de miles de espectadores. El desfile culmina con una gran fiesta en la playa Charles Chlor. Pero eso no es todo ... Los eventos del orgullo continúan a través de docenas de fiestas por toda la ciudad.
					</p>

					<h3>
					  Festival de Innovación DLD:
					</h3>

					<p>
					  DLD Tel Aviv Digital Conference es la mayor reunión global de innovadores y emprendedores de Israel, con cientos de empresas de nueva creación, capitales riesgo, inversores ángel y multinacionales líderes. Haciendo gala del mejor talento tecnológico, las mayores inversiones de capital de riesgo per capita y de centros multinacionales para líderes de la industria como Intel, Google, Microsoft, Kimberly Clark, Amazon, GM, Amdocs, Facebook y otros, ¡Tel Aviv es la mejor ubicación para conocer de cerca y en persona el hub de alta tecnología! El festival comprende numerosos eventos, conferencias, reuniones, confluencias y encuentros, todos enfocados en diferentes aspectos de la innovación digital, tecnológica, social y urbana. 
					</p>

         `,
      };
    },
  },

  {
    id: "Vegan_Friendly_TelAviv",
    bgImage: "posts/bank/8/1.jpg",
    mobBgImage: "posts/bank/8/M.jpg",
    title: "TEL AVIV EL MEJOR DESTINO VEGANO DEL MUNDO",
    ctg: "culinarytelaviv",
    isVid: true,
    // vidId: "prLvetkAWwg",
    // vidId: "Gl-YB8qK5WI",
    vidId: "9l04RfZ95J0",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                   <h3>Explorar Tel Aviv nunca ha sido tan divertido o tan sabroso para veganos </h3>
					<p>Viajar a ciudades extranjeras puede ser difícil para los veganos que siguen una dieta libre de platos de origen animal. No es así en Tel Aviv, el hogar de una escuela culinaria totalmente vegana con decenas de restaurantes veganos. Tel Aviv ha adoptado el veganismo a medida que crece en popularidad, de tal modo que la revista culinaria <em>The Daily Meal</em> ha declarado a la ciudad como "el mejor destino vegano del mundo", por delante de otras ocho ciudades.</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/6/2.jpg"} class="img-responsive" />
					</div><h3>Lo que los veganos quieren</h3>
					<p>Pasee por la ciudad de Tel Aviv y se encontrará con innumerables bistrós, restaurantes y puestos de comida rápida veganos. Tome una bocanada de los aromas dulces y sabrosos que flotan por el aire de la ciudad y sabrá cuan cerca está su próximo delicioso platillo. Siguiendo con los gustos y las demandas de los habitantes de Tel Aviv y los turistas, la mayoría de los restaurantes de la ciudad, o al menos aquellos que se respetan a sí mismos, tienen opciones veganas en sus menús. Otros ofrecen un menú enteramente vegano, ofreciendo una versión de las delicias locales como el falafel sin huevo, shawarma de seitan y pizza libre de queso.</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/6/3.jpg"} class="img-responsive" />
					</div>
					<h3>Pruebe los sabores mediterráneos frescos</h3>
					<p>Respire el fresco aire mediterráneo que le abrirá el apetito para comer algunos dulces locales frescos. Para los veganos que recorren Tel Aviv, los quejidos de su estómago son solamente una flecha que le señala la dirección de algún producto local fresco transformado en riquísimos platos que reflejan diversas culturas y tendencias culinarias.</p>
					<p>Israel dispone de muchas opciones de comida vegana, pero cuando se trata de restaurantes veganos, Tel Aviv es una verdadera gema culinaria. Ya se trate de comida rápida, un menú gourmet o postres, Tel Aviv tiene una opción vegana especialmente para usted, por lo que la ciudad israelí a orillas del mar es un destino de visita obligada en su próximo viaje a Israel.</p>
										
                    
                   
					
                   


			`,
      };
    },
  },

  {
    id: 13,
    bgImage: "/posts/bank/28/1.jpg",
    mobBgImage: "/posts/bank/28/M.jpg",
    title: "Jerusalem Cuisine",
    ctg: "culinary",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>Exhilarating and diverse and oh so yummy</h3>

					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/2CSCe2WC7Ns/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<p>
						Jerusalem is filled with scores of lively and trendy restaurants and entertainment spots. The city is packed with areas offering excellent options for every form of day and night time entertainment, where you can enjoy a delightful evening over a great meal, a cold beer or dance to great music.
					</p>

					<p>
						In Jerusalem, they say that you come for the hummus, but stay for the incredibly diverse cuisine. From traditional Middle Eastern and North African to South American, Asian fusion, and continental European cuisine; from street food to fine dining, Jerusalem’s got it all. Jerusalem’s wide array of culinary options can be found literally everywhere local delicacies in street stalls, authentic restaurants in the markets, and if you are looking for the gourmet experience, you can reserve a spot at one of the city’s many exclusive chef restaurants.
					</p>

         `,
      };
    },
  },

  {
    id: "Coffee_In_TelAviv",
    bgImage: "posts/bank/42/1.jpg",
    mobBgImage: "posts/bank/42/M.jpg",
    title: "PAUSA PARA UN CAFÉ EN TEL AVIV",
    ctg: "culinarytelaviv",
    isVid: true,
    // vidId: "rVr0gqFC364",
    vidId: "s6kkkk8_Q2g",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			             <p>Tel Aviv es famosa por ser una bulliciosa ciudad turística llena de paisajes, sonidos y actividades vibrantes, pero el corazón de la ciudad late en sus cafés. <strong>La cultura del café</strong> es fundamental para Tel Aviv, así que reduzca la velocidad y absorba el espíritu de Tel Aviv con un café.</p>
						
					    <h3>La cultura del café</h3>
						<p>Si desea experimentar la Tel Aviv "real", no hay mejor manera que unirse a la tradición de ir a una cafetería. Podría tomar algo en uno de los muchos cafés de moda de los turistas, pero ¿por qué no salir de lo común para sentir el ritmo de la vida cotidiana en una pequeña cafetería local? Observe el flujo de la mañana a su alrededor, o únase a los residentes de Tel Aviv que llenan los cafés de la calle por las noches para disfrutar de la brisa fresca, charlar y, por supuesto, tomar un café. Querrá quedarse en su mesa, así que aproveche la variedad de deliciosas comidas que se sirven en cada cafetería. Algunos lo deleitarán con ricos pasteles europeos, mientras que otros servirán comidas completas que se basan en una variedad de sabores y culturas.</p>
						<div class="img-wrapper">
						    <img src=${getImgUrl() +
                  "posts/coffe-in-tlv/1.jpg"} class="img-responsive" />
					    </div>
						<p>Tel Aviv está llena de excelentes lugares para tomar café, cada uno con un ambiente diferente. Disfrute de un café helado junto a la playa mientras toma el sol, mézclese con los lugareños en una elegante cafetería entre los famosos edificios Bauhaus, en la moderna Neve Tzedek o relájese con un café con leche en el revivido puerto de Tel Aviv. Observe a los enérgicos corredores bronceados, ciclistas y patinadores pasar de largo mientras toma un descanso para saborear la vida y un buen café.<a name="_de4lxhpnquhm" id="_de4lxhpnquhm"></a></p>
						<h3>La hora del café</h3>
						<p>En Tel Aviv, no solo beberá diferentes tipos de café, absorberá diferentes mundos y tradiciones. Por la mañana, la franquicia de Joe podría ser un ‘cafe hafuch’ moderno y de moda: la versión israelí de capuchino hecha con un chorro de café con leche al vapor que beben los jóvenes y entusiastas habitantes de Tel Aviv. Para tomar un café a media mañana, deje que una olla de café turco tradicional, caliente, oscuro y fuerte lo lleve a un mundo diferente a solo unos minutos de la antigua Jaffa. El aroma y la atmósfera le transportarán a través de los años a los olores y sabores del viejo Medio Oriente. Finalmente, únase a la costumbre mediterránea de tomar un café por la tarde en una mesa al aire libre en el bulevar Rothschild con los "sabras".</p>
												
              
			`,
      };
    },
  },

  {
    id: "Non_Stop_Markets",
    bgImage: "posts/bank/non-stop-markets/1.jpg",
    mobBgImage: "posts/bank/non-stop-markets/M.jpg",
    title: "Non Stop Markets",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
			                 <p>A tour of the markets in Tel Aviv, with their unparalleled human tapestry and never-ending variety of delicacies is probably one of the best ways to get to know the true local spirit of Tel Aviv.<br>
                             Here are some of the markets that are definitely a must, when visiting the sunny city:</p>

                             <h3>Carmel Market:</h3>
                             <p>The city’s most famous market, renowned for its colorful spirit and food stalls, featuring fresh local delicacies and excellent restaurants serving fresh food straight from the market. You can also find hidden food placed behind the stalls and around the area. They are really worth finding. <br>
                             <h3>The Flea Market:</h3>
                             <p>Located in Jaffa, packed with fantastic authentic antiques from Tel Aviv and Jerusalem, a joy to bargain hunters. This market is also home to many fashionable and excellent cafés and restaurants of all varieties of cuisines: from Greek, to Italian, to Arabic.<br>
                             <div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/non-stop-markets/1.jpg"} class="img-responsive" />
					         </div>
                             <h3>Nahalat Binyamin Arts & Crafts Market: </h3>
                             <p>Open on Tuesdays and Fridays, this is a ‘fair-like’ artists’ market, rich with creative and original ideas for gifts. It is just the place to pick up that perfect souvenir you won’t find in any store.<br> 
                             <h3>Sarona Market</h3>
                             <p>Offering a unique and fabulous culinary adventure, Sarona Market is located in the Trendy Sarona Complex, and is home to a modern and vibrant “food court” which offers a huge assortment of culinary options. Sarona is also extremely family friendly, filled with outdoor activities and fantastic playgrounds. <br>
                             <h3>Tel Aviv Port Market</h3>
                             <p>With more of a Farmers Market feel, this seaside Market is packed with tasty treats and specialty produce which you can enjoy, on the spot of take home as culinary souvenirs.<br>

              
			`,
      };
    },
  },

  {
    id: "Joys_Of_Jaffa",
    bgImage: "posts/bank/joys-of-jaffa/1.jpg",
    mobBgImage: "posts/bank/joys-of-jaffa/M.jpg",
    title: "JAFFA MÁGICA",
    ctg: "telaviv",
    isVid: true,
    // vidId:"uC5KX4MVpC0",
    vidId: "tgF0zMUYY2g",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			            <br/>
			            <h3>Experimente todas las riquezas que ofrece la hermosa y antigua Jaffa</h3>
			            <h3>Historia colorida e irresistible encanto oriental</h3>
						<p>Los olores del mar aromatizados con café negro y especias de los mercados, la cultura oriental combinada con la europea, lo antiguo mezclado con lo nuevo - esto es Jaffa. Una de las ciudades portuarias más antiguas del mundo, cuya historia se relaciona con el diluvio, Jaffa hoy es una ciudad vibrante que nunca deja de sorprender e innovar. Pintorescas callejuelas, galerías de arte, boutiques únicas, edificios antiguos, monumentos maravillosos y abundancia de auténticos restaurantes de Oriente Medio. Un viaje a la antigua Jaffa es una experiencia estimulante multisensorial obligatoria para cualquier persona que visite Israel. Prepárese para enamorarse.</p>
						<h3>Descubra la magia de una vibrante ciudad portuaria</h3>
						<p>Situado en una colina con vistas al mar Mediterráneo, en la parte sur de Tel Aviv, Jaffa ha sido el centro de eventos históricos durante miles de años. Todavía un puerto activo hoy, el <strong>Puerto de Jaffa</strong> es un gran lugar para explorar. Maravíllese con las galerías de arte, boutiques y mercados de alimentos gourmet. Pasee por los antiguos muelles, escuche música en vivo, beba, coma y empápese del ambiente especial.</p>
						<p>Para obtener una mejor vista de la ciudad, suba a la colina del <strong>Parque la Cima</strong> (<strong><em>Ha'Pisga</em></strong>) y contemple la hermosa ciudad y su bahía. En su camino hacia abajo, pida un deseo en el <strong>Puente de los Deseos</strong>. Quién sabe, puede hacerse realidad.</p>
						<h3>Embárquese en una aventura urbana romántica</h3>
						<p>Las calles de Jaffa están llenas de sorpresas. Pasee por las estrechas calles de piedra de la Ciudad Vieja de Jaffa, descubra los patios escondidos y observe los pequeños detalles: azulejos de cerámica pintados, pequeñas esculturas y terrazas. Observe a la gente, entre en las galerías de arte, estudios de artistas y boutiques únicas.</p>
						<p>Siga explorando. Desde la plaza de la <strong>Torre del Reloj</strong>, en el corazón de la ciudad, continúe hasta el conocido <strong>Mercado de las Pulgas de Jaffa</strong> y haga su camino hacia tesoros ocultos. Es hora de probar esas habilidades de negociación. Disfrute de los pequeños cafés pintorescos, restaurantes auténticos de Oriente Medio, y algunos de los mejores hummus que probará. &nbsp;Garantizado.</p>
			            
              
			`,
      };
    },
  },

  {
    id: 22,
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    title: "Shakshuka Time",
    smltitle: "",
    isVid: true,
    vidId: "n4kCnPXEX7g",
    html: function() {
      return {
        __html: `

				<h3>Learn how to make the world famous Shakshuka Dish!</h3>

		<!--<div class="responisve-iframe">
			<iframe src="https://www.youtube.com/embed/n4kCnPXEX7g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
		</div>-->

      		<p>
      		When you ask people who visit Tel Aviv and Jerusalem what was their favorite dish they tried on their trip, the answer, more often than not, will be Shakshuka. This Mediterranean delicacy, a definite local favorite is essentially a dish of eggs poached in a sauce of tomatoes, chili peppers, and onions rich in flavor and often served with bread and tahini. Of course, there are many variations on this dish according to local styles and tastes and it is usually served for breakfast or brunch though you’’ll find it makes for a fantastic dinner as well.
      		</p>
      		<p>
      		The best way to eat Shakshuka is definitely by under the fantastic year round sun of Tel Aviv or Jerusalem, as you enjoy an amazing city break full of flavors and unforgettable experiences.
      		</p>
      		<p>
      		However, should wish to DIY and recreate the taste of the sensational Shakshuka in your own kitchen, here’s how it’s done:
      		</p>
      		<h3>
            Ingredients
          </h3>
          <ul>
             <li>2 tablespoons olive oil</li>
             <li>1 onion, chopped</li>
             <li>1 red bell pepper, seeded and diced</li>
             <li>4 cloves garlic, minced</li>
             <li>2 cans of diced tomatoes</li>
             <li>6 eggs</li>
             <li>2 tablespoon fresh cilantro, chopped</li>
             <li>¾ teaspoon salt</li>
             <li>1 teaspoon paprika</li>
             <li>¼ teaspoon black pepper</li>
             <li>1 jalapeno (optional)</li>
          </ul>
          <h3>
             Instructions
          </h3>
          <ol>
              <li>Preheat oven to 375 degrees while you wait.</li>
              <li>Heat the olive oil in a heavy oven-safe pan over medium heat. Add in onion, bell pepper, and jalapeno and fry until onions are translucent.</li>
              <li>Add in garlic and paprika. Add tomatoes, salt, and black pepper. </li>
              <li>Bring to a simmer and reduce heat. cook for 10- 15 minutes. </li>
              <li>Create 6 small spaces in the sauce and carefully crack each egg into the space.</li>
              <li>Place pan into the preheated oven and cook until eggs whites are set – roughly 10 minutes.</li>
              <li>Add cilantro as garnish before serving.  </li>
              <li>Serve with bread and tahini and enjoy! </li>
          </ol>

         `,
      };
    },
  },

  {
    id: "Gourmet_TelAviv",
    bgImage: "posts/bank/33/1.jpg",
    mobBgImage: "posts/bank/33/M.jpg",
    title: "TEL AVIV GOURMET SCENE",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "jfyHxk8ZRrI",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Wake up your taste buds in Tel Aviv</h3>
			<p>
			   Tel Aviv's huge variety of amazing restaurants - The perfect place to treat yourself.
			</p>
              
			`,
      };
    },
  },

  {
    id: 34,
    bgImage: "/posts/34/1.jpg",
    mobBgImage: "/posts/34/M/1.jpg",
    title: "the DEAD SEA",
    ctg: "deadsea",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            
				<p>
               		A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction.

                </p>

                <p>
               		Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
					
                </p>

                <p>

					Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.

                </p>
				
            	 `,
      };
    },
  },

  {
    id: 22,
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    title: "Shakshuka Time",
    ctg: "culinary",
    isVid: true,
    vidId: "n4kCnPXEX7g",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>Learn how to make the world famous Shakshuka Dish!</h3>
				<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/n4kCnPXEX7g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->

      		<p>
      		When you ask people who visit Tel Aviv and Jerusalem what was their favorite dish they tried on their trip, the answer, more often than not, will be Shakshuka. This Mediterranean delicacy, a definite local favorite is essentially a dish of eggs poached in a sauce of tomatoes, chili peppers, and onions rich in flavor and often served with bread and tahini. Of course, there are many variations on this dish according to local styles and tastes and it is usually served for breakfast or brunch though you’’ll find it makes for a fantastic dinner as well.
      		</p>
      		<p>
      		The best way to eat Shakshuka is definitely by under the fantastic year round sun of Tel Aviv or Jerusalem, as you enjoy an amazing city break full of flavors and unforgettable experiences.
      		</p>
      		<p>
      		However, should wish to DIY and recreate the taste of the sensational Shakshuka in your own kitchen, here’s how it’s done:
      		</p>
      		<h3>
            Ingredients
          </h3>
          <ul>
             <li>2 tablespoons olive oil</li>
             <li>1 onion, chopped</li>
             <li>1 red bell pepper, seeded and diced</li>
             <li>4 cloves garlic, minced</li>
             <li>2 cans of diced tomatoes</li>
             <li>6 eggs</li>
             <li>2 tablespoon fresh cilantro, chopped</li>
             <li>¾ teaspoon salt</li>
             <li>1 teaspoon paprika</li>
             <li>¼ teaspoon black pepper</li>
             <li>1 jalapeno (optional)</li>
          </ul>
          <h3>
             Instructions
          </h3>
          <ol>
              <li>Preheat oven to 375 degrees while you wait.</li>
              <li>Heat the olive oil in a heavy oven-safe pan over medium heat. Add in onion, bell pepper, and jalapeno and fry until onions are translucent.</li>
              <li>Add in garlic and paprika. Add tomatoes, salt, and black pepper. </li>
              <li>Bring to a simmer and reduce heat. cook for 10- 15 minutes. </li>
              <li>Create 6 small spaces in the sauce and carefully crack each egg into the space.</li>
              <li>Place pan into the preheated oven and cook until eggs whites are set – roughly 10 minutes.</li>
              <li>Add cilantro as garnish before serving.  </li>
              <li>Serve with bread and tahini and enjoy! </li>
          </ol>

         `,
      };
    },
  },

  {
    id: "The_Gates_Of_Jerusalem",
    ctg: "jerusalem",
    isVid: true,
    // vidId:"MXtcTm_JXus",
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/gates-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/gates-of-jerusalem/M.jpg",
    title: "THE GATES OF JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `
				  
				                <p>Jerusalem’s Old City walls, built in the early 16th century by the Turkish Sultan Suleiman the Magnificent, have eight gates. All but one (the Gate of Mercy) still serve Jerusalemites and visitors streaming to its markets, and sacred and historic sites.</p>

                                <p>Following  is a thumbnail description of the gates, counter-clockwise from south to west:</p>

                                <h3>The Zion Gate:</h3>

                                <p>Bearing Jerusalem’s earliest biblical name in Hebrew and English, this gate’s  Arabic name is the Gate of the Prophet David, as the Tomb of King David, on adjacent Mount Zion, is only a few steps away. Zion Gate leads directly to the Armenian and Jewish quarters.</p>

                                <h3>The Dung Gate:</strong> This gate’s unusual name derives from the refuse dumped here in antiquity, where the prevailing winds would carry odors away. Nehemiah 2:13 mentions a Dung Gate that was probably near this one. This gate leads directly to the Western Wall and the Southern Wall Archaeological Park.</p>

                                <h3>Gate of Mercy:</strong> This gate, in the eastern Temple-Mount wall, may be the best-known of them all. Also called the Golden Gate or the Eastern Gate, it has been blocked for centuries, and is said to be awaiting a miraculous opening when the Messiah comes and the dead are resurrected.</p>
                                <div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/gates-of-jerusalem/1.jpg"} class="img-responsive" />
					            </div>

							    <h3>Lion’s Gate:</h3>

                                <p>This portal is named after a pair of ferocious-looking animal carvings that flank it. They are actually tigers, the heraldic symbol of the 13th-century Sultan Beybars. It is also called St. Stephen’s Gate, after the first Christian martyr, who tradition says was stoned nearby. Lion’s Gate, which leads to the Pools of Bethesda, the Via Dolorosa, and the markets, became famous during the Six Day War.</p>

                                <h3>Herod’s Gate:</h3>

                                <p>  Despite its name, the notorious Judean king had nothing to do with this gate. In Arabic and Hebrew this north-facing gate, which leads to the Old City markets, is called the Flowers Gate. Some say the name derives from a rosette carved over it. However, in Arabic a similar word means “awakened,” and may refer to a nearby cemetery and the hope of resurrection.</p>

                                <h3> Damascus Gate:</h3>

                                <p> This most imposing of Jerusalem’s gateways also faces north and is named for the grand city from which Jerusalem’s rulers once came. It is always a busy thoroughfare, thanks to the bustling markets within. Below the 16th-century gate, archaeologists have uncovered part of the entryway built by Emperor Hadrian in the second century CE.</p>

                                <h3> The New Gate:</h3>

                                <p>This is the only Old City entryway not part of the original design of the 16th-century walls. It was breached in the waning days of the Ottoman Empire to allow Christian pilgrims quicker access to their holy places within the ramparts.</p>

                                <p>The Jaffa Gate: This was the destination of Jewish and Christian pilgrims disembarking at the Jaffa port, hence its name. It led (and still leads) directly to the Jewish and Christian quarters, as well as to the most popular parts of the market, and to the Tower of David Museum, once Jerusalem’s citadel and now a showcase of its history.</p>
							    

         `,
      };
    },
  },

  {
    id: "Shopping_Delights",
    ctg: "jerusalem",
    isVid: true,
    // vidId:"MXtcTm_JXus",
    // vidId:"JxSjC2kZfvI",
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/shopping-delights/1.jpg",
    mobBgImage: "/posts/bank/shopping-delights/M.jpg",
    title: "Placer de Compras",
    smltitle: "",
    html: function() {
      return {
        __html: `
				    
				    <br/>
					<h3>
						De la alta costura a los recuerdos - Jerusalén lo tiene todo
					</h3>
					<p>
						Hay varias zonas de Jerusalén con paseos de compras al aire libre y también algunos centros comerciales cubiertos. Cuando usted sale de compras por Jerusalén puede estar seguro de poder encontrar todo lo que busca y adecuado a todos los presupuesto.
					</p>

					<h3>
            CENTRO DE LA CIUDAD: BEN YEHUDA Y LAS CALLES CIRCUNDANTES
          </h3>
          <p>
            Toda el área del centro de la ciudad de Jerusalén es hoy en día una calle de compras peatonal. El corazón del centro es la calle Ben Yehuda, una peatonal llena de negocios y restaurantes que fue renovada algunos años atrás a fin de hacerla más acogedora, con sus aceras repavimentadas con piedra de Jerusalén, farolas de estilo clásico, áreas de asientos y una pequeña fuente para empezar. Las calles circundantes también disfrutaron de mejoras con la elegante renovación de las aceras de baldosas grises y las mismas farolas clásicas emplazadas en Ben Yehuda. Esta renovación fue parte del lanzamiento del tren ligero en la calle Jaffa.
          </p>

          <p>
            Dada la expansión y la modernización de todo el área, cuando se sale de compras en Jerusalén vale la pena caminar sin rumbo por todas las calles del centro de la ciudad: Shatz, King George, Hillel, Ben Yehuda, Jaffa, Yoel Salomon y todas sus ramificaciones. Un consejo: los viernes durante el día, eche un vistazo al mercadillo de los artistas en las calles Shatz y Bezalel – un lugar excelente para conseguir regalos hechos por artesanos locales.
          </p>

          <p>
           Ben Yehuda en sí misma es una colina que conecta con la calle King George en la parte más alta y con Jaffa en la parta baja, en el punto donde desemboca a la Plaza Zion (Kikar Tzion). Los puntos destacados de Ben Yehuda incluyen sucursales de dos compañías israelíes famosas: Ahava, que produce productos del Mar Muerto y Teva-Naot, que produce zapatos de cuero de alta calidad. Ben Yehuda es también un buen lugar para examinar souvernirs de judaica o cristianos a precios intermedios – ¡y no se olvide de negociar el precio! En el área también se consiguen artículos prácticos para la vida diaria, desde gorras hasta paraguas o productos electrónicos.
          </p>

          <!-- Hadar aked to hide this paragraph <p>
            En el corazón de Ben Yehuda, la Plaza Zion, se encuentra el recientemente instalado gran almacén Hamashbir LaTzarján (comúnmente conocido como “HaMashbir”), con varios pisos que ofrecen todo lo que se espera encontrar en esta clase de negocio. Cerca de la Plaza Zion se encuentra la joyería Baltinester (calle Jaffa), de renombre por sus collares con nombre hechos por encargo. Desde la Plaza Zion se entra a Najalat Shivá, centrado en la calle Yoel Salomon, que alberga varios negocios de artistas de cerámica y orfebrería, así como boutiques de ropa.
          </p>-->

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/3.jpg"} class="img-responsive" />
					</div>

					<h3>
                        EL MALL DE MAMILLA Y EL CARDO DE LA CIUDAD VIEJA: COMPRAS DE LUJO
                        </h3>

                        <p>
                        Saliendo del área de Ben Yehuda en dirección a la Ciudad Vieja, se encontrará con la increíblemente elegante Avenida Mall Alrov Mamilla, una pasarela comercial al aire libre de alto nivel arquitectónico. La avenida comienza en el hotel de 5 estrellas Mammilla Hotel y se expande hasta la Puerta de Jaffa, la entrada a la ciudad vieja, e incluye varias marcas de prestigio, tales como Versace, H. Stern, Nike y Gap, así como regalos judaica de alto nivel. El lujoso Mall Mammilla también exhibe regularmente obras de arte, ofrece música en vivo en su anfiteatro y promueve actividades para toda la familia, en especial durante las temporadas de fiestas. Revise nuestra agenda de eventos para más información.
                        </p>

                        <p>
                          Durante sus tours por la Ciudad Vieja, descubrirá una experiencia de compra exclusiva en el Cardo del Barrio Judío. La fila de negocios lujosos en el Cardo son adecuados en particular para la compra de recuerdos de Jerusalén, todo esto con el telón de fondo tan especial de las columnas del antiguo Cardo romano y otras ruinas arqueológicas. Por esta razón el Cardo es una experiencia única en su género para un visitante en Jerusalén, en la cual puede combinar un paseo a través de la historia con compras de alto nivel.
                        </p>
                        <h3>
                         EL MALL DE MALJA EN JERUSALÉN
                        </h3>
                        <p>
                         El Mall de Malja de Jerusalén es una elección sólida para los que prefieren salir de compras en un centro comercial urbano cubierto, así como para familias que buscan salir a esta clase de lugares.
                        </p>

                        <p>
                         Cuando el mall de Malja fue abierto veinte años atrás, fue apodado “El mall más grande de Medio Oriente”. Hoy en día el mall de Malja ciertamente mantiene su estatus como el mayor conglomerado de negocios de Jerusalén, con más de 250 tiendas para elegir
                        </p>

                        <p>
                         El Mall de Malja alberga tanto negocios israelíes como internacionales, con productos adecuados a presupuestos algo bajos hasta presupuesto medio y boutiques de alta calidad. Las marcas más famosas del mundo, como H&M, Zara, Home Depot y Toys R Us tienen sucursales en este mall. Algunas tiendas de ropas israelíes adecuadas a todos los bolsillos tienen también lugar aquí, así como una sucursal de los grandes almacenes de HaMashbir LaTzarchan (el mismo almacén de la Plaza Zion), y el supermercado Mega. Además, el mall de Malja ofrece servicios prácticos como sinagoga, oficina de correos y sucursal del Bank Hapoalim. Para comer existe una amplia selección de restaurantes en el patio de comidas, todo kosher.
                        </p>

					

					<p>
                        Las actividades incluyen una pista de patinaje de hielo cubierta que funciona durante el invierno, entretenimientos y talleres de artesanías durante las temporadas de las fiestas. Revise nuestra agenda de eventos para planificar su salida. Además, la sucursal de la tienda para bebés Shilav, tiene un stand de Gymboree adecuada para niños de hasta seis años de edad. Es fácil llegar al mall de Malja en autobuses desde el centro de la ciudad o en un taxi desde cualquier lugar.
                        </p>
                        <h3>
                         EL MERCADO ÁRABE EN LA CIUDAD VIEJA
                        </h3>
                        <p>
                          Si usted está en busca de lo auténtico y de productos locales, el mercado árabe de la Ciudad Vieja es el lugar indicado. Se encuentra en los barrios musulmán y cristiano; entre por la Puerta de Jaffa y siga derecho hacia el barrio musulmán. Cuando vea vestidos y túnicas colgando de lo alto es señal de que ha llegado. se le puede llamar un “pequeño Estambul”. El mercado árabe de la Ciudad Vieja es un mercado fiel al estilo de los mercados del Medio Oriente, lleno de artesanía endémica tanto en ropas como en comidas. Aquí también puede encontrar suvenirs cristianos, judíos y musulmanes, por lo general a un precio más bajo que en la calle Ben Yehuda, dependiendo de su capacidad de regatear el precio. (Consejo: empiece ofreciendo la mitad del precio exigido.)
                        </p>
                        <p>
                        En el mercado árabe podrá apreciar el sabor de como las cosas eran en el pasado y lleva funcionando en la Ciudad Vieja dede hace un par de milenios en esas estrechas callejuelas, diariamente; la autenticidad de este mercado centenario es algo sin paralelo en la cultura occidental en general e incluso en Israel en particular.
                        </p>
                        <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/2.jpg"} class="img-responsive" />
					</div>
                        <h3>
                         EL SHUK (MERCADO) MAHANÉ YEHUDA
                        </h3>

                        <p>
                        El mercado Mahané Yehuda o el Shuk, es bien conocido por la combinación tan de Jerusalén de productos frescos y nueces, productos de pastelerías (como mazapán), junto con puestos de shwarma y falafel. En los últimos años Mahané Yehuda experimentó un giro hacia establecimientos más selectos, yendo “del Shuk al chic con negocios que se especializan en vinos y quesos, tiendas de alimentos naturales y saludables, restaurantes vegetarianos e incluso una sucursal de la cadena israelí internacional Café Aroma. Además de la comida, es posible encontrar regalos, tales como judaica, joyas y cerámicas. También es posible adquirir productos electrónicos, teléfonos móviles y ropas a bajo precio, incluyendo pantalones Levi Strauss por alrededor de 15 Nis (de todos modos se parecen bastante a los verdaderos Levi).
                        </p>
                        <p>
                         Incluso con su giro hacia lo exclusivo de los últimos años, el shuk Mahané Yehuda, es el auténtico ambiente de Jerusalén, que aún permanece intacto, por lo cual la visita al shuk es obligatoria.
                        </p>
                        <h3>
                          EN RESUMEN
                        </h3>
                        <p>
                         Considerando todo esto, las compras en Jerusalén reflejan a la ciudad en sí misma, que se extiende en la escala desde lo antiguo hasta lo moderno, con opciones para presupuestos limitados y para los que buscan objetos de lujo. Usted vera que salir de compras en Jerusalén es realmente una experiencia variada y excitante.
                         <br/>
– Ver más en: http://www.itraveljerusalem.com/articles/popular-shopping-places/#sthash.HdOTQ81q.dpuf
                        </p>

         `,
      };
    },
  },

  {
    id: "TelAviv_Highlights",
    ctg: "telaviv",
    isVid: false,
    bgImage: "/posts/bank/37/1.jpg",
    mobBgImage: "/posts/bank/37/M.jpg",
    title: "Lo Más Destacado de Tel Aviv",
    smltitle: "",
    isVid: true,
    // vidId: "eRNnLm6R0LI",
    vidId: "tgF0zMUYY2g",
    html: function() {
      return {
        __html: `
					<br/>
					<h3>Las 5 mejores cosas para ver y hacer en la ciudad:</h3>
					<h3>
						Viejo Jaffa
					</h3>
					<p>
					A pesar de que data de miles de años, una visita a Old Jaffa siempre
					se siente como un descubrimiento emocionante. Encantadores callejones sinuosos intercalados
					con galerías de arte, edificios históricos, monumentos extraordinarios y multitud de pintorescos y auténticos restaurantes. Un recorrido por el viejo Jaffa es una tremenda experiencia, un definido imperdible para cada turista que visita Israel.

					</p>
					<h3>
						Puerto de Jaffa
					</h3>
					<p>
					Considerado uno de los puertos más antiguos del mundo, el Puerto de Jaffa
					sirvió a pescadores, marineros, mercaderes, cruzados, conquistadores e
					inmigrantes por miles de años. Hoy, el puerto continúa sirviendo como
					un puerto pesquero, y también se está renovando como atracción urbana, ofreciendo
					actividades culturales y de ocio, compras y turismo y al mismo tiempo, su carácter histórico
					y fascinantemente único.

					</p>
					<h3>
					Puerto de Tel Aviv
					</h3>
					<p>
					Recientemente restaurado, el área portuaria de moda, realmente lo tiene todo. Durante el
					día puede, encontrarse vagando a través de 
					espacios para tiendas de marca y boutique, compartir una comida en restaurantes
					con magníficas vistas al mar y participar en muchas actividades para
					toda la familia. Por la noche, sin embargo, las multitudes de jóvenes descienden a la zona que se transforma en uno de los uno de los puntos más populares de la ciudad
					con algunos de los mejores clubes y bares de Tel Aviv.

					</p>
					<h3>
				    	La Ciudad Blanca
					</h3>
					<p>
					Únete a un fascinante recorrido por la "Ciudad Blanca" de Tel Aviv y descubre por qué
					ha sido declarado Patrimonio de la Humanidad por la UNESCO. La Ciudad Blanca es
					sede de la agrupación más grande del mundo edificios de este estilo internacional, también
					conocido como Bauhaus. Construido entre los años 1920 y 1930, y minuciosamente
					restaurado, el barrio de la "Ciudad Blanca" es verdaderamente único y
					un memorable tesoro arquitectónico.

					</p>
					<h3>
						Neve Tzedek
					</h3>
					<p>
					Tome un descanso del ritmo agitado de Tel Aviv; esta escondida joya de barrio,
					cuenta con un hermoso estilo arquitectónico oriental y encantadoras calles
					estrechas que hacen que Neve Tzedek, que literalmente significa un oasis de Justicia,
					sea un verdadero oasis en el corazón mismo de la bulliciosa ciudad.

					</p>

         `,
      };
    },
  },

  {
    id: "Amazing_Nightlife",
    bgImage: "/posts/bank/18/1.jpg",
    mobBgImage: "/posts/bank/18/M.jpg",
    title: "Sorprendente Vida Nocturna",
    ctg: "telaviv",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    // vidId:"WKfjMATNH8Q", - this is an old youtube video
    smltitle: "",
    html: function() {
      return {
        __html: `

					<div class="ac-cradit">
					<span class="ac-cradit-text">Credits:</span>
						<br/>
						<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
						<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
					</div>
					<p></p>
					</div>
					<br/>


                    <p>
						 No has vivido la cultura de Tel Aviv hasta no haber bailado hasta el amanecer en uno de los famosos clubes nocturnos de la ciudad.
					</p>
					
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/2.jpg"} class="img-responsive" />
					</div>

					<p>
                         Dizingoff –  un auténtico mega club, buen ambiente y buena música.
                    </p>

                    <p>
                          The Cat and the Dog –  para los más trasnochadores, cuando la mayoría de los clubes ya cierran sus puertas, aquí empieza la fiesta. La música, tan ecléctica como su público.
                    </p>

                    <p>
                         Biggy Z Bar – Inspirado en el Mardi Grass de Nueva Orleans, cuenta con una pista al aire libre y otra cubierta, así como con la popular política de “bebe todo lo que puedas beber” para los que compran la pulsera del club.
                    </p>

                    <p>
                         Dream Exhibition –  Un elegante club con moderno equipo de sonido. Los mayores de 24 años bailan al ritmo del rock, música comercial y estilo house.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/3.jpg"} class="img-responsive" />
					</div>

					<p>
                          Valium – Un lujoso y espacioso club nocturno en el quinto piso del edificio Migdalor. Disfruta en la pista de baile o en la tranquila terraza.
                          <br/>
                          Ktovet – Un club alternativo con una curiosa decoración y DJ locales e internacionales para aquellos que simplemente quieren bailar.
                           <br/>
                         The Block – El techno – trance es la música preferida en este club, conocido por su excelente sistema de sonido de gran nivel.
                           <br/>
                          Kuli Alma – Donde se expone arte local y con zonas al aire libre, un menú vegetariano y gran variedad de estilos musicales.
                        </p>
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/4.jpg"} class="img-responsive" />
					</div>
                      <p>
                      Clubes nocturnos alternativos – Club solo para hombres es el Apolo Bar (Allenby 46) y para mujeres el Barvaz (Ha´Mejoga 10) o el Amazona para mujeres de 24 años en adelante (Lilienblum 23).
                    </p>

         `,
      };
    },
  },

  {
    id: "Boutique_Hospitality",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "Boutique Hospitality",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `

                                <p>Tel Aviv has long been known as a young and vibrant seaside city, where life is fast-paced and non-stop. And with countless bars, restaurants, beaches, museums, shops and attractions lining every free inch of prime Tel Aviv real estate, the recent revolution in the city’s boutique hotel offerings in the past two years has paved the way for luxury and leisure packed vacations, combining action with relaxation and increased visitor satisfaction.</p>

                                <h3>A unique, personalized touch</h3>

                                <p>If you are seeking a unique hospitality experience in a trendy neighborhood establishment that blends into the local infrastructure, a Tel Aviv boutique hotel stay is just what you need. Perfectly bringing together desired service and amenity features with an added increasingly personalized customer service, boutique hotels are known for their staff’s exemplary accommodating attention to their visitors’ every request and fancy.</p>

                                <p>Built in converted heritage sites, restored old buildings or other contemporarily designed structures, each Tel Aviv neighborhood boutique hotel possesses unique themes, concepts and characteristics. Defined by their souls and coupled with uniquely designed guest rooms and a high level of customized service, the boutique hotels have great views of the “City that Never Sleeps” from sprawling rooftop terraces, in-house spas, internet hubs and restaurants.</p>
								<div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/boutique-hospitality/1.jpg"} class="img-responsive" />
						            Credit: Dana Friedlander
					            </div>
							   
								<h3>Live the big city</h3>

                                <p>Looking to enjoy a romantic couple’s getaway, find a quiet place to unwind during a weeklong business conference, gather your family for an intimate reunion or hang out with friends for a fun beach vacation? Don’t want to travel far from your hotel room or sit in traffic to reach big city attractions, nightlife and events? The warm and inviting yet luxurious nature of boutique hotel stays in Tel Aviv provide the ideal hospitality experience that lets you “live” Tel Aviv like a local, minus the onus of cleaning your own rooms and preparing your own meals.</p>

                                <p>Think of boutique hotels as upscale and authentic guest houses in the heart of the big city. Somewhere you can go to escape the hustle and bustle when it’s time to relax and be pampered, but still be able to pop out on a whim and casually enjoy the plethora of sites and services Tel Aviv offers the public, just like any one of  the city’s locals. And with many of the city’s boutique hotels situated in trendy areas, including in Neve Tzedek, along the coastline, in the diamond district and on Rothschild, Shenkin and Montefiore streets, a Tel Aviv boutique hotel stay is charming, authentic, pleasurable and exciting for all hospitality seekers.</p>
            

         `,
      };
    },
  },
  {
    id: "Shakshuka_Time",
    ctg: "culinarytelaviv",
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    isVid: true,
    vidId: "n4kCnPXEX7g",
    title: "Hora de Shakshuka",
    smltitle: "",
    html: function() {
      return {
        __html: `

         <br/>
         <h3>¡Aprende a hacer el mundialmente famoso, Plato Shkshuka!</h3>
          <p>
          Cuando le preguntas a las personas que visitan Tel Aviv y Jerusalén al respecto de cuál fue su plato preferido a lo largo de su viaje, la respuesta, en la mayoría de los casos, será Shkshuka. Esta exquisitez mediterránea, definida como favorito local, es esencialmente un plato de huevos escalfados en salsa de tomates, chiles o pimientos y cebollas ricas en sabor, sirviéndose a menudo, con pan y tahini. Por supuesto, hay muchas variaciones de este plato de acuerdo a los gustos y estilos locales, sirviéndose por lo general, para el desayuno o el brunch, aunque también lo encontrará fantástico para la cena.
      		</p>
      		<p>
          La mejor forma de comer Shakshuka es, sin duda, durante todo el año de fantástico sol en Tel Aviv o Jerusalén, mientras disfruta de un sorprendente descanso en una ciudad llena de sabores y experiencias inolvidables.
      		</p>
      		<p>
          Sin embargo, si desea hacerlo con sus propias manos y recrear el sensacional sabor del Shakshuka en su propia cocina, así es como se hace:
      		</p>
      		<h3>
            Ingredientes
          </h3>
          <ul>
             <li>2 cucharadas de aceite de oliva</li>
             <li>1 cebolla picada</li>
             <li>1 pimiento rojo, sin semillas y en cubitos</li>
             <li>4 dientes de ajo picados</li>
             <li>2 latas de tomates cortados en cubitos</li>
             <li>6 huevos</li>
             <li>2 cucharadas de cilantro fresco, picado</li>
             <li>¾ cucharadita de sal</li>
             <li>1 cucharadita de pimentón</li>
             <li>¼ cucharadita de pimienta negra</li>
             <li>1 jalapeño (opcional)</li>
          </ul>
          <br/><br/>
          <h3>
             Instrucciones
          </h3>
          <ol>
              <li>Precalienta el horno a 375 grados mientras esperas.</li>
              <li>Caliente a fuego medio el aceite de oliva en una sartén pesada apta para horno. Agregue la cebolla, el pimiento y el jalapeño friendo hasta que las cebollas estén translúcidas.</li>
              <li>Agregue el ajo y el pimentón. Incorpore los tomates, la sal y la pimienta negra.</li>
              <li>Lleve a fuego lento reduciendo el calor. Cocine de 10 a 15 minutos.</li>
              <li>Cree 6 espacios pequeños en la salsa y cuidadosamente rompa cada huevo en el espacio.</li>
              <li>Coloque la cacerola en el horno precalentado y cocine hasta que los huevos se blanqueen estando listos en aproximadamente 10 minutos.</li>
              <li>Agregue el cilantro como guarnición antes de servir.</li>
              <li>¡Sirve con pan, tahini y diviértete!</li>
          </ol>
        `,
      };
    },
  },

  // {
  //     id: "Jerusalem_Cuisine",
  //     ctg: "culinaryjerusalem",
  //     bgImage: "/posts/bank/28/1.jpg",
  //     mobBgImage: "/posts/bank/28/M.jpg",
  //     isVid:true,
  //     vidId: "2CSCe2WC7Ns",
  //     title: "GASTRONOMÍA EN JERUSALÉN",
  //     smltitle: "",
  //     html: function() {
  //         return {
  //             __html: `

  //            <br/>
  //            <h2 >Los 5 restaurantes más<br> singulares de Jerusalén</h3>
  //            <p>
  //                            Jerusalén está llena de decenas de animados restaurantes a la moda y lugares de entretenimiento. Además está repleta de áreas que ofrecen excelentes opciones para todo tipo de entretenimientos, ya sean diurnos o nocturnos, donde podrá disfrutar de una deliciosa velada con una gran comida, una cerveza fría o un baile con buena música.
  // 						</p>
  // 						<p>
  // 						   En Jerusalén, se dice que vienes por el hummus, pero te quedas por su increíblemente diversa cocina. Desde la gastronomía tradicional de Oriente Medio y Norte de África hasta Sudamérica, fusión asiática y continental europea; desde comida callejera hasta comida de etiqueta, Jerusalén lo tiene todo. Esta amplia variedad de opciones culinarias se puede encontrar literalmente en todas partes. Lugares como puestos callejeros ofreciendo delicias locales, auténticos restaurantes en los mercados, y si está buscando la experiencia gourmet, puede reservar un lugar en uno de los múltiples restaurantes exclusivos de la ciudad.
  // 						</p>
  //         `
  //         }
  //     }
  // },

  {
    id: "Jerusalem_Cuisine",
    bgImage: "/posts/bank/28/1.jpg",
    mobBgImage: "/posts/bank/28/M.jpg",
    title: "GASTRONOMÍA EN JERUSALÉN",
    ctg: "culinaryjerusalem",
    isVid: true,
    // vidId: "2CSCe2WC7Ns",
    vidId: "oy9ozIvV7Co",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                   <br/>
           <h3>Los 5 restaurantes más singulares de Jerusalén</h3>
           <p>
                           Jerusalén está llena de decenas de animados restaurantes de moda y lugares de entretenimiento. Además está repleta de áreas que ofrecen excelentes opciones para todo tipo de entretenimientos, ya sean diurnos o nocturnos, donde podrá disfrutar de una deliciosa velada con una gran comida, una cerveza fría o un baile con buena música.
						</p>
						<p>
						   En Jerusalén, se dice que vienes por el hummus, pero te quedas por su increíblemente diversa cocina. Desde la gastronomía tradicional de Oriente Medio y Norte de África hasta Sudamérica, fusión asiática y continental europea; desde comida callejera hasta comida de etiqueta, Jerusalén lo tiene todo. Esta amplia variedad de opciones culinarias se puede encontrar literalmente en todas partes. Lugares como puestos callejeros ofreciendo delicias locales, auténticos restaurantes en los mercados, y si está buscando la experiencia gourmet, puede reservar un lugar en uno de los múltiples restaurantes exclusivos de la ciudad.
						</p>

			`,
      };
    },
  },

  {
    id: 10,
    bgImage: "/posts/bank/12/1.jpg",
    mobBgImage: "/posts/bank/12/M.jpg",
    ctg: "telaviv",
    isVid: false,
    title: "Culture Time",
    smltitle: " ",
    html: function() {
      return {
        __html: `

					<h3>A variety of fascinating museums and unique galleries</h3>

				    <h3>
				        Tel Aviv Museum of Art
				    </h3>

					<p>
						The Tel Aviv Museum of Art presents a variety of permanent and temporal exhibits at its home in the Helena Rubenstein Pavilion, located on Shaul Hamelech Boulevard, next to the Mann Auditorium. The permanent exhibits include some of the best works of Israeli art, as well as sculptures from the 20’s until today. It features European paintings – impressionism and post-impressionism – from the 16th to the 19th centuries, as well as European and American works of the 20th century. The museum’s graphic collection includes more than 20,000 prints and sketches. Among the museum’s outstanding works are a unique selection of early painted reliefs of Alexander Archipenko and works by Chagall, which he donated to the museum before its establishment. Helena Rubenstein’s well-known collection of miniature rooms is on permanent display in the pavilion, which bears her name.
					</p>

					<h3>
				        OPENING HOURS:
				    </h3>

				    <p>

                          Sun Closed <br>
                          Mon, Wed, Sat 10:00-18:00 <br>
                          Tue, Thu 10:00-22:00 <br>
                          Fri 10:00-14:00 <br>
                          Sat 10:00-16:00 (July-August closed on Sat)<br>
                    </p>

                    <p>
                       For more information, pinche en&nbsp;<a href="//www.tamuseum.org.il/en/default.aspx" target="_blank">Tel Aviv Museum of Art</a>
                    </p>

                    <h3>
                        Beit Hatfutsot: The Diaspora Museum
                    </h3>

                    <p>
                       Beit Hatefutsot-The Jewish Diaspora Museum, situated on the Tel Aviv University campus, has gained honorary distinction throughout the Jewish world as the first museum of the history of the Jewish people to showcase the Jewish contribution to human creativity and culture over a period of more than two millennia. The Museum’s permanent exhibition brings the story of the Jewish People throughout the Diaspora to life through drawings, video clips, films, reconstructed models and other means. The exhibit focuses on various subjects – including “The Jewish Family life cycle”, “the community”, “the faith”, and “the return to Zion”.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/10/2.jpg"} class="img-responsive" />
					</div>

					<p>

                          For more information, pinche en&nbsp;<a href="//www.bh.org.il/" target="_blank">Beit Hatfutsot: The Diaspora Museum</a>

                    </p>

                    <h3>
                         Eretz Israel Museum
                    </h3>

                    <p>

                            The Eretz Israel Museum- Tel Aviv is a multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, judaica, cultural history, local identity, traditional crafts and functional arts. The museum’s pavilions are scattered throughout a spacious courtyard with the ancient archaeological mound of Tel Kassile, at which excavations revealed valuable findings, positioned at its center. The museum houses a variety of reconstructed ancient production devices, including wine presses, an olive oil press, and a flour mill, along with a “craftsperson’s marketplace” which showcases traditional work instruments that were used in the Land of Israel and throughout the region. There is also a sophisticated Planetarium with its “Journey to the Universe” program, and a museum shop offering a unique selection of locally produced gifts and ornaments.<br>

                            OPENING HOURS:<br>

                          Sun-Wed 10:00-16:00 <br>



                          Thu 10:00-20:00<br>



                          Fri-Sat 10:00-14:00<br>

                        </p>

                    <p>
                       For more information, pinche en <strong>&nbsp;</strong><a href="//www.eretzmuseum.org.il/e/" target="_blank">Eretz Israel Museum&nbsp;</a>
                    </p>

					<h3>
					    Beit Ha’ir
					</h3>


					<p>

                          Beit Ha’ir, renovated by the city, was the old City Hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city’s history.  Beit Ha’ir has a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years, a project that was part of the centenary celebrations of the city. The main hall has a virtual display, including hundreds of documentary films and thousands of rare photos and documents that showcase major events in the early years of city life.  At Beit Ha’ir you can also visit the Dizengoff House, the restored residence of Meir Dizengoff, first mayor of Tel Aviv-Yafo, which includes a permanent exhibition.

                          <br>
                          OPENING HOURS:
                          Sun Closed
                          Mon-Thu 9:00-17:00 <br>
                          Fri-Sat 10:00-14:00
                    </p>

                    <p>
                      For more information, pinche en <a href="//www.eretzmuseum.org.il/e/" target="_blank">Beit Ha’ir</a>
                    </p>

                    <h3>
                        The Olympic Experience Museum
                    <h3>

                    <p>

                          A new museum in Tel Aviv-Yafo, The Olympic Experience Museum, presents a one-hour, five-ring trip through the greatest Olympic records, with a special focus on Israel’s finest moments. The Olympic Experience boasts state-of-the art high tech imaging and illustrations, audio-visuals presentations, holograms, interactive screens, hands-on trials and much, much more.

                          Guided tours for organized groups every 30 minutes. Advanced reservation is recommended.

                          Opening Hours: Sunday-Thursday: 10:00-18:00, Friday:  10:00-14:00

                          The Olympic Experience, 6 Shitrit Street, Hadar-Yosef. Tel: +972-3-6498385

                    </p>

                    <p>
                       For more information, pinche en&nbsp;<a href="//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2" target="_blank">The Olympic Experience Museum</a>
                    </p>

                    <p>

                          Ilana Goor Museum in Jaffa

                          The private home of this world renowned artist has been turned into a museum. You can see her sculptures, furniture, jewelry and get a glimpse into this unique Jaffa home <br>
                          OPENING HOURS: <br>
                          Sun-Fri 10:00-16:00 <br>
                          Sat 10:00-18:00<br>
                          <a href="//www.ilanagoormuseum.org/eng/">www.ilanagoormuseum.org</a>
                    </p>

                    <h3>
                         Palmach Museum
                    </h3>

                    <p>
                        Rated #1 Tel Aviv museum on Trip Advisor, this museum examines the Palmach, the military wing of the Zionist Movement, which functioned until the establishment of the State of Israel.
                    </p>

                    <p>
                        For more information, pinche en&nbsp;<a href="//info.palmach.org.il/show_item.asp?itemId=8096&amp;levelId=42798&amp;itemType=0" target="_blank">Palmach Museum</a>
                    </p>

                    <h3>
                        Other unique Museums
                    </h3>

                    <p>
                        Tel Aviv-Yafo is home to a variety of smaller, specialized museums, such as Beit Ben Gurion (The home of David Ben Gurion, Israel’s first prime minister), Beit Hatanach (The home of the Bible), The Haganah (defense) Museum, The I.Z.L. (the Irgun Zva’I Leumi – National Military Organization) Museum, Beit Hasofer (author’s house), Beit Reuven, The Jabotinsky Museum, and many others. Each of these smaller museums is a treasure house of artifacts. For example, Beit Bialik – the house of the national poet, displays the books, furniture and belongings of Israel’s renowned national poet. Bialik’s personal library of more than 3,000 books has been preserved, and the museum’s archives contain thousands of manuscripts, including the most extensive collection of his writings.
                    </p>

                    <h3>
                        OPENING HOURS OF TEL AVIV MUSEUMS:
                    </h3>
                    <h3>
                        Etzel Museum:
                    </h3>

                    <p>

                          King George 38: Sun-Thu 8:30-16:00 <br>

                          For more information, pinche en&nbsp;<a href="//www.goisrael.com/Tourism_Eng/Tourist%20Information/attractions/Pages/Etzel%20Museum.aspx" target="_blank">Etzel Museum</a>
                    </p>

                    <h3>
                        Ben Gurion House:
                    </h3>

                    <p>
                            Sun, Tue-Thu 8:00-15:00 <br>
                            Mon 8:00-17:00<br>
                            Fri 8:00-13:00<br>
                            Sat 11:00-14:00
                    </p>

                    <p>
                       For more information, pinche en&nbsp;<a href="//www.bg-house.org/?categoryId=6575" target="_blank">Ben Gurion House</a>
                    </p>

                    <h3>
                        Jabotinsky Institute in Israel:
                    </h3>

                    <p>

                        Sun-Thu 8:00-16:00 <br>
                        For more information, pinche en&nbsp;<a href="//en.jabotinsky.org/" target="_blank">Jabotinsky Institute in Israel</a>

                    </p>

                    <h3>
                           The Israeli Museum:
                    </h3>

                    <p>
                            Sun, Mon, Wed 9:00-17:00 <br>
                            Tue, Thu 9:00-19:00<br>
                            Fri 9:00-14:00 <br>
                            For more information, pinche en
                            <a href="//www.imj.org.il/en/">www.imj.org.il</a>
                    </p>

                    <h3>
                       Jaffa Visitors Center:
                    </h3>

                    <p>

                            Summer Sun-Thu, Sat 9:00-20:00<br>

                            Fri 9:00-17:00<br>

                            Winter Sun-Thu, Sat 9:00-18:00<br>

                            Fri 9:00-15:00<br>

                            For more information, pinche en  <br>

                            <a href="//www.touristisrael.com/old-jaffa-visitors-center/3604/" target="_blank">Jaffa Visitors Center</a>

                    </p>

                    <h3>
                         Hall of Independence:
                    </h3>

                   <p>

                            Sun-Thu 9:00-17:00 <br>

                            Fri 9:00-14:00<br>

                            For more information, pinche en&nbsp;<a href="//eng.ihi.org.il/" target="_blank">Hall of Independence</a>

                    </p>

                    <h3>
                        The Bible Museum:
                    </h3>

                    <p>

                            Sun-Fri 10:00-13:00 + 16:00-18:30 <br>

                            For more information, pinche en&nbsp;<a href="//www.blmj.org/en/" target="_blank">The Bible Museum</a>

                    </p>

                    <h3>
                        Joseph Bau house:
                    </h3>

                    <p>

                            By appointment only (including weekends) <br>

                            For more information, pinche en&nbsp;<a href="//www.josephbau.com/" target="_blank">Joseph Bau house</a>

                    </p>

                    <h3>
                        Rubin Museum:
                    </h3>

                    <p>

                            Sun Closed <br>

                            Mon, Wed, Thu 10:00-15:00 <br>

                            Tue 10:00-20:00<br>

                            Sat 11:00-14:00<br>

                            For more information, pinche en &nbsp;<a href="//www.rubinmuseum.org.il/" target="_blank">Rubin Museum</a>

                    </p>

                    <h3>
                        Art Galleries
                    </h3>

                    <p>
                        Don’t miss the dozens of fine galleries, primarily located along Gordon Street and in the Old City of Jaffa, featuring the very latest in contemporary Israeli art. We won’t say another word- we’ll let the art speak for itself.
                    </p>

         `,
      };
    },
  },

  {
    id: 99,
    bgImage: "/posts/bank/20/1.jpg",
    mobBgImage: "/posts/bank/20/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "rkjLPq-Zsp8",
    title: "JERUSALEM MAIN SITES ",
    smltitle: "",
    html: function() {
      return {
        __html: `
					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/rkjLPq-Zsp8/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<h3>
				    	Discover the history that stretches back thousands of years
				    </h3>
					<p>
						Like any city, the charm and essence of Jerusalem is best absorbed by walking its streets. However, depending on your interests, you don’t want to miss out on exploring at least some of these major attractions.
					</p>

					<p>
                         When visiting religious sites, it’s advised to dress modestly and wear clothing that covers your knees and elbows.
                    </p>

					<p>
                       A good place to start is Jerusalem’s Old City, which has a very special and distinct atmosphere and is where many of the major attractions of Jerusalem are found.
                    </p>

                    <h3>
                        OLD CITY
                    </h3>

                    <h3>
                        JERUSALEM WESTERN WALL
                    </h3>

                    <p>
                      The Western Wall, also known as the Wailing Wall and Kotel, is the western retaining wall of the Second Temple. Considered Judaisms’s holiest site, the wall is divided into a men’s and women’s section where worshipers congregate throughout the day for morning, afternoon and evening services. Diverse crowds come to pray against the stones, to tuck small pieces of paper with prayers into the cracks and to simply marvel at the site.
                    </p>

                    <p>
                          Address: Jewish Quarter, Old City <br>
                          Phone: +972-2-627-3515<br>
                          Hours: 24/7<br>
                    </p>

                    <h3>
                        VIA DOLOROSA
                    </h3>

                    <p>
                        TCrossing the Muslim Quarter from east to west is this street that traces the last steps of Jesus Christ as he was led to his crucifixion. Popular with both pilgrims and general tourists, the route marks 14 events on Christ’s last walk and is also lined with shops and stalls. It is worth visiting on a Friday afternoon (3:00opm in winter; 4:00pm in summer) when the Franciscans lead a procession along the route.
                        <br>Address: Via Dolorosa, Muslim Quarter, Old City.
                    </p>

                    <h3>
                        JERUSALEM CHURCH OF THE HOLY SEPULCHER
                    </h3>

                    <p>
                        One of the holiest sites for Christians, this impressive building draws millions of pilgrims from around the world every year. The compound is believed to be the site of Golgotha (the Hill of Calvary), where, according to the New Testament, Jesus was crucified, buried and resurrected.
                        <br>
                        Address: Between Suq Khan e-Zeit and Christian Quarter Rd, Christian Quarter, Old City<br>
                        Phone: +972-2-627-3314 <br>
                        Hours: Sun – Sat: 5:00am – 8:00pm/9:00pm
                    </p>



					<h3>
					    DAVID’S CITADEL
					</h3>

					<p>
					   David’s Citadel (also known as the Tower of David) was originally built in the second century BC to strategically strengthen a weak point in the city’s defences, and was subsequently destroyed and rebuilt many times over the ensuing centuries. Since 1989, the grounds are home to a fascinating museum, which sheds light on the history of Jerusalem. Don’t forget to take in the splendid view of Jerusalem from its ramparts.
					</p>

					<p>
                          Address: Jaffa Gate, Christian Quarter, Old City <br>
                          Phone: +972-2-626-5333<br>
                          Hours: Sun-Thu: 10:00am -4:00pm, Fri: Closed, Sat: 10:00am – 2:00pm (September-June), Sun-Thu:<br> 10:00am – 5:00pm, Fri: 10:00am – 2:00pm, Sat: 10:00am – 5:00pm (July-August)
                    </p>

                    <h3>
                        CITY OF DAVID
                    </h3>

                    <p>
                        Situated deep below ground in the Arab village of Silwan is the remains of the once-grand citadel where a dynasty of Judean kings once ruled. A massive visitors’ center offers a tour that begins with an observation point overlooking the remains of ancient Jerusalem, then continues underground with a look at recent archaeological finds and ends at the Gihon Spring, where according to tradition Solomon was anointed king. Visitors can also wade through the waters of the 2,700-year-old Hezekiah’s Tunnel.
                    </p>

                    <p>
                          Address: Silwan, East Jerusalem <br>
                          Phone: +972-2-626-2341<br>
                          Hours: Sun-Thu: 8:00am – 5:00pm (winter), 8:00am – 7:00pm (summer), Fri: 8:00am – 1:00pm (winter), 8:00am – 3:00pm (summer)
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/9/3.jpg"} class="img-responsive" />
					</div>

					<h3>
                       MOUNT OF OLIVES
                    </h3>

                    <p>
                        The hill that rises to the east of the Old City, the Mount of Olives, is a great place to take in views of the Old City and the Dome of the Rock. Its slopes are filled with holy and burial sites and are home to several grand churches including the Church of all Nations. To take in all the sights, it’s best to start at the top, near to the Mosque of Ascension, and walk downhill to the Tomb of the Virgin. The Old City views are best in the morning. <br>
                        Address: Mount of Olives, East Jerusalem
                    </p>

                    <h3>
                        YEMIN MOSHE
                    </h3>

                    <p>
                        This charming neighbourhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. It is known for its windmill and communal housing block, known as Mishkenot Shaananim, which is now a venue for art and culture. The area is home to artists, writers and academics and is renowned for its Oriental-style houses, green parks, a music center, the YMCA, King David Hotel, Herod’s Family Tomb. <br>
                        CITY CENTER
                    </p>

                    <h3>
                        MAMILLA ALROV AVENUE
                    </h3>

                    <p>
                          Situated between the city center and the Old City, Mamilla Alrov Avenue is a pedestrian mall that offers a selection of luxury shops, as well as upscale restaurants and cafes. Mamilla is known for its chic and tasteful European feel, and offers spectacular views of the Old City walls. <br>
                          Address: 6 Yitzhak Kariv St, Jerusalem <br>
                          Phone: +972-2-636-0000<br>
                          Hours: Sun-Thu: 10:00am – 9:30pm (winter), 10:00am – 10:30pm (summer), Fri: 9:00am – 2:00pm (winter), 9:30am – 3:30pm (summer), Sat: One hour after Shabbat – 11:00pm
                    </p>

                    <h3>
                        BEN YEHUDA STREET
                    </h3>

                    <p>
                    One of Jerusalem’s prime hangout spots for locals and tourists alike, Ben Yehuda Street is a pedestrian mall extending between King George Street and Jaffa Road in downtown Jerusalem. The street is filled with gift shops, falafel and ice-cream stores, buskers, beggars, musicians and street performers.
                    </p>

					<h3>
                        NACHALAT SHIVA
                    </h3>

                    <p>
                          This charming cobblestone neighbourhood just south of Ben Yehuda Street in the&nbsp;<a href="//www.itraveljerusalem.com/placecategory/food-nightlife?multi_hood=11" target="_blank"><strong>city center</strong></a>&nbsp;offers a great selection of shops, restaurants, bars and outdoor cafes. This is a great place to experience in summer and at night with many bustling until late.
                    </p>

                    <h3>
                       MEAH SHEARIM
                    </h3>

                    <p>
                          Though it is just a few minutes’ walk from modern Ben Yehuda Street, the ultra-orthodox enclave of Mea Shearim is an entirely different reality. You will feel as though you have stepped into 18th Century Europe with Jewish Orthodoxy dressed in full traditional attire such as long black coats, black fur hats and stockings. When touring, it’s recommended to dress extremely modestly, covering up your wrists and ankles, and to take photos with discretion. <br>
                          Address: Meah Shearim Rd, Jerusalem
                    </p>

                    <h3>
                        Mahane Yehuda Market
                    </h3>

                    <p>
                          Often referred to as “the shuk”, Mahane Yehuda Market offers a huge assortment of fresh produce and food, as well as a variety of other shops like clothing stores, kitchenware shops, jewellery stores, ceramic stores and a variety of gentrified eateries. The shuk includes an open air and closed area, bounded by Jaffa Road on the one side and busy Agripas Street on the other. It’s worth taking public transportation to the shuk as there is not a huge abundance of parking, and a great deal of traffic. If you can handle crowds, go on a Friday to experience last minute Shabbat shopping.<br>
                          Address: Agripas and Jaffa Street, Jerusalem
                    </p>

                    <h3>
                        OTHER AREAS OF JERUSALEM
                    </h3>

                    <h3>
                       YAD VASHEM
                    </h3>

                    <p>
                          Yad Vashem, Israel’s national Holocaust memorial, commemorates the six million men, women and children murdered by the Nazis and their allies. Located at the foot of Mt. Herzl, Yad Vashem comprises several moving memorials, including the Hall of Remembrance and the haunting Children’s Memorial; the Holocaust History Museum; the Museum of Holocaust Art; sculptures and installations; a massive archive and a research institute. Dress appropriately, and make sure to reserve at least a few hours for a visit to the Museum.  Address: Har Hazikaron <br>
                          Phone: +972-2-644-3400
                    </p>

                    <h3>
                       ISRAEL MUSEUM
                    </h3>

                    <p>
                          You’ll want to devote at least a day to Israel’s largest cultural institution, the Israel Museum, which was re-launched in the summer of 2010 after a major overhaul. The Museum is made up of many different wings and a huge collection of art, archaeological findings and judaica. One of the major highlights is the distinctly shaped Shrine of the Book, which houses many ancient manuscripts including the Dead Sea Scrolls. Other highlights include the Youth Wing for children, the Billy Rose Art Garden, which showcases the development of western sculpture over the centuries, the Museum’s Fine Arts Wing and its in-depth Archaeology Wing.
                    </p>

         `,
      };
    },
  },

  {
    id: "Sensational_Beaches",
    ctg: "telaviv",
    isVid: true,
    // vidId:"XDei1Zy_cu4",
    vidId: "EJAqEcK4Te0",
    bgImage: "/posts/bank/17/1.jpg",
    mobBgImage: "/posts/bank/17/M.jpg",
    title: "PLAYAS SENSACIONALES",
    smltitle: "",
    html: function() {
      return {
        __html: `
					<br/>
					<h3>
						Ven a relajarte en las soleadas playas de Tel Aviv
					</h3>
					

					<p>
					Relájese en las soleadas playas de Tel Aviv, saque el protector solar, coja sus palas de playa y vaya a jugar.<br/>
						Tel Aviv-Yafo cuenta con un largo paseo, que se extiende a lo largo de la orilla del mar y constituye su borde occidental. Las personas caminan, hacen footing, montan en bicicleta o se sientan en los bancos, llenando sus pulmones de aire fresco, todo ello dentro de estos 14 kilómetros excepcionales con amplias vistas, horizontes azules y velas blancas que se balancean sobre las olas.
					</p>

					<p>
						Decenas de restaurantes, cafeterías y heladerías, que están llenos a todas horas, y pubs, discotecas y clubes de jazz que florecen al anochecer. Independientemente de la hora, abundan las atracciones: payasos, caricaturistas, tatuadores, peluqueros, magos y, por supuesto, el siempre cambiante desfile de personas que pasean por las playas cercanas. Justo al lado del paseo encontrará arena limpia, tumbonas, vendedores de helados y amantes de la playa que nadan a diario, en invierno y en verano, pase lo que pase. Cada una de las 13 hermosas playas de Tel Aviv cuenta con características únicas y ofrece una variedad de servicios, que incluyen puestos de salvavidas, quioscos, restaurantes, áreas de juegos infantiles, gimnasios al aire libre y mucho más.
					</p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>

					<h3>
						Algunos consejos
					</h3>

					<ul>
                      <li>Los viernes por la tarde en la playa Dolphinarium, puede participar en un festival improvisado de percusión y una combinación brasileña de artes marciales, danza y música llamada capoeira.</li>
                      <li>La playa de Gordon es ideal para el vóley playa.</li>
                      <li>El observador religioso encontrará natación por géneros en Hof Hadatiyim (playa de Nordau), justo al sur del puerto de Tel Aviv. Las mujeres y las niñas se bañan el domingo, el martes y el jueves, mientras que a los hombres y niños se les permite el lunes, el miércoles y el viernes. Ambos géneros están permitidos el sábado.</li>
                      <li>La comunidad LGBT tiende a concentrarse en torno al tramo cercano al hotel Hilton, que se ha ganado el título no oficial de la playa con mayor ambiente gay de la ciudad.</li>
                      <li>La estrecha franja de arena cerca de la Marina está menos concurrida y es más tranquila que el resto de playas. En el puerto deportivo puede alquilar tablas de windsurf, tablas de surf, veleros, lanchas y equipos de buceo.</li>
                      <li>El surf es popular en la playa junto al hotel Hilton, donde recientemente se instaló un sistema de iluminación especial para permitir el surf nocturno. </li>
                      <li>El Kite Surfing es popular en la playa de Aviv.</li>
                      <li>Para el windsurf, diríjase a la playa Dolfinarium.</li>
                      <li>El voleibol se puede encontrar tanto en la playa de Aviv como en la de Gordon.</li>
                      <li>Las playas de la ciudad están bien equipadas con vestuarios, duchas y aseos. Los servicios salvavidas están disponibles en temporada (mayo-octubre) y los oficiales de la policía turística están presentes para proporcionar servicios de seguridad, asistencia e información. </li>
                  	</ul>

                  	<h3>
						Curiosidades
					</h3>

					<ul>
                       <li> 8.500.000 bañistas disfrutan en las playas anualmente. </ li>
                       <li> La temporada oficial de baño es de mayo a octubre. </ li>
                       <li> Hay 13 playas a lo largo de la costa de Tel Aviv-Yafo. </ li>
                       <li> Cuatro playas son accesibles para personas con discapacidad: Tzuk, Tzuk del Norte, Metzizim y Hilton (todas en la parte norte de la ciudad). </ li>
                       <li> Las playas de Tel Aviv-Yafo obtienen una alta puntuación en las pruebas que lleva a cabo el Ministerio de Medio Ambiente de Israel y se consideran muy limpias. </ li>
                       <li> Una versión israelí del tenis de playa, llamada&nbsp;<a href="//www.gomatkot.com/the-game/" target="_blank">Matkot</a>, es el deporte estrella que se juega a lo largo de las costas (¡cuidado con la cabeza!). </ li>
                       <li> La sandía con queso feta es un aperitivo de playa muy popular. Los Artikim, o polos, también son muy apreciados, con el sabor chocolate y plátano como uno de los favoritos en la lista de la mayoría de la gente. </ Li>
                  </ ul>

                  	<h3>
						Reglas en la playa
					</h3>

					<ul>
                      <li> Los bañistas deben obedecer a los salvavidas y guardias de rescate. </ li>
                       <li> El baño está prohibido cuando no hay ningún socorrista trabajando. </ li>
                       <li> Los baños en el mar están prohibidos cuando la bandera negra está izada. </ li>
                       <li> NO se permiten deportes de motor (motos de agua, embarcaciones). </ li>
                       <li> Los vehículos motorizados están prohibidos en las playas y pasarelas. </ li>
                       <li> Se prohíbe hacer hogueras en las playas. </ li>
                    </ul>

                    <h3>
                    	Temporada de baño
                    </h3>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>

					<p>
						Durante la temporada, se prestarán servicios de rescate, supervisión y primeros auxilios en las siguientes playas: North Cliff, South Cliff, Tel Baruch, Hilton, Gordon, Frishman, Borgashov (la apertura se retrasó debido a renovaciones), Jerusalem, Charles Clore y Givat Aliyah.
					</p>
					<p>
						<strong>
							Horario:
						</strong>
					</p>

					<p>
						9-31 de Mayo: 07:00-17:00 <br />
						Junio: 07:00-18:00<br />
						Julio-Agosto: 07:00-19:00<br />
						Septiembre-Octubre: 07:00-17:00 <br />
						Se proporcionará inspección y limpieza en todas las playas mencionadas anteriormente, desde las 7 de la mañana hasta última hora de la tarde.
					</p>

					<p>
						<strong>
							La lista de precios de las playas es:
						</strong>
					</p>
					<p>
						Pita o pan con hummus o ensalada - 12 NIS <br />
						Botella pequeña de agua mineral - 7 NIS <br />
						Polo - 5 NIS <br />
						Tumbona reclinable (por día) - 12 NIS <br />
						Tumbona (por día) - 6 NIS <br />
						Sombrilla (por día) - 6 NIS <br />
					</p>
					
					

         `,
      };
    },
  },

  {
    id: "Modern_And_Vibrant",
    bgImage: "/posts/bank/39/1.jpg",
    mobBgImage: "/posts/bank/39/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    // vidId: "1Yx2Uht4rms",
    vidId: "V0Acsw3Hf_M",
    title: "Moderna y Vibrante",
    smltitle: "",
    html: function() {
      return {
        __html: `
                            <br/>
                            <h3>Mucho que ver en el bullicioso centro de la ciudad de Jerusalén</h3>
                
                            <p>
					El centro de Jerusalén es el corazón de esta moderna metrópolis, lleno de vida nocturna, restaurantes y opciones culturales que le permiten competir con cualquier ciudad del mundo.
					</p>
					<p>
					El área se compone de varios barrios y lugares atractivos como el encantador Nahalat Shiva, la bulliciosa Yafo Street y la calle Ben Yehuda, con su propia personalidad y atmósfera únicas que no debe perderse.
						</p>
					<p>
					El centro de Jerusalén incluye fascinantes atracciones y algunos de los barrios con más encanto de la ciudad. Para una experiencia cultural inmejorable, visite la amplia variedad de fascinantes museos de Jerusalén, incluyendo el change to ""Museo de Israel, el Museo de las Tierras de la Biblia y el Museo de Ciencias de Jerusalén.
					</p>
					<h3>
						Mercado de Machane Yehuda
					</h3>
					<p>
					Descubra la incomparable atmósfera y variedad de este mercado que atrae a miles de turistas cada día. Una vez que terminen las compras y cierren los vendedores de comida, únase a la multitud de jóvenes, tanto extranjeros como locales, que descienden al mercado para beber y divertirse hasta la madrugada, en los bares, restaurantes y callejones.
					</p>
					<h3>
						Nahalat Shiv'a
					</h3>
					<p>
					Este encantador barrio de adoquines en el corazón de la ciudad ofrece una excelente selección de tiendas, restaurantes, bares y cafés al aire libre. Nahalat Shiva es el hogar de Kikar Hamusica (Manzana de la Música), un moderno y animado espacio al aire, que ofrece música en vivo todos los días durante toda la semana.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/modern-and-vibrant/1.jpg"} class="img-responsive" />
					</div>
					<h3>
						Yemin Moshe
					</h3>
					<p>
						Este precioso barrio frente a las murallas de la Ciudad Vieja fue construido originalmente para escapar de la sobrepoblación en el siglo XIX. Hogar de artistas, escritores y académicos, Yemin Moshe es conocido por su hermoso molino de viento y sus casas de estilo oriental, sus parques verdes, su animado centro de música y sus impresionantes vistas.
						</p>
					<h3>
						Ein Kerem
					</h3>
					<p>
					Ubicado en un tranquilo valle, entre las montañas y las colinas en terrazas al suroeste de Jerusalén, Ein Kerem es uno de los barrios más pintorescos de Jerusalén. Con sus sinuosas calles empedradas, sus encantadoras casas de piedra adornadas con arcos, iglesias cuyas campanas repican en al aire, Ein Kerem irradia encanto y belleza como una isla en un mar de bosque verde.
					</p>
					
					

         `,
      };
    },
  },

  {
    id: "New_And_OLd_Jerusalem",
    bgImage: "/posts/bank/39/1.jpg",
    mobBgImage: "/posts/bank/39/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "JxSjC2kZfvI",
    title: "NUEVO Y ANTIGUO JERUSALÉN",
    smltitle: "",
    html: function() {
      return {
        __html: `
                            
					
					<p>Jerusalén es una invitación abierta a un viaje que no olvidará. Suba las montañas, entre en la ciudad y sienta la mezcla única entre pasado y presente, lo ordinario y extraordinario. Una de las ciudades más antiguas del mundo, sagrada para judíos, cristianos y musulmanes, Jerusalén ofrece una experiencia sensorial y espiritual inigualable.</p>
					<p><strong>Entre</strong>. El corazón de la ciudad más sagrada en el judaísmo es la Ciudad Vieja. Entre a través de la histórica<em> puerta de Jaffa</em>, o por <em>la puerta de Zion</em> que conduce directa <strong>al barrio judío</strong>, uno de los cuatro barrios de la ciudad amurallada y hogar de los judíos casi ininterrumpidamente desde&nbsp;el siglo VIII a.C. Maravíllese a través de los callejones, vea la gente, visite el <strong>Cardo</strong>, antigua calle principal de Jerusalén y absorba el ambiente único. Está caminando tras los pasos de reyes y profetas - No es cosa ordinaria.</p>
					<h3>Sea testigo de cómo la historia cobra vida y sienta la energía espiritual profunda dentro de los muros</h3>
					<p><strong>Lo que está por venir</strong>. El último segmento restante de las antiguas murallas que rodearon el Segundo Templo, <strong>el Muro Occidental</strong>, es un símbolo de los anhelos judíos por su patria ancestral y espiritual. Cada judío que no está en Jerusalén reza en dirección al lugar donde está ahora, el lugar donde, según el judaísmo, Dios reside. No importa cuáles sean sus creencias, es una experiencia de humildad. Honrar el espíritu del sitio y colocar una nota en la pared con una oración o un deseo.</p>
					<h3>Lo que hay debajo</strong>. Jerusalén está literalmente cubierta de capas de historia y la historia conmovedora obtiene un nuevo significado aquí.</p>
					<p>Haga el fascinante tour de <strong>los Túneles del Muro Occidental</strong> y descubra sus secciones ocultas. La historia cobrará vida a medida que avance por los pasajes subterráneos, averigüe cómo era la vida en Jerusalén durante la era del Segundo Templo y aprenda sobre el arte, la arquitectura y las técnicas de construcción.</p>
					<p>Visite el sitio arqueológico cercano, la <strong>Ciudad de David</strong> y aprenda más sobre la historia de la ciudad. El Rey David la declaró como la capital unificada de las 12 tribus de Israel hace 3000 años. Haga un viaje entre los muros y fortalezas antiguas, fuentes ocultas donde reyes fueron coronados y sigua el camino de los residentes que huyeron de Jerusalén después de que la ciudad fuera conquistada por los romanos.</p>
					<h3>Maravíllese de la impresionante vista y siéntase en la cima del mundo</h3>
					<p><strong>Lo que está por encima</strong>. Originalmente construidas para proteger la ciudad contra los intrusos, Jerusalén está rodeada de murallas. Hoy <strong>las murallas de Jerusalén</strong> ofrecen una oportunidad para explorar la ciudad desde un ángulo diferente. Escuche las historias, vea la ciudad subterránea y disfrute de toda esta belleza.</p>
					<p>Está empezando a alcanzar la superficie.</p>

         `,
      };
    },
  },

  {
    id: "Humus_In_Jerusalem",
    bgImage: "/posts/bank/humus-in-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/humus-in-jerusalem/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    title: "EL MEJOR HUMUS DE JERUSALÉN",
    smltitle: "",
    html: function() {
      return {
        __html: `
                        
					<p>
					¿Cómo prefieres el hummus?<br/>
						Hay dos certezas al visitar Jerusalén: comerá hummus y docenas de locales lo intentarán convencer que solo ellos saben dónde se come el mejor hummus de la ciudad. El aire de autoridad con el que se hacen estas recomendaciones, tales como “Le doy mi palabra que en mi familia preparan (¿o se refiere a comen?) hummus desde hace siete generaciones”, puede resultar confuso, en especial cuando dos personas parecen abogar por el mismo establecimiento.<br/>
                        Permítanos ayudarle, porque nosotros de verdad conocemos los mejores lugares de Jerusalén que ofrecen este plato tan importante de. Ahora en serio, los siguientes son (algunos) de los mejores lugares de Jerusalén para comer hummus.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/humus-in-jerusalem/2.jpg"} class="img-responsive" />
					</div>
					<p>
						Para aquellos que no están seguros de qué comida se trata exactamente, el hummus es un plato para mojar – sus orígenes se debaten vehementemente pero por lo general se acepta que su origen proviene de algún lugar de Oriente Medio – hecho de garbanzos cocidos y finamente triturados, mezclado con tahina (en hebreo – tejina, una especie de mantequilla de semillas de sésamo), aceite de oliva, zumo de limón, sal y ajo. Se ofrece como plato de entrada en todos los restaurantes de Oriente Medio, donde los comensales mojan pan de pita en la mezcla. Sumergir el pan de pita en la mezcla es una parte importante de la experiencia de comer hummus.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/humus-in-jerusalem/3.jpg"} class="img-responsive" />
					</div>
					<h3>
						AZURA, LA ZONA IRAQUÍ DEL MERCADO MAHANÉ YEHUDA
					</h3>
					<p>
						 Hay muchas razones para visitar el mercado Mahané Yehuda y Azura es una de ellas. Ubicado en la zona iraquí del mercado, Azura es un muy buen lugar para probar hummus y comidas de Oriente Medio, tales como sopa y guisados de carne.
					</p>
					<h3>
						LINA, BARRIO CRISTIANO EN LA CIUDAD VIEJA DE JERUSALÉN
					</h3>
					<p>
						Alguno de los mejores lugares de hummus se encuentran dentro y en los alrededores de la Ciudad Vieja. Vaya al barrio cristiano a probar uno de los mejores restaurantes de hummus de Jerusalén. Lina, que ofrece un menú enfocado en el hummus, se encuentra cerca de la estación 8 de la Vía Dolorosa. Sirve un cierto número de variaciones del plato tradicional, como hummus con piñones, hummus con judías y hummus con huevo duro.
					</p>
					<h3>
						 HUMMUS ACRAMAWI, BARRIO MUSULMÁN EN LA CIUDAD VIEJA
					</h3>
					<p>
						 Hummus Acramawi, frente a la Puerta de Damasco en la Ciudad Vieja, es otro lugar que goza del afecto del público y es bien conocido tanto por su atmósfera auténtica como por su excelente hummus. Fundado en 1952, Acramawi perfeccionó su producto durante décadas.
					</p>
					<h3>
						HUMMUS BEN SIRA, CENTRO DE LA CIUDAD CERCA DEL HOTEL MAMILLA
					</h3>
					<p>
						Uno de los pocos restaurantes de hummus con insomnio, permanece abierto hasta primeras horas de la madrugada. Hummus Ben Sirá es el lugar perfecto para los que están de fiesta y algo hambrientos después de disfrutar en los bares y clubes cercanos o para turistas que desean salir del hotel a altas horas de la noche.
					</p>

					<h3>
						ABU SHUKRI, BARRIO MUSULMÁN EN LA CIUDAD VIEJA
					</h3>
					<p>
						 Abu Shukri es un pequeño restaurante familiar en el barrio musulmán. Además del hummus ofrecen bolas de falafel y ensaladas. Abu Shukri no se encuentra en la zona lujosa de la ciudad, pero ofrece un asiento para escapar del calor (o del frío). Sentarse en Abu Shukri después de deambular por las callejuelas de la Ciudad Vieja es una experiencia relajante y refrescante.
					</p>
					<p>
					 PARA MÁS INFORMACIÓN: <a target="_blank" href="//www.itraveljerusalem.com/articles/best-hummus/#sthash.fza0m1xK.dpuf">http://www.itraveljerusalem.com/articles/best-hummus/#sthash.fza0m1xK.dpuf</a>
					</p>
					
					
					

         `,
      };
    },
  },

  {
    id: "Jerusalem_After_Dark_Fun",
    bgImage: "/posts/bank/modern-and-vibrant/1.jpg",
    mobBgImage: "/posts/bank/modern-and-vibrant/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    title: "After Dark Fun in the Holy City",
    smltitle: "",
    html: function() {
      return {
        __html: `

                

					

					            <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
                              <p>To check it out, make your way to the City Center and explore the narrow streets just off Jaffa Street. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. Rivlin Street is a popular hangout for young people, while Shoshan Street and the surrounding area offers a more laid-back grown up vibe.</p>
                              <div class="img-wrapper">
						          <img src=${getImgUrl() +
                        "/posts/modern-and-vibrant/1.jpg"} class="img-responsive" />
					          </div>
                              <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing. </p>
                              <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session. </p>
                              <p>For a daytime change of pace head to the German Colony (Moshava) and, particularly, the neighborhood of Baka. Start at Beit Lechem Street where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up Emek Refaim Street or through HaMesila (Railway) Park until you reach The First Station – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>
            	

         `,
      };
    },
  },

  {
    id: "Jerusalem_Musts",
    bgImage: "/posts/bank/38/1.jpg",
    mobBgImage: "/posts/bank/38/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    // vidId: "k4OwoEk5wMw",
    vidId: "FvAWuLQEOJw",
    title: "Jerusalén “Obligados”",
    smltitle: "",
    html: function() {
      return {
        __html: `
                       <br/
				    <h3>5 mejores cosas para hacer y ver en la impresionante ciudad</2>
					
					<h3>
						Excursiones Segway
					</h3>
					<p>
					Esta forma de ver la ciudad llena de adrenalina te permitirá disfrutar de
					la belleza de Jerusalén desde una perspectiva completamente única.
					Los recorridos en Segway parten de varios puntos centrales, como el Paseo
					de Armon HaNatziv (East Talpiot), Yemin Moshe y la Ciudad Vieja, así como
					también cerca del Knesset y la zona del museo.
					</p>
					<h3>
						La Primera Estación (Hatachana)
					</h3>
					<p>
					La Primera Estación está justo en el corazón de Jerusalén, entre la
					Ciudad Vieja y el Centro de la Ciudad, entre los barrios históricos de la
					Colonia Alemana y Yemin Moshe. Es el sitio de la primera estación de tren
					en Jerusalén, que fue construida en 1892. Después de someterse a una
					renovación y conservación la Primera Estación se reabrió como un activo
					lugar de entretenimiento, abierto los siete días de la semana.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/jerusalem-must/1.jpg"} class="img-responsive" />
					</div>
					<h3>
						El Ascensor del Tiempo
					</h3>
					<p>
					Si eres un fanático de los viajes de diversión, te encantará tener tus sentidos
					al máximo con el Ascensor del Tiempo. Es una experiencia interactiva que
					lleva a sus visitantes a través de viajes fabulosos a lugares fascinantes, con
					asientos basados en el movimiento, dentro de una sala única, llena de
					efectos especiales.
					</p>
					<h3>
						El Zoológico Bíblico
					</h3>
					<p>
					Se extiende sobre 62 acres, este hermoso zoológico de dos niveles se
					centra en un gran lago artificial completo con cascadas piscinas,
					rodeado de espaciosos jardines y lugares de descanso con sombra. Para
					deleite de niños y adultos por igual, hay más de 200 especies a la vista, la
					mayoría de ellas mencionadas en la Biblia y algunas casi extintas.
					Esto no significa que los animales comunes no estén presentes, incluso
					hay pingüinos. Cerca del zoológico hay un hermoso, enorme e impresionante
					acuario, abierto para los visitantes durante el día y la noche, que muestra
					el hábitat marino del mar Mediterráneo, el Mar Rojo y más.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/jerusalem-must/2.jpg"} class="img-responsive" />
					</div>
					<h3>
						Teddy Park
					</h3>
					<p>
					Llamado así en honor a Teddy Kollek quien fue alcalde de Jerusalén entre
					1965-1995; Teddy Park es divertido, hermoso e históricamente significativo.
					El parque constituye un importante punto de encuentro entre la antigua
					y la nueva Jerusalén e incluye un estanque de los deseos, un impresionante
					reloj solar, esculturas originales, propiedades históricas restauradas y una
					fantástica atracción de fuentes. que ofrece un espectacular
					espectáculo nocturno de luz y sonido.

					</p>
					
					
					
					

         `,
      };
    },
  },

  {
    id: 16,
    bgImage: "/posts/bank/34/1.jpg",
    ctg: "eilat",
    isVid: true,
    vidId: "yXzhH92kREg",
    mobBgImage: "/posts/bank/34/M.jpg",
    title: "NEGEV MAJESTIC DESERT",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>Action adventures in the desert sun. With so much to see and do, there is never a dull moment in the Negev</h3>

					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/yXzhH92kREg/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<h3 class="negev-secondary-title">
								 The Negev Desert - Pure Magic Desert
							</h3>


							\n

                            <!--negev text-->

                            <p>
								The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.
							</p>
							<p>
								Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.
							</p>
							<p class="p-margin">
								There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.
							</p>

							<h3>
                                The Israeli desert is special for the following reasons:
                            </h3>

							<ul class="p-margin">
							    <li>
										<b>The desert is very near:</b> just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).
										Starting from November, there will be direct flights from Europe and Russia to Ovda airport including Ryanair, Wizzair, and SAS.
							    </li>
                                <li>
                                        <b>Easy to Hike and Bike:</b> There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:<br>
                                        <a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a>
                                        <a href="//www.en.aravaway.co.il " target="_blank">www.en.aravaway.co.il</a>
							    </li>
							    <li>
                                        <b>Cordial local population:</b> The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.
							    </li>
							    <li>
                                        <b>Tourists Activities:</b> Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.
							    </li>
							    <li>
                                        <b>Magnificent landscapes:</b> Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety<br>
                                        <ul>
                                        	<li>
                                        		There are spectacular sand dunes in the north.
                                        	</li>
                                        	<li>
                                        		The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.
                                        	</li>
                                        	<li>
                                        		In the east, one experiences the African desert with wide savannas and acacia trees.
                                        	</li>
                                        	<li>
                                        		To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.
                                        	</li>
                                        </ul>
                                        During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.
										Many tourists decide for to stay for 2 or 3 days in each region of the Negev.

							    </li>
							    <li>
                                        <b>The Negev is very safe to travel.</b> In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.
							    </li>
							</ul>
							<h3>
							    More information and tips for accommodation and recommendations:
							</h3>
							<p>
							   <a href="//www.negevtour.co.il/homepage/accommodation/?lang=en" target="_blank">www.negevtour.co.il</a><br>
							   <a href="https://en.aravaway.co.il/business/category/1/" target="_blank">www.en.aravaway.co.il</a>
							</p>
							<p class="p-margin">
							   <a href="//goisrael.de/taxonomy/term/85" target="_blank">Travel deals</a><br>

							</p>




                            <!--Negev - Transportations-->

							<h3>
							    NEGEV - LOCATION AND APPROACH
							</h3>
							<p class="p-margin">
							   Landing at the airports of Ovda or Eilat with the  onward journey to Mitzpe Ramon or Sde Boker:
							</p>

							<h3>
							   Public means of transportation:
							</h3>
							<p>
								Bus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p>
								Arrival at the central bus station of Mitzpe Ramon after about an hour and a half.
							</p>
							<p>
								Mondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p class="p-margin">
							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Bus service </a><br>
							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Shuttle service from Ovda Airport </a>
							</p>
							<h3>
							   Car rental in Eilat, Mitzpe Ramon and Be'erSheva:
							</h3>
							<p>
								There a multiple option in renting a car in these cities.
                                There is a choice of international and Israeli companies.

							</p>
							<p class="p-margin">
								Landing at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon

							</p>
							<h3>
							   Public means of transportation:
							</h3>
							<p>
								Bus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.
								<a href="//www1.rail.co.il/EN/Pages/Homepage.aspx" target="_blank">Train from Ben Gurion or Tel Aviv to Be'erSheva.</a>
                            </p>
                            <p>
								From Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes).
                                Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.
                            </p>
                            <p class="p-margin">
								More information about the public means of transportation is given <a href="https://www.bus.co.il/otobusimmvc?Language=en" target="_blank">here</a> or <a href="//www.egged.co.il/HomePage.aspx">here</a>
                            </p>


                             <!--NEGEV DESERT-don't miss-->








                            <h3 class="margin-h">
                                 NEGEV ROAD DISTANCES
                            </h3>
							<table>
							  <tr>
							    <th></th>
							    <th>Tel Aviv</th>
							    <th>Jerusalem</th>
							    <th>Bee'r Sheva</th>
							    <th>Eilat</th>
							  </tr>
							  <tr>
							    <td class="place-table"> <strong>Old Town <br class="show-on-mobile"> Beer Sheva</strong></td>
							    <td>113 Km</td>
							    <td>122 Km</td>
							    <td></td>
							    <td>232 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Tel Arad</strong></td>
							    <td>134 Km</td>
							    <td>144 Km</td>
							    <td>40 Km</td>
							    <td>229 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Ben-Gurion's House <br class="show-on-mobile">in Sde Boker</strong></td>
							    <td>162 Km</td>
							    <td>171 Km</td>
							    <td>49 Km</td>
							    <td>185 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Ramon Crater</strong></td>
							    <td>210 Km</td>
							    <td>192 Km</td>
							    <td>97 Km</td>
							    <td>141 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Hai Bar Wildlife <br class="show-on-mobile"> reserve Yotvata</strong></td>
							    <td>323 Km</td>
							    <td>288 Km</td>
							    <td>202 Km</td>
							    <td>35 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Timna Park</strong></td>
							    <td>330 Km</td>
							    <td>294 Km</td>
							    <td>208 Km</td>
							    <td>30 Km</td>
							  </tr>
							</table>

                            <h3>
								NEGEV DESERT - DON'T MISS
							</h3>

							 <h3>
                                Ramon Crater
                            </h3>

                            <p>
                                At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater,also known as Machtesh Ramon.
								Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.
								Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.
								The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/7.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
                                Timna Park
                            </h3>

                            <p>
                               15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions.
                               With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/9.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h2 class="title-to-play">
								CLICK TO PLAY: Timna Park - An Exhilarating Desert Adventure
							</h3>
							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/i_4QKtXIeto/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

						

                            <h3>
							    Sandboarding in the desert
							</h3>
							<p>
								An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?
							</p>
							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/1.jpg"} class="img-responsive" />
							</div>
							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/2.jpg"} class="img-responsive" />
							</div>

							<!--<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/3.jpg"} class="img-responsive" />
							</div>-->

							<h3>
							    Negev at night
							</h3>
							<p>
								The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/4.jpg"} class="img-responsive" />
							</div>

							<h3>
							    Sunrise at Masada
							</h3>
							<p>
								Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/6.jpg"} class="img-responsive" />
							</div>


							<h3>
                                NEGEV - ISRAEL’S MAJESTIC DESERT
                            </h3>
                            <h3>
                                Where Adventure and Inspiration Await
                            </h3>
                            <p>
                              An ideal destination for travelers who love adventure in the great outdoors.
							  The south of Israel is sparsely populated, but packed with fascinating sites and activities.

                            </p>
                            <p class="p-margin">
                                With amazing natural wonders and beauty, the South boasts magnificent views that are guaranteed to take your breath away, from sunrise to sunset.
								A desert but definitely not deserted, there is so much to see and do here – there are many extraordinary geological marvels, significant historical landmarks and wonderful nature reserves, where you can go hiking, cycling and camel riding, or enjoy adrenaline-charged safari rides in the desert.
								Simply put, this majestic Southern region is one of the country’s greatest assets and an absolute must on the itinerary.

                            </p>


							<h3>
                                Sde Boker
                            </h3>

                            <p class="p-margin">
                                A remarkable glance to the history of the State of Israel, Sde Boker is a Kibbutz originally established by pioneers, with the mission to settle the Negev in the early 50’s.
                                Sde Boker is renowned as the home of David Ben Gurion, Israel’s first Prime Minister whose home is now a museum open to the public.


                            </p>

                            <h3>
                                Vidor Center
                            </h3>

                            <p class="p-margin">
                                A truly unique attraction, offering a multi-sensory experience of the exceptional nature of the Arava region. Visitors to the center can discover advanced farming methods, the local flora and fauna, climate challenges, and special qualities of the soil and water of the desert.
                            </p>



                            <h3>
                                Nevatim
                            </h3>

                            <p class="p-margin">
                               A visit to Nevatim, the home to Cochin Jews, is a fascinating experience. Cochin Jews, originally from India, immigrated to Israel after the establishment of the State. Cochin Jews consider themselves as one of the most ancient Jewish communities in the world.
                               The Center for Cochin Heritage at Moshav Nevatim tells the story of this unique community.
                            </p>

                            <h3>
							   MidBurn Festival
							</h3>

							<p class="p-margin">
								Israel’s own version of the famous “Burning Man” festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.
							</p>

							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/QL3BGy2p77g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

							<br>

                            <h3>
                                The Bedouin Experience
                            </h3>

                            <p>
                               The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.
                               A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality. From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a longforgotten way of life.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/8.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
                                The Culinary Queens of Yeruham
                            </h3>

                            <p class="p-margin">
                              For a truly memorable local experience, make sure to visit the Culinary Queens of Yeruham – a unique project, in which the wonderful women of Yeroham host tourists from far and wide for an excellent traditional meal in their homes, creating an unforgettable experience of smells, colors and flavors.
                              Get to know the real life of locals through their fascinating stories, while tasting the ethnic delicacies and enjoying their amazing hospitality.

                            </p>
                            <h3>
                                The Old City of Be'er Sheva
                            </h3>

                            <p class="p-margin">
                               Said to have been founded by biblical Abraham, Be'er Sheva is one of the oldest cities in the country, with evidence of a settlement dating back thousands of years. As charming as it is historic, the old city of Be'er Sheva offers a fascinating mosaic of urban spaces, and exploring the Old City will reveal a rare wealth of unique architecture, extensive history and stories as old as time.
                            </p>
                            <h3>
                                Carasso Science Park
                            </h3>

                            <p>
                               New in the Old City of Be’er Sheva, the Carasso Science Park, spread over 4.25 acres, is the largest science park in Israel.
                               Engaging and entertaining for all ages, Carasso Science Park features an interactive museum and a scientific garden with games and hands-on activities. The park also offers ten interactive exhibitions in various fields of science including: Genetics, Communication, Microelectronics, Nuclear Energy and more.

                            </p>
                            <h3>
                                Arad
                            </h3>

                            <p class="p-margin">
                               Arad of the new millennium is a town with young spirit and rich experience. Arad and its surroundings have been blessed with beautiful landscapes, desert tranquility, and many walking trails nestled amongst untouched desert nooks, suitable for any age or style.
                               With lots of attractions and plenty of tourism sites in and around the city, Arad is the perfect starting point and your natural gate to the perfect desert vacation.

                            </p>


							<h3>
                               Yotvata Hai-Bar
                            </h3>

                            <p>
                               The Yotvata Hai-Bar Nature Reserve is the area’s largest animal breeding and reclamation center for animals before they are reintroduced into the wild. The reserve boasts wonderful attractions that are an absolute delight for animal lovers, including the predators’ center with its live predators and small desert animals, a Nocturnal animal’s observatory in dark room conditions and 12 square kilometers of ground where herds of herbivores roam free.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/10.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>


							<h3>
                               Extreme Adventures
                            </h3>

                            <p>
                               The south of Israel is a total dream destination for adventure-hungry travelers.  Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/11.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
							    Camel rides
							</h3>
							<p>
								A definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/5.jpg"} class="img-responsive" />
							</div>


                            <!--NEGEV - וPDATED TEXT SITES-->

                            <h3>
                                EVENTS IN THE NEGEV: CALENDAR
                            </h3>
						


							<div class="row-1 mounth-row">
					             <div class="mounths active">
					            <p id="myHeader1" data-div="newboxes1" onClick="toggleMounth(event)" href="">January <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths month-mid">
					            <p id="myHeader2" data-div="newboxes2" onClick="toggleMounth(event)" href="">February <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths" >
					            <p id="myHeader3" data-div="newboxes3" onClick="toggleMounth(event)" href="">May <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths month-mid">
					            <p id="myHeader1" data-div="newboxes4"onClick="toggleMounth(event)"  href="">June <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths">
					            <p id="myHeader2" data-div="newboxes5" onClick="toggleMounth(event)" href="">July <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>
					        </div>



					        <div class="row-2 mounth-row">
					          <div class="mounths" >
					            <p id="myHeader3" data-div="newboxes6" onClick="toggleMounth(event)" href="">August <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths month-mid">
					            <p id="myHeader1" data-div="newboxes7"onClick="toggleMounth(event)"  href="">October <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths">
					            <p id="myHeader2" data-div="newboxes8" onClick="toggleMounth(event)" href="">November <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths month-mid" >
					            <p id="myHeader3" data-div="newboxes9" onClick="toggleMounth(event)" href="">December <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					        </div>



					         <div class="newboxes" id="newboxes1" style="    display: block;"> <!--Jen-->
					                Round The Arava Race - The 63-kilometer bike race named after Yoni Friedman offers a breathtaking desert landscape, endless expanses of nature, the power of spirituality, serenity and serenity and a connection to an extraordinary sporting experience. The starting point and end of the race are in Moshav Hatzeva.<br>
					                <a href="https://www.arava-active.co.il/MenuDefault.aspx?id=4240" target="_blank">www.arava-active.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes2"><!--Feb-->
					                Darom Adom is an annual festival held during the Anemone flower's blossoming season in the northern Negev region. The festival offers agricultural tours, farmers' markets, and countryside lodging, as well as sports activities such as marches, race, bike tours through the red fields of the northern Negev and other activities such as artistic performances. The local tourism association "Shikma Besor" is responsible for the festival and its yearly activities.<br>
					                <a href="//daromadom.habsor.co.il/" target="_blank">www.daromadom.habsor.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes3"><!--May-->
					                The cherry festival takes place in the Yatir Forest, which is the largest forest in Israel where large orchards of orchards grow, and is a 5-minute drive from Be'er Sheva. The event includes a cherry harvest for the whole family, sweet and sour snacks, baking pita bread, sheep herding, cheese gibbon, local farmers' market, klezmer melodies, climbing wall, omega and many other activities for the whole family.<br>
					                <a href="//kinderland.co.il/events/%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%93%D7%95%D7%91%D7%93%D7%91%D7%9F-%D7%91%D7%99%D7%A2%D7%A8-2017-%D7%A7%D7%98%D7%99%D7%A3-%D7%A2%D7%A6%D7%9E%D7%99-%D7%A9%D7%9C-%D7%93%D7%91%D7%93%D7%91%D7%A0/" target="_blank">www.kinderland.co.il</a>
					        </div>

					        <div class="newboxes" id="newboxes4"><!--June-->
					                Experience the magic of Ramadan nights in Rahat - when the night becomes a day and the streets are bustling with life. Join an unforgettable tour at the most special time of the year, giving a unique glimpse into Bedouin culture in Rahat. Meet the authentic dishes, absorb the fragrances of spices and roasted coffee, discover the secrets of Rahat from local guides and enjoy street performances, Debka music and more.<br>
					                <a href="//ramadan-nights.co.il/" target="_blank">www.ramadan-nights.co.il</a><br>
					                The Cinema South Festival, initiated by the School of Sound and Screen Arts at Sapir Academic College, started in 2002 with an emphasis on student films. Within a few years, however, became the festival an international film festival that provides a central stage for Israeli cinema, international quality and radical cinema. The festival takes place every year in June for five full days in various locations throughout the northern and western Negev. This is a festival that opens its doors to anyone, free of charge. The South Cinema Festival is produced from a unique cultural agenda relevant to the place where it was created.<br>
					                <a href="//csf.sapir.ac.il/csf2017/csf.sapir.ac.il/index.html" target="_blank">www.csf.sapir.ac.il</a>
					        </div>
					        <div class="newboxes" id="newboxes5"><!--July-->
					               The International Fringe Festival Beer Sheva is a multi-disciplinary festival that crosses audiences and ages and constitutes a quality stage for the best Israeli and international artists from the fields of theater, dance, music, street art and the plastic arts. The festival is considered one of the major fringe events in Israel and the largest and leading cultural festivals in the south of the country. The festival was recently received by the EFFE (European Festivals Association) and is gaining a reputation as a prestigious event.<br>
					               <a href="https://www.iffb7.com/" target="_blank">www.iffb7.com</a>
					        </div>
					        <div class="newboxes" id="newboxes6"> <!--Aug-->
					               Negev Of Stars - Like every summer, the Earth passes through the shrapnel left behind by the comet SWIFT-TATTLE. These fragments penetrate our atmosphere and create a spectacular view of "shooting stars". During this time in the Negev celebratethe people the amazing experience of the Perseid Meters, a number of astronomical events - a joint observation of the meteor shower, observation points with elaborate telescopes, lectures and many other activities.
					        </div>
					        <div class="newboxes" id="newboxes7"><!--Oct-->
					                The Tamar Festival is a combination of the ideal Israeli soundtrack and the spectacular vista of Masada and the Dead Sea region. The extraordinary experience takes place with concerts over 4 days at various locations and at different times over 24 hours, when the audience ventures out to the country's most extraordinary sites and landscapes.<br>
					                <a href="//www.tamarfestival.com/" target="_blank">www.tamarfestival.com</a><br>
					                Desert Magic Festival - The first Bedouin festival: A variety of experiential activities for the whole family that provide an authentic glimpse into the ancient Bedouin tradition.<br>
					                <a href="//www.kesem-hamidbar.co.il/" target="_blank">www.kesem-hamidbar.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes8"><!--Nov-->
					                The Arava Film Festival is a unique event that has been going on for several years every November in the heart of the Arush Nature Reserve, adjacent to Tzukim. The films at the festival are screened in the evening and in the night, under the stars in the open air. They are the first line of international production that has been screened at world film festivals in the last year. Among the films of the festival are films for children and teenagers, as well as short films produced and filmed during the past year in the Arava. The films are screened on a giant screen and the audience can relax on a spacious and surprisingly comfortable platform, which was built especially for this purpose in the valley between the mountain cliffs of the eastern Negev.<br>
					                <a href="https://www.aravaff.co.il/" target="_blank">www.aravaff.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes9"><!--Dec-->
					                Ben-Gurion's march has been taking place for more than 20 years, at the initiative of the Ramat Negev Regional Council, following the daily sporting march of the first Prime Minister, David Ben-Gurion, during his stay in Kibbutz Sde-Boker. The march takes place on three tracks – a short track for families (7 km), a medium pathway (15 km) and a long one (22 km).<br>
					                <a href="//www.zaadatbg.org.il/" target="_blank">www.zaadatbg.org.il</a><br>
					                 Docaviv Negev - Docaviv, the Tel Aviv International Documentary Film Festival, is the largest film festival in the city of Tel Aviv, and the only festival in Israel dedicated in its entirety to documentary films. In order to expose as wide an audience as possible to documentary work, the NPO also organizes a regional festivals: Docaviv Negev, held in Yeruham, as well as dozens of documentary film screenings at cultural centers located throughout the country. Each year, Docaviv NPO awards Israel’s largest prize for an original Israeli documentary production, and alongside it, prizes for the Best International Film Award, prizes for outstanding student filmmakers, and an additional prize within the Depth of Field framework, for innovative, inspiring documentary films from around the world.<br>
					                <a href="//www.docaviv.co.il/" target="_blank">www.docaviv.co.il</a>
					        </div>




                            <a href="//graphics-lapam.org.il/clients/tayarut/negev/files/assets/basic-html/page-1.html#" target="_blank">FOR MORE IMFORMATION CLICK HERE </a>


         `,
      };
    },
  },

  {
    ctg: "telavivAndJerusalem",
    isVid: false,
    id: 41,
    bgImage: "/posts/bank/family/1.jpg",
    mobBgImage: "/posts/bank/family/M/1.jpg",
    title: "Tel Aviv y Jerusalén",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>Diversión sin parar para toda la familia.</h3>

              		<p>Viajar con niños a Tel Aviv y Jerusalén es una experiencia fantástica. Ambas ciudades, como la mayoría del país, son muy familiares y podrán encontrar numerosas atracciones sorprendentes y actividades emocionantes, de la naturaleza a la cultura, para disfrutar en familia. Vaya donde vaya, es probable que encuentre niños en las calles con sus padres, abuelos o en grupos.</p>

                               <p>Con hasta 300 días soleados al año, las hermosas playas de Tel Aviv se convierten en uno de los destinos favoritos tanto de locales como de turistas. Las playas en sí ofrecen una combinación fabulosa de sol y diversión. El paseo marítimo de Tel Aviv es un excelente lugar para que los niños puedan caminar, correr o montar en bicicleta o mini scooter, y hay muchos parques infantiles y cafés.</p>

                              <p> Para pasar un día divertido al aire libre, llévese una cesta de picnic al hermoso Parque Yarkon y disfrute de montar en bicicleta, pasear en barca o correr. Tel Aviv también ofrece multitud de prácticos museos y exhibiciones, actuaciones gratuitas, especialmente en la hermosa área del puerto de Tel Aviv, y entretenimiento al aire libre con los que la diversión está asegurada para los visitantes de todas las edades.</p>

                               <p>Una visita a Jerusalén despertará la imaginación de sus pequeños con sus pintorescas callejuelas, sus museos únicos y su fascinante historia. A la sombra de sus parques, con fuentes de agua, exhibiciones y espectáculos orientados a los niños, siempre encontrará algo para todas las edades.</p>

                               <p>Una increíble variedad de comida hará las delicias de niños y mayores por igual. Desde puestos de comida al aire libre hasta restaurantes en los que comer sentados, no faltan los lugares donde comer, y la mayoría de los restaurantes y cafés ofrecen menús infantiles a precios reducidos.</p>

                               <p>La diversión y la satisfacción están garantizadas en su visita a Tel Aviv o Jerusalén con niños, especialmente por la gran variedad de actividades que aquí les esperan. Desde animales hasta museos, parques y espectáculos, siempre hay algo emocionante que ver, escuchar o hacer para todos y cada uno, desde los más pequeños hasta los abuelos.</p>

		<div class="img-wrapper">
			<img src=${getImgUrl() + "/thingsToDo/posts/35/1.jpg"} class="img-responsive" />
		</div>
              		<h3>
                                              Tel Aviv
                              </h3>
                              <p><strong>"Luna Park": </strong>un fantástico parque de atracciones en el corazón de la ciudad que ofrece una variedad de atracciones emocionantes para toda la familia. Justo enfrente del famoso Parque Yarkon, el pulmón verde de Tel Aviv.</p>
                              <p><strong> Parque Yarkon:</strong> el tranquilo Parque Yarkon, a las afueras de la bulliciosa ciudad, ofrece hermosas y amplias zonas verdes, paseos en barca por el río o en bicicleta a lo largo de sus carriles bici, campos deportivos, y mucho más. Disfrute de un picnic con una impresionante vista de la silueta de Tel Aviv en el horizonte.</p>
                               <p><strong>Globo aerostático:</strong> tras relajarse en el magnífico Parque Yarkon, despéjese con una hermosa vista de Tel Aviv como nunca lo había visto, flote sobre el Parque Yarkon en una experiencia que es ideal tanto para viajes románticos como para la diversión familiar.</p>
                               <p><strong>Observatorio:</strong> mientras se encuentre en Azrieli, no deje de visitar el increíble observatorio ubicado en el último piso para una vista a 360° de Tel Aviv que los más pequeños no olvidarán facilmente.</p>
                               <p><strong>El Planetario:</strong> una introducción divertida a la astronomía, en la que será transportado al espacio por exhibiciones interactivas, asientos giratorios y presentaciones informativas para toda la familia.</p>
                               <p><strong>Safari:</strong> con la mayor colección de animales en el Medio Oriente, puede pasar un día maravilloso en la naturaleza a solo 15 minutos del corazón de Tel Aviv, desde donde puede echar un vistazo al resto de las impresionantes atracciones de la ciudad.</p>
                               <p><strong>HaTachana, la antigua estación de trenes de Tel Aviv:</strong> el complejo Old Train Station ofrece algo para todos y cada uno, con restaurantes, actividades para niños, galerías de arte, espectáculos callejeros e incluso un paseo en tren que hará las delicias de toda la familia.</p>
                              <p><strong> Puerto de Tel Aviv:</strong> respire la brisa marina desde el hermoso puerto deportivo, tómese algo y disfrute de las increíbles actuaciones callejeras de música, magia y más, pensadas específicamente para divertir a los más pequeños.</p>
                              <p><strong> Feria callejera Nachlat Binyamin:</strong> la mayor de este tipo en Israel, la feria es una experiencia alegre y bulliciosa de artesanía, música en vivo, actuaciones callejeras y cafés que gustará a todos</p>
                              <p><strong> Sarona:</strong> núcleo de restaurantes, cafeterías y bares de moda, el mercado cubierto es un destino popular para las parejas, grupos y familias que buscan uno de los lugares de mayor actualidad en la ciudad.</p>

                              <h3>
                                              Museos: 
                              </h3>
                              <p><strong>Museo de Arte de Tel Aviv:</strong> con una gran cantidad de colecciones, guías, actividades creativas e interactivas y juegos, el museo es un tesoro tanto para los padres como para sus hijos.</p>
                              <p><strong>Museo de Historia Natural:</strong> inaugurado en 2018, el museo de 5 plantas, con sus 3000 objetos, ofrece a los niños la posibilidad de ver de cerca las criaturas del país.</p>
                              <p><strong>Museo de la Experiencia Olímpica:</strong> disponible a través de visitas guiadas, presenta una visión interactiva de la historia del deporte en Israel por medio de divertidas exhibiciones multimedia para toda la familia.</p>
                              <p><strong>Independence Hall,</strong> el lugar de nacimiento del Estado de Israel y de la primera ciudad de habla hebrea, Tel Aviv. Un viaje fascinante a través de la change to ""historia.</p>
                               
		<div class="img-wrapper">
			<img src=${getImgUrl() + "/thingsToDo/posts/35/2.jpg"} class="img-responsive" />
		</div>
              		 <h3>
                                             Jerusalén 
                              </h3>
                              <p><strong>Ciudad de David:</strong></strong> una experiencia arqueológica inmersiva en el corazón de la antigua Jerusalén, que incluye excavaciones arqueológicas, visitas guiadas y un paseo por un túnel de agua subterráneo.</p>
                              <p><strong>Espectáculo nocturno de luz y sonido:</strong> un impresionante espectáculo, el primero de esta clase, en el que las paredes de la Ciudadela se convierten en escenario de un espectáculo nocturno que celebra los 4000 años de historia de Jerusalén a través de imágenes y sonidos.</p>
                              <p><strong>El acuario: </strong>una de las atracciones más populares de Jerusalén, inaugurado a finales de 2017, ofrece una aventura cautivadora a través de los cuatro mares de Israel que emocionará a todos, desde jóvenes hasta mayores.</p>
                              <p><strong>Time Elevator:</strong></strong> sumérjase con la realidad virtual en un viaje por la fascinante historia de Jerusalén, con asientos en movimiento y efectos especiales que sorprenderán a todos.</p>
                             <p><strong> El jardín botánico:</strong> una impresionante joya en el corazón de la ciudad, con más de 6000 especies de plantas de todo el mundo, es un lugar interesante y tranquilo para que todo el mundo disfrute.</p>
                              <p><strong>Segway Tours:</strong> adecuado para adolescentes algo más mayores y adultos, los recorridos en Segway ofrecen una experiencia inolvidable a través de áreas fascinantes, lo que le permitirá disfrutar del carácter moderno y antiguo de la ciudad.</p>
                              <p><strong>Mini Israel: </strong>ofrece cientos de mini réplicas de monumentos israelíes, una visión única a vista de pájaro de lugares históricos, religiosos y modernos de todo el país.</p>

                              <h3>
                                   Museos:
                              </h3>
                              <p><strong>Museo de Israel:</strong> un destacado museo de arte y arqueología que te sumerge en la rica historia y cultura del país y sus gentes, con exhibiciones que interesarán a visitantes de todas las edades.</p>
                              <p><strong>Museo de la Torre de David:</strong> la histórica entrada al casco antiguo de Jerusalén, la ciudadela medieval cuenta con modelos en 3D, pasadizos ocultos, y recorridos y actividades familiares.</p>
                              <p><strong>Museo Activo Ein Yael:</strong> ofrece un viaje empírico a través de una antigua calle romana, con talleres creativos, horneado de pitas y reuniones cara a cara con personajes de la época, a las familias les encantará este día.</p>
                             <p><strong> Museo de Ciencias Bloomfield:</strong> un fantástico museo cultural y educativo orientado a los niños, que presenta exposiciones y exhibiciones interactivas sobre temas de ciencia y tecnología.</p>


            	`,
      };
    },
  },

  {
    ctg: "telaviv",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    id: "Party_Capital",
    bgImage: "/posts/bank/party-capital/1.jpg",
    mobBgImage: "/posts/bank/party-capital/M.jpg",
    title: "Party Capital",
    smltitle: "",
    html: function() {
      return {
        __html: `

						<div class="ac-cradit">
							<span class="ac-cradit-text">Credits:</span>
								<br/>
								<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
								<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
							</div>
							<p></p>
						</div>

                            <h3>Epic Nights in the non stop city</h3>
              		        <p>Tel Aviv is rightly famous as one of the world’s great nightlife cities, with her warm Mediterranean climate making it ideal to party outdoors for most of the year. As the sun goes down the city transforms into a welcoming nighttime experience that’s pulsing with life.</p>

                            <h3>Tel Aviv by Night</h3>
                            <p>No matter what time it is, there’s always something going on in Tel Aviv. Watch the sun go down at a casual beach bar, feet in the warm sand and a cold drink in your hand, before moving on to taste craft brews in a packed, friendly pub, enjoy an exotic cocktail in a relaxed bar or eat something delicious before heading off to one of Tel Aviv’s pumping, pulsing clubs to dance the night away.</p>
                            
                            <p>Foodies will love the amazing cocktails mixed by Tel Aviv’s expert baristas, Israel’s lively pub scene serving craft beers and snacks, and the restaurants that range from elegant to casual to street pop-ups, offering every possible style and type of food. Eat your heart out!</p>
                            <div class="img-wrapper">
			                    <img src=${getImgUrl() +
                            "/posts/party-capital/1.jpg"} class="img-responsive" />
		                    </div>
                            <h3>Making the Most of Tel Aviv’s Nightlife</h3>
                            <p>Spend a relaxed evening in an upmarket wine bar in a trendy neighborhood like Neve Tzedek, where you’ll be introduced to some of Israel’s highly acclaimed wines. Move on to chill at one of the many bars that feature live bands, or enjoy some culture with your cocktails in one of Tel Aviv’s new and exciting gallery bars that display pieces by up and coming artists.</p>

                            <p>If you want a pumping party night on the town, Tel Aviv is the right place to find it. Tel Aviv’s nightclubs are world-famous, often hosting international DJs. During the long summer season some of the beaches transform into nightclubs for all-night raves, with throbbing beats, lasers and pulsing music. The party doesn’t reach full swing until 2am in most of Tel Aviv’s wildly popular nightclubs, manned by top DJs. You’ll find every time of club, from intimate to massive and from throwback dance to the newest electric indie beats.</p>

                            <p>The LGBTQ scene is also hot in Tel Aviv, with some of the best parties and music nights hosted by gay-friendly clubs and bars. Whether you want chilled or full-on, cultural or flirty, you’ll find countless places to hang out at every hour of the day and night.</p>
                            <p>Tel Aviv’s awesome nightlife scene has become famous worldwide. The city the doesn’t stop is teaming up with endless possibilities designed for an epic night out! </p>
                            <p>Start slow and easy in a bar at the chilled out Port of Tel Aviv, or grab yourself a shoreline table, perhaps at Jerusalem Beach. Order a beer, feel the sand between your toes, and watch the sunset.</p>
                            <p>Now that you’re in a mellow mood, it’s time to get your groove on. you’ll be spoiled for choice with upscale clubs, bracelet bars, and other hangouts around Tel Aviv’s White City, Rothschild Boulevard and nearby streets (Levontin, Yehuda HaLevi, Lillenblum, and Allenby), with their trendy see and be seen vibe, filled with young party people all night long. </p>
                            <div class="img-wrapper">
			                    <img src=${getImgUrl() +
                            "/posts/party-capital/2.jpg"} class="img-responsive" />
		                    </div>
                            <p>A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.</p>
                            <p>Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.</p>
                            <p>Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv! </p>

            	`,
      };
    },
  },

  {
    ctg: "jerusalem",
    isVid: false,
    id: "Mamilla_Avenue",
    bgImage: "/posts/bank/mamila-avenue/1.jpg",
    mobBgImage: "/posts/bank/mamila-avenue/M.jpg",
    title: "AVENIADA MAMILLA, UN PASEO POR EL ARTE",
    smltitle: "",
    isVid: true,
    // vidId: "V0Acsw3Hf_M",
    vidId: "JxSjC2kZfvI",
    html: function() {
      return {
        __html: `
                               

		                         <h3>Lujo moderno con el esplendor de la Jerusalén antigua</h3>
								<p>Justo entre la antigua y nueva Jerusalén, frente a la impresionante vista de las murallas de la Ciudad Vieja y a pocos pasos de la Puerta de Jaffa y el Muro Occidental, se encuentra la avenida Alrov Mamilla. El moderno centro comercial al aire libre, que se hizo popular entre los lugareños y turistas por su proximidad a la ciudad vieja y al reunir lo mejor de todos los mundos: rica historia, cultura local y una sofisticada experiencia de compras en una ubicación inmejorable.</p>
                                <div class="img-wrapper">
			                         <img src=${getImgUrl() +
                                 "/posts/mamila-avenue/1.jpg"} class="img-responsive" />
		                         </div>
								<h3>Descubra el moderno complejo de ocio a los pies de la Ciudad Vieja de Jerusalén</h3>
								<p>Camine por las calles adoquinadas de Jerusalén y busque las placas que cuentan la&nbsp;historia&nbsp;de las estructuras históricas de la zona. Disfrute de las actuaciones de teatro callejero, siéntese en uno de los restaurantes y cafés locales y disfrute de una mezcla de gran calidad de tiendas de diseñadores de marcas locales y líderes mundiales.</p>
								<p>Por la noche, tome asiento en uno de los excelentes bares de la zona, alce los ojos y admire la espectacular vista de la Ciudad Vieja justo enfrente. No hay otro lugar como este en el mundo.</p>
								<h3>Visite las calles que unen la Ciudad Vieja con la Nueva Jerusalén</h3>
								<p>La Avenida Mamilla es un complejo de entretenimiento contemporáneo que ofrece a sus visitantes un sabor de la rica, original y siempre innovadora cultura de Jerusalén.</p>
								<p>Para experimentar plenamente lo que la Avenida Mamilla tiene para ofrecer, la mejor época es cuando el clima es cálido. Miles de personas pasean por la avenida cada noche, con algo más de fresco, durante el verano y disfrutan de una variedad de eventos culturales. Únase a ellos y disfrute de las ferias de arte callejero, exposiciones abiertas, teatro de calle, payasos, acróbatas, bateristas y actuaciones musicales diarias. Con tanto que ver y hacer, nunca querrá irse.</p>

            	`,
      };
    },
  },

  {
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    id: "First_Time_In_Jerusalem",
    bgImage: "/posts/bank/first-time-in-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/first-time-in-jerusalem/M.jpg",
    title: "FIRST TIME IN JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>The must list for the first-time visitor</h3>

              		<p>
						Scour the globe it’s hard to match Jerusalem for history, culture, and significance! So rich in sites and activities, it’s difficult to know where to begin. Here are a few suggestions…
              		</p>
					<p>
						Jerusalem is the nexus of three of the world’s great faiths. As such, you might want to consider religious, spiritual, or historical locations that will be meaningful to you.
					</p>
					<p>
						Almost any itinerary will include Old City. Famous as the home of the Western Wall, and the Church of the Holy Sepulcher, you could spend days exploring its four quarters – Jewish, Christian, Muslim, and Armenian – and only see but a small part of its many treasures. Make sure to download the free Audio Tours of Jerusalem app, which offers dozens of walking routes, GPS maps, and geo-location alerts as you approach each site.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/first-time-in-jerusalem/1.jpg"} class="img-responsive" />
					</div>
					<p>
						A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.
					</p>
					<p>
						Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.
					</p>
					<p>
						Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!
					</p>
            	`,
      };
    },
  },

  {
    ctg: "telavivAndJerusalem",
    isVid: false,
    id: 44,
    bgImage: "/posts/bank/travelling-on-budget/1.jpg",
    mobBgImage: "/posts/bank/travelling-on-budget/M.jpg",
    title: "TRAVELLING ON A BUDGET",
    smltitle: "",
    html: function() {
      return {
        __html: `

				    <h3>Making It Count in Tel Aviv and Jerusalem!</h3>

              		<p>
						So you’ve heard of the stunning beaches, the amazing sights and the fabulous cuisine and you are looking to travel to Jerusalem and Tel Aviv, but affordability is a concern. Well, pack your bags and worry no more! Both cities offer low-cost accommodations, transportation, and meals, as well as countless sites to see and things to do, which require little or no expense.
              		</p>
					<p>
						For affordable accommodation you can choose from the many hostels and smaller hotels, many of which are located only a few minutes’ walk from Tel Aviv’s Beaches and Jerusalem’s main attractions.
					</p>
					<p>
						Getting around? In both cities it’s a snap with a Rav Kav card. Purchase one for little more than a dollar at”Al Hakav” (on the line) Service centers at central stations and other locations around the city. Jerusalem also offers an affordable City Pass option, and in Tel Aviv, the Tel Ofan bicycle rental municipal service is a great and low cost way to get around in the city.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/80/1.jpg"} class="img-responsive" />
					</div>
					<p>
						What to do? Jerusalem and Tel Aviv are packed with sites, marketplaces, parks, nearby nature reserves and hiking trails. There are endless ways to not spend a dime and fill your trip with unforgettable experiences.
					</p>
					<p>
						Finally, everyone’s gotta eat, from hummus to gourmet, both cities are famous for great street food and low-price restaurants offering cheap lunch time dining.
					</p>
					<p>
						So come visit Tel Aviv and Jerusalem where you are guaranteed a fantastic time without breaking the bank.
					</p>
            	`,
      };
    },
  },

  {
    ctg: "jerusalem",
    isVid: false,
    id: 45,
    bgImage: "/posts/bank/upscale-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/upscale-jerusalem/M.jpg",
    title: "UPSCALE JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h3>Modern luxuries for the pampered traveler</h3>
              		<p>
						When it comes to luxury travel, high class accommodations, fine dining, and top-drawer shopping options Jerusalem is a city that’s truly arrived.
              		</p>
					<p>
						The city features numerous 5-star and boutique hotels ready to custom cater to your needs for comfort and relaxation, offering amazing rooftop views and inhouse spa treatments to boot.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/81/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Looking to delight your palette? Well, in 2018, several Jerusalem establishments were listed in the prestige French restaurant guide, Gault & Millau. Beyond that, the city features and is increasingly attracting some of the world’s best chefs.
					</p>
					<p>
						When it comes to style, fashion, and swanky shopping, Jerusalem has any number of places you’ll want to visit. Among these are Arlov Mamilla Avenue. This happening and trendy outdoor mall complex is a must for your go-to city destinations. Even better, it’s situated just steps away from the Old City’s Jaffa Gate.
					</p>
					<p>
						Another not-to-be-missed stop on your itinerary is the elegant The First Station. For over 100 years a railway depot, the site has been transformed into an urban shopping and culinary mecca that’s chock-a-block with restaurants, shops, art galleries and an artists’ marketplace three days a week, as well as live performances and more.
					</p>
					<p>
						And as long as you’re in the neighborhood, treat yourself to a romantic afternoon or evening on Emek Refaim Street, the German Colony’s main thoroughfare. Its beguiling architecture laid back mood, stylish boutiques, intimate restaurants, and 1920s-era cinema offer an absolute treat for all the senses.
					</p>
            	`,
      };
    },
  },

  // End Posts

  {
    id: 5,

    ctg: "deadsea",
    isVid: false,
    bgImage: "posts/bank/100/1.jpg",
    mobBgImage: "posts/bank/100/M.jpg",
    title: "Dead Sea Joys",
    smlTitle: "",
    html: function() {
      return {
        __html: `
					<h3>For a floating good time</h3>

			              <p>
			                              A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. 
			                              Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. 
			                              <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, 
			                              allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. 
			                              While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
			              </p>

			              <p>
			                              Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
			              </p>
			              
			`,
      };
    },
  },

  // No translation, Hadar asked to hide this post
  // {
  // 	id:"Ultimate_Beach_Fun",
  //                bgImage : "/posts/bank/17/1.jpg",
  //         	mobBgImage : "/posts/bank/17/M.jpg",
  //               title : "ULTIMATE BEACH FUN",
  //               ctg:"telaviv",
  //               isVid:true,
  //               vidId:"I9a4BFWO_6w",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //             		<p>Israel has a wide selection of beaches to choose from. The wide Mediterranean stretch along the west side of the country boasts wide golden sands and the gorgeous blue waves of the med.</p>

  //         		 	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/24/1.jpg"} class="img-responsive" />

  // 					</div>

  //             		<p>Up North the Sea of Galilee have some lovely beaches where you can camp out, barbeque and really make a day of it. The Galilee offer boat hire and water sport equipment for some water fun!</p>

  //             	 `
  //     }
  //   }
  // },
  // End No translation, Hadar asked to hide this post

  {
    id: "Purchases_In_Israel",
    bgImage: "/posts/bank/purches-in-israel/1.jpg",
    mobBgImage: "/posts/bank/purches-in-israel/M.jpg",
    title: "COMPRAS EN ISRAEL",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
              
              
                                   
                                <p>Ir de compras en Israel es algo más que adquirir cosas. Se convierte en la mejor manera de pensar en sus seres queridos y amigos en casa, porque les traerá (y para usted también) un bolso, una botella o una caja que simboliza las maravillas que vivió. A medida que avanza a través de los mercados, tiendas y galerías, verá la increíble variedad de productos y seguro que encontrará algo para todos y se divertirá al mismo tiempo.</p>
								<h3>Hermosos souvenirs de Oriente Medio</h3>
								<p>Algunos de los recuerdos más significativos le están esperando en los lugares santos de Israel en Galilea y Jerusalén. Los llamativos artículos de cerámica armenia en azul y blanco adornados con temas familiares de los lugares sagrados son populares como recuerdos y útiles como platos para la mesa. Madera de olivo y nácar, artesanías que recrean siglos de antigüedad, ahora adornan biblias, cajas, broches y muchos otros elementos que mantendrán su visita fresca en su mente y corazón.</p>
								<h3>Judaica única</h3>
								<p>¡Qué mejor manera de recordar Safed, Jerusalén, Jaffa u otros centros judaicos que adornar una mesa de Sabbath y de fiestas que&nbsp; una cobertura bordada a mano para Challah o matzah (¡ligera y fácil de guardar en la maleta!) o candelabros,&nbsp; una copa de kiddush o una menorah de Chanukkah en plata contemporánea o tradicional, estaño, vidrio o cerámica. Las mezuzahs son el regalo perfecto para una fiesta de inauguración de una casa, y un manto de oración (talit) es un recuerdo de Bar / Bat Mitzvah para toda la vida.</p>
								<div class="img-wrapper">
						               <img src=${getImgUrl() +
                             "/posts/purches-in-israel/1.jpg"} class="img-responsive" />
						
					               </div>
								<h3>Cosmética y Productos minerales del mar Muerto</h3>
								<p>Israel es el hogar del spa al aire libre más grande del mundo - el mar Muerto - y después de bañarse en su agua rica en minerales, su piel y su cabello tendrán una suavidad incomparable. Y sí, efectivamente, ¡lo comercializan! Puede comprar una gama entera de productos realizados en base a los minerales del mar Muerto, embalados maravillosamente.&nbsp; Son el regalo perfecto de Israel.</p>
								<h3>Compras</h3>
								<p>Seguramente querrá curiosear por las tiendas&nbsp;o boutiques de diseñadores de ropa israelíes en su estancia en Israel. Ropa de bebé 100% algodón también es fácil de meter en su maleta como regalo. ¿Ha caminado por Israel? Antes de que su viaje termine, compre un par de sandalias o zapatos hechos en Israel.</p>
								<h3>Joyería</h3>
								<p>Los diseñadores de joyería israelíes se encuentran en las mejores tiendas de todo el mundo y cuando usted compra en Israel está en el lugar de origen. Particularmente, son atractivos los brazaletes de moda con sus cristales multicolores y abalorios con diseños interminables, así como las creaciones en malaquita fina verde-azul (piedra de Eilat) y así todos sabrán que estuvo en Israel cuando se lo ponga.</p>
								<p>Israel ha sido durante mucho tiempo famoso por el tallado y pulido de sus diamantes y la experiencia, el conocimiento y la habilidad de sus expertos en diamantes es única. Como un país exportador de diamantes, comprar en Israel a menudo goza de la ventaja de un precio reducido. También puede visitar una instalación de tallado y pulido de diamantes para aprender todo sobre la industria.</p>
								<h3>No se olvide de la comida</h3>
								<p>En un país famoso por su cocina de los cuatro rincones de la tierra, los productos alimenticios envasados&nbsp; son ideales para llevar a casa. Hay especias como el hisopo bíblico para su cocinero favorito y dátiles dulces bien envasados para ofrecer en su oficina o club de lectura, y una variedad de tés de hierbas, miel, premiados vinos y otros productos.</p>
								<p>Y cuando usted y sus regalos lleguen al aeropuerto, le encantará el incentivo especial de reembolso de Impuestos al valor añadido en compras de más de $ 100 en las tiendas participantes.</p>
								            	
            	 `,
      };
    },
  },

  // {
  // 	id:"Jerusalem_Fun",
  //                bgImage : "/posts/bank/jerusalem-fun/1.jpg",
  //         	mobBgImage : "/posts/bank/jerusalem-fun/M.jpg",
  //               title : "JERUSALEM FUN",
  //               ctg:"jerusalem",
  //               isVid:true,
  //               vidId: "nLKWDp5uA-U",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                                <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
  //                                 <div class="img-wrapper">
  // 						               <img src=${getImgUrl() +  "/posts/jerusalem-fun/1.jpg"} class="img-responsive" />

  // 					               </div>
  //                                  <p>To check it out, make your way to the <b>City Center</b> and explore the narrow streets just off <b>Jaffa Street</b>. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. <b>Rivlin Street</b> is a popular hangout for young people, while <b>Shoshan Street</b> and the surrounding area offers a more laid-back grown up vibe.</p>

  //                                  <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing.</p>
  //                                  <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session.</p>

  //                                  <p>For a daytime change of pace head to the <b>German Colony (Moshava)</b> and, particularly, the neighborhood of <b>Baka</b>. Start at <b>Beit Lechem Street</b> where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up <b>Emek Refaim Street</b> or through <b>HaMesila (Railway) Park</b> until you reach The <b>First Station</b> – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>

  //             	 `
  //     }
  //   }
  // },

  {
    id: "Western_Wall_Wonders",
    bgImage: "/posts/bank/30/1.jpg",
    mobBgImage: "/posts/bank/30/M.jpg",
    title: "WESTERN WALL WONDERS",
    ctg: "jerusalem",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
              

				<p>
					The Western Wall (or Kotel, in Hebrew) was part of the most magnificent building Jerusalem had ever seen, which was the Second Temple, built by the great King Herod.
				</p>

				<p>
					The Second Temple was destroyed in the year 70 CE and despite the destruction that took place, all four of the Temple Mount support walls remained standing.  Throughout the generations since the Temple’s destruction, the Western Wall was the remnant closest to the site of the Temple’s ‘holies of holies - a place where only the Jewish High Priests were allowed, as it was there they believed God was present.  The actual remains of the Temple can be found the Western Wall Tunnels, which are an extraordinary journey through time.
				</p>
				
             	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/27/1.jpg"} class="img-responsive" />
				</div>

				<p>
					For centuries Jewish People from around the world have been going there to mourn the loss of this grand temple. You will often find hundreds of people of different nationalities and religions’ pouring out their heart with prayers as the wall is believed to have enormous spiritual significance. 
				</p>

				<p>
					It is tradition for the people that visit to write a note and place it in the cracks of the Western Wall, as it is believed the message will be taken to God. You will often find doves resting in the crevices of this impressive structure, which are a symbol of peace.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/27/2.jpg"} class="img-responsive" />
				</div>

				<p>
					The Western Wall is a national symbol as the ancient bricks have seen Israel and the Jewish peoples  birth, exile and redemption. It’s a very popular location for national ceremonies and even Bar Mitzvah to take place
				</p>
				<p>
					For more information   <a  target="_blank" href="//www.thekotel.org">www.thekotel.org</a>
				</p>
                
            	 `,
      };
    },
  },

  {
    id: 28,
    bgImage: "/posts/bank/white-city-splendor/1.jpg",
    mobBgImage: "/posts/bank/white-city-splendor/M.jpg",
    title: "WHITE CITY SPLENDOR",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
              
				

				<p>
					Tel Aviv’s “WHITE CITY” is a UNESCO World Heritage Site, because the city is home to more Bauhaus, modern and “International” architecture than any city on earth.
				</p>

				
				
             	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/28/1.jpg"} class="img-responsive" />
				</div>

				<p>
					Tel Aviv was founded in 1909 as a garden suburb of the crowded port city of Jaffa. Very quickly it grew into a bustling metropolis so that by 1929, it was a flourishing city that was the apex of the Zionist dream. With the rise to power of Hitler in 1933, dozens of German Jewish architects escaped to Palestine – many of whom were students or graduates of the legendary Bauhaus school of design. The burgeoning of Tel Aviv required more and more buildings, and the arriving architects very quickly adapted their northern European Bauhaus design to the needs of the eastern Mediterranean heat. A walk through central Tel Aviv will bring you face to face with dozens of these extraordinary office buildings, apartment buildings and stores.
				</p>

				<p>
					<a  target="_blank" href="//www.bauhaus-center.com/">www.bauhaus-center.com/</a>
				</p>
                
            	 `,
      };
    },
  },

  {
    id: "Tower_Of_David_Museum",
    bgImage: "/posts/bank/30/1.jpg",
    mobBgImage: "/posts/bank/30/M.jpg",
    title: "TOWER OF DAVID MUSEUM",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
            

				<p>
					Jerusalem’s Citadel, known as the “Tower of David”, is a historical and archaeological asset of international significance. The Tower is a medieval fortress that is located near the Jaffa Gate, the historical entrance to the Old City and has been the symbol for the city of Jerusalem for generations.
				</p>

				
				
             	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/1.jpg"} class="img-responsive" />
				</div>

				<p>
					At the Tower of David Museum you are presented with Jerusalem’s astounding story. While absorbing yourself in legends of the past and their dramatic chronicles it will not take you long to realise that the very stones of the museum are part of this city’s living history.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/2.jpg"} class="img-responsive" />
				</div>


				<p>
					The 500-year-old walls are part of the Turkish citadel; its name derives from a tower so massive that early Jerusalemites ascribed it to their great King David and despite the name being ‘The Tower of David’ it was actually build by King Herod.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/3.jpg"} class="img-responsive" />
				</div>

				<p>
					Your visit can begin with a breath-taking view of old and new Jerusalem from the top of the tower. Each ancient room has been revamped to showcase a different period, allowing the tempestuous events of 4,000 years to fall perfectly into place in your mind.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
				</div>

				<p>
					The windows frame glimpses of modern Jerusalem, and with each doorway you exit, you look down into the citadel’s central courtyard, where archaeologists have unearthed remains dating from the Maccabees to the Middle Ages. This incredible site really is a maze of time!
				</p>

				<p>
					The museum also utilizes its unique space for multi-sensory exhibits by leading designers and artists from Israel and abroad. This One of a kind museum hosts the annual ‘Night Spectacular’ which is a unique sound and light show where the whole of the Citadel is lit up with stunning designs!
				</p>

				<p>
					For more information:   <a href="//www.tod.org.il/en/">www.tod.org.il/en/</a>

				</p>
                
            	 `,
      };
    },
  },

  {
    id: "Must_Eat_In_Jerusalem",
    bgImage: "/posts/bank/must-in-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/must-in-jerusalem/M.jpg",
    title: "Qué debe probar en Jerusalén",
    ctg: "jerusalem",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smltitle: "",
    html: function() {
      return {
        __html: `
            
                               <p>Jerusalén es una ciudad fascinante y mágica. Muchas personas que visitan Jerusalén alaban su sorprendente atmósfera, sus lugares inolvidables, sus impactantes vistas y mucho más. Sin embargo, para entender realmente de qué trata Jerusalén, hay algunas cosas que sencillamente tendrá que experimentar a través de su estómago. Aquí tiene algunas de las cosas que debería probar durante su visita:</p>
                    
                               <div class="img-wrapper">
						                 <img src=${getImgUrl() +
                               "/posts/must-in-jerusalem/1.jpg"} class="img-responsive" />
				                 </div>

							    <p><strong>Malabi:</strong> una combinación única de bebida y postre, una mezcla a base de agua de rosas, leche, harina de maíz y azúcar. El Malabi es un plato muy popular de Jerusalén, que se vende en muchos restaurantes y kioscos de Oriente Medio por toda la ciudad. Le garantizamos que no ha probado nunca nada parecido.</p>
                                <p><strong>Knafe:</strong> un plato muy interesante y con un sabor sensacional cuando se sirve y come fresco. El Knafe es esencialmente un postre árabe hecho de queso de cabra fundido y cubierto con hilos de pasta de naranja, bañado en sirope de agua de rosas dulce. Encontrar el Knafe perfecto es una misión, y una vez que lo encuentre, comerlo se convertirá en una adicción.</p>
                                <p><strong>Pretzel de Jerusalén:</strong> cuando recorra los fascinantes lugares de la Ciudad Vieja no olvide parar en uno de los carritos verdes y comprar un auténtico pretzel de Jerusalén. Junto con este, obtendrá una hierba verde local aromática llamada Zaatar que combina muy bien con la deliciosa masa.</p>
                                <p><strong>Meorav Yerushalmi:</strong> se traduce literalmente como "Jerusalén mixto". Esta deliciosa mezcla de varias carnes con una combinación local de especias única es una delicia total para los carnívoros.</p>
                                <p><strong>Ashtanur:</strong> abreviatura en hebreo de "fuego en el horno", el Ashtanur es un auténtico pan de pita local que podrá encontrar en el centro de la ciudad o en los mercados durante el almuerzo. Si está especialmente hambriento, pruébelo con shawarma o falafel.</p>
                                <p><strong>Sabij:</strong> absolutamente original, el Sabij es un plato local verdaderamente único compuesto por un pan de pita relleno de berenjena frita, huevos duros y pepinillos, generalmente cubierto por Amba, un sabroso condimento local. Una vez que lo pruebe, se enganchará de por vida.</p>

                
            	 `,
      };
    },
  },

  {
    id: "Jerusalem_Arts",
    bgImage: "/posts/bank/jerusalem-art/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-art/M.jpg",
    title: "JERUSALEM’S ART",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
            
                                <h3>Finding Inspiration in Jerusalem</h3>

                                <p>There's no doubt Jerusalem is one of the most fascinating cities in the world. Its fusion of diverse religions, traditions, ancient history and modern city life intrigues visitors for centuries. It's also what attracts artists there. Today's Jerusalem is full of Museums, galleries, marketplaces and cultural festivals, which together form a vivid and unique Art and Culture scene. Prepare to be inspired.</p>

                                <p>Discover. On a hill next to the Knesset and Israel's Supreme Court, situated Israel's largest cultural institution and one of the world's leading museums in art and archeology, The Israel Museum. Start with the archeological wing. Organized chronologically, the pieces there form the most extensive collection in the world for biblical and Holy Land archeology. Continue to the outstanding Jewish Art and Life wing, the impressive Fine Arts collection and the rotating contemporary art exhibitions. Don't miss few of the museum's highlights – The Shrine of The Book which holds the Dead Sea Scrolls and the stunning Art Garden looking over the Jerusalem Mountains. Tip: Give yourself time. It's an accessible, fascinating museum and there's so much to see.</p>
                                <div class="img-wrapper">
						                <img src=${getImgUrl() +
                              "/posts/jerusalem-art/1.jpg"} class="img-responsive" />
				                </div>
							    <small style="color:#000; display:block;">
                      		        Credit: Noam Chen
                      	        </small>

								<p>In close proximity to the Israel Museum you'll find the riveting <strong>Bible Lands Museum</strong>. Describes as "an interactive time capsule", it's the only museum of its kind in the world. Tour through the galleries and discover the wonders of the lives of ancient cultures in the Near East and their interrelations from the dawn on of civilization to the early Christian era.</p>

                                <h3>Experience</strong>. Go to <strong>The Artists' Colony of Jerusalem</strong> (Hutzot Hayotzer) and experience creativity. This Art and Craft complex is a workplace for artists and designers from various fields. Stroll down this picturesque boulevard of shops and galleries underneath the northern walls of the Old City and see artists at work. Hear stories, learn about traditional and more contemporary art techniques and purchase works directly from the artists.</p>

                                <p>See the <strong>Tower of David Light Show</strong>, known as the Jerusalem Night Spectacular. This truly stunning show combines modern technology with the city's history and the beauty of the Tower. You'll witness the walls and walkways comes alive with a 3D light show and vibrant music that pulls the viewer into an almost dreamlike experience.</p>

                                <h3>Celebrate</strong>. Jerusalem has rich history but it's also a bustling modern city that loves to celebrate. Make sure to check the city's rich schedule of festival and cultural events and enjoy of the best Jerusalem has to offer throughout the year.</p>

                                <p>Celebrate <strong>The Israel Festival</strong>, Israel's prominent multidisciplinary international festival that presents a large variety of outstanding theatre, contemporary dance, classical music and performance from all around the world. Join the Jerusalem Arts and Craft fair Hutzot Hayotzer where you'll meet Israeli and international artists and listen to great music; visit Jerusalem Night Market and stroll through the many stalls set by all types of artists and designers, showing off and selling their wares; Experience the Light in Jerusalem Festivalthat provides a dramatic unique and artistic dimension to the old city through use of light; listen to opera in the Jerusalem Opera Festival. Set in the Sultan pool, you'll watch great performance with the great Jerusalem night summer air and stunning view as a backdrop.</p>

                                <p>Don't miss the Jerusalem Sacred Music Festival. As part of the Jerusalem Season of Culture, this extraordinary festival brings together diverse artists from huge array of fields, cultures and traditions that show and explore 'sacred' music from all around the world.</p>
            	
                
            	 `,
      };
    },
  },

  {
    id: "All_Sensory_Markets",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    title: "ALL SENSORY MARKETS",
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            

				<p>
					For a genuine Middle Eastern experience you can’t beat a visit to one of Israel’s many markets (Shuks).  The different colours, textures, smells, tastes and sounds of these hives of activity can be a highlight of any Israel visit.  
				</p>

				<p>
					These markets are a melting pot of cultures and a great place to give your bartering skills a go. Through the winding cobbled streets you will find, fresh produce, souvenirs, art and handmade jewellery…the list is endless. Bring home a gift for your friends and family or just enjoy walking around and tasting different flavours.
				</p>
				
				
             	<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/1.jpg"} class="img-responsive" />
				</div>

				<h3>
					Tel Aviv
				</h3>
				<p>
					The Carmel Market, or Shuk HaCarmel, is the most famous of all Tel Aviv’s marketplaces. In recent years, it’s even joined the ranks of Tel Aviv’s trendy spots for bars, restaurants, coffee shops and chef-owned food stalls. It’s no wonder Shuk HaCarmel is Tel Aviv’s largest and most-centrally located shuk: From hand-made Jachnun, a traditional Yemenite dish, to boutique cheeses, and from one-off cotton clothes to designer threads, HaCarmel has it all. Plan your visit around your tastebuds and food preferences - salted fish, cured meats, Middle Eastern fare, fresh baked French pastries, and local-roasted coffee or fresh-pressed fruit or vegetable juice blends to wash it all down.
				</p>

				<p>
					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
						www.shuktlv.co.il/en/category/carmel-market
					</a>
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/2.jpg"} class="img-responsive" />
				</div>

				<p>
					Nachlat Binyamin arts and crafts fair was established in 1988. It is the oldest and biggest of its kind in Israel, and one of the nicest in the world. The market is home to over two hundred artists who use materials such as wood, glass, fabric, plastic, paper…even rocks (almost anything) to hand-make what they sell on their stall. 
				</p>

				<p>
					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
						www.shuktlv.co.il/en/category/carmel-market
					</a>
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/3.jpg"} class="img-responsive" />
				</div>
				<h3>
					Jerusalem
				</h3>

				<p>
					The Machane Yehuda market is widely recognized as a symbol of the Jerusalem, and for a very good reason: Jerusalemites see it as a place that represents them, symbolizes them, and gives them a unique identity in a larger Israeli social context. Jerusalem today has many shopping and entertainment centres, but there is something about the Machane Yehuda market that attracts people, even without a shopping list.  From the heady scent of spices to the colourful displays of fruits and vegetables, a trip to this market is pleasing for all your senses.
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
				</div>

				<p>
					One option of experiencing this market is by buying a ‘Machane Yehuda Bites Card’.  This card is comprised of vouchers curated in order to give you a chance to try a variety of products, flavours and the aromas of the market - without having to depend on an organized group or tour.  For more information please click here: 
				</p>

				<p>
					<a target="_blank" href="//www.machne.co.il/en/">
						http://www.machne.co.il/en/
					</a>
				</p>
				
                
            	 `,
      };
    },
  },

  {
    id: 31,
    bgImage: "/posts/bank/20/1.jpg",
    mobBgImage: "/posts/bank/20/M.jpg",
    title: "UNFORGETTABLE YAD VASHEM",
    ctg: "jerusalem",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            

				<p>
					Yad Vashem, Israel’s main Holocaust remembrance and education centre is situated on the green slopes of Har HaZikaron, (the Mount of Remembrance) in Jerusalem.
				</p>

				<p>
					Israel’s Holocaust commemoration project began in 1953 with the task of perpetuating the memory of Holocaust victims and documenting the history of the Jewish people during the Holocaust so that it will be remembered by future generations. This project was an important step for the young nation of Israel at the time and was significant for the citizens of Israel, particularly for the survivors of the ghettos and concentration camps.
				</p>
				
				
             	<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/31/1.jpg"} class="img-responsive" />
				</div>

				<p>
					The new Yad Vashem museum was opened to the public in 2005. The museum is designed in the shape of a prism penetrating the mountain. Divided into nine galleries, the museum relates the stories of the Jewish communities before the Second World War and the series of events beginning from the rise of the Nazis to power, the pursuit of the Jews, their eviction to the ghettos and ending with “the Final Solution” and mass genocide
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/31/2.jpg"} class="img-responsive" />
				</div>


				<p>
					The personal experiences and feelings of the victims of the Holocaust constitute the groundwork for the museum’s exhibits. Photographs, films, documents, letters, works of art, and personal items found in the camps and ghettos are all an integral part of the exhibits. As you exit the Museum itself is the Hall of Names, an inspiring memorial containing over three million names of Holocaust victims that were submitted by their families and relatives. Names can still be submitted by visitors to the memorial and added to the computerized archive.
				</p>

				<p>
					In addition to the Holocaust History Museum Yad Vashem has other memorials and monuments including  the Hall of Remembrance, where the ashes of the dead are buried and an eternal flame burns in commemoration; Yad Layeled, the children’s memorial, commemorating the one and a half million Jewish children who were murdered in the Holocaust;
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/31/3.jpg"} class="img-responsive" />
				</div>
				
				<p>
					The Memorial to the Deportees, an authentic railroad car hanging over the cliff on the road winding down from the mountain. The car was used to transport Jews who had been banished from their homes to the concentration camps.
				</p>

				<p>
					The Avenue of the Righteous Among the Nations has over 2,000 trees which were planted in honor of non-Jews who endangered their lives in order to rescue Jews from the Nazis; The archives and library of Yad Vashem House the world’s largest repository of material about the Holocaust;
				</p>

				<p>
					Visiting the Yad Vashem museum is an emotional and heartrending experience, but seeing the exhibits and remembering the Holocaust gives the more than one million individuals, world leaders and dignitaries who pass through its doors annually a meaningful way to commemorate the six million Jewish victims of the Holocaust.
				</p>

				<p>
					For more information   <a target="_blank" href="//www.yadvashem.org/">www.yadvashem.org</a>
				</p>
                
            	 `,
      };
    },
  },

  {
    id: "What_To_Pack",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "QUÉ PONER EN LA MALETA",
    smltitle: "",
    html: function() {
      return {
        __html: `

								<p>Israel es un país moderno y desarrollado&nbsp;y puede comprar prácticamente cualquier cosa que necesite durante su estancia, incluyendo ropa, cosméticos y productos de higiene.</p>
								<p>Si está visitando Israel durante el verano necesitará ropa ligera - camisas de manga corta y sin mangas, pantalones cortos, sandalias, zapatos de playa y un traje de baño. También es buena idea llevar un suéter o una chaqueta, ya que las noches en las montañas y en el desierto pueden ser frescas.</p>
								<p>Si está visitando Israel en el invierno, necesitará ropa abrigada, un abrigo (preferiblemente un impermeable), buenos zapatos, un paraguas, guantes y una bufanda. El clima en Israel no es tan frío como en Europa, pero los días pueden ser lluviosos y fríos.</p>
								<div class="img-wrapper">
																   <img src=${getImgUrl() + "/posts/what-to-pack/1.jpg"} class="img-responsive">
															    </div>
								<p>Es buena idea traer una bolsa pequeña para excursiones de un día. Si está viajando a Eilat o al mar Muerto, es buena idea traer un traje de baño, ya que el agua es lo suficientemente caliente como para nadar allí incluso en invierno.</p>
								<p>Protector solar, un sombrero&nbsp;y gafas de sol son elementos esenciales durante todo el año.</p>
								<p>Si está planeando&nbsp; ir de excursión, necesitará buenos zapatos y mucha agua, ya sea en una cantimplora o en varias botellas. Si está planeando dormir al aire libre, un saco de dormir, una tienda de campaña y un equipo de campamento. La mayoría de los albergues suministran sábanas y mantas.</p>
																
							

		                        `,
      };
    },
  },
  {
    id: "Electrical_Appliances",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "ELECTRICIDAD",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>
									​ La fuente de alimentación israelí es monofásica de 220 voltios a 50 hercios. La mayoría de los enchufes en Israel tienen tres orificios, pero muchos funcionarán con enchufes europeos de dos agujeros. Los visitantes que quieran utilizar máquinas de afeitar, planchas móviles y otros pequeños electrodomésticos pueden necesitar transformadores o adaptadores de enchufes.
									</p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/electrical-appliances/1.jpg"} class="img-responsive">
							    </div>

		                        `,
      };
    },
  },
  {
    id: "Weather",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "CLIMA",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>Con alrededor de 40 días de lluvia al año de promedio, Israel es conocido por su predisposición al sol, pero tenga en cuenta que este es un país de 4 estaciones. Los veranos son largos, duran de abril a octubre y el máximo calor y humedad es usualmente alrededor de julio-agosto. El otoño y el invierno duran de noviembre a marzo.</p>
<p>La ciudad meridional de Eilat disfruta de casi 360 (!) días soleados al año, convirtiéndola en la ciudad más cálida de Israel.</p>
<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/weather-planyour-trip/1.jpg"} class="img-responsive">
							    </div>
<p>El Servicio Meteorológico de Israel: <a href="//www.ims.gov.il" rel="nofollow" target="_blank">www.ims.gov.il</a></p>
								

		                        `,
      };
    },
  },
  {
    id: "Transportation",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "TRANSPORTE",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>Israel es un país pequeño, donde se puede llegar rápida y cómodamente a cualquier lugar. Los taxis son comunes en Israel para los trayectos urbanos e interurbanos y pueden ser parados en la calle o reservados por teléfono o aplicaciones internacionales designadas como Gett.</p>
<p>Las principales formas de transporte público son los autobuses y el servicio nacional de tren que ofrece un medio de transporte conveniente, a un precio razonable para viajar a casi todos los destinos del país.</p>
<p>Servicios de Información de trenes: <a href="//www.rail.co.il" rel="nofollow" target="_blank">www.rail.co.il</a> / Teléfono: 08-6831222 o * 5770.</p>
<p>Servicios de información de autobuses: <a href="//bus.gov.il/?language=en#/origindestination/1/0" rel="nofollow" target="_blank">www.bus.co.il</a> / Teléfono: 1-900-72-1111</p>
<p>Los billetes se pueden comprar en las taquillas de la estación central de autobuses en cada ciudad, o a través del conductor. La mayoría de las líneas de autobús no funcionan en Shabat o en las fiestas judías. El servicio termina el viernes por la tarde y se reanuda el sábado por la noche.</p>
<p>Los estudiantes tienen derecho a descuentos en las líneas de autobuses interurbanos. Para recibir un descuento deben presentar una tarjeta de estudiante internacional al comprar los billetes.</p>
<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/transportation/1.jpg"} class="img-responsive">
							    </div>
<h3>Tarjeta de viaje inteligente - Rav Kav</h3>
<p>Los turistas pueden comprar una tarjeta &nbsp;anónima de Rav Kav. Se puede comprar a bordo por una pequeña tarifa, y luego la pueden recargar, por lo general con un 20% de descuento.</p>
<p>Para su información:</p>
<p>• &nbsp;Rav Kav se puede utilizar para pagar el transporte de varios pasajeros.</p>
<p>• La cuota de un niño es como la de un adulto.</p>
<p>• Rav Kav se puede utilizar en una región y no entre regiones a menos que se recargue específicamente para las rutas deseadas.</p>
<p>• En algunas áreas, es posible obtener viajes diarios ilimitados dentro de esa región solamente.</p>
<h3>Vuelos domésticos</h3>
<p>Como ya bien sabe, Israel es un país pequeño, y por esta razón, sólo vale la pena considerar volar entre Eilat y Tel Aviv. Varias compañías operan vuelos de Eilat al aeropuerto de Ben Gurion, o de Sde Dov al norte de Tel Aviv. Las tarifas aéreas son razonables, pero son más altas que las tarifas de autobús.</p>

<p>Arkia Teléfono: 00 972 3 690 2222,</p>
<p>Israir Teléfono: 00 972 3 795 5777</p>
<h3>Alquiler de coche</h3>
<p>La mayoría de las empresas de alquiler de coches internacionales y las empresas locales tienen oficinas en las grandes ciudades y en el aeropuerto de Ben Gurion. Se recomienda reservar un coche con anticipación desde el extranjero.</p>
<p>Para alquilar un coche en Israel el conductor debe ser mayor de 24 años, y debe tener una licencia de conducir internacional válida (no en el caso de UE) y una tarjeta de crédito internacional.</p>
<p>Israel tiene una extensa red de carreteras y señalización clara en la mayoría de los lugares (en hebreo, inglés y árabe).</p>
<h3>Conducir en Israel</h3>
<p><strong>La edad mínima</strong> para conducir en Israel es 17 años y el lado de conducción de la carretera es el derecho. Los límites de velocidad son de 30 a 50km / h en ciudades, 80-90 en carreteras, 130 en autopistas y la autopista de peaje 6. Los cinturones de seguridad son obligatorios, y si usted está disfrutando de una noche en la ciudad, tenga en cuenta que hay una política de tolerancia cero si bebe y conduce, así que designe un conductor y disfrute con seguridad.</p>
<h3>Autopista de Peaje 6</h3>
<p>La autopista 6 funciona como un peaje electrónico sin barreras en las entradas o salidas y sin semáforos que permite trayectos ininterrumpidos. Los sistemas avanzados de información computarizada instalados a lo largo de la carretera incluyen peajes electrónicos, identificación de vehículos, categorización por tipos de tarifas (suscripción o no registrados) y calculan el número de secciones de autopistas que cada vehículo realiza. Cada trayecto se tabula automáticamente y se factura. Los conductores disfrutan de una experiencia de viaje rica, cómoda y segura con un límite de velocidad de 130 kilómetros por hora.</p>
<p>Los turistas que alquilen un coche se les cobrará a través de su tarjeta de crédito. Consulte con la empresa de alquiler las condiciones y tarifas.</p>
<p>La mayoría de las empresas de alquiler de coches no ofrecen seguros para las áreas de Cisjordania bajo el control de la Autoridad Palestina. Los turistas que deseen conducir con automóviles alquilados a las áreas de la Autoridad Palestina se les recomienda contratar un seguro apropiado.</p>
								
            	

		                        `,
      };
    },
  },
  {
    id: "Israeli_Currency",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "ISRAELI CURRENCY",
    smltitle: "",
    html: function() {
      return {
        __html: `

								<p>
								Eilat’s currency is the New Israel Shekel (NIS) or shekel for short (pluralized as shkalim in Hebrew or shekels in English). There are 100 agorot (agora in singular) in each shekel. Bank notes are in values of 20, 50, 100, and 200 NIS; coins are in values of 10, 5, 2 & 1 NIS and you have 50 and 10 aggorrot.
								</p>
								<h3>
								Exchange Services 
								</h3>
								<p>
								Unlimited sums of local and foreign money may be brought into Israel as cash, credit cards or State of Israel bonds. Foreign currency of all kinds may be exchanged at the airport, banks, post offices, most hotels or licensed exchange agencies in large cities. 
								A passport is required when exchanging currencies. The rates vary from place to place, and banks charge a commission. More Information is available here.
								</p>
								<h3>
								Cash Withdrawals 
								</h3>
								<p>
								Holders of international credit cards can withdraw local or foreign currency at banks which accept their credit cards. There are ATM Machines outside most banks.
								</p>
								<h3>
								Value-added tax refunds
								</h3>
								<p>
								Eilat is a VAT-free zone, but if you visit other places in Israel, foreign tourists may request VAT refunds on purchases made during their visits. Be sure to keep your receipts.
								</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/israeli-currency/1.jpg"} class="img-responsive">
							    </div>
            	

		                        `,
      };
    },
  },
  {
    id: "Immigration_Customs",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "INMIGRACIÓN Y ADUANAS",
    smltitle: "",
    html: function() {
      return {
        __html: `
						        <h3>Procedimientos en los puntos fronterizos</h3>
                                
                                
							    <h3>Control de pasaportes</h3>
								<p>A su llegada a Israel, los visitantes pasan el control de pasaportes y deben presentar un pasaporte válido por lo menos seis menos posterior a la fecha de su salida.</p>
								<p>Por favor, tenga en cuenta que Israel ha incorporado un sistema tecnológico nuevo y moderno para satisfacer las necesidades de las diferentes autoridades de Inmigración, Seguridad, Aeroportuaria y Turismo, además de proporcionar al turista las credenciales necesarias para probar su estatus de visado sin estampar el pasaporte. Con sólo pulsar un botón, el puesto de control de fronteras imprimirá una tarjeta que incluye los detalles principales del viajero como en la primera página del pasaporte. La tarjeta también mostrará la fecha de llegada y la información de la visa. Esta tarjeta se llama el "paso de puerta electrónico".</p>
								<div class="img-wrapper">
																    <img src=${getImgUrl() +
                                      "/posts/immigration-customs/1.jpg"} class="img-responsive">
															    </div>
								<p>El Pase de Puerta es una forma oficial de identificación mientras se encuentra en Israel. Pedimos a todos los turistas que mantengan la tarjeta a mano en todo momento como prueba de su estatus.</p>
								<p>Llegada aérea y terrestre de pasajeros - Los viajeros que llegan al aeropuerto continúan al área de equipajes después de inspeccionar sus pasaportes. Los carritos están a su disposición. Desde allí, continúan al control aduanero y a la salida del aeropuerto.<br/>
								
								<h3>Aduana</h3>
								<p>Puede descargar información general sobre las leyes y políticas de la Autoridad de Aduanas<br/>
								<a href="https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page" rel="nofollow" target="_blank">https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page</a></p>
								<p>Por favor, tenga en cuenta que viajar por el cruce del Puente de Allenby tiene limitaciones y directivas específicas. Por ejemplo, los visitantes que pasan por el Puente de Allenby entre Israel/Jordania pueden llevar hasta 2000 dinares jordanos en efectivo.</p>
								<h3>Aduanas e IVA para Turistas:</h3>
								<a href="https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx" rel="nofollow" target="_blank">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a></p>
								<p><strong>Aparte </strong><strong>del cruce del Puente de Allenby</strong><strong>, y para todas las otras entradas, incluyendo aeropuertos</strong>, la siguiente guía turística es relevante para los visitantes según lo definido por la Autoridad de Aduanas y Tributaria:<br/>
								<a href="https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx" rel="nofollow" target="_blank">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a><br/>
								<a href="https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx" rel="nofollow" target="_blank">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a></p>
								<p>Tenga en cuenta que hay un sistema de tránsito aduanero de dos canales, uno verde y otro rojo, en el aeropuerto Ben Gurion y diversos puntos de cruce. Los visitantes que no tienen mercancías para ser declaradas pueden pasar por el canal verde en la salida de la sala de llegada de pasajeros.</p>
										    
		                        `,
      };
    },
  },
  {
    id: "Frequently_Asked_Questions",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "PREGUNTAS MÁS FRECUENTES",
    smltitle: "",
    html: function() {
      return {
        __html: `
											<br/>
											<h3>Preguntas frecuentes sobre Covid19</h3>
											<p>
											   <ol start="1">
					                               <li>
								                  <strong>Soy un turista en Israel y creo que podría tener el COVID-19, ¿A dónde debo acudir?</strong><br/>
								                  Si tienes 38ºC o más de fiebre, tos, dificultad para respirar u otros problemas respiratorios, debes auto aislarte inmediatamente y llamar a la línea directa de 101 de Servicios de Urgencia de MDA para indicaciones médicas.
								                  <strong class="ac-pink">
								                    No acudas a una clínica o sala de urgencias.
								                  </strong>
								                </li>
								                <li>
								                  <strong>¿Cuándo volverá a aceptar Israel a visitantes de fuera</strong><br/>
								                  En este momento no hay fecha conocida en la que Israel volverá a permitir la entrada a los visitantes extranjeros.
								                </li>
					                               
					                              </ol>
											</p>
											<h3>¿Israel está muy lejos?</h3>
											<p>A 4 horas de vuelo desde Barcelona y 5 desde Madrid.&nbsp; Hay vuelos directos con El Al, Iberia, Air Europa, Vueling y Norwegian.&nbsp; Para pasajeros procedentes de Latino América, existen numerosas conexiones con múltiples compañías.</p>
											<h3>¿Qué documentos necesito para viajar a Israel?</h3>
											<p>Para ciudadanos españoles, todo lo que necesita es un pasaporte válido por lo menos seis meses más que su fecha de llegada a Israel. (Para estancias de hasta tres meses, no necesita visa). Para cualquier otra nacionalidad, consulte en:<br><a href="//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" rel="nofollow" target="_blank">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>
											<h3>¿Es seguro viajar a Israel?</h3>
											<p>No le pediríamos que viniera si no lo fuera. Cada año entre 3 y 4 millones de turistas vienen de vacaciones a Israel - y aparte de aquellos que se enamoran de un israelí - o de Israel - todos vuelven a casa sanos y salvos. Más de 90 compañías aéreas no volarían a Israel si no fuera seguro.</span></p>
											<h3>He oído que hay una entrevista de seguridad antes de mi vuelo ...</h3>
											<p>Si usted vuela con EL AL Israel Airlines o cualquier otra compañía israelí, &nbsp;sepa que las precauciones de seguridad tomadas por las líneas aéreas israelíes son la envidia de las compañías aéreas del mundo. En la facturación para sus vuelos se le preguntarán algunas cuestiones durante una entrevista de seguridad. Algunas de las preguntas pueden parecer<s>,</s> intrusivas, irrelevantes o repetitivas. Sólo responda con sinceridad y no pierda la calma. Recuerde, las preguntas están diseñadas para protegerlo a usted y a los otros pasajeros. Al salir de Israel, el proceso de salida es idéntico al que se ha señalado anteriormente, para todas las líneas aéreas.</span></p>
											<h3>¿Puedo combinar mi visita a Israel con Jordania y / o Egipto?</h3><p>Por supuesto. Hay vuelos regulares entre Tel Aviv y El Cairo y Tel Aviv y Ammán. O puede ir por tierra: cruzar la frontera entre Israel y Egipto por Eilat / Taba, o entre Israel y Jordania por Eilat o el Puente Sheikh Hussein al sur del Mar de Galilea. Consulte con los consulados locales egipcios y jordanos los requisitos de visado antes de viajar.</span></p>
											<h3>¿Qué pasa si quiero visitar otro país árabe?</h3>
											<p>No hay problema. Al igual que muchos países europeos, Israel ya no sella los pasaportes de los visitantes, por lo que su pasaporte no indica que estuvo aquí.</span></p>
											<h3>¿Puedo visitar la Autoridad Palestina?</h3>
											<p>Visitar Belén es muy simple, y miles de visitantes lo hacen todos los días. Puede tomar un tour (consulte con la recepción del hotel) o tome un taxi hasta el cruce de Jerusalén / Belén y tome un taxi palestino en Belén.</span></p>
											<h3>¿Qué pasa con la salud, medicamentos, vacunas?</h3>
											<p>Israel es un país ultramoderno con el mayor número de médicos per cápita del mundo y un sistema sanitario y hospitalario que es la envidia del mundo. No se requieren vacunas para visitar Israel (a menos que haya estado recientemente en una zona donde se han producido epidemias de fiebre amarilla, cólera o ébola). Puede comprar la mayoría de los medicamentos sin receta en Israel. También puede traer suministros de sus medicamentos recetados. (Si necesita traer jeringas y viales de medicina - traiga una carta de su médico que lo atestigüe, por si acaso.) Si necesita consultar a un médico en Israel, consulte con la recepción del hotel. Siempre se recomienda un seguro de viaje (incluida la cobertura médica) para todos los viajes al extranjero.</p>
											<h3>¿Qué ponerse?</h3>
											<p>Al igual que en casi todas partes del mundo, el estilo informal es perfecto para todos los días. Traiga buenos zapatos para caminar o zapatillas y ropa variada. A los israelíes (especialmente las mujeres) les gusta ser "elegante informal" por las tardes en Tel Aviv y Jerusalén. Algunos santuarios religiosos requieren vestido decoroso (brazos y piernas cubiertos, y, ocasionalmente, no se permiten pantalones para las mujeres). No se olvide de su traje de baño y, para el mar Muerto, calzado de goma para entrar en el agua.</span></p>
											<h3>¿Qué pasa con el dinero?</h3>
											<p>La moneda israelí es el Shekel (oficialmente "Nuevo Shekel israelí"), que vale alrededor de 4€. <a href="//www.boi.org.il/en/Markets/ExchangeRates/Pages/Default.aspx" rel="nofollow" target="_blank">Haga clic aquí para ver la tasa de conversión actual</a>. A su llegada a Israel, es una buena idea usar su tarjeta bancaria para retirar algunos Shekels del cajero automático en las salas de llegada de Ben Gurion (consulte con su banco política de comisión) o cambiar pequeñas cantidades de euros o cheques de viaje en un banco o su hotel. Hay cajeros automáticos en todo Israel y las tarjetas de crédito son ampliamente aceptadas.</span></p>
											<h3>Electricidad</h3>
											<p>Casi todas las habitaciones de&nbsp;hotel están equipadas con secador de pelo, y todas tienen tomas para máquinas de afeitar. Para otros aparatos, la electricidad de Israel es 220V A / C, monofásico de 50 ciclos; Se pueden utilizar transformadores de 110V-220V. Los enchufes israelíes tienen tres clavijas, pero normalmente los adaptadores europeos de dos clavijas funcionan.</p>
											<h3>Mantenerse en contacto – Hora en Israel</h3>
											<p>La mayoría de los hoteles tienen wi-fi gratuito en el vestíbulo, y algunos hoteles ofrecen internet gratis en la habitación. Muchos hoteles también tienen centros de negocios donde puede acceder a su correo electrónico e Internet sin cargo alguno. Hay una hora más con respecto al huso horario de España (península).</p>
											<h3>Temperaturas</h3>
											<p>Aunque la mayor parte del año reina un tiem&shy;po caluroso y soleado, en invierno puede hacer frío, en especial en la montaña y por la noche. El invier&shy;no es también la temporada de lluvias, así que si viene en invierno venga preparado.</p>
											<h3>Las pautas generales son:</h3>
											<p>VERANO (Jun / Jul / Aug / Septiembre): Tel Aviv y Tiberíades son calurosos y húmedos (como Barcelona o Málaga). Jerusalén es más seco y fresco, especialmente en la noche. Masada y Eilat son extremadamente calurosas... pero seco. No habrá una gota de lluvia.</p>
											<p>ENTRE TIEMPO (finales de Mar / Abr / Mayo / finales de Sep / Oct / Nov): Las temperaturas diurnas son muy agradables.&nbsp; (pero más cálido&nbsp; en el mar Rojo y Muerto).</p>
											<p>INVIERNO (Dic / Ene / Febrero / Marzo): El clima invernal puede fluctuar. Algunos inviernos son suaves y soleados, otros son severos y nublados. A menudo hay fuertes lluvias y en enero y febrero, incluso a veces, nieve. En Jerusalén y Galilea hará frío por la noche.</p>
											<h3>Cómo moverse</h3>
											<p><strong>AUTOBÚS:</strong> Israel tiene uno de los mejores y más baratos sistemas de autobuses del mundo, y casi todas las ciudades, pueblos y asentamientos están conectados.</p>
											<p><strong>TREN:</strong> Los trenes de alta velocidad conectan el aeropuerto Ben Gurion con Tel Aviv, Jerusalén y Haifa, y hay servicio de tren rápido, eficiente y barato en gran parte del país. <a href="//www.rail.co.il/EN/Pages/Homepage.aspx" rel="nofollow" target="_blank">Haga clic</a> para obtener información completa.</p>
											<p><strong>VUELOS:</strong> Tel Aviv y Eilat están conectados por varios vuelos diarios a bordo de Arkia, El Al e Israir, y también hay vuelos a Haifa y la Galilea.</p>
											<p><strong>TAXIS:</strong> Hay taxis disponibles en las ciudades, y los taxistas también están dispuestos a llevarle entre ciudades. Compruebe el precio antes de iniciar su viaje.</p>
											<p><strong>TAXIS COMPARTIDOS:</strong> Los taxis compartidos o "Sherut" son muy populares. Hay estaciones "Sherut" en todas las ciudades. Pregunte en su hotel por la parada de sherut más cercano.</p>
											<h3>ALQUILER DE COCHES:</h3>
											<p>La mayoría de las compañías de alquiler de coches internacionales tienen oficinas en Israel y también hay excelentes empresas israelíes. Su licencia de conducir española es válida en Israel.&nbsp;Otras nacionalidades, consulte con la compañía de alquiler.</p>		
													                        `,
      };
    },
  },
  {
    id: "Passports_Visa",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "PASAPORTES Y VISAS",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <p>Todos los visitantes a Israel deben tener un pasaporte válido por lo menos seis menos posterior a la fecha de salida del país. Las personas sin nacionalidad deben tener un salvoconducto válido, así como una visa de regreso al país que la emitió.</p>
								<p>Los visitantes tienen derecho a permanecer en Israel hasta tres meses desde la fecha de su llegada, de acuerdo a las condiciones del visado que se les ha concedido. Los visitantes que deseen trabajar en Israel deben presentar una solicitud al Ministerio del Interior para obtener una visa especial.</p>
								<p>Israel ya no sella pasaportes en los aeropuertos y en la mayoría de los cruces terrestres. Sin embargo, debido a que a veces surgen dificultades técnicas y, a veces, el control fronterizo debe volver al método de sellado de pasaportes, recomendamos que los turistas que continúan desde Israel a los países árabes <strong>soliciten oficialmente</strong> que el sello israelí no aparezca en su pasaporte. El turista debe notificar al empleado esta solicitud antes de sellar los documentos.</p>
								<h3>El “pase de puerta electrónico”</h3>
								<p>De conformidad al artículo 13 de la ley de 1952 en relación a la entrada a Israel, un inspector oficial o un oficial de policía puede solicitar la identificación y la prueba de su estatus legal en Israel. La estación de control de fronteras imprimirá una tarjeta que incluye los detalles principales del viajero tal y como aparece en la primera página del pasaporte. La tarjeta también mostrará la fecha de llegada y la información de la visa. Esta tarjeta se denomina "Pase de Puerta Electrónico" y es un sistema tecnológico nuevo que satisface las necesidades de las diferentes autoridades de Inmigración, Seguridad, Aeroportuarias y Turismo, así como proporciona al turista las credenciales necesarias para acreditar su estado de visado. <strong>El "Pase de Puerta Electrónico" sustituye al sistema de sellado de pasaportes.</strong> En el aeropuerto, esta tarjeta permite al viajero salir de la terminal de llegadas sin más demora.</p>
								  <div class="img-wrapper">
																   <img src=${getImgUrl() +
                                     "/posts/passports-visa/1.jpg"} class="img-responsive">
															    </div><br>
								<p><strong>El pase de puerta es una forma oficial de identificación mientras se encuentra en Israel</strong>. Pedimos a todos los turistas que mantengan la tarjeta a mano en todo momento como prueba de su estado de visa. En el aeropuerto y en cruces terrestres designados, esta tarjeta permite al viajero salir de la terminal de llegadas y continuar a la zona de recogida de equipaje.</p>
								<h3>Se le pide al turista que mantenga la tarjeta a mano en todo momento.</h3>
								<h3>&#8203;Visas de turismo</h3>
								<p>Damos la bienvenida a los visitantes a Israel. Muchos países cuentan con un Programa de Exención de Visas con Israel, que permite a sus ciudadanos visitar Israel sin visa. Antes de embarcarse en un viaje, los visitantes que deseen detenerse en Israel en su camino a otros destinos deben comprobar si necesitan una visa de turista. La lista de países en el siguiente enlace especifica los paises desde los que los turistas deben presentar una visa.</p>
								<p><a href="//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" rel="nofollow" target="_blank">Http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>
								<p>Todos los viajeros del Programa de Exención de Visas deben presentar un pasaporte legible por máquina en el puerto de entrada para entrar en Israel sin una visa; de lo contrario, se requiere visa. Esto se aplica a los turistas que llegan con una tarjeta de embarque de países con un Programa de Exención.</p>
								<h3>Extensión de su estadía</h3>
								<p>Su visa puede ser extendida (con coste) en la oficina del Ministerio del Interior más cercana, llame por favor a su centro de llamadas al: * 3450 o marque 12223450</p>
								                             
							   
		                        `,
      };
    },
  },

  {
    id: "Crazy_Night",
    ctg: "telaviv",
    bgImage: "/posts/bank/crazy-night/1.jpg",
    mobBgImage: "/posts/bank/crazy-night/M.jpg",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    title: "Looking for a crazy nightlife?",
    smltitle: "",
    html: function() {
      return {
        __html: `<div class="ac-cradit">
									<span class="ac-cradit-text">Credits:</span>
										<br/>
										<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
										<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
									</div>
									<p></p>
									</div>
                               <h3>
                                 Book your trip to Tel Aviv!
                               </h3>
                               <p>
                                 Amazing nightlife in Tel Aviv <a href="https://en.citiesbreak.com/Posts/telaviv/Amazing_Nightlife" target="_blank">Click here >> </a>
                               </p>
		                        `,
      };
    },
  },

  {
    id: "Heart_Of_The_World",
    ctg: "jerusalem",
    bgImage: "/posts/bank/heart-of-the-world/1.jpg",
    mobBgImage: "/posts/bank/heart-of-the-world/M.jpg",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    title: "Jerusalén, el corazón del mundo",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               <br/>
                                <h3>Cruce las puertas y conozca otro aspecto de la ciudad vieja de Jerusalén</h3>
                                <p>Las murallas de la Ciudad Vieja de Jerusalén, construidas a principios del siglo XVI por el sultán turco Solimán el Magnífico, tienen ocho puertas. Todas menos una (la Puerta de la Misericordia) siguen sirviendo a los habitantes de Jerusalén y a los visitantes que llegan a sus mercados y a los sitios sagrados e históricos.</p>
								<p>La siguiente es una descripción resumida de las puertas, en sentido contrario a las agujas del reloj, de sur a oeste:</p>
								<p><strong>La Puerta de Sión:</strong>Con el nombre bíblico más antiguo de Jerusalén en hebreo e inglés, el nombre árabe de esta puerta es la Puerta del profeta David, ya que la Tumba del Rey David, en el cercano monte Sión, está a sólo unos pasos.&nbsp;La&nbsp; Puerta de Sión conduce directamente a los barrios armenio y judío.</p>
								<p><strong>La Puerta del Estiércol</strong>: El nombre inusual de esta puerta deriva de la basura arrojada aquí en la antigüedad, donde los vientos se llevaban los olores. Nehemías 2:13 menciona una puerta de estiércol &nbsp;que probablemente estaba cerca de ésta. Conduce directamente al Muro Occidental y al Parque Arqueológico.</p>
								<p><strong>Puerta de la Misericordia</strong>: Esta puerta, en la pared oriental del Monte del Templo, puede ser la más conocida de todas. También se llama la Puerta Dorada o la Puerta Oriental, permanece bloqueada desde hace&nbsp; siglos, y se dice que está esperando una apertura milagrosa cuando el Mesías venga y los muertos sean resucitados.</p>
								<p><strong>Puerta de los Leones:</strong>Este portal lleva el nombre por un par de relieves de animales de aspecto feroz que lo flanquean. En realidad son tigres, el símbolo heráldico del sultán Baibars del siglo XIII. También se llama Puerta de San Esteban, desde que el primer mártir cristiano, según la tradición, fuera apedreado no muy lejos. La Puerta de los Leones, que conduce a las Piscinas de Bethesda, la Vía Dolorosa y los mercados, se hizo famosa durante la Guerra de los Seis Días.</p>
								<p><strong>Puerta de Herodes:</strong>A pesar de su nombre, el famoso rey de Judea no tenía nada que ver con esta puerta. En árabe y hebreo esta puerta orientada hacia el norte, que conduce a los mercados de la Ciudad Vieja, se llama la Puerta de las Flores. Algunos dicen que el nombre deriva de una roseta tallada sobre ella. Sin embargo, en árabe una palabra similar significa "despertado", y puede referirse a un cementerio cercano y la esperanza de la resurrección.</p>
								<p><strong>Puerta de Damasco:</strong>Esta es la más imponente de las puertas de entrada a Jerusalén en dirección al norte y se llama así por la gran ciudad de la que llegaron los gobernantes de Jerusalén. Siempre es una zona muy concurrida, gracias a los bulliciosos mercados. Debajo de la puerta del siglo XVI, los arqueólogos han descubierto parte de la entrada construida por el emperador Adriano en el siglo II d.C.</p>
								<p><strong>La Puerta Nueva:</strong>Esta es la única entrada de la Ciudad Vieja que no forma parte del diseño original de las murallas del siglo XVI. Fue abierta en el ocaso del Imperio Otomano para permitir a los peregrinos cristianos un acceso más rápido a los lugares sagrados dentro de las murallas.</p>
								<p><strong>La Puerta de Jaffa:</strong> Este fue el destino de los peregrinos judíos&nbsp;y cristianos que desembarcaron en el puerto de Jaffa, de ahí su nombre. Conducía (y aún dirige) directamente a los barrios judío y cristiano, así como a las partes más populares del mercado, y al Museo de la Torre de David, una vez ciudadela de Jerusalén&nbsp; y ahora un escaparate de su historia.</p>
										                  
		                        `,
      };
    },
  },

  {
	  id: "Neot_Semadar",
	  ctg: "eilat-negev",
	  bgImage: "/posts/bank/Neot_Semadar/1.jpg",
	  mobBgImage: "/posts/bank/Neot_Semadar/M.jpg",
	  isVid: false,
	  title: "Neot Semadar",
	  smltitle: "",
	  html: function() {
		return {
		  __html: `
								  
  
						<p>Ubicado en el corazón del desierto de Aravá en Israel, Neot Semadar ofrece a los viajeros un viaje único donde el arte, la ecología y la comunidad se entrelazan. Este extraordinario kibutz es mucho más que un destino: es un lienzo vivo de creatividad humana y armonía medioambiental.</p>
						<p>Imagina un lugar donde el prodigio arquitectónico converge con la innovación ecológica. El centro artístico del kibutz se erige como un testimonio de diseño colaborativo, con un edificio extraordinario de estructuras redondeadas y audaces, coronado por una impresionante torre de observación de 38 metros. Cada elemento cuenta una historia de vis ión colectiva y expresión artística.</p>
						<div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/Neot_Semadar/1.jpg"} class="img-responsive">
						</div>
						<p>Los visitantes podréis explorar las múltiples facetas de esta comunidad amante del desierto.  Los talleres de artistas exhiben artesanía local, incluyendo pintura en seda, talla en madera y textiles. El paisaje circundante ofrece panorámicas de 360 grados que os dejarán sin aliento, invitándoos a conectar con la cruda belleza del entorno natural.</p>
						<p>Más allá de la estética, Neot Semadar representa un compromiso profundo con un estilo de vida sostenible. La comunidad practica la agricultura ecológica, productos artesanales y mantiene una biodiversidad sorprendente que atrae a investigadores científicos. Con más de 196 especies de fauna documentadas, el kibutz se distingue como un santuario ecológico único en su especie.</p>
						<div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/Neot_Semadar/2.jpg"} class="img-responsive">
						</div>
						<p>Para quienes buscáis una experiencia inmersiva, el lugar ofrece oportunidades de participar en la vida comunitaria, asistir a talleres y degustar productos ecológicos locales. El alojamiento os brinda un retiro sereno en medio del desierto, permitiéndoos desconectar y reconectar con los ritmos de la naturaleza.</p>
						<p>Una visita a Neot Semadar va más allá del turismo convencional: es un viaje al interior de una comunidad reflexiva y creativa que reinventa el potencial humano en perfecta armonía con el paisaje desértico.</p>
						<div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/Neot_Semadar/3.jpg"} class="img-responsive">
						</div>
						<p>Para obtener información adicional sobre el kibutz y las opciones de visita, consultad nuestra página web:  <a href="https://neot-semadar.com/en" rel="noopener" target="_blank">https://neot-semadar.com/en</a></p>
						 `,
		};
	  },
	},

  {
    id: "Privacy_Policy",
    ctg: "telaviv",
    bgImage: "/HomeSlider/desktop/1.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "PRIVACY POLICY",
    smltitle: "",
    html: function() {
      return {
        __html: `


							<p><u><span>Last updated</span></u><span>: March 4, 2020</span></p>
							
							<h3><span>OUR COMMITMENT TO YOU</span><span>&nbsp;</span></h3>
							<p>We, at&nbsp;The Israeli government, the Ministry of Tourism ("<strong>us</strong>", "<strong>we</strong>" or the<strong>&nbsp;"Ministry</strong>") respect the privacy of our users (each, a "<strong>User</strong>" or "<strong>you</strong>") and are committed to protect the privacy of Users who access, download, install, register, use or engage with our website, our mobile application(s), and any other service we provide (the<strong>&nbsp;</strong>"<strong>Website</strong>" and "<strong>App</strong>" respectively, and collectively the "<strong>Service(s)</strong>"). &nbsp;</p>
							<p>We've prepared this Privacy Policy to outline our practices with respect to collecting, using and disclosing your information when you use the Services. We encourage you to read this Privacy Policy carefully and use it to make informed decisions. By using the Services, you agree to the terms of this Privacy Policy and your continued use of the Services constitutes your ongoing agreement to the Privacy Policy.</p>
							
							<h3><span>CONTENTS</span></h3>
							<p>
							  <a href="#Grounds" style="color:#000"><span>1. </span>GROUNDS FOR DATA COLLECTION</a><br/>

							  <a href="#WhatType" style="color:#000"><span>2. </span>WHAT TYPE OF DATA WE COLLECT?</a><br/>

							  <a href="#HowDoWeUse" style="color:#000"><span>3. </span>HOW DO WE USE THE DATA WE COLLECT?</a><br/>

							  <a href="#Tracking" style="color:#000"><span>4. </span>TRACKING TECHNOLOGIES</a><br/>

							  <a href="#WitWhom" style="color:#000"><span>5. </span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</a><br/>

							  <a href="#HowWeProtect" style="color:#000"><span>6. </span>HOW WE PROTECT YOUR INFORMATION</a><br/>

							  <a href="#Retention" style="color:#000"><span>7. </span>RETENTION</a><br/>

							  <a href="#UserRigths" style="color:#000"><span>8. </span>USER RIGHTS</a><br/>

							  <a href="#Transfer" style="color:#000"><span>9. </span>TRANSFER OF DATA OUTSIDE THE EEA</a><br/>

							  <a href="#OurPolicy" style="color:#000"><span>10. </span>OUR POLICY TOWARD CHILDREN</a><br/>

							  <a href="#HowToContactUs" style="color:#000"><span>11. </span>HOW TO CONTACT US?</a><br/>

							  <a href="#Updates" style="color:#000"><span>12. </span>UPDATES TO THIS POLICY</a><br/>
							</p>

							
							<h3 id="Grounds"><span>GROUNDS FOR DATA COLLECTION</span><span>&nbsp;</span></h3>
							<p><span>Processing of your “<strong>Personal Data</strong>” (meaning any information which may potentially allow your identification, either directly or by using reasonable means) is necessary for the performance of our contractual obligations towards you, for providing you with our Services and the operation of our Website, to protect our legitimate interests and for compliance with legal and regulatory obligations to which we are subject.</span></p>
							<p><span>When you use our Services, you consent to the collection, storage, use, disclosure and other uses of your Personal Information as described in this Privacy Policy.</span></p>
							
							<h3 id="WhatType"><span>WHAT TYPE OF DATA WE COLLECT?</span></h3>
							<h3><span>Personal Data</span></h3>
							<p><span>In the course of using the Services, we may collect certain Personal Data to provide and improve the Services, to contact or identify you, to enable you to access certain parts of the Service</span><span>&nbsp;or as otherwise indicated in this Policy. We collect the following Personal Data about you</span><span>:</span></p>
							<ul style="list-style-type: disc;margin-left:0in;">
							  <li><span>When you send us an email&nbsp;</span><span>or contact us through a contact form on the Website, we will collect your name and email address so we could respond to your inquiry. We may also collect any Personal Data that you choose to include in your inquiry to us.</span></li>
							  <li><span>Our webserver may also automatically collect your IP address, and unique online identifiers. These details are pseudonymized (cannot directly identify you) and are collected for the purpose of delivering relevant content and operating and improving our Service.</span></li>
							</ul>
							<h3><span>Non-Personal Data</span></h3>
							<p><span>We also collect data about the use of our Service and the characteristics and activities of users, in order to operate it and improve it. We may collect the following non-Personal Data:&nbsp;</span><span>Your operating system, device type, session start/stop time, time zone, network connection type (e.g., Wi-Fi, cellular), your general location (city and country), and general information regarding your browser and device.</span></p>
							<p><span>If we combine Personal Data with non-Personal Data, the combined data will be treated as Personal Data.&nbsp;</span></p>
							
							<h3 id="HowDoWeUse"><span>HOW DO WE USE THE DATA WE COLLECT?</span></h3>
							<ul>
							  <li><strong><span>Provision of the Service</span></strong><em><span>&nbsp;–&nbsp;</span></em><span>we will use the Personal Data you provide us for the provision and improvement of our Service, providing customer support and to respond to your queries.&nbsp;</span></li>
							  <li><strong><span>Service announcements</span></strong><span>&nbsp;- we will use your Personal Data to communicate with you and to keep you informed of our latest updates to our Service and offer you service offers.</span></li>
							  <li><strong><span>Analytics, surveys and research</span></strong><span>&nbsp;- from time to time, we may conduct surveys or test features, and analyze the data we have to develop, evaluate and improve these features, all in order to improve our Services and offerings, and think of new and exciting features for our users.</span></li>
							  <li><strong><span>Protecting our interests</span></strong><em><span>&nbsp;-&nbsp;</span></em><span>we may use your Personal Data when we believe it’s necessary in order to take precautions against liabilities, investigate and defend ourselves against any third party claims or allegations, investigate and protect ourselves from fraud, protect the security or integrity of our services and protect the rights and property of the Ministry, its users and/or partners.&nbsp;</span></li>
							  <li><strong><span>Enforcing of policies</span></strong><span>&nbsp;- we may use your Personal Data in order to enforce our policies, including but not limited to our <a href="https://goisrael.com/Posts/telaviv/Privacy_Policy" style="text-decoration:underline;color:#000" target="_blank"> Terms </a></span><span style="line-height:115%;font-family:Calibri;font-size:8.0pt;color:windowtext;">
								 
								</span><span style="line-height:;font-family:Calibri;line-height:;color:windowtext;">.&nbsp;</span></li>
							  <li><strong><span>Compliance with legal and regulatory requirements</span></strong><span>&nbsp;- we may use your Personal Data to investigate violations, and as required by law, regulation or other governmental authority, or to comply with a subpoena or similar legal process.</span></li>
							  <li><strong><span>Newsletter</span></strong><span>&nbsp;- we may use your Personal Data in order to send you our newsletter, if you subscribed to it. &nbsp;</span>
								<ol style="list-style-type: circle;">
								  <li><u><span>Opt-out of receiving our newsletter</span></u><span>&nbsp;- You may choose not to receive our newsletter by clicking on the “unsubscribe” link contained therein. Please note that even if you unsubscribe, we may continue to send you Service-related updates and notifications, or reply to your queries and feedback you provide us.&nbsp;</span></li>
								</ol>
							  </li>
							</ul>
							
							<h3 id="Tracking"><span>TRACKING TECHNOLOGIES</span></h3>
							<p><span>When you visit or access our Services we use (and authorize 3<sup>rd</sup> parties to use) pixels, cookies, events and other technologies (collectively, "<strong>Tracking Technologies</strong>"). Those allow us to automatically collect information about you, your device and your online behavior, in order to enhance your navigation in our Services, improve our Services’ performance, perform analytics and customize your experience. In addition, we may merge data we have with data collected through these tracking technologies and data we may obtain from other sources and, as a result, such data may become Personal Data.</span></p>
							<p>If you do not accept the use of cookies by us, please disable cookies by following the instructions below. However, please note that disabling cookies might seriously affect the function, User experience and other features of our Services.</p>
							<h3>Types of Tracking Technologies We Use</h3>
							<p>There are two broad categories of cookies: (a) <strong>First party cookies</strong>, served directly by us to your computer or mobile device, and (b) <strong>Third party cookies</strong>, served by a third party. We use third party cookies for functionality, performance and analytics, and social media purposes.</p>
							<p>Cookies can remain on your computer or mobile device for different periods of time. Some cookies are "session cookies" and expires upon closing of your browser. Other cookies are "persistent cookies", meaning that they survive after your browser is closed. They can be used by websites to recognize your computer when you open your browser and browse the Internet again.</p>
							<p>For example, we use a performance tracking technology tool called “<strong>Google Analytics</strong>” to collect information about the use of the Website. Google Analytics collects information such as how often users visit this site, what pages they visit when they do so, and what other sites they used prior to coming to this Site. We use the information we get from Google Analytics to maintain and improve the Site and our products. We do not combine the information collected through the use of Google Analytics with personally identifiable information. Google’s ability to use and share information collected by Google Analytics about your visits to this Site is restricted by the Google Analytics Terms of Service, available at 
							  <a href="//www.google.com/analytics/terms/us.html" target="_blank" style="text-decoration:underline;color:#000">www.google.com/analytics/</a>, and the Google Privacy Policy, available at 
							  <a href="//www.google.com/policies/privacy/" target="_blank" style="text-decoration:underline;color:#000">www.google.com/policies/</a>. You can opt-out of Google's collection of Personal Data through Google Analytics by downloading and installing the Google Analytics Opt-out Browser Add-on, available at 
							  <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" style="text-decoration:underline;color:#000">tools.google.com/dlpage/gaoptout</a>.
							</p>
							<h3><span>Interest-Based Advertising &amp; User Choice</span></h3>
							<p>Through our Services, we may display advertisements that are tailored to you, for example ads or partner services that are based on your recent browsing behavior. In order to tailor advertisements and services in which you might be interested, we as well as certain third parties may use Tracking Technologies to display advertisements based on your visits to the Websites, to target advertisements to you for products and services in which you might be interested, and to measure the effectiveness of the ads. You can turn off certain third party Tracking Technologies used for behavioral advertising purposes by visiting the Network Advertising Initiative&nbsp;or by visiting the&nbsp;DAA opt-out program&nbsp;or the&nbsp;EDAA consumer choice page&nbsp;(if you reside in the EU) using the links provided below. Please note that certain Tracking Technologies operate at the device and browser level, so to fully opt-out across devices, you will need to do so on each device and browser individually, as described below as well.</p>
							<h3><span>How to Manage Your Tracking Technologies Settings</span></h3>
							<p>There are various ways in which you can manage and control your Tracking Technologies settings. Please remember that, by deleting or blocking Tracking Technologies, some of the features of the Services may not work properly or as effectively.</p>
							<p style="margin-bottom:6.0pt;"><strong>Turning off cookies via your web browser
								<br>&nbsp;
							  </strong>Most web browsers will provide you with some general information about cookies, enable you to see what cookies are stored on your device, allow you to delete them all or on an individual basis, and enable you to block or allow cookies for all websites or individually selected websites. You can also normally turn off third party cookies separately. Please note that the settings offered by a browser or device often only apply to that particular browser or device. Information about cookies is usually found in the "Help" section of the web browser. Below are some links to some commonly used web browsers:</p>
							<p>
							  <a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank" style="text-decoration:underline;color:#000"><span>Google Chrome</span></a><br/>

							  <a href="https://support.microsoft.com/en-us/kb/260971" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Explorer</span></a><br/>

							  <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" style="text-decoration:underline;color:#000"><span>Mozilla Firefox</span></a><br/>

							  <a href="https://support.apple.com/kb/PH5042?locale=en_US" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Desktop)</span></a><br/>

							  <a href="https://support.apple.com/en-us/HT201265" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Mobile)</span></a><br/>

							  <a href="//support.google.com/ics/nexus/bin/answer.py?hl=en&amp;answer=2425067" target="_blank" style="text-decoration:underline;color:#000"><span>Android Browser</span></a><br/>

							  <a href="//www.opera.com/help" target="_blank" style="text-decoration:underline;color:#000"><span>Opera</span></a><br/>

							  <a href="//www.opera.com/help/mobile/android#privacy" target="_blank" style="text-decoration:underline;color:#000"><span>Opera Mobile</span></a>
							</p>
							<p>For other browsers, please consult the documentation that your browser manufacturer provides.</p>
							<p style="margin-bottom:6.0pt;"><strong>Turning off third party cookies
								<br>&nbsp;
							  </strong>You can turn off certain third party targeting/advertising cookies by visiting the following link:&nbsp;
							  <a href="//www.networkadvertising.org/choices/" target="_blank" style="text-decoration:underline;color:#000">Network Advertising Initiative</a>.
							</p>
							<h3><span>Other helpful resources</span><br/></h3>
							<p>
							<span>To learn more about advertisers’ use of cookies the following links may be helpful:</span><br/>
							  <a href="//www.youronlinechoices.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>European Interactive Digital Advertising Alliance (EU)</span></a><br/>

							  <a href="//www.iab.net/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (US)</span></a><br/>

							  <a href="//www.iabeurope.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (EU)</span></a>
							</p>
							<p style="margin-top:6.0pt;margin-right:0in;margin-bottom:.0001pt;margin-left:0in;text-align:justify;"><strong>Turning off cookies on a mobile device</strong></h3>
							<p>You can-opt out of certain types of interest-based advertising, by accessing the “settings” on your device:</p>
							<ul style="list-style-type: disc;margin-left:undefined;">
							  <li><strong><span>If you're using an Apple device</span></strong><span>&nbsp;you can configure your device to limit ad tracking to by clicking on "settings" &gt; "privacy" &gt; "advertising" and toggling "limit ad tracking" to ‘on.’</span></strong></li>
							  <li><strong><span>If you're using an Android device</span></strong><span>&nbsp;you can opt out of most app-based tracking for advertising by opening the "Google Settings" app on your device, selecting "Ads", and then selecting the option to opt-out of interest-based ads.</span></strong></li>
							</ul>
							<p>Please note that the above information may change when manufacturers update their systems. Also note, that your device may use another platform, not described above. In that case, please consult the manufacturer documentation for further instructions.</p>
							
							<h3 id="WitWhom"><span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</span></h3>
							<ul>
							  <li><strong><span>Internal concerned parties</span></strong><span>&nbsp;- we may share your information with other</span><span style="color:windowtext;">&nbsp;</span><span>government ministries, as well as our employees, as needed to provide our Services.</span></li>
							  <li><strong><span>Business partners</span></strong><span>&nbsp;- we may share your information with business partners such as storage and analytics providers who help us provide you with our Services. These third parties may have access to your Personal Data so that they may perform these tasks on our behalf, but they are obligated to comply with the highest security standards and applicable data protection legislation, and may not use your Personal Data for any other purpose.</span></li>
							  <li><strong><span>Compliance with laws and law enforcement entities</span></strong><span>&nbsp;- we cooperate with other governmental agencies and law enforcement officials to enforce and comply with the law. We will disclose Personal Data about you to government or law enforcement officials or private parties if we, in our sole discretion, believe necessary or appropriate to respond to claims and legal process (including but not limited to subpoenas), to protect our or a third party's property and rights, to protect the safety of the public or any person, or to prevent or stop any activity we may consider to be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable.&nbsp;</span></li>
							</ul>
							
							<h3 id="HowWeProtect"><span>HOW WE PROTECT YOUR INFORMATION</span></h3>
							<p><span>We have implemented administrative, technical, and physical safeguards to help prevent unauthorized access, use, or disclosure of your Personal Data. Your data is stored on secure servers and isn’t publicly available. We limit access of your information only to those employees or partners on a “need to know” basis, in order to enable the carrying out of the agreement between us.&nbsp;</span></p>
							<p><span>While we seek to protect your information to ensure that it is kept confidential, we cannot absolutely guarantee its security. You should be aware that there is always some risk involved in transmitting information over the internet. While we strive to protect your Personal Data, we cannot ensure or warrant the security and privacy of your Personal Data or other content you transmit using the Service, and you do so at your own risk.&nbsp;</span></p>
							
							<h3 id="Retention"><span>RETENTION</span></h3>
							<p><span>We will retain your Personal Data for as long as necessary to provide our Services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing Personal Data, communications and anything else as required by applicable laws and regulations.&nbsp;</span></p>
							
							<h3  id="UserRigths"><span>USER RIGHTS</span></h3>
							<h4><strong><span style="font-family:&quot;Calibri&quot;,sans-serif;color:windowtext;font-style:normal;">EU User Rights</span></strong></h4>
							<p><span>As an EU resident, you may request to:&nbsp;</span></p>
							<ol start="1" style="list-style-type: lower-alpha;margin-left: 0px;">
							  <li><span>Receive confirmation as to whether or not Personal Data concerning you is being processed, and access your stored Personal Data, together with supplementary information.&nbsp;</span></li>
							  <li><span>Receive a copy of Personal Data you directly volunteer to us in a structured, commonly used and machine-readable format.&nbsp;</span></li>
							  <li><span>Request rectification of your Personal Data that is in our control.</span></li>
							  <li><span>Request erasure of your Personal Data.&nbsp;</span></li>
							  <li><span>Object to the processing of Personal Data by us.&nbsp;</span></li>
							  <li><span>Request to restrict processing of your Personal Data by us.</span></li>
							  <li><span>Lodge a complaint with a supervisory authority.</span></li>
							</ol>
							<p><span>Please note that these rights pertain to EU residents only, are not absolute, and may be subject to our own legitimate interests and regulatory requirements.&nbsp;</span></p>
							<p><span>Users Outside the EU -&nbsp;</span></strong><span>Some of the aforementioned rights are applicable in certain jurisdictions outside the EU as well. Users residing outside the EU are welcome to contact us for any questions or requests by using the details provided below.</span></p>
							
							<h3 id="Transfer"><span>TRANSFER OF DATA OUTSIDE THE EEA</span><span>&nbsp;</span></h3>
							<p><span>If you reside in the European Union ("<strong>EU</strong>"), please note that some data recipients may be located outside the EEA. In such cases we will transfer your data only to such countries as approved by the European Commission as providing adequate level of data protection, or enter into legal agreements ensuring an adequate level of data protection.</span></p>
							
							<h3 id="OurPolicy"><span>OUR POLICY TOWARD CHILDREN</span></h3>
							<p>We do not knowingly collect or solicit personal information from anyone under 18 years of age, (or the age of consent as determined under the applicable laws where the individual resides; “<strong>Age of Consent</strong>”). By accessing, using or interacting with our Services, you certify to us that you are not under the Age of Consent. In the event that we learn that we have collected personal information from an individual under the Age of Consent without verification of parental consent, we will delete that information upon discovery. If you believe that we might have any information from or about an individual under the Age of Consent, then please contact us through the contact details available below.</p>
							
							<h3 id="HowToContactUs"><span>HOW TO CONTACT US?</span></h3>
							<p><span>If you wish to exercise any of the aforementioned rights, or receive more information, please contact us using the details below:</span><br/>Email:<a href="mailto:Dpo@tourism.gov.il" style="text-decoration:underline;color:#000"> Dpo@tourism.gov.il</a>
							</p>
							
							<h3 id="Updates"><span>UPDATES TO THIS POLICY</span></h3>
							<p>This Privacy Policy is subject to changes from time to time, in our sole discretion. The most current version will always be posted on our Services (as reflected in the "Last Updated" heading). You are advised to check for updates regularly. By continuing to access or use our Services after any revisions become effective, you agree to be bound by the updated Privacy Policy.&nbsp;</p>

						   
							`,
      };
    },
  },

  {
    id: "Destination_For_All",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: true,
    vidId: "QWA7qwsbbGY",
    title: "UN DESTINO PARA TODOS",
    smltitle: "",
    html: function() {
      return {
        __html: `


			<p>El número de visitas a Israel está teniendo un crecimiento sin precedentes. Más y más gente de todo el mundo está cumpliendo su sueño de visitar Israel. El Ministerio de Turismo se compromete a ayudar a todo aquel que quiera visitarlo, aunque tenga alguna discapacidad.</p>
			<p>En cuanto a la accesibilidad, Israel es líder mundial en legislación.</p>
			<p>Desde la infraestructura hasta el servicio, Israel proporciona una estancia acogedora y sin problemas.</p>
			<p>Vea los enlaces siguientes de todos los que ayudan y aseguran una estancia fácil, agradable y sin barreras.</p>

		   <div class="img-wrapper">
			   <img src=${getImgUrl() +
           "/posts/destination-for-all/1.jpg"} class="img-responsive">
			</div><br>
			<h3>ONGs y viajes</h3>
			
			<p><u>Bosques, parques y lugares accesibles en Israel</u><br/>
			En los últimos años, KKL-JNF se ha dedicado a desarrollar las instalaciones adecuadas para discapacitados físicos en sus bosques y parques. Nuestro objetivo es abrir la naturaleza a todos los sectores de la población, creando un entorno a través del cual las personas con movilidad limitada puedan desplazarse de forma segura y cómoda. También hemos dado un paso más y hemos llevado la naturaleza a los colegios con proyectos únicos en colegios de educación especial. <a href="//www.kkl-jnf.org/tourism-and-recreation/accessible-forests-parks-sites-israel/" target="_blank">www.kkl-jnf.org</a>
		   </p>

		   <h3>Autoridades para la Naturaleza y los Parques de Israel</h3>
		   <p>INPA se ha dedicado en los últimos años a habilitar el entorno para personas con discapacidades. En todos los parques nacionales, reservas naturales, lugares de antigüedades y patrimonios de la humanidad, se está trabajando para mejorar la accesibilidad y facilitar el acceso.<br/>
			INPA está haciendo todo lo que está en su mano para aumentar la cantidad de visitantes con discapacidades que puedan recorrer y disfrutar los distintos lugares y todas las actividades que ofrecen.<br/>
			En la página web hay más información y mapas relevantes. <a href="https://www.parks.org.il/en/accessibility/" target="_blank">www.parks.org.il</a></p>
			 
			<div class="img-wrapper">
			<img src=${getImgUrl() +
        "/posts/destination-for-all/2.jpg"} class="img-responsive">
		 </div><br>
			 <h3>Yad Sarah para Turistas</h3>
			 <p>Viajar al extranjero es un desafío a personas con necesidades especiales. Yad Sarah para turistas ofrece la asistencia a personas con necesidades especiales y sus familiares lo que garantizará unas vacaciones agradables y relajadas. Una vez concretados los planes en el departamento de turismo, el visitante puede sentarse y relajarse, sabiendo que todo estará resuelto por un representante de Yad Sarah.</p>
		   
				<p> <u>Algunos de los servicios disponibles:</u>:<br/>
				 
				• Préstamo del equipo médico necesario. Se puede organizar la entrega en un hotel o residencia por un módico precio.<br/>
				• Equipar la habitación de hotel para que su estancia sea más cómoda, con camas especiales, sillas, etc.<br/>
				• Préstamo de cilindros/concentradores de oxígeno.<br/>
				• Traslados en furgonetas con bloqueo para sillas de ruedas, incluyendo traslados de ida y vuelta del aeropuerto y visitas turísticas.<br/>
				• Recomendación de guías turísticos especializados en guiar a turistas con movilidad limitada y necesidades especiales, y asesoramiento sobre sitios turísticos de fácil acceso.<br/>

				<br/>
				El servicio personalizado de Yad Sarah está disponible para cualquier turista con necesidades especiales, con previo aviso al departamento de turismo.<br/>
		

		 Este servicio está disponible en todo Israel.<br/>

			Para más información, o para organizar un traslado o excursión, llame al departamento de Turismo al <a href="tel:+97226444382">+972-2-6444382</a> o envíenos un correo electrónico: <a href="mailto:chaimvi@yadsarah.org.il">chaimvi@yadsarah.org.il</a></p>
			<div class="img-wrapper">
			<img src=${getImgUrl() +
        "/posts/destination-for-all/3.jpg"} class="img-responsive">
		 </div><br>
			<h3>Access Israel</h3>
			<p>Access Israel es una organización sin ánimo de lucro que promueve la accesibilidad y la inclusión de personas con discapacidades y ancianos en todos los ámbitos de la vida. Access Israel fue creada en 1999 por Yuval Wagner, un ex piloto de helicóptero, postrado a una silla de ruedas debido a un accidente. Access Israel lleva a cabo diversos proyectos para cumplir el objetivo de tener una sociedad totalmente accesible e inclusiva, con proyectos de sensibilización en los colegios, consultoría de accesibilidad para empresas, cursos de accesibilidad, cursos de lenguaje de signos, conferencias sobre diversos temas y más. Además, Access Israel trabaja para promover la accesibilidad en la ley israelí, dirige un centro de quejas de accesibilidad y organiza eventos de sensibilización para el público. Access Israel promueve la accesibilidad y la inclusión en todos los ámbitos de la vida,  en la educación, el turismo, cultura, situaciones de emergencia y más. Turismo accesible en la página web de Access Israel.
				<a href="https://www.aisrael.org/?CategoryID=3030" target="_blank">Accessible Tourism on Access Israel website</a></p>
                 <h3>LOTEM</h3>
				<p> Es la organización más importante en Israel para actividades de aprendizaje al aire libre para niños con necesidades especiales, y ofrece actividades educativas al aire libre, así como excursiones adaptadas. 
Surin Hershko, un héroe de guerra que resultó gravemente herido en la Operación Entebbe en 1976, es fundador y presidente de LOTEM. Su inspiración para LOTEM viene del corazón: "Dar a los niños el derecho básico de experimentar la vida al aire libre, es el propósito de mi vida y me llena de gran alegría". La sede principal, Emek HaShalom (Valle de la Paz), es una granja de 40 acres ubicada en el norte de Israel, cerca de Yokneam. En medio de un precioso valle, la granja está rodeada por naturaleza floreciente y el tranquilo fluir de las aguas. Proporciona una experiencia de aprendizaje con prácticas en un jardín de enseñanza, prensas de aceite y vino habilitadas para sillas de ruedas, panadería y senderos aptos también para sillas de ruedas.
                </p>
				<p>Lotem comprende el papel vital que desempeña el aire libre en la vida de los israelíes, y el impacto inconmensurable que tiene en la sociedad, no solo en la persona con una necesidad especial, sino también en su familia y la comunidad. Su labor es garantizar que ningún miembro de la sociedad se quede atrás, LOTEM brinda la oportunidad a niños y adultos con necesidades especiales de aprender y participar en actividades al aire libre en todo el país. 
				<a href="https://www.lotem.net/?page_id=386" target="_blank">www.lotem.net</a></p>

				<h2 class="ac-margin-bottom-20 ac-margin-top-20"> Transporte</h3>
				<h3>Autoridad aeroportuaria de Israel</h3>
				<p>Por ley, la Autoridad aeroportuaria de Israel es responsable de proporcionar la infraestructura física para la actividad de las entidades que prestan servicios a los pasajeros asistidos. Sin embargo, conforme a las normas de transporte, la responsabilidad del manejo de los pasajeros asistidos y su equipaje, desde el momento de su entrada en el edificio de la terminal, o su desembarque del avión, recae sobre la aerolínea con la que vuelan los pasajeros. El servicio dentro del aeropuerto Ben Gurión lo proporcionan las empresas dedicadas a la asistencia en tierra. Este servicio incluye el acompañamiento y asistencia a pasajeros discapacitados en los trayectos de salida y llegada. 
				<a href="https://www.iaa.gov.il/en-us/airports/bengurion/pages/accessibility.aspx" target="_blank">www.iaa.gov.il</a></p>
				<h3>Estas son las empresas de asistencia en tierra: </h3>
				<p>Aero Handling: <a href="//www.aerohandling.com/" target="_blank">www.aerohandling.com</a><br/>
				Laufer Aviation: GHI <a href="//lauferghi.com/" target="_blank">www.lauferghi.com</a><br/>
				QAS: <a href="//www.qasisrael.co.il" target="_blank">www.qasisrael.co.il</a><br/>


				</p>
				<div class="img-wrapper">
				<img src=${getImgUrl() +
          "/posts/destination-for-all/4.jpg"} class="img-responsive">
			 </div><br>

				<p>Teléfono de Atención al cliente del Ministerio de Transporte (llamada local) <a href="tel:5678*">5678*</a></p>
				
				<h3>Transporte público</h3>
				<p>Trenes: en caso de necesitar asistencia de un miembro del personal de la estación para subir y bajar del tren, debe coordinar con antelación su viaje con 'Israel Railways', a través de la página web o a través de la línea directa <a href="tel:*5770">*5770</a>.</p>
				 
				<p><u>'Israel Railways'</u> hará todo lo posible para brindarle el mejor servicio, aunque no haya coordinado su viaje con antelación.</p>
				<p>En cualquier caso, sí se debe coordinar con antelación todos los viajes que tengan lugar entre las 20:00 de la tarde y las 06:00 de la mañana siguiente, así como los viajes que se realicen el sábado por la noche.</p>
				<p><u>Autobuses:</u> todas las líneas de autobuses de la ciudad están adaptadas para personas discapacitadas. Los autobuses interestatales están parcialmente habilitados.</p>
				<p><u>Taxis:</u> es difícil encontrar un taxi adaptado directamente en la calle. Se recomienda hacer una reserva de <a href="https://www.aisrael.org/?CategoryID=2657&ArticleID=64179" target="_blank">https://www.aisrael.org/?CategoryID=2657&ArticleID=64179</a>.</p>


				<h2  class="ac-margin-bottom-20 ac-margin-top-20">Alojamiento</h3>
				<p>Todos los tipos de alojamiento en Israel con 7 o más habitaciones están obligados por ley a ofrecer al menos 1 habitación adaptada. Todos los proveedores de servicios con un mínimo de 25 empleados también deben tener un Supervisor de Accesibilidad. Estas leyes aseguran que no queda ni un rincón en Israel en el que no haya la solución perfecta para el alojamiento. Siempre es recomendable escribir un email previo a la visita para coordinar sus expectativas.</p>
				<div class="img-wrapper">
				<img src=${getImgUrl() +
          "/posts/destination-for-all/5.jpg"} class="img-responsive">
			 </div><br>
				
				
				<div id="ac-left-nav">
				<h2 class="ac-margin-bottom-20 pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Accessibility for those with special needs at the beaches:</span>
								</h3>
				<ul id="chaptersList" class="list-unstyled xs-mb-0">
					
						<!-- ngRepeat: chapter in Guide.Chapters -->
						<li data-show="1" class="ac-active ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope light-gray-e7-background blue-border-right-5px" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt nounderline  ng-binding reforma-bold">Northern District</span>						                  
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
						
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<li data-show="2" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Haifa District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<li data-show="3" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Central District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
					
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<div class="clear show-on-mobile"></div>
						<li data-show="4" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Tel Aviv District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
					
						</li>
						<!-- end ngRepeat: chapter in Guide.Chapters --><li data-show="5" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
							<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Southern District</span>
							<img src="${getImgUrl() +
                "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
					
						</li><!-- end ngRepeat: chapter in Guide.Chapters -->
						<div class="clear"></div>
					</ul>
				</div>

				<div id="res">
					<!-- ac part -->
					<div class="ac-part ac-part-1 ac-part-active">

						<div ng-include="chapterItem" class="row row-gov ng-scope">
							<!-- Sub Title -->
							<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
								<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Northern District</span>
								</h3>
							</div>

							<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
								<!-- IMAGE TAG  ------->
								<!--- Image-->

						<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
							<div class="position-relative col-lg-10 lg-p-0">
								<!-- ngIf: CurrChapter.Image.ClickURLRef -->

								<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
								</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
								<!--Image desc-->
								<div>
									<div class="position-absolute">
										<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
									</div>
									<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
										<span class="small-txt ng-binding"></span>
										<span class="small-txt ng-binding"></span>
									</div><!-- end ngIf: CurrChapter.Image -->
								</div>
							</div>
						</div><!-- end ngIf: CurrChapter.Image -->
													<!-- End IMAGE TAG  ------->

													<div class="row row-gov no-gutters">
														<!--Content Text-->
														<div id="GuidesChapterContent-1" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
							<tbody>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Kineret Municipal Unio</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking&nbsp;&nbsp; &nbsp;</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Tzinbari</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>No</td>
									<td>No</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Berniki</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>At the nearby Shikmim beach</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Shikmim</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Hukok</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>No</td>
									<td>No</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Amnon</td>
									<td>Yes&nbsp;</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
									<td>No</td>
									<td>No</td>
									<td>Yes&nbsp;&nbsp; &nbsp;</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Kinar</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Doga</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>Closed</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Tze’elon</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Kursi</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>At the nearby Levanon beach</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Levanon</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Halukim</td>
									<td>At the nearby Levanon beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>At the nearby Levanon beach</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Shizaf</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Dugit – Golan</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Gofra</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Tiberias</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Guy</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Galei Kineret - Rimonim</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Leonardo Pacific</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
									<td>Closed for renovations</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Coco Hot / Holiday Inn</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Jordan Valley Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Ein Gev Vacation</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Ginnosar</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Migdal Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Restal Magdala</td>
									<td>Yes</td>
									<td>No</td>
									<td>&nbsp;</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td class="rtecenter" colspan="6"><strong>Mateh Asher Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Banana Beach Achziv</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Nahariya</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Sokolov</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Galil Central</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Acco</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Argaman Central</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Hatmarim</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
								</tr>
							</tbody>
						</table></div></div>

						<p>&nbsp;</p>
						</div>

														<!--Chapters/Collapse-->
														<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
															<!-- ngRepeat: collapse in CurrChapter.Collapses -->
														</div>

														<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
														<!--End of Chapters/Collapse-->

														<div class="col-12 xs-mb-25 lg-mb-30">
															<!-- Files for Download-->
															<!-- Files for Download-->
						<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

															<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

																<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																	<!-- horizontal line -->
																	<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																		<div class="horizontal-line"></div>
																	</div>
																</div><!-- end ngIf: Guide.Chapters.length > 1 -->

																<!--arrows subject nav  דפדוף-->
																<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																	<!--  לדף הקודם -->
																	<!-- ngIf: CurrChapterindex > 0 -->

																	<!--  לדף הבא -->
																	<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																		<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																			<span class="small-txt gray-txt width-100">Next page:</span>
																			<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																		</div>
																		<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																	</div>
																</div>
															</div><!-- end ngIf: !isOnPrintMode -->
														</div>
													</div>
												</div>
											</div>

					</div>
					<!-- ac- part -->

					<!-- ac part 2 -->
					<div class="ac-part ac-part-2">
					<div ng-include="chapterItem" class="row row-gov ng-scope">
					<!-- Sub Title -->
					<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
						<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span class="ng-binding">Haifa District</span>
						</h3>
					</div>

					<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
						<!-- IMAGE TAG  ------->
						<!--- Image-->

<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
<div class="position-relative col-lg-10 lg-p-0">
	<!-- ngIf: CurrChapter.Image.ClickURLRef -->

	<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
	</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
	<!--Image desc-->
	<div>
		<div class="position-absolute">
			<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
		</div>
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
			<span class="small-txt ng-binding"></span>
			<span class="small-txt ng-binding"></span>
		</div><!-- end ngIf: CurrChapter.Image -->
	</div>
</div>
</div><!-- end ngIf: CurrChapter.Image -->
						<!-- End IMAGE TAG  ------->

						<div class="row row-gov no-gutters">
							<!--Content Text-->
							<div id="GuidesChapterContent-2" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table align="left" cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
<tbody>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Kiryat Yam</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zevulun</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Haifa</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Zamir 1</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zamir 2</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Neot Kiryat Haim Central</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Bat Galim 1</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Bat Galim 2</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Hof Hacarmel Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Dor Central 2</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Neve Yam</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Aqueduct</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Jisr a-Zarka Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Jisr</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Hadera</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Kfar Yam&nbsp;</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Olga Central 2</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
</tbody>
</table></div></div>

<p>&nbsp;</p>
</div>

							<!--Chapters/Collapse-->
							<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
								<!-- ngRepeat: collapse in CurrChapter.Collapses -->
							</div>

							<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
							<!--End of Chapters/Collapse-->

							<div class="col-12 xs-mb-25 lg-mb-30">
								<!-- Files for Download-->
								<!-- Files for Download-->
<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

								<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

									<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
										<!-- horizontal line -->
										<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
											<div class="horizontal-line"></div>
										</div>
									</div><!-- end ngIf: Guide.Chapters.length > 1 -->

									<!--arrows subject nav  דפדוף-->
									<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
										<!--  לדף הקודם -->
										<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
											<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
											<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
												<span class="small-txt gray-txt width-100"> Previous page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Northern District</span>
											</div>
										</div><!-- end ngIf: CurrChapterindex > 0 -->

										<!--  לדף הבא -->
										<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
											<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
												<span class="small-txt gray-txt width-100">Next page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
											</div>
											<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
										</div>
									</div>
								</div><!-- end ngIf: !isOnPrintMode -->
							</div>
						</div>
					</div>
				</div>
					</div>
					<!-- end ac part-2 -->

					<!-- ac-part-3 -->
					<div class="ac-part ac-part-3">
												<div ng-include="chapterItem" class="row row-gov ng-scope">
												<!-- Sub Title -->
												<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
													<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
														<!-- ngIf: Guide.ShowChaptersIndex -->
														<span class="ng-binding">Central District</span>
													</h3>
												</div>
						
												<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
													<!-- IMAGE TAG  ------->
													<!--- Image-->
						
						<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
							<div class="position-relative col-lg-10 lg-p-0">
								<!-- ngIf: CurrChapter.Image.ClickURLRef -->
						
								<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
								</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
								<!--Image desc-->
								<div>
									<div class="position-absolute">
										<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
									</div>
									<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
										<span class="small-txt ng-binding"></span>
										<span class="small-txt ng-binding"></span>
									</div><!-- end ngIf: CurrChapter.Image -->
								</div>
							</div>
						</div><!-- end ngIf: CurrChapter.Image -->
													<!-- End IMAGE TAG  ------->
						
													<div class="row row-gov no-gutters">
														<!--Content Text-->
														<div id="GuidesChapterContent-3" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
							<tbody>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Emek Hefer Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Michmoret – Station number 1</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Michmoret – Station number 2</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>Joint with number 1</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beit Yannai</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>NeUrim Beach</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Netanya</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Kiryat Tzanz</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>HaOnot Beach</td>
									<td>Parking</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Ampi Beach</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Herzl</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Sironit Beach A</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Sironit Beach B</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Argaman Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Poleg Beach</td>
									<td>Yes</td>
									<td>Bathrooms only</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td class="rtecenter" colspan="6"><strong>Hof Hasharon Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Shefayim (Ga’ash)</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td class="rtecenter" colspan="6"><strong>Municipality of Rishon Le-Zion</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Beach number 1 – Hakachol (Blue) Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beach number 2 – Neve Hof Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Beach number 3 – Hofit Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beach number 4 – Tel Yonah Beach</td>
									<td>No</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Beach number 5 – Hayeladim (Children’s) Beach</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td>Beach number 6 – separate beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td class="rtecenter" colspan="6"><strong>Gan Raveh Regional Council</strong></td>
								</tr>
								<tr style="background-color: rgb(255, 255, 255);">
									<td><strong>Name of beach</strong></td>
									<td><strong>Parking</strong></td>
									<td><strong>Bathrooms and showers</strong></td>
									<td><strong>Access to shade</strong></td>
									<td><strong>Access to water</strong></td>
									<td><strong>Bathing chairs for the disabled</strong></td>
								</tr>
								<tr style="background-color: rgb(244, 244, 244);">
									<td>Palmahim Beach</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>No</td>
									<td>No</td>
									<td>No</td>
								</tr>
							</tbody>
						</table></div></div>
						
						<p>&nbsp;</p>
						</div>
						
														<!--Chapters/Collapse-->
														<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
															<!-- ngRepeat: collapse in CurrChapter.Collapses -->
														</div>
						
														<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
														<!--End of Chapters/Collapse-->
						
														<div class="col-12 xs-mb-25 lg-mb-30">
															<!-- Files for Download-->
															<!-- Files for Download-->
						<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
						
															<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
						
																<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																	<!-- horizontal line -->
																	<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																		<div class="horizontal-line"></div>
																	</div>
																</div><!-- end ngIf: Guide.Chapters.length > 1 -->
						
																<!--arrows subject nav  דפדוף-->
																<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																	<!--  לדף הקודם -->
																	<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
																		<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
																		<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
																			<span class="small-txt gray-txt width-100"> Previous page:</span>
																			<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																		</div>
																	</div><!-- end ngIf: CurrChapterindex > 0 -->
						
																	<!--  לדף הבא -->
																	<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																		<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																			<span class="small-txt gray-txt width-100">Next page:</span>
																			<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
																		</div>
																		<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																	</div>
																</div>
															</div><!-- end ngIf: !isOnPrintMode -->
														</div>
													</div>
												</div>
											</div>
					</div>
					<!-- end ac-part-3 -->

					<!-- ac-part-4 -->
					<div class="ac-part ac-part-4">
					<div ng-include="chapterItem" class="row row-gov ng-scope">
			<!-- Sub Title -->
			<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
				<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
					<!-- ngIf: Guide.ShowChaptersIndex -->
					<span class="ng-binding">Tel Aviv District</span>
				</h3>
			</div>

			<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
				<!-- IMAGE TAG  ------->
				<!--- Image-->

<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
<div class="position-relative col-lg-10 lg-p-0">
<!-- ngIf: CurrChapter.Image.ClickURLRef -->

<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
<!--Image desc-->
<div>
<div class="position-absolute">
	<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
</div>
<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
	<span class="small-txt ng-binding"></span>
	<span class="small-txt ng-binding"></span>
</div><!-- end ngIf: CurrChapter.Image -->
</div>
</div>
</div><!-- end ngIf: CurrChapter.Image -->
				<!-- End IMAGE TAG  ------->

				<div class="row row-gov no-gutters">
					<!--Content Text-->
					<div id="GuidesChapterContent-4" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
<tbody>
<tr style="background-color: rgb(255, 255, 255);">
<td class="rtecenter" colspan="6"><strong>Municipality of Herzliya</strong></td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td><strong>Name of beach</strong></td>
<td><strong>Parking</strong></td>
<td><strong>Bathrooms and showers</strong></td>
<td><strong>Access to shade</strong></td>
<td><strong>Access to water</strong></td>
<td><strong>Bathing chairs for the disabled</strong></td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Nof Yam</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Hasharon&nbsp;&nbsp; &nbsp;Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Zevulun</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Acadia North Beach&nbsp;&nbsp; &nbsp;</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Acadia South Beach</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Acadia South Beach – Disabled</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Separate beach</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td class="rtecenter" colspan="6"><strong>Municipality of Tel Aviv - Jaffa</strong></td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td><strong>Name of beach</strong></td>
<td><strong>Parking</strong></td>
<td><strong>Bathrooms and showers</strong></td>
<td><strong>Access to shade</strong></td>
<td><strong>Access to water</strong></td>
<td><strong>Bathing chairs for the disabled</strong></td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>HaTzuk Beach – Station number 1</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Tel Baruch Beach – Station number 1</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Nordau (Metzitzim) Beach</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Nordau separate beach</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>Yes</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Gordon</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Bograshov</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Allenby (Jerusalem)</td>
<td>No</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Charles Clore</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Jaffa – Givat HaAliyah</td>
<td>Yes</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Hilton North</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>HaTzuk Beach – Station number 2</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Frishman</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Aviv Beach</td>
<td>No</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>Yes</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td class="rtecenter" colspan="6"><strong>Municipality of Bat Yam</strong></td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td><strong>Name of beach</strong></td>
<td><strong>Parking</strong></td>
<td><strong>Bathrooms and showers</strong></td>
<td><strong>Access to shade</strong></td>
<td><strong>Access to water</strong></td>
<td><strong>Bathing chairs for the disabled</strong></td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>HaSela – Station number 1</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>HaSela – Station number 2</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>HaSela – Station number 3</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Sample Beach</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Riviera</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(244, 244, 244);">
<td>Separate beach</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
<tr style="background-color: rgb(255, 255, 255);">
<td>Tayo</td>
<td>Yes</td>
<td>Bathrooms only</td>
<td>No</td>
<td>No</td>
<td>No</td>
</tr>
</tbody>
</table></div></div>

<p>&nbsp;</p>
</div>

					<!--Chapters/Collapse-->
					<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
						<!-- ngRepeat: collapse in CurrChapter.Collapses -->
					</div>

					<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
					<!--End of Chapters/Collapse-->

					<div class="col-12 xs-mb-25 lg-mb-30">
						<!-- Files for Download-->
						<!-- Files for Download-->
<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

						<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

							<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
								<!-- horizontal line -->
								<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
									<div class="horizontal-line"></div>
								</div>
							</div><!-- end ngIf: Guide.Chapters.length > 1 -->

							<!--arrows subject nav  דפדוף-->
							<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
								<!--  לדף הקודם -->
								<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
									<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
									<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
										<span class="small-txt gray-txt width-100"> Previous page:</span>
										<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
									</div>
								</div><!-- end ngIf: CurrChapterindex > 0 -->

								<!--  לדף הבא -->
								<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
									<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
										<span class="small-txt gray-txt width-100">Next page:</span>
										<span class="reforma description-txt blue-txt width-100 ng-binding">Southern District</span>
									</div>
									<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
								</div>
							</div>
						</div><!-- end ngIf: !isOnPrintMode -->
					</div>
				</div>
			</div>
		</div>
					</div>
					<!-- end ac-part-4 -->

					<!-- ac-part-5 -->
					<div class="ac-part ac-part-5">
					<div ng-include="chapterItem" class="row row-gov ng-scope">
					<!-- Sub Title -->
					<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
						<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span class="ng-binding">Southern District</span>
						</h3>
					</div>

					<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
						<!-- IMAGE TAG  ------->
						<!--- Image-->

<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
<div class="position-relative col-lg-10 lg-p-0">
	<!-- ngIf: CurrChapter.Image.ClickURLRef -->

	<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
	</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
	<!--Image desc-->
	<div>
		<div class="position-absolute">
			<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
		</div>
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
			<span class="small-txt ng-binding"></span>
			<span class="small-txt ng-binding"></span>
		</div><!-- end ngIf: CurrChapter.Image -->
	</div>
</div>
</div><!-- end ngIf: CurrChapter.Image -->
						<!-- End IMAGE TAG  ------->

						<div class="row row-gov no-gutters">
							<!--Content Text-->
							<div id="GuidesChapterContent-5" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
<tbody>
	<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Ashdod</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Mei Ami Beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Lido</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>&nbsp;</td>
		<td>&nbsp;</td>
		<td>&nbsp;</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Oranim</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>Yes</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Hakshatot</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Rova K</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Riviera</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td colspan="6" style="text-align: center;"><strong>Hof Ashkelon Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Nitzanim</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zikim</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Ashkelon</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Bar Kochva North</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Bar Kochva South</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Delila North</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Delila South</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Ashkelon National Park Beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>לא</td>
		<td>לא</td>
		<td>לא</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Tamar Regional Council</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Mazor Springs</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Meridian Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Hod Hotel Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Tzel Harim</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Crown Plaza Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Lot</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Lot’s Wife</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Ein Bokek South</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Daniel Hotel Beach</td>
		<td>Yes</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Under construction&nbsp;&nbsp; &nbsp;</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Solarium Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Isrotel Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>International Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Leonardo Plaza Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Zohar Springs (North)</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Leonardo Club Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Eilat&nbsp;&nbsp; &nbsp;</strong></td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><br>
		Separate beach</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
	</tr>
	<tr style="background-color: rgb(255, 255, 255);">
		<td>Herod’s beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
	<tr style="background-color: rgb(244, 244, 244);">
		<td><br>
		Northwestern Beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
	</tr>
</tbody>
</table></div></div>

<p>&nbsp;</p>
</div>

							<!--Chapters/Collapse-->
							<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
								<!-- ngRepeat: collapse in CurrChapter.Collapses -->
							</div>

							<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
							<!--End of Chapters/Collapse-->

							<div class="col-12 xs-mb-25 lg-mb-30">
								<!-- Files for Download-->
								<!-- Files for Download-->
<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->

								<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">

									<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
										<!-- horizontal line -->
										<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
											<div class="horizontal-line"></div>
										</div>
									</div><!-- end ngIf: Guide.Chapters.length > 1 -->

									<!--arrows subject nav  דפדוף-->
									<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-start" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
										<!--  לדף הקודם -->
										<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
											<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
											<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
												<span class="small-txt gray-txt width-100"> Previous page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
											</div>
										</div><!-- end ngIf: CurrChapterindex > 0 -->

										<!--  לדף הבא -->
										<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer ng-hide" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="true">
											<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
												<span class="small-txt gray-txt width-100">Next page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding"></span>
											</div>
											<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
										</div>
									</div>
								</div><!-- end ngIf: !isOnPrintMode -->
							</div>
						</div>
					</div>
				</div>
					</div>
					<!-- end ac-part-5 -->

				</div>
				<div class="img-wrapper">
				<img src=${getImgUrl() +
          "/posts/destination-for-all/6.jpg"} class="img-responsive">
			 </div><br>
					
					`,
      };
    },
  },

  // {
  // 				id:"EILAT1",
  // 		       	ctg : "eilat-negev",
  // 		        bgImage : "/HomeSlider/desktop/4.jpg",
  // 		        mobBgImage : "/HomeSlider/M/3.jpg",
  // 		       	isVid:true,
  // 		       	vidId: "ZdnNT-GDJv4",
  // 		        title : "EILAT",
  // 		        smltitle : "",
  // 		        html: function(){
  // 					return {
  // 						__html: `

  //                         <p>Eilat is a port that is Israel’s outlet to India, eastern Asia and Africa. Six decades ago it was a shanty-style frontier town, but Eilat has developed into one of Israel’s major resorts whose Red Sea beaches and dozens of hotels attract Israelis and tourists from 100 countries. Eilat is devoted to vacationing. Resorts line the promenade and lagoon, along with a giant shopping mall, restaurants and a variety of attractions for visitors young and old. Eilat is also an entrée to one of the world’s most magnificent coral reefs: the Eilat Underwater Observatory is a must for every visitor, as is the dolphin reef where tourists swim with the dolphins.</p>
  //                         <div class="img-wrapper">
  // 								    <img src=${getImgUrl()+ "/posts/eilat1/1.jpg"} class="img-responsive">
  // 							    </div>
  //                         <p>Eilat is a 4/5-hour drive from Tel Aviv and Jerusalem – or a one-hour flight into Eilat Airport which sits in the heart of town. A 15-minute drive south from Eilat brings visitors to the crossing point to Egypt. And 10-minutes to the north, tourists cross to Jordan and the neighboring port city of Aqaba. Many visitors to Eilat take day trips to Petra in Jordan.</p>

  //                          <div class="img-wrapper">
  // 								    <img src=${getImgUrl()+ "/posts/eilat1/2.jpg"} class="img-responsive">
  // 							    </div>
  //                         <h3>Take a deep at the Red Sea</h3>
  //                         <p>An amazing attraction in itself, Eilat’s gorgeous Red Sea and the 10 kilometer-long shoreline surrounding it are the city’s focal point and the main attraction for tourists from far and wide.<br> With their clean, clear and unexpectedly cool water allowing a welcome escape from the city’s high temperatures and dry air, and the wide variety of facilities and attractions, Eilat’s beaches are the perfect spot for sunbathing, rest and relaxation.</p>
  //                         <p>Extreme sports enthusiasts will love the dozens of water sports clubs spread along the southern and northern coasts of Eilat, and the range of activities such as Jet skiing, banana boats, tubing, kayaking and much more.</p>
  //                         <h3>Feel the vibe</h3>
  //                         <p>When evening comes and the hot desert sun sets on Eilat and the pools and beaches close, that is just the time to shower, change and hit the town’s fantastic nightlife scene. Eilat holds a unique record – the city with the most clubs, bars and other entertainment venues per capita in Israel, so there is no shortage of hotspots to make your night as fun-filled as your day.</p>
  //                         <h3>A desert adventure</h3>
  //                         <p>North of the city lies the southern Arava, a region of breathtaking desert vistas, and one of the most recommended areas to visit in the country, where you can feel the vast expanses and hike steep cliffs, valleys, streams and more.</p>
  //                         <p>The colorful and stunning mountains of the Eilat area, besides contributing to the city's breathtaking view, will provide all nature lovers with an unforgettable experience. There are a variety of routes and sites to visit and enjoy by hiking, bicycling, driving, camel riding and even rock climbing or rappelling down cliffs for the extreme sports enthusiasts.</p>
  //                         <p>Don't wait up. Visit Eilat. Escape to the sun.</p>
  // 						 `
  // 		    }
  // 		  }
  // 		},
  // {
  // 		id:"Welcome_To_Eilat",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"ZdnNT-GDJv4",
  //         title : "WELCOME TO EILAT",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                 <h3>A city of sun and fun!</h3>
  // 							<p>The southernmost city in Israel, Eilat is renowned for its spectacular combination of the surrounding desert landscape, the beautiful bay and the summer sun that shines all year round.</p>
  // 							<p>Whether you come to stay in Eilat as a family, a couple or even by yourself, you will find loads to see and do here. Accommodations are abundant, ranging from youth hostels to the r luxury resorts, offering visitors an unforgettable 5 star experience, with everything from the finest restaurants to beach side service.</p>
  // 							<p></p>
  // 							<div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/welcome-to-eilat/1.jpg"} class="img-responsive">
  // 							</div>
  // 							<p>With a whopping 360 Sunny days a year, a visit to Eilat is a fun-filled experience, where you get to relax, recharge and get energized all at the same time. This lively resort city offers a multitude of year-round activities and attractions, excellent restaurants and cafés, shopping centers and trendy bars and clubs.</p>
  // 							<h3>The Red Sea</strong><br> An amazing attraction, Eilat’s gorgeous Red Sea and the 10-kilometer-long shoreline surrounding it are the city’s focal point and the main attraction for tourists from far and wide. With their clean, clear and unexpectedly cool water, allowing a welcome escape from the city’s high temperatures and dry air, and the wide variety of facilities and attractions, Eilat’s beaches are the perfect spot for sunbathing, rest and relaxation.</p>
  // 							<p>Extreme sports enthusiasts will love the dozens of water sports clubs spread along the Southern and Northern coasts of Eilat, and the range of activities such as Jet skiing, banana boats, tubing, kayaking and much more.</p>
  // 							<p></p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "The_Ultimate_Holiday",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: false,
    title: "¿POR QUÉ EILAT ES EL MEJOR DESTINO DE VACACIONES?",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                 
                                 <br/>
                                <h3>Explorando la Ciudad del Sol Eterno<h3>
							    <p><strong>Eilat</strong>, la ciudad más al sur de Israel, tiene todo lo que necesita para unas vacaciones perfectas. Ya sea si está buscando una escapada romántica, vacaciones familiares, una aventura llena de acción o una fiesta con sus amigos, esta bulliciosa ciudad turística a orillas del mar Rojo es el lugar perfecto para usted. Sol mediterráneo, aguas cristalinas, balnearios relajantes, vida nocturna vibrante, compras libres de impuestos y una interminable lista de atracciones, eso es Eilat.</p>
								<p><strong>Disfrute de los rayos del sol</strong>. Con el sol de verano que brilla durante todo el año, el mejor momento para visitar Eilat es... cualquier momento! Incluso en medio del frío invierno europeo, Eilat ofrece una escapada del frío. Solo súbase a un avión y en unas pocas horas dejará de tiritar y se sentirá lleno de vida.</p>
								<p><strong>Elija su casa de vacaciones.</strong> Hostales y albergues asequibles a su bolsillo o lujosos hoteles y hoteles boutique. Centros turísticos orientados a familias y grupos o apartados, tranquilos y románticos: Eilat ofrece una gran variedad de alojamientos para todos los presupuestos y necesidades.</p>
								<p><strong>Salte al agua</strong>. Con más de 7 km de la impresionante costa del mar Rojo, Eilat tiene mucho que ofrecer cuando se trata de actividades acuáticas. Desde snorkel y buceo hasta windsurf, kite-surf, navegación y mucho más, esta ciudad lo tiene todo.</p>
								<p>Experimente el <strong>arrecife de delfines</strong>, una playa ecológica familiar con un magnífico jardín botánico, piscinas de relajación y la atracción principal: una oportunidad para ver, tocar, nadar y bucear con delfines. (<em>No se preocupe, toda interacción con estas hermosas criaturas se basa únicamente en la libre elección del delfín</em>).</p>
                                <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/the-ultimate-holiday/1.jpg"} class="img-responsive">
								</div>
								<p>Visite el <strong>Observatorio Submarino</strong>, una de las atracciones más populares de Eilat que le permite a usted y su familia ver y aprender sobre la vida marina única del mar Rojo. A través de los enormes ventanales observará tiburones, tortugas, rayas y peces multicolores del mar Rojo. Navegando en un barco con visión submarina, se sentirá parte de este mágico reino submarino.</p>
								<p>No se pierda la famosa <strong>Reserva Natural de Coral Beach</strong> y su impresionante arrecife de corales. Practique snorkel y buceo para ver los coloridos peces y las extraordinarias plantas acuáticas en este raro y delicado hábitat natural.</p>
								<p><strong>De aventura por el desierto</strong>. El desierto del Negev ofrece algunas de las rutas panorámicas más espectaculares de Israel. Senderismo, ciclismo o paseos en jeep para explorar y maravillarse con la belleza que le rodea.</p>
								<p>A solo 25 km al norte de Eilat, encontrará el <strong>Valle de Timna</strong>. Realice un recorrido, explore el espléndido paisaje y la antigüedad de la primera mina de cobre del mundo y disfrute de las numerosas atracciones que ofrece a familias y aventureros.</p>
								<p>¿Quiere complementar su aventura? Desde la ciudad es fácilmente accesible el resto del país. Haga una excursión de un día al mar Muerto o Jerusalén.</p>
								<p><strong>Relajese</strong>. Eilat es una ciudad tranquila donde hacer un alto y descansar. Fiel a su estilo, está llena de fantásticas instalaciones de spa que ofrecen diferentes tratamientos, desde masajes tradicionales hasta terapia de agua. <em>Confíe en nosotros, ¡vale la pena!</em></p>
								<p><strong>Compre, coma, beba y festeje</strong>. Compre en el bazar del paseo marítimo, en el lujoso bulevar y en numerosos centros comerciales, ¡todo es libre de impuestos!</p>
								<p><strong>Salga de fiesta por la noche.</strong> Diviértase viendo el colorido espectáculo audiovisual de la fuente musical; prepárese para dejarse cautivar por el espectáculo Wow al estilo de Broadway que combina baile, efectos de luz acrobáticos, gran banda sonora y muchas sorpresas más.</p>
								<p>Cene en uno de los muchos restaurantes y bares de la ciudad y luego baile en un club.</p>
								<p>No hay nada mejor que esto.</p>
								                               
                               
							  


		                        `,
      };
    },
  },
  {
    id: "Eilat_Calling",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat2/1.jpg",
    mobBgImage: "/posts/bank/eilat2/M.jpg",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    title: "EILAT EL VERANO INTERMINABLE",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  
									<h3>La capital del mar Rojo, Eilat, es la ciudad turística más famosa de Israel que atrae a casi 2.8 millones de visitantes al año que vienen de vacaciones a las orillas del impresionante mar Rojo</h3>
									<p>Eilat, la ciudad más meridional de Israel, es famosa por su espectacular combinación de paisaje desértico circundante, la hermosa bahía y el sol de verano que brilla todo el año.</span></p>
									<p>Si viene a Eilat con su familia, pareja o incluso sólo, encontrará mucho para ver y hacer y variedad de alojamiento, que incluye desde los mejores hoteles de lujo de 5 estrellas a apartamentos acogedores de Airbnb y albergues juveniles.</span></p>
									<p>Eilat cuenta con&nbsp; 360 días de sol al año, lo que la hace muy popular entre los turistas de todo el mundo que buscan alejarse de su frío clima invernal.</span><br>Una visita a Eilat es una experiencia llena de diversión donde se relajará y se llenará de energía al mismo tiempo. Esta animada ciudad ofrece una multitud de actividades y atracciones durante todo el año, excelentes restaurantes y cafés, centros comerciales y bares y clubes de moda.</span><br>¿</span>La mejor parte? Todo en Eilat está a pocos pasos de la playa.</span></p>
									<h3>Sumérjase en las profundidades del mar Rojo</h3>
									<p>Una atracción increíble por sí misma, el magnífico mar Rojo de Eilat y la costa de 10 kilómetros que la rodean son el punto focal de la ciudad y la principal atracción para turistas de todo el mundo.</span><br>Las playas de Eilat son perfectas para tomar el sol, descansar y relajarse, gracias a su agua transparente y fresca que permite una escapada de las altas temperaturas y del aire seco de la ciudad, sin olvidar la gran variedad de instalaciones y atracciones.</span><br>Los entusiastas de los deportes extremos adorarán las decenas de clubes de deportes acuáticos que se extienden por las costas del sur y norte de Eilat y la gama de actividades como esquí acuático, bananas, snorkel, kayak y mucho más.</span></p>
									<h3>Viva la noche</h3>
									<p>Cuando cae la tarde y el sol del desierto da una tregua y las piscinas y las playas cierran, es justo el momento de ducharse, cambiarse y disfrutar de la vida nocturna fantástica de la ciudad. Eilat tiene un récord único - la ciudad con más clubes, bares y otros lugares de entretenimiento per cápita en Israel, por lo que no hay escasez de lugares para disfrutar de la noche tanto como del día.</span></p>
									<h3>Una aventura en el desierto</h3>
									<p>Al norte de la ciudad se encuentra la sureña Arava, una región con impresionantes vistas al desierto, y una de las zonas más recomendables para visitar en el país, donde puede sentir las vastas extensiones y caminar por los cortados escarpados, valles, arroyos y mucho más.</span></p>
									<p>Las coloridas e impresionantes montañas de la zona de Eilat, además de contribuir a la impresionante vista de la ciudad, proporcionan a todos los amantes de la naturaleza una experiencia inolvidable. Hay una variedad de rutas y lugares para visitar y disfrutar del senderismo, ciclismo, conducción, paseo en camello e incluso escalada en roca o rapel en los cortados para los entusiastas de los deportes extremos.</span></p>
									<p>No espere. Visite Eilat. Escape al sol.</span></p>
											                        `,
      };
    },
  },
  {
    id: "Eilat_Doolphin_Reef",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: true,
    vidId: "3Cvz8GoxNzA",
    title: "EL ARRECIFE DE DELFINES DE EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
							    <p>Un encuentro fantástico con la fauna.</p>
							    <h3>Nade con los delfines en la singular atracción de Eilat.</h3>
								<p>El Arrecife de delfines de Eilat es un tesoro de vida silvestre en las costas del mar Rojo, donde aventuras llenas de acción acompañan a la naturaleza y relajación. En el arrecife, los visitantes entran en un sitio mágico, interactuando con los delfines en su hábitat natural; una impresionante playa, donde la vida vegetal está en plena floración y la vista es impresionante.</p>
								<p>El largo muelle es un lugar asombroso para observar a los delfines locales "nariz de botella” mientras realizan sus rutinas diarias: comer, jugar, cazar, aparearse y socializarse - a veces también se relacionan con los visitantes humanos del sitio. Los que buscan una experiencia más práctica, pueden intentar interactuar con los delfines a través de las variadas actividades abiertas al público.</p>
								<p>Una experiencia verdaderamente inolvidable, es observar a los delfines durante las comidas, programadas pero encantadoras. Hay algo emocionante en el juego enérgico e infantil de los delfines con sus adiestradores, esperando ansiosamente su comida. La alegría absoluta que sienten una vez que alcanzan la comida provoca casi instintivamente una oleada de aplausos por parte de todos los espectadores. De hecho, los visitantes tienden a sentirse tan emocionados y satisfechos como si fueran ellos mismos los que han recibido comida.</p>

								<p>Sienta la belleza del arrecife y zambúllase con los delfines, obsérvelos en su ecosistema; nadando hasta seis metros de profundidad y experimente la vida magnífica y secreta. Otra opción para los visitantes es nadar con los delfines. Flotar junto a ellos&nbsp;permite a humanos y delfines interactuar de forma divertida.</p>
								<p>En las "piscinas de relajación" del arrecife, los visitantes pueden dejar que sus preocupaciones desaparezcan mientras flotan al son de música relajante. Los restaurantes del lugar llenarán de mimos y atenciones a los visitantes, sin que tengan que salir del pequeño santuario de belleza natural.</p>
										                      
		                        `,
      };
    },
  },
  {
    id: "Action_Packed_Eilat",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "ACTION PACKED EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               <p>So, you’ve heard about the fabulous beaches, the awesome nightlife and fantastic atmosphere of year round sunny Eilat, but aren’t you wondering, amongst all the leisure, what to do with the excess energy? Well wonder no more. Here are just some of the amazing ways to have some action-packed fun in the sun:</p>
		                       
                                   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/action-packed-eilat/1.jpg"} class="img-responsive">
									</div>
								   <p>Eilat’s stunning red sea offers loads of fantastic adventures. For one, its gorgeous underwater environment is known as a world-famous <b>scuba diving destination</b>. Not a pro? No problem. There are short courses that run for 1-2 days.</p>
								   <p>Atop the waves, you’ll find, <b>windsurfing</b>, <b>kitesurfing</b>, and <b>stand-up paddle boarding</b> options for which it’s always an ideal time in Eilat, with its pristine beaches, calm waters, and perfect sunny weather almost year-round. By the way, don’t worry about equipment or experience, as there are plenty of options for rentals and individual or group lessons for all ages as well as all-inclusive packages. You’ll be flying across the sea in no time!</p>
								   <p>Looking to flex a few more muscles? Eilat’s nearby desert area offers <b>fantastic hikes</b> in stunning trails where you can <b>walk or bike</b> through breathtaking desert scenery.<span class="Apple-converted-space">&nbsp; </span>Feeling adventurous? Check out the huge array of unique action attractions from unforgettable camel rides to <b>adrenaline charged ATV rides</b> to thrilling off cliff <b>paragliding,</b> guaranteed to get the heart racing.</p>
								   <p>If your holidays are all about breathtaking adventures, Eilat is definitely the place for you!</p>
								 


		                        `,
      };
    },
  },
  // {
  // 		id:"Eilat_Ultimate_Beachside",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"ZdnNT-GDJv4",
  //         title : "EILAT ULTIMATE BEACHSIDE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 						   <p><strong data-mk-aweb-org-font-size="17">Enjoy the water attractions that make Eilat the ultimate beachside getaway</h3>
  // 						   <p>Surrounded by water, Eilat, Israel’s most southern city, is a wet and wild adventure hub unlike anywhere else in the country. Eilat boasts top beaches, water sports, activities and attractions, open to the public year-round due to the warm local climate.</p>
  // 						   <p>Dip your toes in the clear, blue waters of Eilat’s beaches, spanning over twelve kilometers of sand, boardwalk, hotel and commercial attractions.</p>
  // 						   <p>Relax at one of the more secluded and quiet southern beach locations and swim around the coral reefs, or enjoy a vibrant tourist scene at one of the northern beaches, where nearby hotels, restaurants and shops keep the public satisfied and entertained. Or, enjoy the region from aboard a yacht sailing through the waters, allowing you to soak up the sun, unwind and socialize.</p>
  // 						   <p>Delve into the uniquely beautiful habitat of the Eilat Coral Beach Nature Reserve. Put on snorkeling gear and observe or interact with the local sea creatures as they swim about.</p>
  // 						   <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/eilat-ultimate-beachside/1.jpg"} class="img-responsive">
  // 							</div>

  // 						   <p><strong data-mk-aweb-org-font-size="17">The heart of Israel’s extreme water adventures</h3>
  // 						   <p>Eilat is the heart of Israel’s extreme water adventures. Feel the wind in your hair and sun on your cheeks as you embark upon a water ski, jetski, banana boat, surfing or glass bottom boat ride, speeding through the waters at an exhilarating pace. Prefer to remain above water? Opt instead to take in an aerial view of the waters and parasail over the Eilat Bay.</p>
  // 						   <p>Do you love wildlife? Swim or snorkel with dolphins at Eilat’s Dolphin Reef. The unique ecological site, in the midst of a magical beach, allows visitors an up-close glimpse into the dolphins’ lives and makes for an exciting outdoor adventure. Fancy an underwater experience without getting wet? Take a tour of the Eilat Underwater Observatory, a captivating glimpse into life below sea level, combined with interactive activities and special exhibits.</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "One_Day_In_Eilat",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "ONE DAY IN EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
								   <h3>Suggestions for an awesome day in the sun</h3>
								   <p>Whether you’re staying in one of the city’s 5 star hotels, a hostel or have opted for the cool camping alternative, we recommend to start your day with a delicious breakfast and make your way to the <b>Dolphin Reef</b>. This is one of the most popular attractions in Eilat, where you can touch, swim and dive with these beautiful creatures. Watch the dolphins in their natural habitat, visit the underwater photo center, or take part in either scuba diving or snorkeling. Check out also <b>Coral Beach</b>, the natural underwater reserve that extends for 1,200 meters along the coast and gives you the opportunity to go snorkeling with an extraordinary variety of tropical fish in a beautiful coral reef.</p>
								   <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/one-day-in-eilat/1.jpg"} class="img-responsive">
									</div>
								
								   <p>Once you’ve dried off, head to the stunning <b>Botanical Gardens</b> within Eilat. You’ll find there more than 1,000 types of trees and plants from all around the world, streams, waterfalls, a rainforest and bird sanctuaries.</p>
								   <p>To end of your day with something slightly different, head just outside of Eilat to the <b>Red Canyon,</b> where you can track through the riverbed and between the red Nubian sandstone walls that have been sculpted over the centuries by wind and water.</p>
								   <p>When evening comes, make your way to the buzzing Eilat promenade ,stroll by the shops and market stands which are open until late. You can treat yourself to a meal in any of the dozens of the excellent restaurants and cafés or a drink in any of the lively seaside pubs and bars.</p>
								  
		                        `,
      };
    },
  },
  {
    id: "Majestic_Desert",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "EL NEGEV - EL MAJESTUOSO DESIERTO DE ISRAEL",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   <div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/yXzhH92kREg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>
								   <h3>DONDE LA AVENTURA Y LA INSPIRACIÓN AGUARDAN</h3>
								   <p>UN DESTINO IDEAL PARA VIAJEROS QUE AMAN LA AVENTURA AL AIRE LIBRE, EL SUR DE ISRAEL ESTÁ ESCASAMENTE POBLADO, PERO LLENO DE SITIOS FASCINANTES Y ACTIVIDADES.</p>
									<p >Con impresionantes maravillas naturales y belleza, el sur cuenta con magníficas vistas que seguro le quitarán el aliento, desde el amanecer hasta el atardecer.</p>
									<p >Un desierto pero definitivamente no desértico, hay tanto que ver y hacer aquí - hay muchas maravillas geológicas, importantes hitos históricos y maravillosas reservas naturales donde puede practicar senderismo, ciclismo y paseos en camello o disfrutar de paseos por el desierto en 4x4 cargados de adrenalina.</p>
									<p >En pocas palabras, esta majestuosa región meridional es uno de los mayores activos del país y una visita obligada en el itinerario.</p>
									
									<h3>Cráter de Ramón</h3><br/>
									<div class="responisve-iframe">
																           <iframe width="560" height="315" src="https://www.youtube.com/embed/QL3BGy2p77g" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
															           </div>
									<p >En el corazón del gran desierto del Negev de Israel se encuentra el cráter de Ramón, el cráter de erosión más grande del mundo, también conocido como Maktesh Ramon. Este fascinante fenómeno natural, que abarca una gran diversidad de rocas de colores y formas fantásticas, mide 40 km de longitud entre 2 y 10 km de ancho, con forma de corazón largo, cuenta con el parque nacional más grande de Israel, la Reserva Natural Ramón.<br>Lejos de las luces de la ciudad y las multitudes y con arena multicolor, roca volcánica y fósiles, el cráter de Ramón es a menudo descrito como el Gran Cañón de Israel.<br>Las impresionantes vistas desde el mirador del Maktesh Ramon con un desnivel de 300 metros, recuerdan a un telón de fondo de Hollywood, ofrecen una poderosa experiencia para turistas de todo el mundo, durante todo el año</p>
									<div class="img-wrapper">
																					<img src=${getImgUrl() + "/posts/majestic-desert/1.jpg"} class="img-responsive">
																					Credit: Daphna Tal
																		</div>
									<h3>La experiencia beduina</h3>
									<p >La hospitalidad beduina es una experiencia verdaderamente incomparable, agradable y&nbsp;atractiva.<br>Un grupo de tribus nómadas indígenas de la zona que se remontan a cientos de años atrás, los beduinos de Israel, siguen viviendo de forma tradicional, abriendo sus corazones y sus hogares y su forma de vida al público para compartir sus costumbres y su hospitalidad conocida mundialmente.<br>Desde paseos en camello hasta comidas beduinas tradicionales e incluso noches en tiendas beduinas, todas estas atracciones son muy populares ente los turistas de la región que les brinda la oportunidad de descubrir y conectarse con un estilo de vida olvidado.</p>
									<h3>La Ciudad Vieja de Be'er Sheva</h3>
									<p >Se dice que fue fundada por Abraham, el Patriarca, Be'er Sheva es una de las ciudades más antiguas del país. La ciudad vieja de Be'er Sheva, tan encantadora como histórica, ofrece un fascinante mosaico de espacios urbanos y al explorar la ciudad antigua revela una rara riqueza de arquitectura única, con&nbsp;historias tan antiguas como el tiempo.</p>
									<div class="img-wrapper">
																					<img src=${getImgUrl() + "/posts/majestic-desert/2.jpg"} class="img-responsive">
																		</div>
									<h3>Arad</h3>
									<p >Arad del nuevo milenio es una ciudad con espíritu joven y rica experiencia. Arad y sus alrededores han sido bendecidos con hermosos paisajes, la tranquilidad del desierto, y muchos senderos para caminar en solitario, adecuados para cualquier edad o estilo.<br>Con un montón de atracciones y un montón de sitios de turismo en la ciudad y alrededor, Arad es el punto de partida perfecto y su puerta natural a las vacaciones perfectas en el desierto.</p>
									<div class="img-wrapper">
																					<img src=${getImgUrl() + "/posts/majestic-desert/3.jpg"} class="img-responsive">
																					Credit: Daphna Tal
																		</div>
									<h3>Naturaleza</h3>
									<h3>Yotvata Hai-Bar</h3>
									<p >La reserva natural de Yotvata Hai-Bar es el centro más grande de&nbsp; cría y recuperación de animales antes de ser reintroducidos en la vida salvaje. La reserva cuenta con maravillosas atracciones que son un deleite absoluto para los amantes de los animales, incluyendo el centro de los depredadores con especímenes vivos y pequeños animales del desierto, un observatorio de animales nocturnos en condiciones oscuras y 12 kilómetros cuadrados de terreno donde las manadas de herbívoros vagan libres.</p>
									<div class="img-wrapper">
																					<img src=${getImgUrl() + "/posts/majestic-desert/4.jpg"} class="img-responsive">
																					Credit: Daphna Tal
																		</div>
									<h3>Aventuras extremas</h3>
									<p >El sur de Israel es un destino de ensueño total para viajeros aventureros. Su terreno único y desafiante es un escenario ideal para diversos deportes extremos y actividades como descenso por cañones empinados y ciclismo en todas sus variedades que son muy populares en esta zona, así como son los tours de aventura en 4x4 que está de moda tanto para lugareños como turistas.</p>
																	   
															           
								
                                   
									
									


		                        `,
      };
    },
  },
  // {
  // 		id:"Negev1",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"yXzhH92kREg",
  //         title : "NEGEV",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                              <p>The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.</p>
  // 					   <p>Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.</p>
  // 					   <p>There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.</p>
  // 					   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/negev/1.jpg"} class="img-responsive">
  // 							</div>

  // 					   <h3>The Israeli desert is special for the following reasons:</h3>
  // 					   <ul>
  // 					      <li><strong>The desert is very near:</strong>&nbsp;just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half). Starting from November, there will be direct flights from Europe and Russia to Ovda airport including&nbsp;Ryanair, Wizzair, and SAS.</li>
  // 					      <li><strong>Easy to Hike and Bike:</strong>&nbsp;There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert.</li>
  // 					      <li><strong>Cordial local population:</strong>&nbsp;The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.</li>
  // 					      <li><strong>Tourists Activities:</strong>&nbsp;Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.</li>
  // 					      <li>
  // 					         <strong>Magnificent landscapes:</strong>&nbsp;Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety
  // 					         <ul>
  // 					            <li>There are spectacular sand dunes in the north.</li>
  // 					            <li>The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.</li>
  // 					            <li>In the east, one experiences the African desert with wide savannas and acacia trees.</li>
  // 					            <li>To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.</li>
  // 					         </ul>
  // 					         <p>During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers. Many tourists decide for to stay for 2 or 3 days in each region of the Negev.</p>
  // 					      </li>
  // 					      <li><strong>The Negev is very safe to travel.</strong>&nbsp;In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.</li>
  // 					   </ul>
  // 					   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/negev/2.jpg"} class="img-responsive">
  // 							</div>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Location_And_Approach",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    title: "NEGEV – CÓMO LLEGAR UBICACIÓN Y ENFOQUE",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
								    <p>Aterrizaje en los aeropuertos de Ovda o Eilat para seguir&nbsp; a Mitzpe Ramon o Sde Boker:</p>
									<h3>Medios de transporte públicos:</h3>
									<p><strong>Autobús 392</strong> de Eilat a Mitzpe Ramon y Be'erSheva, para en el aeropuerto de Ovda los <strong>domingos</strong> a las 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.</p>
									<p>Llegada a la estación central de autobuses de Mitzpe Ramon una hora y media.</p>
									<h3>Lunes a jueves</strong> a las 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.</p>
									<img src=${getImgUrl() +
                    "/posts/location-and-approach/1.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div><br/><br/>
									<p><a href="//www.egged.co.il/HomePage.aspx" target="_blank">Servicio de autobús</a><br/>
									<a href="https://eilatshuttle.com/" target="_blank">Servicio de transporte desde el aeropuerto de Ovda</a></p>
									<h3>Alquiler de coches en Eilat, Mitzpe Ramon y Be'erSheva:</h3>
									<p>Hay varias opciones de alquiler de coches en estas ciudades. Hay una selección de compañías internacionales e israelíes.</p>
									<p>Aterrizaje en el Aeropuerto Internacional Ben Gurion cerca de Tel Aviv y continuando viaje a Negev a Mashabei Sadeh / Sde Boker / Mitzpe Ramon</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/location-and-approach/2.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>
									<h3>Medios públicos de transporte:</h3>
									<div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/i_4QKtXIeto" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>
									<ul>
									<li>Rutas de autobús 370/380 de Tel Aviv a Be'er Sheva.</li>
									<li>Rutas de autobús 446/470 desde Jerusalén a Be'er Sheva.</li>
									<li>Tren desde Ben Gurion o Tel Aviv a Be'er Sheva.</li>
									<li>Desde Be'er Sheva las rutas de autobús 60, 64, 65, 660. Salida todas las mañanas a las 6 a.m. (aproximadamente cada 20 minutos). Llegada a Mashabei Sadeh en 35 minutos / área de Sde Boker en 55 minutos / Mitzpe Ramon en 1 hora y 20 minutos.</li>
									</ul>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/location-and-approach/3.jpg"} class="img-responsive">
									</div>
									<p>Puede encontrar más información sobre los medios de transporte público en los siguientes enlaces: <a href="https://www.bus.co.il/otobusimmvc?Language=en" target="_blank">https://www.bus.co.il/otobusimmvc?Language=en</a>;
									<br/><a href="//www.egged.co.il/HomePage.aspx" target="_blank">http://www.egged.co.il/HomePage.aspx</span></a></span></p>

									
									
									
									
						           <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/location-and-approach/3.jpg"} class="img-responsive">
									</div>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/location-and-approach/4.jpg"} class="img-responsive">
									</div>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/location-and-approach/5.jpg"} class="img-responsive">
									</div>
									

		                        `,
      };
    },
  },
  // {
  // 		id:"Stay_In_The_Negev",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "STAY IN THE NEGEV",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `<p> A trip to the Negev offers so much more than just grand vistas and tranquil surroundings one tends to think about when conjuring up the word desert. While the Negev still offers all the natural beauty, calmness and wondrous sites, which the desert tourist is looking for, it is also extremely interesting, westernized and packed with activities and adventures and even offers all the comforts of a modern holiday.</p>
  //                                <p> The Negev offers a huge variety of accommodation options. So much more than just a place to lay your hat down, the form of accommodation you choose will offer you opportunity to acquaint yourself with the undisputable gem of the Negev - its local community. From the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, you will find the people of the Negev are warm, hospitable and always ready to lend a hand. Here are just a few examples of hospitality options, which can be found in the Negev:</p>
  //                                <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/stay-in-the-negev/1.jpg"} class="img-responsive">
  // 						  </div>

  // 						   <p>Hotels – the Negev has a huge host of hotel options ranging from budget hotels to 5-star international prize-winning luxury hotels, where you can chill in style during your desert break.</p>
  // 						   <p>Hostels – an affordable accommodation geared mostly towards young travelers. Here many tourists enjoy the opportunity to meet and engage with other like-minded travelers from all over the world and spend their evenings socializing and often creating lasting friendships.</p>
  // 						   <p>Zimmers -This is Israel’s version of the Bed and Breakfast, usually separate from the owners’ own home, these are often more secluded and cozy lodgings, suitable for travelers looking for romance and peaceful settings.</p>
  // 						   <p>Bedouin Hospitality tents- the definite Negev must, this truly unique and authentic form of hospitality, which welcomes you into the indigenous Bedouin community’s way of life, affords an exceptional opportunity to take part in the Bedouin traditions in their natural environment – highly recommended.</p>
  // 						   <p>Khans – again, unique to the Negev, the popular Kahns are in fact large outdoors complexes, which offer huts and communal sleep areas as well as all basic facilities. While Kahns are often a more basic and rustic form of accommodation, they are an excellent way to experience the chilled atmosphere of the area, connect with other travelers and locals and feel part of the natural surroundings of the desert.</p>
  // 						   <p>Lone farms – a more recently developed form of accommodation, lone farms are in fact guest rooms in quaint and remote family-run farms throughout the Negev. &nbsp;Combining tranquil settings with home comforts, the lone farms offer privacy, incredible views and an authentic way to experience the awesome desert atmosphere of the Negev.</p>
  // 						   <p>Kibbutz - a distinctly Israeli form of collective communal settlements, Kibbutz accommodations offer good value accommodation at affordable prices. The true appeal of the Kibbutz, however, is their uncountably their special atmosphere and communal spirit, and the residents warm, inviting and hospitable spirit, guaranteeing a pleasant and memorable stay.</p>

  //                         `
  //     }
  //   }
  // },
  // {
  // 		id:"Pure_Desert_Magic",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "NEGEV PURE DESERT MAGIC",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				               <p>The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.</p>
  // 							   <p>Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.</p>
  // 							   <p>There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.</p>
  // 							   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/pure-desert-magic/1.jpg"} class="img-responsive">
  // 						       </div>
  // 						       <p><strong data-mk-aweb-org-font-size="17">The Israeli desert is special for the following reasons</strong>:</p>
  // 							   <ul>
  // 							      <li><strong>The desert is very near</strong>&nbsp;- just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).</li>
  // 							   </ul>
  // 							   <p>Starting from November, there will be direct flights from Europe and Russia to Ovda airport including&nbsp;<strong>Ryanair</strong>,&nbsp;<strong>Wizzair</strong>, and&nbsp;<strong>SAS</strong>.</p>
  // 							   <p>For further details check the following link:&nbsp;<a href="//www.iaa.gov.il/en-US/airports/ovda/Pages/default.aspx" target="_blank" rel="noopener">www.iaa.gov.il</a></p>
  // 							   <ul>
  // 							      <li><strong>Easy to Hike and Bike</strong>: There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:&nbsp;<a href="//www.negevtour.co.il/" target="_blank" rel="noopener">www.negevtour.co.il</a>&nbsp;;&nbsp;<a href="//www.en.aravaway.co.il/" target="_blank" rel="noopener">www.en.aravaway.co.il</a></li>
  // 							      <li><strong>Cordial local population</strong>: The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.</li>
  // 							      <li><strong>Tourists Activities:</strong>&nbsp;Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.</li>
  // 							      <li>
  // 							         <strong><strong>Magnificent landscapes:&nbsp;Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety</strong></strong>
  // 							         <ul>
  // 							            <li>There are spectacular sand dunes in the north.</li>
  // 							            <li>The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.</li>
  // 							            <li>In the east, one experiences the African desert with wide savannas and acacia trees.</li>
  // 							            <li>To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.</li>
  // 							         </ul>
  // 							      </li>
  // 							   </ul>
  // 							   <p>During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.</p>
  // 							   <p>Many tourists decide for to stay for 2 or 3 days in each region of the Negev.</p>
  // 							   <ul>
  // 							      <li><strong>The Negev is very safe to travel</strong>. In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.</li>
  // 							   </ul>
  // 							   <h3>More information and tips for accommodation and recommendations:</h3>
  // 							   <p><a href="//www.negevtour.co.il/" target="_blank" rel="noopener">www.negevtour.co.il</a></p>
  // 							   <p><a href="//www.en.aravaway.co.il/" target="_blank" rel="noopener">www.en.aravaway.co.il</a></p>
  // 									                        `
  //     }
  //   }
  // },
  {
    id: "Action_Fun_In_The_Desert",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: true,
    vidId: "yXzhH92kREg",
    title: "EL NEGEV: AVENTURA EN EL DESIERTO",
    smltitle: "",
    html: function() {
      return {
        __html: `

						          <h3>El negev: aventura en el desierto no hay lugar como el negev para unas vacaciones relajantes bajo el sol del desierto</h3>
								   <p>El desierto del Negev de Israel es un lugar impresionante para visitar. Cubre más de la mitad de la superficie total de Israel&nbsp; y es una región rica en arena, sol, parques naturales y atracciones turísticas. La región sur del país es una visita obligada en su próximo viaje a Israel, especialmente si busca un lugar amplio y una experiencia del desierto israelí estrellada.</span></p>
									<h3>Relájese rodeado de increíbles maravillas naturales</h3>
									<p>Diríjase hacia el sur, al desierto del Negev, donde la arena y el sol se mezclan y conectan con la región a través de emocionantes rutas de senderismo, impresionantes vistas, sitios históricos y atracciones turísticas. Elija entre una amplia variedad de actividades para satisfacer sus intereses únicos,&nbsp; encontrarse con animales majestuosos y&nbsp; familiarizarse con las culturas antiguas. Diríjase al cráter de Ramón, donde la vista es infinita. Desenrolle una estera de yoga o siéntese en la colorida arena y disfrute de un momento de profunda e intensa meditación. Cuando el sol se pone y el cielo se llena de estrellas, viaje a un centro de hospitalidad beduino, donde los huéspedes son tratados como reyes con deliciosos dulces, divertidos paseos en camello y la oportunidad de acampar en el desierto. O bien, viaje a lo largo de la Ruta del Incienso y visite las cuatro ciudades locales que florecieron gracias al comercio de especias y se convirtieron en sitios del patrimonio mundial.</span></p>
									<div class="img-wrapper">
										<img src=${getImgUrl() +
                      "/posts/action-fun-in-the-desert/1.jpg"} class="img-responsive">
									</div> 
									<h3>Cuando se trata de vacaciones familiares, el cielo del desierto es el límite</h3>
									<p>El desierto israelí tiene actividades divertidas y maravillosos alojamientos que se adaptan a las necesidades de todas las familias, muy cerca de muchos hoteles modernos y pintorescas casas de huéspedes. Lleno de sitios y actividades increíbles, el Negev es un gran lugar para la diversión simple; ir de excursión a parques nacionales, andar en bicicleta por los senderos para bicicletas de la región o conducir en todoterreno (o conducción de ATV) arriba y abajo por las dunas. Las vastas extensiones y el paisaje montañoso lo convierten en una aventura emocionante, independientemente de la actividad que elija. Si está buscando una forma más relajada de pasar sus vacaciones, visite una bodega del Negev, contemple un manantial de aguas cristalinas en el corazón del desierto israelí o visite una granja. O aproveche su visita al Negev para viajar un poco más y flotar en el salado mar Muerto, limpiando su piel en el barro aterciopelado de la región.</span></p>
									<p>photo credit: &nbsp;Dafna Tal</p>
								   
								                           
		                        `,
      };
    },
  },
  {
    id: "The_Incense_Route",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    title: "LA RUTA DEL INCIENSO",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						                <br/><h3>Una historia de éxito comercial de 2.000 años de antigüedad</h3>
						                <p>La legendaria Ruta del Incienso es una historia de éxito comercial con 2.000 años de antigüedad.<br/>
										En esa época, sin transporte, carreteras o mapas, largas caravanas de camellos atravesaban senderos difíciles encontrándose con ladrones, saqueadores, obstáculos y gobernantes de mente estrecha. Con bienes valiosos, la ruta comenzaba en Yemen hacia el este, cruzaba Arabia Saudita, Jordania e Israel terminando en el puerto de Gaza, donde fueron cargados en buques mercantes con destino a Europa. Allí, las mujeres del Imperio Romano podían disfrutar de los perfumes del incienso y la mirra, los sabores de las especias orientales y las sales útiles para cocinar y conservar alimentos.</p>
										<p>El viaje de la Ruta del Incienso de 2.400 kilómetros duraba unos seis meses. Las caravanas de camellos, con miles de personas, avanzaban con paso lento, pasando por 56 paradas, donde se detenían a descansar, cuidar de los animales y reunir fuerzas para el día siguiente.</p>
										 <div class="img-wrapper">
																						<img src=${getImgUrl() +
                                              "/posts/the-incense-route/1.jpg"} class="img-responsive">
																		        </div> 
										<p>La sección israelí de la Ruta del Incienso cubría unos 150 kilómetros. Al otro lado del desierto del Negev todavía hay ruinas de la ruta, y muchos viajeros se dispusieron a seguirlos&nbsp; explorando el desierto y tratar de experimentar el estilo de vida de los expertos del desierto. Varias de las paradas de descanso continúan comenzando en Moa de Arava en la frontera con Jordania, donde las ruinas de una posada, un puesto de guardia,&nbsp; agricultura,&nbsp; cuevas,&nbsp; depósitos y un acueducto aún son evidentes. Desde aquí, la ruta continúa hacia el noroeste hasta Mamshit, una gran ciudad cuyas impresionantes ruinas incluyen una posada, iglesias, una casa de baños, piscinas de recolección de agua de lluvia y otras estructuras.</p>
										<p>La siguiente parada era la ciudad de Avdat, ubicada en lo alto de una colina. Aquí también están las ruinas de una fortaleza, iglesias, una prensa de aceite, un taller de cerámica, casas, una casa de baños e incluso cuevas funerarias.</p>
										<p>La caravana continuaba de Avdat a Shivta, una pequeña ciudad con un sistema de agua bien desarrollado, piscinas, prensas de aceite y algunas iglesias. La penúltima y más septentrional parada fue Halutsa, de la que quedan las ruinas de un teatro y una iglesia, y desde donde las caravanas se dirigían directamente a Gaza. Se agregaron algunas estaciones menores en el camino, Kasra, Nekarot, Makhmal y Grafon, así como una posada adicional, Ein-Saharonim, de la cual todavía hay un patio rodeado de talleres y un baño.</p>
										<p>A lo largo de la ruta, hay embalses, torres de vigilancia, sitios rituales, instalaciones de baño e hitos que marcaron la ruta.</p>
										<p>Moa, Mamshit, Avdat, Shivta y Haluza, así como Ein-Saharonim, son accesibles con cualquier vehículo. La ruta en sí, a través del desierto es transitable solo en jeeps, aunque ciclistas y&nbsp; peatones también pueden disfrutar del fascinante sendero. En 2005, la UNESCO declaró la Ruta del Incienso Patrimonio de la Humanidad. Israel lo invita cordialmente al Negev y a Aravá a seguir los pasos de los nómadas y disfrutar de las impresionantes historias y del espléndido legado que dejó un testigo silencioso en una época tormentosa.</p>
																                
								     
										                        `,
      };
    },
  },
  {
    id: "Mount_Karkom",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "MOUNT KARKOM",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  <p>In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.</p>
								   <p>Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai – mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.</p>
								   <p>Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/mount-karkom/1.jpg"} class="img-responsive">
								       </div>	
								       <p>Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.</p>
                                    <p>To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.</p>                      

										                        `,
      };
    },
  },
  {
    id: "Ha_Arava",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: false,
    title: "ARAVÁ: ¡SORPRÉNDASE!",
    smltitle: "",
    html: function() {
      return {
        __html: `

						       <p>Entre la intersección de Menucha en el norte y la primera rotonda entrando a Eilat, abrazado por Har HaNegev, las Montañas Eilat al oeste y las montañas Edom al este está ... Aravá: un tramo estrecho pero impresionante donde <i>sentirá</i> el desierto, con todo lo que ofrece, con su pareja, familia o grupo. Los visitantes tienen muchas maneras de ver Aravá, ya sea a pie, en bicicleta, en automóvil o autobús. Los alojamientos van desde máximo lujo a "glamping" para dormir bajo las estrellas. Aquí tiene una lista recomendada de que ver y que hacer:</p>
								<h3>Parque Nacional&nbsp; Timna</h3>
								<p>Nuestro recién inaugurado centro de visitantes en la entrada del parque le da la bienvenida con una introducción informativa del sorprendente paisaje de Timna, que combina arenisca roja esculpida por la naturaleza yuxtapuesta con cantos rodados en blanco y negro que crean un espectacular telón de fondo. Timna en forma de U, descubre tesoros de diferentes épocas y cuenta la historia de antiguas minas de cobre egipcias que todavía producen mineral, mediante auténticas reliquias y otros hallazgos.</p>
								<p>Timna cuenta con más de 25 rutas de senderismo, ciclismo (incluida una pista única) y automovilismo, entre ellas, el <b>Hongo</b>, los <b>Arcos</b>, los <b>Pilares de Salomón</b>, el <b>Cañón Rosado</b>, el <b>Sacacorchos</b> y las <b>Caras</b>. Y hay más: el Tabernáculo, una réplica exacta del &nbsp;tabernáculo bíblico llevado por los israelitas mientras deambulaban por el Sinaí; un lago con botes de pedales; preparación de botellas de arena de colores y otras artes y artesanías; alquiler de bicicletas; un camping regulado; y la Posada del Rey Salomón, donde puede disfrutar de un refrigerio en el desierto y comprar suvenires.</p>
								<h3>Hai-Bar santuario de fauna</h3>
								<p>El objetivo de Hai-Bar es reintroducir &nbsp;los animales mencionados en la Biblia en la naturaleza. Mientras tanto, los animales están protegidos y cuidados en sus hábitats naturales, abiertos a los visitantes. Estos incluyen circuitos para vehículos motorizados donde se puede disfrutar de un safari que incluye Óxix, antílopes de cuerno de tornillo, y ... ¡avestruces! ... intercalados con la flora del desierto, incluida la acacia bíblica. En nuestra tienda se venden&nbsp; CD en varios idiomas para guiarlo. Las visitas guiadas se realizan los sábados a las 11 a.m. ¡la hora del "brunch" de los animales! Camping con servicios también está disponible.</p>
                                <div class="img-wrapper">
											   <img src=${getImgUrl() + "/posts/ha-arava/1.jpg"} class="img-responsive">
								    </div>
								<h3>Granja de especias Eilat</h3>
								<p>La granja, que se dedica a la investigación de la maricultura, se encuentra en un antiguo cruce entre la Ruta de las Especias y la Via Maris, frente a las montañas de Edom. Se cultivan aquí algas marinas, almejas, gambas artemias y los dottybacks de orquídeas (también conocidos como "peces Friedman", llamados así por el dueño de la granja que los descubrió).</p>
								<p>El centro de visitantes de la granja es una celebración para los sentidos, donde al entrar, le envuelven las fragancias de docenas de especias, mezclas e infusiones tanto para cocinar como curativas; así como una variedad de utensilios de cocina y utensilios especiales, cuyos usos estará encantado de explicarle nuestro personal.</p>
								<h3>Consuma productos orgánicos en Neót Smadár</h3>
								<p>Realice un recorrido a pie auto-guiado por nuestra comunidad, que cuenta con un impresionante centro artístico que tardó 13 años en construirse, a través de nuestros terrenos, que reflejan nuestra atención al detalle combinado con nuestro carácter rústico, viñedo orgánico y la bodega más sureña de Israel.</p>
								<p>Nuestro centro de arte alberga talleres de artesanía y una galería que exhibe y vende su trabajo. El centro de la estructura, conocida por su torre característica, es un eje hidrante que enfría todo el edificio en lugar del aire acondicionado convencional. Todo el centro, por dentro y por fuera, presenta carpintería ornamental, elaborada por nuestros miembros de la comunidad.</p>
                                 <div class="img-wrapper">
											   <img src=${getImgUrl() + "/posts/ha-arava/2.jpg"} class="img-responsive">
								    </div>
								<h3>Aravá después del anochecer</h3>
								<p>El paisaje cambia al atardecer, desde las montañas de Edom, cambiando a tonos cada vez más oscuros rojizos y color púrpura, en la noche plagada de estrellas y bañada por la luz de la luna. Es hora de dormir ... lo ayudaremos a elegir el alojamiento más adecuado y cómodo. Llámenos al teléfono fijo +972 (8) 661.6976.</p>

								    
															                               
		                        `,
      };
    },
  },
  {
    id: "Machtesh_Ramon",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "MACHTESH RAMON",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <p>At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater, also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an elongated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.</p>
		                        <div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/machtes-ramon/1.jpg"} class="img-responsive">
								</div>
								<p>Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock, and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.</p>
								<p>The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.</p>
								<p>A visit to Machtesh Ramon offers a range of exciting experiences and attractions specifically geared towards tourists and world travelers:</p>
								<h3>Ramon Crater Visitor Center</strong>&nbsp;–&nbsp; Built on the crater’s edge, the visitor center overlooks the awesome views from the Machtesh and offers an opportunity to learn about its unique natural phenomena, and also about the life and work of Ilan Ramon, the first Israeli astronaut.</p>
								<h3>Hai Ramon</strong>&nbsp;- Raising awareness to the local animal population, The Hai Ramon animal park offers a fascinating encounter with the often obscure and unseen small animals of the desert, The site features about 40 species of animals: lizards, snakes, turtles, spurs, hedgehogs, falcons, pheasants and more.</p>
								<h3>Kahn Saharonim</strong>&nbsp;– a short walk from this once station on the Nabatean Spice Route, is Ein Saharonim, a beautiful spring (dry in the summer) which features rich vegetation and the footprints of the many animals that come to enjoy its waters.</p>
								<h3>The Carpentry</strong>&nbsp;– a fascinating geological phenomenon, The Carpentry is a concentration of elongated stones in the form of prisms formed when the sandstone was "baked" at the high temperature created by a hot lava flow from the depths of the earth. During its cooling, the rock formed into thousands of ribbed columns, and the fragments of the columns act as the prisms.</p>
								<h3>The Ammonite Wall</strong>&nbsp;- a rock wall featuring fossils of ammonites - marine animals that lived millions of years ago in the sea which then covered the entire Negev area.</p>
								<p>A trip to Machtesh Ramon is a fascinating experience, one guaranteed to create a strong impression and a lasting memory.</p>

		                        `,
      };
    },
  },
  {
    id: "Epic_Masada",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    title: "EXPLORE MASADA",
    smltitle: "",
    html: function() {
      return {
        __html: `   <h3>La cumbre del valor en el corazón del desierto de Judea</h3><br/>
						            <h3>Reviva la historia épica en la cima de la gloriosa fortificación del desierto de Judea</h3>
									<p >Viaje al Parque Nacional Masada, la única, aislada, antigua fortificación&nbsp; del desierto de Judea, con vistas al cercano mar Muerto. Camine por el serpenteante sendero o escalera romana desde la base de la fortificación, o entre en el Centro de Visitantes de Masada. Llegue a la cumbre a través del teleférico y comience a experimentar una parte de la historia antigua, como si todavía estuviera realizándose.</p>
									
									<h3>Explore ruinas regias y siéntase parte de la historia</h3>
									<p>Entre a lo que fue una vez residencia de lujo que forma la fortaleza final habitada por los luchadores por la libertad, que valientemente libraron la guerra contra el imperio romano después de la destrucción del segundo templo. Un sitio tan rico en narrativa histórica, que las frescas paredes de piedra lloran prácticamente por las almas valientes que eligieron la muerte prematura a la esclavitud bajo el régimen enemigo.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/epic-masada/1.jpg"} class="img-responsive">
								    </div>
									<h3>Donde experimentar cultura y religión alcanza nuevas alturas</h3>
									<p>Pasee por las ruinas del palacio y descubra las habitaciones y estructuras, hallazgos arqueológicos que destacan la vida en Masada durante el asedio romano. Entre por la zona norte, las ruinas del palacio de la fortaleza privada del rey Herodes. Susurre una oración en la antigua sinagoga, donde los judíos se reúnen tres veces al día para orar por la salvación. Rinda homenaje a los fallecidos combatientes por la libertad que echaron a suerte, en la "Sala de la Lotería" el orden de las muertes inminentes de los hombres, hasta que el último puso fin a su vida también.</p>
									<p>&nbsp;Mire lo que queda de una iglesia de la época bizantina y sus obras de arte en mosaico, posiblemente usadas durante siglos por monjes cristianos escapados desde el siglo I, durante un período de aproximadamente 600 años.</p>
									<p >Experimente Masada como uno de los patrimonios de la humanidad de la UNESCO, con el espectáculo de luces en la base de la fortificación, que se adentra en el modo de vida y las batallas experimentadas en el sitio hace siglos.</p>
									
								  
							    `,
      };
    },
  },
  {
    id: "The_Bedouin_Experience",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "THE BEDOUIN EXPERIENCE",
    smltitle: "",
    html: function() {
      return {
        __html: `

						           <p>The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.</p>
                                   <p>A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality.</p>
                                   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/the-bedouin-experience/1.jpg"} class="img-responsive">
								   </div>
								   <p>From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a long-forgotten way of life.</p>
		                        `,
      };
    },
  },
  {
    id: "The_Israel_National_Trail",
    ctg: "eilat-negev",
    bgImage: "/HomeSlider/desktop/4.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "THE ISRAEL NATIONAL TRAIL",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                 <p>The Israel National Trail (“Shvil Israel”) is a national project, paving a marked and safe hiking route across the country. Over 900km long, the route is one of the most rewarding ways to experience the nature and community in Israel.</p>
		                          <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/the-israel-national-trail/1.jpg"} class="img-responsive">
								   </div>
								   <p>The Israel Bike Trail (Part of The Israel National Trail Project) is a national initiative to create mountain biking trail that crosses the country from north to south, connecting Mt. Hermon at one end with Eilat at the other. Perfectly suited for bicycle tourism, the trail passes through national sites and amazing landscapes, allowing riders to experience Israel's diversity of culture and types of communities along the way.The trail is one of the longest demarcated trails in the world suited to, and with appropriate signage for, mountain biking.</p>

		                        `,
      };
    },
  },
  {
    id: "Timna_Treasures",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: true,
    vidId: "i_4QKtXIeto",
    title: "PARQUE DE TIMNA",
    smltitle: "",
    html: function() {
      return {
        __html: `  <h3>Una aventura, un desierto, una emoción</h3>
                                   <h3>Explore la belleza natural y atracciones emocionantes que el Parque Timna tiene para ofrecer</h3>
									<p>El parque Timna es una experiencia única, ubicado a sólo 20 minutos de Eilat, en el corazón del desierto israelí y situado entre impresionantes paisajes naturales. Con atractivos y actividades que combinan <s>la</s> naturaleza, <s>las</s> antigüedades históricas y <s>la</s> aventura, los amplios terrenos impresionan a visitantes de todas las edades e intereses.</span></p>
									<h3>Sea testigo de fenómenos naturales sobresalientes</h3>
									<p>Camine a través de los jardines del parque y contemple las <strong>formaciones rocosas únicas</strong> del sitio con nombres interesantes y formas raras que puede tocar: &nbsp;"Seta", &nbsp;&nbsp;"Media Seta”, " Cañón Rosa ", "Arcos", " Pilares de Salomón " y " Valle de los bocetos de la roca " representan la vida de una época anterior, lo que le permite sentir como si estuviera presenciando algo verdaderamente espectacular.</span></p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() +
                                         "/posts/timna-treasures/1.jpg"} class="img-responsive">
																	   </div>
									<h3>Caminata al aire libre</h3>
									<p>Elija uno de los 20 senderos bien marcados del parque, cada uno varia el nivel de dificultad, adaptándose a sus necesidades individuales o de grupo y capacidades. Camine a través de los senderos espectaculares, geológicos y arqueológicamente significativos, o elija en su lugar descansar en el <strong>lago Timna</strong> a la sombra con zonas para hacer camping o si lo prefiere coma en el restaurante Khan King Solomon, donde puede además hacer talleres&nbsp; relacionados con el desierto como botellas de arena de colores , o darse una vuelta en barcos de pedales.</span></p>
									<p>Si lo que le gusta son los <strong>deportes extremos</strong> pruebe rappel, tirolina y excursiones en bicicleta, que seguro le dejarán lleno de energía.</p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() +
                                         "/posts/timna-treasures/2.jpg"} class="img-responsive">
																	   </div>
									<h3>Experimente hoy tiempos antiguos</h3>
									<p>Conozca la historia bíblica del desierto, durante una visita guiada al <strong>Tabernáculo </strong>reconstruido, con una réplica del Altar, el Santo de los Santos y el Arca. Observe cómo los visitantes más jóvenes miran con asombro la reproducción de la estructura santa que Dios ordenó a los judíos que construyeran en el desierto (delete the&nbsp; hyphen -) &nbsp;y los visitantes mayores examinen la reconstrucción para verificar la exactitud histórica, aprendiendo una cosa o dos a lo largo del camino.</span></p>
									<p>Parque Timna. Donde la historia se encuentra con la aventura, en lo profundo del desierto israelí.</span></p>
									                                    
								  
								  
		                        `,
      };
    },
  },
  {
    id: "Negev_Desert_Dont_Miss",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "DESIERTO DE NEGEV - NO SE LO PIERDA",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                    <h3>Sandboard en el desierto</h3>
									<p>Una experiencia icónica en el desierto Las increíbles dunas de arena del desierto del Negev le permiten deslizarse sentado o de pie a un ritmo vertiginoso. Esta es una habilidad fantástica y muy especial, que una vez que domine (es realmente muy fácil) puede nominarse como un auténtico surfista de arena: ¿genial no?</p>
                                    <h3>El Negev por la noche</h3>
									<p>El cielo del Negev por la noche es fascinante. Simplemente mire hacia arriba y de inmediato quedará impresionado por el esplendor de millones de estrellas titilantes, iluminando la oscuridad azul-negra en un resplandor que solo se puede ver en el desierto.</p>
                                    <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/negev-desert-dont-miss/1.jpg"} class="img-responsive">
								   </div>
                                    <h3>Paseos en camello</h3>
									<p>Retroceda en el tiempo para explorar el maravilloso entorno del desierto. Montar en camello es una actividad que puede encontrar en varios criaderos en el Negev.</p>
									<h3>Festival MidBurn</h3>
									<p>La propia versión de Israel del famoso festival de "Hombre Ardiente"; donde durante 6 días, se establece una ciudad temporal en el desierto de Negev, creando una plataforma que permite un estilo de vida comunitario, creatividad, arte y autoexpresión radical.</p>

								
									<h3>Amanecer en Masada</h3>
									<p>Disponible solo para aquellos que son lo suficientemente valientes como para subir a pie: ver el amanecer en Masada es, sin duda, una de las experiencias más inolvidables en Israel. El lento ascenso del sol a medida que emerge sobre las montañas jordanas de Moab y el Mar Muerto, arrojando su luz sobre los paisajes desérticos circundantes, es una vista verdaderamente espectacular, que no olvidará pronto.</p>
									                                  
                                  
	     

		                        `,
      };
    },
  },
  // {
  // 		id:"Negev_Charms",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"3UddwPEzDXo",
  //         title : "ESCAPE TO THE NEVEG",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                 <p>A desert holiday is unlike any other - the tranquility, the awe inspiring grand vistas, the clear star-studded night skies, all come together to create a truly mesmerizing and exotic experience most of us do not to partake in during our day to day lives.</p>
  //                                 <p>The Negev is so much more than just a Desert. While it still offers all the natural beauty, calmness and wonderous sites which the desert tourist is looking for, it is also extremely westernized and packed with activities and adventures while offering all the comforts of a holiday. This is exactly what makes a trip to the Negev the perfect destination for travelers from all over the world. Another gem of the Negev is undoubtedly its local community, from the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, the people of the Negev are warm, hospitable and always ready to lend a hand. The Negev is rich in geological and archeological treasures and offers loads of exciting activities for the more adventurous travelers.</p>
  //                           <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/negev-charms/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>At the same time, visitors looking for relaxation are sure to find it in the tranquil surroundings, and for some urban excitement, the nearby cities provide a wide range of city fun from culinary treats to exciting nightlife.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Galilee",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"5Ep3GgxELag",
  //         title : "GALILEE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				          <p>Most of northern Israel is generically known as The Galilee (Galil in Hebrew). It stretches virtually from the Mediterranean to the harp-shaped Sea Of Galilee and River Jordan on whose shores vast history has been made. Here is Mount Gilboa where King Saul and his son, Jonathan, died in battle against the Phillistines. Here is Hazor, where Deborah killed Sisera. Here, at Mount Meron, is the grave of Rabbi Hillel. Here in Tzippori, Hamat Tveriya and Bet Alpha, gorgeous 1,800-year-old synagogue mosaics have been discovered. Here is Armageddon (Megiddo) where Solomon built giant stables. Here is the lakeshore city of Tiberias, one of the “Four Holy Cities of Judaism” (another is Galilee’s Safed), which reached fame 2,000 years ago as one of the chief locations in which the Talmud was written.</p>
  //                                 <h3 >Galilee</h3>
  //                                 <div class="responisve-iframe">
  // 					           <iframe width="560" height="315" src="https://www.youtube.com/embed/lzYzxyvnfng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  // 				           </div>
  // 				           <p>The restoration of the Jewish homeland in the period beginning in the 1880’s was largely centered in the Galilee, and in the ensuing 130 years a much neglected landscape of not much more than olive trees has been transformed into one of the most fertile areas in the world. Here are dozens of kibbutzim and independently owned farms – whose produce feeds not only Israelis but is also flown daily to the grocery stores and flower markets of Europe. Here are some of Israel’s 300+ vineyards producing award winning wines. And here are pretty villages, towns and cities including Nazareth and Carmiel.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/galilee/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>In addition to hotels and very comfortable kibbutz guest houses, the Galilee is filled with dozens of country bed-and-breakfast accommodations, known as zimmerim. Many offer luxurious accommodations, including pools, and make a delightful base for relaxing and touring.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Caesarea",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"eLZ433_S6HI",
  //         title : "CAESAREA",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>The Roman port city of Caesarea is one of Israel’s wonders, combining ancient structures, archeology and a picture-perfect harbor, and adapting them for modern use.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/caesarea/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>Built by Rome’s Judean Governor, Pontius Pilate, two millennia ago, Caesarea was one of the largest and most magnificent ports in the Mediterranean, with giant piers stretching out into the sea to accommodate dozens of ships. The city of Caesarea contained a giant hippodrome, aqueduct and theater; a thousand years later the Crusaders arrived and built a giant fortress, and then came the Ottomans, who turned it into a seaside town. Today, the Roman theatre is a venue for concerts, the Crusader fortress is thrilling to visit and the Ottoman harbor and beach are full of cafes, restaurants and a visitors’ center. Caesarea is 45 minutes’ drive from Tel Aviv, 20 from Haifa.</p>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Acre",
    ctg: "north",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "KlXXyToCmCM",
    title: "CIUDAD VIEJA DE ACRE",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						          <br/>
						          <h3>Viaje tras los pasos de los cruzados</h3>
						          
								  
								   <h3>Una antigua ciudad amurallada convertida en centro cultural del norte de Israel</h3>
									<p>La Ciudad Vieja de Acre es uno de los lugares más excepcionales de Israel. Una verdadera ciudad costera rodeada de antiguos muros de piedra, la Ciudad Vieja de Acre es el hogar de innumerables tesoros históricos y culinarios y desprende un ambiente único y sublime, a diferencia de cualquier otro lugar del país.</p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() + "/posts/acre/1.jpg"} class="img-responsive">
																	   </div>
									<h3>Encuentre un patrimonio histórico cautivador</h3>
									<p>Prepárese para una ciudad con sitios y atracciones fascinantes que expone las vidas y prácticas de los cruzados que una vez gobernaron la Ciudad Vieja de Acre. Contemple las grandes y antiguas murallas que rodean la Ciudad Vieja, protegiendo a los habitantes de Acre durante el asedio de Napoleón. Visite el puerto del Acre, donde puede cerrar los ojos, respirar el aire fresco del mar e imaginar el sitio como un verdadero centro de actividad marítima, donde se establecieron los lazos con Occidente y los peregrinos descubrieron una entrada principal a la Tierra de Israel.</p>
									<p>Recorra un espectacular y antiguo sitio subterráneo, conocido como <strong>Túnel de los Templarios</strong>. En el pasado conectó una fortaleza estratégica con el puerto de Acre, ayudando a los peregrinos a entrar en Israel, el pasadizo de piedra sirve hoy como metáfora de cooperación y perseverancia y es impresionante caminar por él. Continúe hasta la Fortaleza Hospitalaria (Sala de los Caballeros), establecida por el rey Ricardo Corazón de León durante la tercera cruzada. Las ruinas de lo que una vez fue el patio central del bastión, rodeado de arcos, es un verdadero testimonio de los lazos profundos forjados en la ciudad durante los tiempos difíciles.</p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() + "/posts/acre/2.jpg"} class="img-responsive">
																	   </div>	
									<h3>Un raro matrimonio de autenticidad y culturas</h3>
									<p>De los sitios antiguos y atracciones, el <strong>mercado</strong> de Acre ejemplifica persistentemente la auténtica red de las culturas orientales y occidentales sobre las cuales la ciudad costera fue fundada y continúa prosperando. El mercado es donde los gustos y los olores llenan el aire - y los lugareños de las cuatro esquinas del mundo envuelven al público, alimentando sus corazones y sus vientres con gemas culturales y golosinas culinarias, tales como pasteles dulces orientales, especias preparadas localmente, productos frescos y peces que todavía coletean. Camine hacia el extremo sur del mercado y visite la sinagoga de Ramchal y el hogar del artista Chaim Parchi, dos sitios que añaden estilo, tradición y vitalidad al ya bullicioso centro cultural.</p>					   
											                        
		                        `,
      };
    },
  },

  {
    id: "Haifa",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "3ahATaKkhBk",
    title: "HAIFA BELLEZA QUE INSPIRA",
    smltitle: "",
    html: function() {
      return {
        __html: `  <br/>
                                    <h3>Tranquilidad urbana y paisajes hipnotizadores</h3>
									<p>Con acantilados escarpados sobre la orilla del mar Mediterráneo y verdes colinas con vistas al puerto de Haifa, la tercera ciudad más grande de Israel cuenta con algunas de las vistas más pintorescas del país. Inmensamente hermosa, tranquila y un modelo para la convivencia entre las diferentes comunidades religiosas, Haifa es más que un lugar - es una forma de vida. Camine bajo los pinos y disfrute de la diversidad cultural de la ciudad, animada escena intelectual, atmósfera pacífica y belleza innegable. Se sentirá obligado a inspirarse.</p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() + "/posts/haifa/1.jpg"} class="img-responsive">
																	   </div>
									<h3>Rodéese de serenidad y belleza</h3>
									<p>Una de las principales atracciones turísticas de Haifa son los mundialmente famosos <strong>Jardines Baha'i</strong>. Declarado por la UNESCO en 2008 como Patrimonio de la Humanidad por su "excepcional valor universal", es un lugar de excepcional belleza con más de un millón de visitantes cada año.</p>
									<p>Comience su visita en la cima del monte Carmelo en el encantador Louis Promenade. Contemple la impresionante vista que se extiende desde la ciudad de Haifa a toda la costa y las verdes montañas de Galilea en la distancia.</p>
									 <div class="img-wrapper">
																		   <img src=${getImgUrl() + "/posts/haifa/2.jpg"} class="img-responsive">
																	   </div>
									<p>Explore los jardines por sí mismo o tome un tour gratuito. Camine por las terrazas en cascada, con los setos y parterres arreglados y nutridos con amor por los jardineros. Visite el santuario de la bóveda de oro del Bab, que es el lugar de descanso del profeta Herald de Baha'i. Maravíllese con los colores y las formas geométricas de estos jardines colgantes únicos y disfrute de la serenidad que evoca.</p>
									<h3>Descubra el corazón de la escena cultural de Haifa</h3>
									<p>Los jardines Baha'i terminan en el barrio de la colonia alemana. Originalmente construido como una comunidad templaría alemana en la década de 1860. En estos días es el corazón de la escena cultural de Haifa y centro turístico con restaurantes, bares, galerías y hoteles boutique. Pasee por las calles de piedra, visite las galerías y disfrute de la hermosa arquitectura. Coma, beba en los cafés locales y restaurantes, explore la vida nocturna y sumérjase en la multitud. Al final de la noche, no se olvide de levantar la cabeza y admirar la magnífica iluminación de los jardines Baha'i. Reconfortará su corazón.</p>

								    
								  
		                        `,
      };
    },
  },

  {
    id: "Safed",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "i3_ihL51bHo",
    title: "SAFED DONDE LO MÍSTICO SE ENCUENTRA CON LO MUNDANO",
    smltitle: "",
    html: function() {
      return {
        __html: `  
									<h3>Sumérjase en el arte y la espiritualidad para una nueva interpretación de la vida</h3>
									<p>Con infinitas vistas que se extienden a horizontes lejanos y un aire de montaña prístino, Safed le cautivará instantáneamente al momento de su llegada. Conocida como la capital del misticismo judío en el pasado y el presente, esta impresionante ciudad antigua en lo alto de una colina es la más alta de Galilea y de todo Israel, tanto desde el punto de vista geológico como espiritual. Una de las cuatro ciudades sagradas del judaísmo, Safed ofrece un viaje palpablemente místico que le dejará impresionado por su profunda energía.</p>
									<p>A un corto trayecto en coche del venerado mar de Galilea, Safed le da la bienvenida con pintorescos callejones de adoquines y arquitectura numinosa. Escuche cómo las almas de la historia comparten sus secretos a través de una antigua fortaleza erigida por los cruzados, las influencias mamelucas, otomanas y británicas, el Monumento a la Guerra de la Independencia, así como una profunda historia sagrada encarnada por extraordinarias sinagogas y antiguas tumbas.</p>
									<h3>La Capital Eterna de la Cabalá</h3>
									<p>Desde el rabino Shimon Bar-Yohai, el autor del segundo siglo de la obra fundacional de la Cábala conocida como Zohar, hasta Ari HaKadosh, el padre de la Cábala contemporánea, Safed ha sido el hogar de los más altos místicos del judaísmo y sus devotos estudiantes. Fue en el siglo XVI cuando Ari HaKadosh "democratizó" las enseñanzas cabalísticas trayendo una nueva comprensión,&nbsp; que permitió a la Cabalá llegar a los laicos.</p>
									<p>Mientras camina de una sinagoga a la siguiente, sentirá cómo Safed se convirtió en el hogar inmutable de un linaje tan largo de aspirantes espirituales, independientemente de todo lo que la historia derribó. La sinagoga Abuhav cuyos elementos arquitectónicos encarnan el misticismo numérico, la sinagoga Ari Ashkenazi dedicada a Ari HaKadosh y la sinagoga Yosef Caro le transportarán a través del tiempo y hacia los mundos superiores del misticismo.</p>
						            <div class="img-wrapper">
															   <img src=${getImgUrl() + "/posts/Safed/1.jpg"} class="img-responsive">
														   </div>
									<h3>Una ciudad vieja inspiradora</h3>
									<p>Añada más momentos inolvidables a su viaje recorriendo los sinuosos callejones de adoquines en la Ciudad Vieja, viendo edificios de piedra únicos y continuando hasta la Colonia de Artistas. Hogar de galerías que le presentarán las exquisitas obras de artistas locales, incluida una gran variedad de Judaica, esta parte de la Ciudad Vieja es para los amantes de todo lo relacionado con el arte. El Museo de Muñecas y el Museo de Arte Impreso son visitas obligadas especiales para los amantes de la cultura.</p>
									<p>Safed puede ser tan nutritivo para su cuerpo como para su alma: las eclécticas ofertas de comida de la Ciudad Vieja prometen satisfacer todos los gustos y presupuestos. Desde panqueques yemeníes y comida callejera hasta delicias inesperadas en restaurantes, encontrará todo lo que está buscando y más en esta encantadora ciudad de profundas tradiciones.</p>
															
								   							   
		                        `,
      };
    },
  },

  {
    id: "The_Bahai_Gardens",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "3ahATaKkhBk",
    title: "La puerta de entrada al Norte de Israel",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						            <br/>
						            <p>La animada "Capital del Norte", Haifa es la tercera ciudad más grande de Israel y de lejos una de sus más emocionantes<span dir="RTL">.</span></p>
									<p>Si bien una visita en primavera o verano es una excelente oportunidad para ir a nadar o descansar en una de sus hermosas playas, Haifa está repleta de cosas para hacer y ver todo el año<span dir="RTL">.</span></p>
									<p>La fantástica ubicación de Haifa en las laderas del impresionante monte Carmel (una atracción por sí misma) se ha ganado el apodo de "San Francisco de Israel", y siendo fiel a esta reputación, está inundada de impresionantes playas, fascinantes lugares de interés, animada vida nocturna y una atrevida escena musical<span dir="RTL">.</span></p>
									<h3>Jardines Bahá'í - Belleza, grandeza y diseño inspirado</h3>
									<p>En julio de 2008, los Jardines Bahá'í fueron declarados Patrimonio de la Humanidad por la UNESCO en reconocimiento a su "valor universal sobresaliente" como lugar santo de peregrinación para los seguidores de la fe Bahá'í<span dir="RTL">.</span></p>
									<p>El santuario y los jardines Bahá'ís son una creación de belleza, grandeza y exquisito diseño en un ambiente especial y tranquilo como ningún otro. Los Jardines Bahá'í son también una de las atracciones más populares del país, atrayendo a más de un millón de visitantes al año<span dir="RTL">.</span></p>
									 <div class="img-wrapper">
																		   <img src=${getImgUrl() +
                                         "/posts/bahai-gardens/1.jpg"} class="img-responsive">
																	   </div>
									<h3>Monte Carmel - La montaña siempre verde cerca de la orilla mediterránea de Israel</h3>
									<p>Uno de los atractivos más llamativos es el monte Carmel, un símbolo de la belleza y la floración, y un panorama ideal para caminatas y picnics familiares. No hay necesidad de esforzarse demasiado para admirar las vistas espectaculares desde la cima del monte Carmel, ya que puede viajar por la ciudad en metro, el Carmelit<span dir="RTL">.</span></p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() +
                                         "/posts/bahai-gardens/2.jpg"} class="img-responsive">
																	   </div>
									<h3>Arte y Cultura</h3>
									<p>Haifa es una ciudad creativa y vibrante y, como tal, se pueden encontrar en cada esquina lugares de arte fantásticos y atracciones culturales. Entre los muchos lugares excelentes que ofrece se encuentra el notable Museo de Ciencia y Tecnología de Madatech, el Museo Nacional de Ciencias de Israel, el Museo de Arte de Haifa y el Zoológico Educativo de Haifa, ubicado en el monte Carmel<span dir="RTL">.</span></p>
									<p>Haifa también cuenta con eventos culturales ricos y variados, como el Festival de las Fiestas de todas las Fiestas, que celebra los festivales judío, cristiano y musulmán, que tienen lugar en diciembre. Tampoco se pierda el Festival Internacional de Cine de Haifa, un evento de una semana que se celebra cada mes de septiembre, transformando la ciudad entera en una gran atracción exhibe más de un centenar de películas de todos los géneros posibles<span dir="RTL">.</span></p>

						         
								   
								    
		                        `,
      };
    },
  },

  {
    id: "The_Sea_Of_Galilee",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "haG-t3wwuMc",
    title: "EL MAR DE GALILEE (Kinneret)",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  
								   
		                        `,
      };
    },
  },

  {
    id: "Rosh_Pina",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "_qKbHL5-qrQ",
    title: "ROSH PINA",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <h3>El secreto turístico de la Galilea pastoral <br/>Viaje en el tiempo en el pintoresco pueblo de Galilea </h3>
									<p>Conocida como la Princesa de Galilea, Rosh Pina es el hogar de la combinación perfecta de lugares con interés natural, cultural, histórico&nbsp;y de entretenimiento. Una hermosa aldea norteña restaurada, serena, donde los olivos y casas pintorescas están rodeados de exuberantes campos. Rosh Pina es el lugar ideal para unas vacaciones tranquilas y relajantes, donde los visitantes pueden recrear la vida de la aldea, hace más de un siglo.</p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() + "/posts/rosh-pina/1.jpg"} class="img-responsive">
																	   </div>
									<h3>Donde el silencio mágico se rompe sólo por el canto de los pájaros</h3>
									<p>¿Busca un lugar tranquilo lleno de naturaleza, que recuerda a la Toscana de Italia o la Alcarria de España? Diríjase hacia el norte a Rosh Pina, donde sus impresionantes paisajes rurales permanecen intactos y se sentirá transportado a una época anterior. Elija entre las muchas casas de huéspedes disponibles, equipadas para proporcionar la máxima hospitalidad, intercaladas en las callejuelas románticas del pueblo, ausente del bullicio de la gran ciudad y disfrute en esta hospitalaria y pintoresca comunidad.</p>
									<p>Aproveche la belleza natural de la localidad y pasee por los espléndidos senderos verdes que rodean el río Rosh Pina o los <strong>Jardines del Barón de Rothschild</strong>, parecidos a los grandes jardines de Versalles. Respire el aire fresco y disfrute de la belleza natural mientras recarga las baterías.</p>
									<h3>Una colonia de vacaciones con un encanto único y artístico</h3>
									<p>Pasee por las calles adoquinadas del pueblo, que recuerdan a viejas ciudades europeas, y encontrará una encantadora atmósfera cultural y artística rodeada de las magníficas montañas de la Galilea. Un lugar de tiendas de moda, restaurantes gourmet, galerías de arte, museos, festivales, sitios históricos y un centro comercial. La ciudad está llena de antigüedad, cultura, naturaleza y delicias culinarias, relatando la historia de la primera " Moshava de la Galilea " (Ciudad) y el asentamiento de comunidades judías en Israel.</p>
									                                 
								   						   
		                        `,
      };
    },
  },

  {
    id: "Nazareth",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "1M7N5BcmjFM",
    title: "NAZARET LA CUNA DEL CRISTIANISMO",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

						         <h3>Una antigua ciudad rica en historia, fascinante arqueología, cultura moderna y talismán de Oriente Medio</h3>
								<p>Nazaret o Natsrat, como su nombre se pronuncia en hebreo, es la cuna del cristianismo, la ciudad donde, según la tradición, el ángel Gabriel le dijo a María que concebiría por el poder del Espíritu Santo y el lugar donde Jesús pasó su niñez y juventud. Nazaret, en la baja Galilea, se encuentra en el corazón de un valle rodeado de montañas que abarcan varios de los sitios cristianos más importantes del mundo. Esta es una ciudad de religión y fe, de espiritualidad y santidad, pero también una ciudad con una rica historia, fascinante arqueología, cultura moderna y encanto de Oriente Medio.</p>
								<h3>La cuna del cristianismo</h3>
								<p>Nazaret, que comenzó como un pequeño pueblo judío hace unos 2.000 años, se convirtió en un bastión del cristianismo en el período bizantino, unos pocos cientos de años después. Durante ese período el nombre de Nazaret se extendió por todas partes, y los anhelos de ver el lugar donde la Virgen María y Jesucristo habían vivido convirtieron a la ciudad en un lugar popular&nbsp; de peregrinación. Estas visitas condujeron a la construcción de la primera iglesia de la ciudad - la Iglesia de la Anunciación en el sitio tradicional de la casa de José y María. Muchas más iglesias se han construido a lo largo de la ciudad, y fueron destruidas y reconstruidas con los cambios en el gobierno musulmán y cristiano a través de los siglos. En el siglo XIX, Nazaret atrajo un renovado interés y los cristianos volvieron a vivir en esta ciudad y reconstruyeron iglesias y monasterios. Hoy Nazaret es la ciudad árabe más grande en Israel y tiene cerca de 30 iglesias y monasterios, así como mezquitas y sinagogas antiguas.</p>
								<div class="img-wrapper">
																	   <img src=${getImgUrl() + "/posts/nazareth/1.jpg"} class="img-responsive">
																   </div>
								<h3>Un sabor de la Ciudad Vieja </h3><p>Un recorrido por Nazaret es como revivir sus diferentes períodos. Cada era dejó detrás de ella un símbolo de gran alcance que la convirtió en un sitio turístico encantador y popular en la era moderna. La mayoría de los sitios se concentran en la Ciudad Vieja, construida a mediados del siglo XIX en un encantador estilo arquitectónico de Oriente Medio. Un paseo por las callejuelas, entre las casas pintorescas, es una experiencia increíble y vale la pena caminar lentamente para disfrutar de su belleza.</p>
								<p>Hay muchas iglesias antiguas en la Ciudad Vieja, con la Iglesia de la Anunciación encabezando la lista. La iglesia reconstruida conservó partes de las iglesias anteriores, de los períodos cruzado y bizantino. La iglesia también alberga una impresionante colección de pinturas.</p>
								<p>Justo al lado de esta iglesia está la iglesia de San José, construida sobre las ruinas de edificios agrícolas donde, según la tradición, José, el esposo de María, tenía su taller de carpintería. Mientras que la Iglesia de la Anunciación fue construida en el sitio de la casa de María, la Iglesia Ortodoxa Griega de la Anunciación se construye sobre el Pozo de María, de la cual se dice que la madre de Jesús bebió. Esta es una estructura del período de los cruzados y tiene algunos frescos interesantes. Según la tradición, esta es la ubicación de la sinagoga en la que Jesús oró.</p>
								<p>Entre las muchas otras iglesias de Nazaret está la iglesia Mensa Christi, la iglesia Maronita, la iglesia de San Gabriel y la iglesia Salesiana. La Ciudad Vieja también tiene importantes edificios de la época otomana, incluyendo la Saraya, o Casa de Gobierno, construida por Daher el Omar, el gobernador de Galilea en el siglo XVIII, y la mezquita Blanca, que se utiliza hoy como una casa de oración y un centro de educación y cultura. La mezquita Blanca también alberga un museo con exposiciones que documentan la historia de Nazaret.</p>
								<p>Ninguna visita a la Ciudad Vieja de Nazaret estaría completa sin una visita al mercado local, que se ha convertido en una atracción popular y conocida gracias a los coloridos puestos y la variedad de mercancías. En el mercado puede disfrutar de una fiesta visual de tejidos de moda, el sabor de las especias y los alimentos locales. Todos los sonidos, paisajes, olores y sabores prometen una auténtica experiencia de Oriente Medio.</p>
								<h3>Un vistazo al talismán de Oriente Medio</h3>
								<p>Nazaret está lleno de encantadores rincones que abrirán su corazón a su belleza. Otro lugar que vale la pena visitar durante un recorrido a pie es el paseo de Nabi Sain para disfrutar de la maravillosa vista de la Galilea. Puede visitar la antigua casa de baño turco descubierta durante las renovaciones de una de las tiendas de la ciudad, explore una casa solariega de lujo con una muestra de las riquezas y costumbres de la clase alta otomana del siglo &nbsp;XIX, que incluye algunos frescos increíbles. También vale la pena visitar la casa del obispo ortodoxo griego, donde puede caminar por una serie de pasajes subterráneos descubiertos en el patio. Otro sitio interesante es el complejo construido por los rusos como un albergue para los peregrinos.</p>
								<p>Nazaret, que ha acogido a los peregrinos durante siglos, cuenta con albergues cristianos y hoteles de lujo para la comodidad de los turistas que acuden a este importante sitio, especialmente por Navidad. Decenas de restaurantes sirven comidas deliciosas con aromas maravillosos que atraen a los visitantes todo el año. Nazaret es ideal durante la Navidad, cuando la ciudad está decorada para la fiesta y sus colores y emoción se unen a la atmósfera santa y los sonidos de la oración que emanan de las iglesias de la ciudad.</p>

								 						   
		                        `,
      };
    },
  },

  {
    id: "Cheers_To_Israel",
    ctg: "culinarynorth",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "Cxii1yKqKwI",
    title: "GREAT WITH WHITE OR RED",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>Over the past decade, Israeli wine-making has become a vital and thriving industry.</p>
                                   <p>The fertile land of the area has been recognized worldwide as an excellent setting for burgeoning vineyards, and the local scene is trendy and opulent.</p>
                                   <p>In the north, the general atmosphere reminiscent of French or Italian wine regions while the south&nbsp;has become renowned for its burgeoning&nbsp;wine scene, thanks to pioneering farmers and their use of computerized drip irrigation.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/cheers-to-israel/1.jpg"} class="img-responsive">
								   </div>
								    <p><span style="font-family: arial,sans-serif;">The Israeli wine scene allows visitors a fantastic experience combining delectable wine tastings with the stunning vistas and energy this has to offer.</span></p>
								   <p>So come get a taste of Israel’s wine country through its many fantastic tours of the vineyards and boutique wineries, the fantastic wine and music festivals and year-round wine-themed events.</p>
								   <p>FYI, a visit to Israel goes great with white or red.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "A_Galilean_Treat",
    ctg: "culinarynorth",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "kF808ENuuTQ",
    title: "UNAS VACACIONES CULINARIAS EN LA GALILEA",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						                  <br/><h3>Un paraíso para los amantes de la buena mesa</strong>  </p>

                                  
								   <p>Una visita a Galilea ofrece sabores y gustos diferentes a cualquiera que haya experimentado antes. Desde quesos regionales hechos a mano en las industrias lácteas artesanales hasta vinos de clase mundial, viñedos boutique, restaurantes gourmet familiares, frutas recién recolectadas y vegetales llenos de sabor, Galilea es un paraíso para los entusiastas de la comida.</p>
									<h3>Una región que fluye con leche y vino</h3>
									<p>Visite una lechería artesanal para descubrir la riqueza de los quesos de Galilea y participe en&nbsp; la elaboración del queso. Deje que un experto quesero lo guíe mientras degusta algunos de los muchos quesos tiernos, curados y semicurados únicos de la zona, como el <em>lebane</em>, un cremoso queso tierno con forma de yogur hecho de leche de oveja o cabra que a menudo se sirve mezclado con especias locales como el <em>za'atar</em>; o <em>zefatit</em>, un queso de oveja salado que se moldea en una cesta y lleva el nombre de la zona de <em>Zefat</em>, o Safed, donde se hizo por primera vez.</p>
									<p>Si desea un poco de vino para acompañar su queso, está de enhorabuena. Cada vino es mejor que el anterior. Una reciente revolución en la elaboración de vino hizo que las bodegas boutique surgieran en el variado terreno de Galilea; cada viñedo cultiva uvas con un sabor específico del suelo en el que crecen. Contemple las colinas cubiertas de parras mientras saborea vinos tintos profundos y afrutados y vinos blancos frescos bajo la guía de los mejores enólogos de Israel. Explore las mezclas de uva que produjeron vinos que obtuvieron los máximos honores en las ferias de vino del mundo, muchas de las cuales no están disponibles para la venta fuera de Israel.</p>
									<div class="img-wrapper">
										
										<img src=${getImgUrl() + "/posts/galilean-treat/1.jpg"} class="img-responsive">

									</div>
									<h3>Pruebe la cosecha</h3>
									<p>Visite los huertos de recolección propia para deleitarse con bayas, manzanas, cerezas, melocotones, ciruelas e incluso "sabra", una fruta que es regordeta, jugosa y rebosante de sabor. Visite las granjas de especias para oler y probar una gama de hierbas y especias en constante cambio, tanto las que le son familiares como las que nunca ha visto antes. Descubra los sabores nativos de Galilea y cree sus propios tés de hierbas y mezclas de especias.</p>
									<p>Otra de las cosechas importantes de Galilea, el aceite de oliva, también le espera. Si pensaba que todo el aceite de oliva tiene el mismo sabor, una visita a una granja de aceite de oliva familiar en Galilea cambiará su opinión. Pruebe aceites de oliva para saber qué hace que cada sabor sea diferente y participe en una recolección de aceitunas y prénselas a la antigua usanza para hacer su propio aceite de oliva virgen extra.</p>
									<h3>Mercados y Restaurantes</h3>
									<p>Las ciudades antiguas de Galilea cuentan con una gran cantidad de mercados donde se pueden comprar los mejores productos locales y productos artesanales, a menudo vendidos por los expertos que los elaboran. Deambule por los mercados, deguste y pruebe en los mercados para descubrir delicias en cada esquina, o contrate un experto guía gastronómico que le guiará a los mejores puestos y los mejores manjares.</p>
									<p>Mientras pasea por la Galilea siguiendo sus papilas gustativas, encontrará restaurantes gourmet escondidos en los rincones más insólitos. Algunas de las mejores cocinas del país se sirven en los modestos restaurantes de Galilea, ubicados junto a magníficas vistas. Muchos son gestionados por familias, sirven platos elaborados con amor a partir de ingredientes con los que crecieron o se criaron a solo unas pocas millas. Pero para realmente sondear las profundidades de los productos de Galilea, tome parte en un taller de cocina. Están dirigidos por chefs locales que conocen la tierra por dentro y por fuera, y están ansiosos por compartir la mejor manera de elegir, preparar y disfrutar los productos locales más sabrosos. Así podrá elegir sus ingredientes antes de prepararlos, haciendo platos que saben mejor que cualquier plato que haya cocinado antes.</p>
									<h3>La experiencia única de Galilea</h3>
									<p>Galilea es mucho más que una serie de deliciosos sabores. Visite fortalezas en ruinas y sitios bíblicos donde Jesús predicó y se libraron batallas. Suba a las montañas, disfrute del rafting en aguas rápidas y camine junto a arroyos burbujeantes como parte de sus vacaciones de ensueño en Galilea.</p>

															 		   
		                        `,
      };
    },
  },

  {
    id: "Galilee_Action",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "5Ep3GgxELag",
    title: "ACCIÓN EN LA GALILEA AVENTURAS EN LA GALILEA",
    smltitle: "",
    html: function() {
      return {
        __html: `  

									<p>La gran cantidad de ríos, lagos y la costa de la Galilea son una inmensa&nbsp; fuente de diversión para todas las edades. Los que buscan emociones fuertes salpicarán sus rostros mientras compiten con sus amigos en kayak en las aguas bravas. Familias o parejas pueden relajarse nadando en las verdes y frescas orillas de uno de los muchos ríos de la Galilea. Puede refrescarse con emocionantes actividades acuáticas como esquí acuático o kite surf en el mar de Galilea. A lo largo de la costa, a los turistas les encanta pasar el rato en las cálidas playas de arena de la Galilea o visitar la belleza resplandeciente de las grutas de Rosh Hanikra.</p>
									<p>Los deportes extremos se pueden practicar tanto en tierra como en aire y en agua. Los turistas activos pueden disfrutar de actividades llenas de adrenalina, como salto de esqui, caminar en las duras pistas de montaña o descender en rappel por acantilados desafiantes. En invierno, disfrute de los deportes en la nieve de la cordillera de Hermon como esquí y snowboard en pistas fáciles o desafiantes.</p>
									<p>La impresionante abundancia natural de la Galilea</p>
									<div class="img-wrapper">
										<img src=${getImgUrl() + "/posts/galilee-action/1.jpg"} class="img-responsive">
									</div>
									<p>La Galilea está llena de áreas de belleza natural donde familias, parejas y grupos de amigos pueden caminar, vislumbrar la vida silvestre o simplemente disfrutar de un picnic en la naturaleza. Recorriendo tranquilos senderos a caballo o siguiendo los senderos bien señalizados a pie o en bicicleta, encontrara belleza, diversión y emoción donde quiera que vaya. Observe la naturaleza de una manera más relajada observando aves y fauna en la Reserva Natural del Valle de Hula, o experimente la magia de todo el mosaico de bosques, campos y río que se despliegan por debajo mientras se eleva en un globo en el Gilboa. No deje pasar la oportunidad de sumergirse en la espiritualidad de sitios sagrados para cristianos, judíos y bahá'ís.</p>
									<p>Las numerosas rutas de senderismo de la Galilea son un imán para excursionistas de todas las edades, durante todo el año. Ya sea si prefiere un paseo sombreado junto a suaves arroyos, la emoción de escalar montañas y rapel, o disfrutar el logro de alcanzar la increíble vista en la cima de una desafiante colina, encontrará el camino perfecto esperándolo. En la Galilea, todas las opciones están abiertas.</p>
															
								   
								   
		                        `,
      };
    },
  },

  {
    id: "Bet_Shean",
    ctg: "north",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: false,
    title: "BET SHE’AN",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>South of the Sea of Galilee are the remains of one of the largest cities in the Roman-Byzantine Empire, Bet She’an. One of ten ancient cities (hence “Decapolis”) that included Philadelphia (present day Amman in Jordan) and Jerash, Scythopolis ((Bet She’an) was the only decapolis city west of the Jordan river.  It was very grand, with a giant theater, streets of tall columns, shops, bathhouses a hippodrome and hundreds of homes.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/bet-shean/1.jpg"} class="img-responsive">
								   </div>
								   <p>However, the splendid city was toppled in 749 by a massive earthquake, and never rebuilt. Over the centuries the ruins were overgrown – and it was not until the mid-20th century that Israeli archeologists pulled Bet She’an out of the murk, discovering (and restoring) the theater, the Cardo, the columns and much more.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "Zichron_Yaakov",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: false,
    title: "ZICHRON YA’AKOV",
    smltitle: "",
    html: function() {
      return {
        __html: ` <p>Zichron Ya’akov is a wonderful town for tourists, both local and foreign. This picturesque moshava semi-cooperative farming community built at the tip of the Carmel mountain range is the first moshava ever built in Israel and is a main tourism and vacation site in this region.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/zichron-yaakov/1.jpg"} class="img-responsive">
								   </div>
								    <p>Anyone who visits&nbsp;<strong>Zichron&nbsp;Ya’akov&nbsp;</strong>goes straight to Ha-Nadiv Street, and Ha-Meyasdim Street in the town center, which has become a very popular pedestrian mall, thanks to the special atmosphere in this place. The streets are paved with stones and pass between the moshava’s original houses (some of which have been reconstructed), which are bustling with activity.</p>
								   <p>There are many quaint and charming restaurants and coffee shops, interspersed between beautifully designed stores that sell local art works and lovely souvenirs. There are art galleries, unique artists' studios and workshops. New, modern buildings stand alongside old ones, such as the synagogue and the administration building, an old courtyard with a display of antique agricultural implements.</p>
								   <p>From its early days,&nbsp;<strong>Zichron Ya’akov</strong>&nbsp;had two main characteristics: wine and tranquility. The moshava’s founding farmers cultivated vineyards and the large winery built here in 1889 became the area’s most important industry. During the British Mandate period (1917-1948), the moshava became a holiday resort and rural vacations site, and to this day has hotels, spas and guesthouses.</p>
																   
		                        `,
      };
    },
  },

  // {
  // 		id:"Discover_The_Wine_Routes",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"Cxii1yKqKwI",
  //         title : "DISCOVER THE WINE ROUTES",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>Discover a different Israel through it's wineries and vineyards, through the passion of the people who are crafting award winning wines from home grown grapes.</p>
  //                                  <p>Enjoy vintage wines, gourmet foods, and gorgeous scenery. Spend time experiencing Israel as you never have before, as a Wine Connoisseur! The beauty of these routes in Israel is of course the authentic wine but also the incredible landscapes that surround the wineries. Many of the wineries are situated near ‘Zimmers’ which are little spa complexes that are dotted around northern Israel. They have little cabins with Jacuzzis that face out to the magnificent views of the rolling green hills. You can relax in your personal cabin with a splendid glass of wine from the local winery.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/discover-the-wine-routes/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <div class="wpb_wrapper"><p>The Middle East &amp; Eastern Mediterranean was the cradle of wine production, and the ancient land of Canaan is in fact one of the earliest countries to cultivate wine over 2,000 years before the vine came to Europe.</p><p>There are currently over 25 commercial wineries and over 150 boutique wineries in Israel where wine making has become a personal obsession with wine makers striving to produce world class wines.</p><p>Israel like other 'long' countries such as Chile or Italy enjoys a variety of microclimates. While the northern region gets much rain and even snow in the winter, just a few hours away Israel's southern region is very arid with desert conditions. This range in microclimates supports many grape varieties, which can grow on several different types of soil, yielding excellent results.</p><p>As always in matters of taste, you must visit Israel’s wineries and vineyards and decide for yourself which is your favourite!</p><p></p></div>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Birdtastic_Hula_Lake",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "ImobrsxsKl8",
    title: "LAGO HULA",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						<br/>
						<h3>La naturaleza en su mejor momento</h3>

						<h3>Descubra uno de los mejores sitios de observación de aves del mundo</h3>
						<p>En el corazón del pintoresco valle de Hula, en la Galilea Superior, a sólo dos horas en coche al norte de Tel Aviv, entre dos majestuosas cordilleras, se encuentra un lugar de extraordinaria belleza - el lago Hula. Uno de los sitios de observación de aves más importantes del mundo, esta reserva ecológica de pantanos internacionalmente reconocida, es un oasis para aves y amantes de la naturaleza de todas partes. Ofrece una oportunidad única para sentir la naturaleza sin barreras. &nbsp;Una experiencia inolvidable.</p>
						<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/birdtastic-hula-lake/1.jpg"} class="img-responsive">
								   </div>
						<p>Durante cada temporada de migración (primavera y otoño), más de 500 millones de aves y cerca de 400 especies viajan a través del lago Hula. Este paraíso de pantanos es la parada perfecta para pequeños, cormoranes, garzas, pelícanos, rapaces y grullas, por mencionar algunas. &nbsp;</p>
						<p>Declarado por la Revista BBC Wildlife como uno de los diez mejores sitios de observación de aves del mundo, el lago Hula o como se llama en hebreo Agamon Hula, atrae naturalmente a los observadores de aves de todo el mundo. Únase al festival internacional de aves Hula cada año en el otoño y disfrute de una verdadera experiencia que no se puede perder<span dir="RTL">.</span></p>
						<p>Hay varias maneras de presenciar este deslumbrante fenómeno. Todo lo que necesita es simplemente elegir su aventura<span dir="RTL">.</span></p>
						<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/birdtastic-hula-lake/2.jpg"} class="img-responsive">
								   </div>
						<p><strong>Explore los senderos</strong>. Recorra los senderos mágicos del parque. Puede caminar, ir en bicicleta o conducir en quad runners. Pasará a través de los árboles frutales y obtendrá una visión de la vida silvestre del humedal<span dir="RTL">.</span></p>
						<p><strong>Maneje un tractor</strong>. Únase a una visita guiada en un tractor "Safari Vagón" que le lleva a las profundidades de las instalaciones de Agamon. El vagón "le esconde" de los pájaros y por lo tanto permite un encuentro íntimo y personal con estas hermosas criaturas<span dir="RTL">.</span></p>
						<p><strong>Excursiones nocturnas y a la salida del sol</strong>. Para los más aventureros, hay 2 experiencias especiales de tour. Uno de ellos es el 'Tour del amanecer' que ofrece inmejorables oportunidades de observación de aves y fotografía. Alternativamente, el ' Tour del búho' que ofrece un aspecto completamente diferente de la reserva. Con la hoguera y bajo la mirada de las estrellas, podrá observar la vida de los gatos salvajes, aves rapaces nocturnas y murciélagos<span dir="RTL">.</span></p>
						<p>Levante el espíritu y sea testigo del trabajo de preservación de la naturaleza </p>
						<p><em>Agamon</em> Hula ha ganado fama mundial por ser un modelo de <s>un</s> sistema ecológico sostenible equilibrando naturaleza, turismo y agricultura<span dir="RTL">.</span></p>
						<p>Visite el centro de anillamiento en el parque y observe el trabajo realizado para preservar la naturaleza. Haga la excursión "Isla de aves" y tal vez <s>incluso</s> tendrá la oportunidad de liberar un pájaro a la naturaleza. No hay nada mejor que esto<span dir="RTL">.</span></p>
						<p>Con tantos tipos diferentes de animales y el trabajo incansable para preservar la naturaleza de forma creativa, el lago Hula ofrece más que un viaje divertido con hermosos paisajes. Es una inusual experiencia que abre el corazón y la mente<span dir="RTL">.</span></p>
												

								   
								                    
		                        `,
      };
    },
  },

  {
    id: "The_Kibbutz_Experience",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: false,
    title: "THE INCOMPARABLE KIBBUTZ EXPERIENCE",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <p>Predominantly based amongst beautiful landscape settings dotted around the country the Kibbutz life is a modern day phenomenon and a totally unique way of living. The movement which started in 1905 is a collective community way of living traditionally based on agriculture. Each kibbutz would sell its own produce.  The people living on them would all collectively work together to preserve it and work the land.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/kibbutz-experience/1.jpg"} class="img-responsive">
								   </div>
								    <p>The word ‘Kibbutz’ in Hebrew means group.&nbsp;The point being it is a voluntary democratic community where people live and work together to generate economically. It is founded on the principles of communal ownership of property and social equality.</p>
                                   <p>Some would describe the beautiful settings and a life of equality a utopia and why not experience it for yourself?&nbsp; Many of the Kibbutzim are open to visitors whether you would like to stay a few hours or a few months learning what this life is all about.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "National_Parks",
    ctg: "north",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: false,
    title: "NATIONAL PARKS",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

						          <p>Despite Israel being small its scenery varies immensely! You will find new cities and old, beaches and lakes, deserts and green mountains. Israel’s National parks and nature reserves make all this possible for you to experience the wondrous landscapes.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/national-parks/1.jpg"} class="img-responsive">
								   </div>
								   <p>In the south of the country you will find the expanse of the golden and orange plains of the desert. The Negev, Arava and Eilat are the fiery beautiful landscapes of the south that home the Dead Sea, Mitzpe Ramon and the beautiful desert oasis of En gedi not mention some wonderful hiking and cycling trails. When the sun sets the south turns in to a red illuminous sea of magic and when dark the sky turns in to a blanket of sparkles as the vast scenery makes it possible to see every star.</p>
                                   <p>In the North of the country you are welcomed with Luscious green hills and mountains including the snow-capped Mount Hermon.&nbsp; The Golan Heights home to magnificent mountainous scenery and an array of cultures.&nbsp; There are endless forest trails and water fall hikes for all the family to enjoy. The view from the mountain tops is breath taking as your eyes take you all the way out to the Mediterranean. Below the mountains you will find the green slopes of the Galilee home to the famous Kinneret, wineries and some wonderful relaxation spa’s. It really is a wonderland.</p>
								   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/national-parks/2.jpg"} class="img-responsive">
								   </div>
								   <p>The national parks offer exciting cultural and natural adventures. You have the opportunity to visit magnificent historical sites and follow wonderful nature trails while searching for some of the countries species i.e. The desert ibex and leopards, Eagles in the Golan. The impressive diversity of natural wonders, encounters with unspoiled nature and with plants.</p>
		                        `,
      };
    },
  },

  {
    id: "Tiberias",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: false,
    title: "TIBERIAS (TVERYA)",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <p>Located at the shores of the Sea of Galilee, Tiberias, the capital of the Galilee, was established in the early Roman period and has served as a religious, administrative and culture center of the Jewish people for many years.</p>
                                  <p>In addition to its rich history and significance, modern day Tiberias is synonymous with holiday in Israel. Here one can enjoy a variety of activities the city has to offer, and experience a wonderful mix of relaxation, nature and history, along with contemporary attractions, active water sports, pilgrimage sites and unique tourist attractions</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/tiberias/1.jpg"} class="img-responsive">
								   </div>
								   <p>A visit to Tiberias is not complete without a visit to its surrounding area, which features many must-see sights, including The city Bet Shean, one of the oldest cities in the world, and one of the country’s largest archaeological sites; Magdala (Migdal) the ancient town on the Sea of Galilee which was home to many of Jesus’s disciples and is said to have been the home of Mary Magdalene; Megiddo, a beautiful and impressive national park and one of the most important archeological sites in Israel from the time of the Bible. Once an ancient city of critical strategic importance, Megiddo is a UNESCO World Heritage Site, and an inspiring location for lovers of history and archeology.</p>
								   
		                        `,
      };
    },
  },
  {
    id: "Discover_Galilei",
    ctg: "north",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: false,
    title: "DESCUBRA LOS TESOROS OCULTOS DE LA GALILEA",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>Descubra la exuberante campiña del norte de Israel, donde las pintorescas ciudades coronan las colinas de la Alta y Baja Galilea y las bodegas y restaurantes boutique están escondidos junto a sitios históricos antiguos. Hospédese en un hotel de lujo o disfrute de unas auténticas vacaciones de campo en uno de los famosos <em>"zimmers"</em> de Galilea, casas rurales de gestión familiar en pequeños pueblos, para ver Israel a través de nuevos ojos.</p>
									<h3>Donde la historia cobra vida</h3>
									<p>Galilea está llena de sitios históricos. Visite los pueblos antiguos de Kfar Nahum (Cafarnaún) y Migdal (Magdala) y entre a la Casa de San Pedro en Cafarnaún. Vea las impresionantes iglesias y monasterios alrededor del mar de Galilea que marcaron los primeros días del cristianismo. Puede respirar la santidad de Safed, una de las cuatro antiguas ciudades espirituales del judaísmo, mientras explora el centro cabalístico más importante del mundo. Descubra las sinagogas más antiguas del mundo en sitios como Baram y explore las fortalezas de los cruzados de Montfort y Nimrod. Brinde sus respetos a Maimónides en la antigua ciudad de Tiberíades y experimente las maravillas del antiguo Akko (Acre), la ciudad subterránea de los cruzados y el túnel y fortaleza de los Templarios.</p>
									<h3>Un paraíso gourmet en la Galilea</h3>
									<p>Las bodegas boutique y las lecherías artesanales esperan en cada esquina de Galilea, junto con auténticos platos drusos y árabes cocinados en fogatas. Pruebe los alimentos directamente de las granjas orgánicas y del productor, haga una pausa en los restaurantes gourmet de gestión familiar y coma las frutas más frescas en los huertos de producción propia. Descubra Israel, que fluye no solo con leche y miel, sino también con vino, aceite de oliva, quesos de cabra y fruta deliciosa.</p>
									<div class="img-wrapper">
																		   <img src=${getImgUrl() +
                                         "/posts/discover-galilei/1.jpg"} class="img-responsive">
																	   </div>
									<h3>Actividades emocionantes junto a hermosos paisajes&nbsp; </h3>
									<p>Las onduladas colinas verdes de la Baja Galilea están entrecruzadas por ríos y son perfectas para caminatas a la sombra. Los que buscan adrenalina pueden subir y bajar por las espectaculares alturas de la Alta Galilea y emocionarse con el descenso de rápidos en las aguas turbulentas del río Jordán. También se ofrecen emocionantes paseos en jeep, paseos a caballo, alquiler de bicicletas o paintball. Hay actividades más suaves y vislumbrar la tímida vida salvaje de Israel en extensas reservas naturales o dar un paseo en bote por las tranquilas aguas del mar de Galilea. Incluso puede disfrutar de los deportes de invierno en las laderas cubiertas de nieve del enorme monte Hermón en el extremo norte del país.</p>
									<p>Visite el norte de Israel para las vacaciones que siempre ha soñado.</p>
															          
								  
		                        `,
      };
    },
  },
];



// WEBPACK FOOTER //
// ./src/Posts/PostsData.js